import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import {validateFormDraft,FORM_WRITE_METHODS} from "src/libs/portal/season/form-detail-policy";
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.admin-support-metric {
  background: linear-gradient(145deg, #ffffff, #f8fafc);
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  padding: 0.9rem 1rem;
}

.admin-support-metric p {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
}

.admin-support-metric strong {
  color: #0f172a;
  display: block;
  font-size: 1.15rem;
  margin-top: 0.25rem;
}

.admin-support-metric.is-progress {
  background: linear-gradient(145deg, #ffffff, #fffbeb);
  border-color: #fde68a;
}

.admin-support-metric.is-answered {
  background: linear-gradient(145deg, #ffffff, #ecfdf5);
  border-color: #a7f3d0;
}

.admin-support-list,
.admin-support-detail {
  min-height: 31rem;
}

.admin-support-list-item {
  background: #ffffff;
  padding: 1rem;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.admin-support-list-item:hover {
  background: #f8fafc;
}

.admin-support-list-item.is-selected {
  background: linear-gradient(90deg, #eef2ff, #ffffff);
  box-shadow: inset 3px 0 0 #4f46e5;
}

.admin-support-message {
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
  padding: 1rem;
}

.admin-support-message.is-user {
  background: #f8fafc;
}

.admin-support-message.is-admin {
  background: linear-gradient(145deg, #eef2ff, #f8faff);
  border-color: #c7d2fe;
}

.admin-support-message-heading {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
}

.admin-support-message-heading strong {
  color: #0f172a;
  font-size: 0.75rem;
}

.admin-support-message-heading span {
  color: #64748b;
  font-size: 0.6875rem;
}

.admin-support-message > p {
  color: #334155;
  font-size: 0.8125rem;
  line-height: 1.65;
  margin-top: 0.75rem;
  white-space: pre-line;
}

.admin-support-answer {
  min-width: 0;
}

.admin-support-answer-section + .admin-support-answer-section {
  border-top: 1px solid rgba(16, 185, 129, 0.18);
  margin-top: 1rem;
  padding-top: 1rem;
}

.admin-support-answer-label {
  color: #047857;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.admin-support-answer-title {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.5;
  margin-top: 0.3rem;
  overflow-wrap: anywhere;
}

.admin-support-answer-body {
  color: #334155;
  font-size: 0.8125rem;
  line-height: 1.75;
  margin-top: 0.4rem;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.admin-support-answer-attachments {
  display: grid;
  gap: 0.5rem;
  margin-top: 0.5rem;
  min-width: 0;
}

.admin-support-answer-attachment {
  align-items: center;
  background: #ffffff;
  border: 1px solid #a7f3d0;
  border-radius: 0.65rem;
  color: #334155;
  display: grid;
  gap: 0.65rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  max-width: 100%;
  min-width: 0;
  padding: 0.65rem 0.75rem;
  text-decoration: none;
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.admin-support-answer-attachment:hover,
.admin-support-answer-attachment:focus-visible {
  background: #ecfdf5;
  border-color: #34d399;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.14);
  outline: none;
}

.admin-support-answer-extension {
  background: #047857;
  border-radius: 0.4rem;
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: 800;
  line-height: 1;
  max-width: 4.5rem;
  overflow: hidden;
  padding: 0.4rem 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-support-answer-filename {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-support-answer-download {
  color: #047857;
  font-size: 0.6875rem;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .admin-support-answer-attachment {
    gap: 0.45rem;
    padding: 0.6rem;
  }
  .admin-support-answer-download {
    font-size: 0.625rem;
  }
}
.admin-support-waiting {
  align-items: flex-start;
  background: #fffbeb;
  border: 1px dashed #fcd34d;
  border-radius: 0.8rem;
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
}

.admin-support-waiting-dot {
  animation: admin-support-pulse 1.8s ease-in-out infinite;
  background: #f59e0b;
  border-radius: 9999px;
  flex-shrink: 0;
  height: 0.55rem;
  margin-top: 0.28rem;
  width: 0.55rem;
}

@keyframes admin-support-pulse {
  0%, 100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}
.access-summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  padding: 0.9rem 1rem;
}

.access-summary-card span {
  color: #64748b;
  display: block;
  font-size: 0.6875rem;
  font-weight: 700;
}

.access-summary-card strong {
  color: #0f172a;
  display: block;
  font-size: 1.15rem;
  margin-top: 0.25rem;
}

.access-summary-card.is-online {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.access-summary-card.is-attended {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.access-summary-card.is-absent {
  background: #fff7ed;
  border-color: #fed7aa;
}

.access-status-note {
  align-items: flex-start;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  color: #64748b;
  display: flex;
  font-size: 0.6875rem;
  gap: 0.5rem;
  line-height: 1.55;
  padding: 0.75rem 1rem;
}

.access-status-row {
  background: #ffffff;
}

.access-status-row.is-current-user {
  background: linear-gradient(90deg, #f0fdf4, #ffffff 42%);
}

.access-status-badge {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 700;
  gap: 0.4rem;
  min-height: 1.75rem;
  padding: 0 0.6rem;
  white-space: nowrap;
}

.access-status-dot {
  background: currentColor;
  border-radius: 9999px;
  height: 0.38rem;
  width: 0.38rem;
}

.access-status-badge.is-online {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.access-status-badge.is-away {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

.access-status-badge.is-offline {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #475569;
}

.access-status-badge.is-not-accessed {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

@media (prefers-reduced-motion: reduce) {
  .admin-support-waiting-dot {
    animation: none;
  }
}
button,
a,
input,
select {
  letter-spacing: 0;
}

select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%2364758b' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E");
  background-position: right 0.65rem center;
  background-repeat: no-repeat;
  background-size: 0.9rem;
  line-height: 1.2;
  min-width: 6.75rem;
  overflow: hidden;
  padding-right: 2.15rem !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.minihome-page {
  background: radial-gradient(circle at 12% 0%, rgba(16, 185, 129, 0.08), transparent 28rem), radial-gradient(circle at 92% 8%, rgba(59, 130, 246, 0.05), transparent 24rem), linear-gradient(180deg, #f8fbf9 0%, #f5f8f6 100%);
  min-height: 100%;
}

.minihome-top {
  box-shadow: none;
}

.minihome-main {
  min-height: calc(100vh - 9.5rem);
}

.dashboard-home {
  padding-bottom: 2rem;
}

.dashboard-intro {
  background-color: #123b31;
  background-image: linear-gradient(180deg, rgba(7, 29, 24, 0.48) 0%, rgba(8, 49, 39, 0.64) 100%), url("/assets/dashboard/ip-workspace-hero.png");
  background-position: center 60%;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 1.25rem;
  box-shadow: 0 20px 46px rgba(6, 78, 59, 0.2);
  color: #ffffff;
  min-height: 12.25rem;
  overflow: hidden;
  padding: 1.5rem 1.75rem;
  position: relative;
}

.dashboard-intro::before {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.02));
  content: "";
  height: 1px;
  left: 1.75rem;
  position: absolute;
  right: 1.75rem;
  top: 0;
}

.dashboard-intro-content {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 9.25rem;
  position: relative;
  width: 100%;
  z-index: 1;
}

.dashboard-intro-copy {
  max-width: 64rem;
  padding: 0 6rem;
  text-align: center;
  width: 100%;
}

.dashboard-kicker {
  align-items: center;
  color: #d1fae5;
  display: flex;
  font-size: 0.625rem;
  font-weight: 800;
  gap: 0.5rem;
  justify-content: center;
  letter-spacing: 0.24em;
  margin-bottom: 0.75rem;
}

.dashboard-kicker-dot {
  background: #6ee7b7;
  border-radius: 9999px;
  box-shadow: 0 0 0 4px rgba(110, 231, 183, 0.18);
  height: 0.4rem;
  width: 0.4rem;
}

.dashboard-title {
  color: #ffffff;
  font-size: clamp(1.3rem, 1.9vw, 1.75rem);
  font-weight: 750;
  letter-spacing: -0.04em;
  line-height: 1.3;
  text-shadow: 0 2px 12px rgba(4, 29, 23, 0.28);
}

.dashboard-subtitle {
  color: rgba(236, 253, 245, 0.82);
  font-size: 0.75rem;
  line-height: 1.6;
  margin-top: 0.5rem;
  text-shadow: 0 1px 8px rgba(4, 29, 23, 0.24);
}

.dashboard-today-card {
  align-items: center;
  backdrop-filter: blur(14px);
  background: rgba(4, 47, 38, 0.62);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  box-shadow: 0 12px 30px rgba(2, 25, 20, 0.2);
  display: flex;
  flex-shrink: 0;
  gap: 0.7rem;
  min-width: 15.75rem;
  padding: 0.65rem 0.7rem;
  position: absolute;
  right: 0;
  top: -0.4rem;
}

.dashboard-today-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 0.625rem;
  color: #d1fae5;
  display: flex;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.dashboard-today-label {
  color: rgba(209, 250, 229, 0.68);
  font-size: 0.5625rem;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.dashboard-today-date {
  color: #ffffff;
  font-size: 0.8125rem;
  font-weight: 700;
  margin-top: 0.125rem;
}

.dashboard-week-count {
  background: #ffffff;
  border-radius: 9999px;
  color: #065f46;
  font-size: 0.6875rem;
  font-weight: 800;
  margin-left: auto;
  padding: 0.375rem 0.625rem;
  white-space: nowrap;
}

.minihome-tab {
  background: rgba(255, 255, 255, 0.72);
  border-color: #bbf7d0;
  color: #475569;
  white-space: nowrap;
}

.minihome-tab:hover {
  background: #ffffff;
  border-color: #86efac;
  color: #14532d;
}

.minihome-tab.is-active {
  background: #14532d;
  border-color: #14532d;
  color: #ffffff;
}

.minihome-work-card {
  background: linear-gradient(145deg, #ffffff 0%, #fbfdfc 100%) !important;
  border: 1px solid rgba(203, 213, 225, 0.74) !important;
  border-radius: 1rem !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.055);
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  transform: translateY(0);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.minihome-work-card:hover {
  border-color: rgba(16, 185, 129, 0.32) !important;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.095);
  transform: translateY(-3px);
}

.minihome-work-card:focus-visible {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2), 0 16px 30px rgba(15, 23, 42, 0.1);
  outline: none;
}

.work-card-shell {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  min-height: 10rem;
  padding: 1.15rem 1.25rem 1rem;
  position: relative;
}

.work-card-accent {
  background: linear-gradient(90deg, #059669, #34d399);
  border-radius: 0 9999px 9999px 0;
  height: 2.6rem;
  left: 0;
  position: absolute;
  top: 1.35rem;
  width: 0.2rem;
}

.work-card-header {
  align-items: flex-start;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
}

.work-card-icon {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.875rem;
  color: #047857;
  display: inline-flex;
  height: 2.75rem;
  justify-content: center;
  width: 2.75rem;
}

.work-card-eyebrow {
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  margin-bottom: 0.25rem;
}

.work-card-count {
  align-items: baseline;
  background: #ffffff;
  border: 1px solid #d1fae5;
  border-radius: 0.75rem;
  color: #047857;
  display: inline-flex;
  gap: 0.125rem;
  min-width: 4rem;
  padding: 0.45rem 0.55rem;
  justify-content: center;
}

.work-card-count-number {
  font-size: 1.625rem;
  font-weight: 800;
  line-height: 1;
}

.work-card-count-unit {
  font-size: 0.6875rem;
  font-weight: 700;
}

.work-card-footer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  border-top: 1px solid #edf2f0;
  padding-top: 0.8rem;
}

.work-card-label {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 600;
}

.work-card-link {
  align-items: center;
  color: #047857;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 0.25rem;
  white-space: nowrap;
}

.minihome-work-card-domestic .work-card-icon {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.minihome-work-card-domestic .work-card-count {
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.minihome-work-card-domestic .work-card-link {
  color: #1d4ed8;
}

.minihome-work-card-domestic .work-card-accent {
  background: linear-gradient(90deg, #2563eb, #60a5fa);
}

.minihome-work-card-dispute .work-card-icon {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

.minihome-work-card-dispute .work-card-count {
  border-color: #fde68a;
  color: #b45309;
}

.minihome-work-card-dispute .work-card-link {
  color: #b45309;
}

.minihome-work-card-dispute .work-card-accent {
  background: linear-gradient(90deg, #d97706, #fbbf24);
}

.minihome-work-card-foreign .work-card-icon {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.minihome-work-card-foreign .work-card-count {
  border-color: #ddd6fe;
  color: #6d28d9;
}

.minihome-work-card-foreign .work-card-link {
  color: #6d28d9;
}

.minihome-work-card-foreign .work-card-accent {
  background: linear-gradient(90deg, #7c3aed, #a78bfa);
}

.dashboard-panel {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(203, 213, 225, 0.75);
  border-radius: 1rem;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.055);
  overflow: hidden;
}

.dashboard-panel-header {
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #fcfefd 100%);
  border-bottom: 1px solid #e7edea;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  min-height: 4.75rem;
  padding: 0.95rem 1.15rem;
}

.dashboard-section-icon {
  align-items: center;
  background: linear-gradient(145deg, #ecfdf5, #d1fae5);
  border: 1px solid #a7f3d0;
  border-radius: 0.75rem;
  color: #047857;
  display: flex;
  flex-shrink: 0;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.dashboard-section-icon.is-urgent {
  background: linear-gradient(145deg, #fff1f2, #ffe4e6);
  border-color: #fecdd3;
  color: #be123c;
}

.dashboard-section-icon.is-selected {
  background: linear-gradient(145deg, #eff6ff, #dbeafe);
  border-color: #bfdbfe;
  color: #2563eb;
}

.dashboard-section-title {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 750;
  letter-spacing: -0.025em;
  line-height: 1.35;
}

.dashboard-section-description {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.45;
  margin-top: 0.2rem;
}

.dashboard-calendar-meta {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 0.75rem;
}

.dashboard-legend {
  align-items: center;
  display: flex;
  gap: 0.65rem;
}

.dashboard-legend-item {
  align-items: center;
  color: #64748b;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 700;
  gap: 0.3rem;
}

.dashboard-legend-dot {
  border-radius: 9999px;
  height: 0.42rem;
  width: 0.42rem;
}

.dashboard-legend-dot.is-week {
  background: #10b981;
  box-shadow: 0 0 0 3px #d1fae5;
}

.dashboard-legend-dot.is-due {
  background: #f43f5e;
  box-shadow: 0 0 0 3px #ffe4e6;
}

.dashboard-month-pill {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 0.625rem;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 800;
  padding: 0.45rem 0.65rem;
}

.dashboard-calendar-body {
  padding: 0 1rem 1rem;
}

.dashboard-weekdays {
  border-bottom: 1px solid #dde6e1;
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.dashboard-weekdays > div:nth-child(6) {
  color: #2563eb;
}

.dashboard-weekdays > div:last-child {
  color: #e11d48;
}

.dashboard-calendar-grid {
  background: #dfe7e3;
  gap: 1px;
}

.dashboard-calendar-day {
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  min-width: 0;
  position: relative;
}

.calendar-day-select {
  background: transparent;
  border: 0;
  cursor: pointer;
  height: 100%;
  inset: 0;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 0;
}

.calendar-day-select:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: -3px;
}

.calendar-day-heading,
.calendar-count-row {
  position: relative;
  z-index: 1;
}

.calendar-day-heading {
  pointer-events: none;
}

.dashboard-calendar-day:hover {
  background: #f8fbf9;
  z-index: 1;
}

.dashboard-calendar-day.is-outside {
  background: #fafcfb;
  color: #a8b3bf;
}

.dashboard-calendar-day.is-selected {
  background: linear-gradient(145deg, #f0fdf8, #ffffff);
  box-shadow: inset 0 0 0 1.5px #059669;
  z-index: 2;
}

.dashboard-calendar-day.is-today .dashboard-day-number {
  color: #065f46;
  font-weight: 800;
}

.dashboard-day-number {
  font-size: 0.6875rem;
  font-weight: 700;
}

.dashboard-today-badge {
  background: linear-gradient(135deg, #047857, #059669);
  border-radius: 9999px;
  box-shadow: 0 3px 8px rgba(5, 150, 105, 0.2);
  color: #ffffff;
  font-size: 0.5625rem;
  font-weight: 800;
  padding: 0.2rem 0.42rem;
}

.deadline-rail {
  align-self: start;
}

.deadline-panel-header {
  min-height: 4.75rem;
}

.deadline-total-pill {
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 9999px;
  color: #be123c;
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 800;
  padding: 0.35rem 0.6rem;
}

.deadline-list {
  min-height: 8.75rem;
}

.deadline-item {
  background: #ffffff;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.deadline-item:hover {
  background: #f8fbf9;
  box-shadow: inset 3px 0 0 #10b981;
}

.deadline-item:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(5, 150, 105, 0.36);
  outline: none;
}

.dashboard-empty-state {
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdfc 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 10.5rem;
  padding: 1.5rem;
  text-align: center;
}

.dashboard-empty-state.is-compact {
  min-height: 8.75rem;
}

.dashboard-empty-icon {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 9999px;
  color: #059669;
  display: flex;
  height: 2.75rem;
  justify-content: center;
  margin-bottom: 0.65rem;
  width: 2.75rem;
}

.dashboard-empty-state.is-compact .dashboard-empty-icon {
  background: #eff6ff;
  border-color: #dbeafe;
  color: #2563eb;
}

.dashboard-empty-title {
  color: #334155;
  font-size: 0.75rem;
  font-weight: 750;
}

.dashboard-empty-description {
  color: #94a3b8;
  font-size: 0.625rem;
  line-height: 1.55;
  margin-top: 0.25rem;
  max-width: 19rem;
}

.minihome-count-box {
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none;
}

.minihome-page section.rounded-lg,
.minihome-page section > div.rounded-lg,
.minihome-page section > aside.rounded-lg,
.minihome-page section > section.rounded-lg {
  background: #ffffff !important;
  border: 1px solid #d9e2dd !important;
  border-radius: 8px !important;
  box-shadow: none;
}

.minihome-page section [class*=border-b] {
  border-color: #e2e8f0 !important;
}

.minihome-page table {
  border-collapse: separate;
  border-spacing: 0;
}

.minihome-page thead {
  background: #f8fafc !important;
}

.minihome-page tbody tr {
  background: #ffffff;
}

.minihome-page tbody tr:hover {
  background: #f8fafc !important;
}

.minihome-page input,
.minihome-page select {
  border-color: #cbd5e1;
  border-radius: 0.375rem;
}

.minihome-page input:focus,
.minihome-page select:focus {
  border-color: #64748b;
  box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.16);
}

.workspace-page {
  animation: workspace-enter 260ms ease-out;
  padding-bottom: 2rem;
}

.case-detail-page {
  max-width: 1800px;
}

.foreign-detail-badge {
  align-items: center;
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  border-radius: 9999px;
  color: #6d28d9;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 750;
  min-height: 1.75rem;
  padding: 0 0.65rem;
}

.foreign-detail-layout {
  display: grid;
  gap: 1rem;
}

.foreign-detail-panel {
  background: #ffffff;
  border: 1px solid #ddd6fe;
  border-radius: 0.75rem;
  overflow: hidden;
}

.foreign-detail-panel-header {
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f5f3ff 100%);
  border-bottom: 1px solid #ede9fe;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.9rem 1rem;
}

.foreign-detail-count {
  background: #ffffff;
  border: 1px solid #c4b5fd;
  border-radius: 9999px;
  color: #6d28d9;
  font-size: 0.6875rem;
  font-weight: 750;
  padding: 0.35rem 0.65rem;
}

.foreign-detail-overview-grid {
  background: #e2e8f0;
  display: grid;
  gap: 1px;
  grid-template-columns: minmax(0, 1fr);
}

.foreign-detail-field {
  background: #ffffff;
  min-height: 5.5rem;
  min-width: 0;
  padding: 0.875rem 1rem;
}

.foreign-detail-field-label {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.foreign-detail-field-value {
  color: #334155;
  font-size: 0.75rem;
  line-height: 1.5;
  margin-top: 0.55rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

.foreign-detail-control {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #334155;
  font-size: 0.75rem;
  min-height: 2rem;
  min-width: 0;
  padding: 0 0.5rem;
  width: 100%;
}

.foreign-detail-control:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.14);
  outline: none;
}

.foreign-detail-pair {
  display: grid;
  gap: 0.4rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.foreign-detail-chip {
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  border-radius: 9999px;
  color: #6d28d9;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.25rem;
  max-width: 100%;
  padding: 0 0.5rem;
}

.foreign-detail-product-row {
  align-items: center;
  display: grid;
  gap: 0.4rem;
  grid-template-columns: minmax(0, 0.75fr) minmax(0, 1.25fr) auto;
}

.foreign-detail-remove-button {
  border: 1px solid #fecdd3;
  border-radius: 0.375rem;
  color: #be123c;
  font-size: 0.6875rem;
  font-weight: 650;
  height: 2rem;
  padding: 0 0.5rem;
}

.foreign-detail-progress-shell {
  overflow-x: auto;
}

.foreign-detail-progress-table {
  min-width: 1100px;
}

.foreign-detail-progress-table th,
.foreign-detail-progress-table td {
  overflow-wrap: anywhere;
}

@media (min-width: 640px) {
  .foreign-detail-overview-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .foreign-detail-field.is-wide {
    grid-column: span 2;
  }
}
@media (min-width: 1280px) {
  .foreign-detail-overview-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .foreign-detail-progress-shell {
    overflow-x: visible;
  }
  .foreign-detail-progress-table {
    min-width: 100%;
    table-layout: fixed;
  }
  .foreign-detail-progress-table input,
  .foreign-detail-progress-table select,
  .foreign-detail-progress-table textarea {
    max-width: 100%;
    width: 100%;
  }
  .foreign-detail-progress-table th:nth-child(1) {
    width: 8%;
  }
  .foreign-detail-progress-table th:nth-child(2) {
    width: 10%;
  }
  .foreign-detail-progress-table th:nth-child(3) {
    width: 9%;
  }
  .foreign-detail-progress-table th:nth-child(4) {
    width: 13%;
  }
  .foreign-detail-progress-table th:nth-child(5) {
    width: 18%;
  }
  .foreign-detail-progress-table th:nth-child(6) {
    width: 14%;
  }
  .foreign-detail-progress-table th:nth-child(7) {
    width: 12%;
  }
  .foreign-detail-progress-table th:nth-child(8) {
    width: 16%;
  }
}
.dispute-detail-summary {
  background: #e2e8f0;
  border: 1px solid #fcd34d;
  border-radius: 0.75rem;
  overflow: hidden;
}

.dispute-detail-summary-grid {
  display: grid;
  gap: 1px;
  grid-template-columns: minmax(0, 1fr);
}

.dispute-detail-field {
  background: #ffffff;
  min-height: 5.5rem;
  min-width: 0;
  padding: 0.875rem 1rem;
}

.dispute-detail-field-label {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.dispute-detail-field-value {
  color: #334155;
  font-size: 0.75rem;
  line-height: 1.5;
  margin-top: 0.55rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

.dispute-detail-control {
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

@media (min-width: 640px) {
  .dispute-detail-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dispute-detail-field.is-wide {
    grid-column: span 2;
  }
}
@media (min-width: 1280px) {
  .dispute-detail-summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.case-detail-summary-shell {
  overflow-x: auto;
}

.case-detail-summary-table {
  min-width: 1380px;
}

@media (min-width: 1400px) {
  .case-detail-summary-shell {
    overflow-x: visible;
  }
  .case-detail-summary-table {
    table-layout: fixed;
    min-width: 100%;
  }
  .case-detail-summary-table th,
  .case-detail-summary-table td {
    min-width: 0 !important;
    overflow-wrap: anywhere;
  }
  .case-detail-summary-table input,
  .case-detail-summary-table select {
    max-width: 100%;
    width: 100%;
  }
}
.case-category-nav {
  background: #f8fafc;
  border: 1px solid #dbe4ee;
  border-radius: 1rem;
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 0.5rem;
}

.case-category-button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  color: #64748b;
  display: flex;
  font-size: 0.8125rem;
  font-weight: 700;
  gap: 0.55rem;
  justify-content: center;
  min-height: 2.75rem;
  padding: 0.6rem 0.75rem;
  transition: border-color 160ms ease, box-shadow 160ms ease, color 160ms ease, transform 160ms ease;
}

.case-category-button:hover {
  border-color: #94a3b8;
  color: #0f172a;
  transform: translateY(-1px);
}

.case-category-index {
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.case-category-button.is-active.is-consultation {
  border-color: #f9a8d4;
  box-shadow: inset 0 -3px #db2777, 0 7px 16px rgba(219, 39, 119, 0.1);
  color: #9d174d;
}

.case-category-button.is-active.is-domestic {
  border-color: #93c5fd;
  box-shadow: inset 0 -3px #2563eb, 0 7px 16px rgba(37, 99, 235, 0.1);
  color: #1d4ed8;
}

.case-category-button.is-active.is-dispute {
  border-color: #fcd34d;
  box-shadow: inset 0 -3px #d97706, 0 7px 16px rgba(217, 119, 6, 0.1);
  color: #b45309;
}

.case-category-button.is-active.is-foreign {
  border-color: #c4b5fd;
  box-shadow: inset 0 -3px #7c3aed, 0 7px 16px rgba(124, 58, 237, 0.1);
  color: #6d28d9;
}

.case-category-button.is-active .case-category-index {
  color: currentColor;
}

@media (max-width: 767px) {
  .case-category-nav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .case-category-button {
    justify-content: flex-start;
  }
}
.workspace-shell {
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(203, 213, 225, 0.76);
  border-radius: 1rem;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.workspace-hero {
  align-items: center;
  background: radial-gradient(circle at 92% 0%, rgba(16, 185, 129, 0.12), transparent 16rem), linear-gradient(135deg, #ffffff 0%, #f3faf6 100%);
  border: 1px solid rgba(167, 243, 208, 0.75);
  border-radius: 1rem;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  min-height: 6rem;
  overflow: hidden;
  padding: 1.25rem 1.4rem;
  position: relative;
}

.workspace-shell > .workspace-hero {
  border: 0;
  border-bottom: 1px solid #e4ece8;
  border-radius: 0;
}

.workspace-hero::after {
  background: linear-gradient(180deg, #10b981, #047857);
  border-radius: 0 9999px 9999px 0;
  bottom: 1.3rem;
  content: "";
  left: 0;
  position: absolute;
  top: 1.3rem;
  width: 0.22rem;
}

.workspace-hero.is-cases {
  background: radial-gradient(circle at 92% 0%, rgba(59, 130, 246, 0.12), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f3f7fd 100%);
}

.workspace-hero.is-cases::after {
  background: linear-gradient(180deg, #60a5fa, #2563eb);
}

.workspace-hero.is-clients {
  background: radial-gradient(circle at 92% 0%, rgba(124, 58, 237, 0.11), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f7f5ff 100%);
  border-color: rgba(221, 214, 254, 0.9);
}

.workspace-hero.is-clients::after {
  background: linear-gradient(180deg, #a78bfa, #7c3aed);
}

.workspace-hero.is-favorite-clients {
  background: radial-gradient(circle at 92% 0%, rgba(236, 72, 153, 0.11), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #fff7fb 100%);
  border-color: rgba(251, 207, 232, 0.9);
}

.workspace-hero.is-favorite-clients::after {
  background: linear-gradient(180deg, #f472b6, #db2777);
}

.workspace-hero.is-ip-market {
  background: radial-gradient(circle at 92% 0%, rgba(14, 116, 144, 0.11), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f2fbfd 100%);
  border-color: rgba(165, 243, 252, 0.9);
}

.workspace-hero.is-business-management {
  background: radial-gradient(circle at 92% 0%, rgba(245, 158, 11, 0.12), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #fffbeb 100%);
  border-color: rgba(253, 230, 138, 0.9);
}

.workspace-hero.is-business-management::after {
  background: linear-gradient(180deg, #f59e0b, #b45309);
}

.workspace-hero.is-ip-market::after {
  background: linear-gradient(180deg, #22d3ee, #0e7490);
}

.workspace-hero.is-admin-support {
  background: radial-gradient(circle at 92% 0%, rgba(79, 70, 229, 0.11), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f7f7ff 100%);
  border-color: rgba(199, 210, 254, 0.92);
}

.workspace-hero.is-admin-support::after {
  background: linear-gradient(180deg, #818cf8, #4f46e5);
}

.workspace-hero.is-access-status {
  background: radial-gradient(circle at 92% 0%, rgba(16, 185, 129, 0.12), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f2fcf8 100%);
  border-color: rgba(167, 243, 208, 0.92);
}

.workspace-hero.is-access-status::after {
  background: linear-gradient(180deg, #34d399, #047857);
}

.workspace-hero.is-consultations {
  background: radial-gradient(circle at 92% 0%, rgba(236, 72, 153, 0.1), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #fff7fb 100%);
}

.workspace-hero.is-consultations::after {
  background: linear-gradient(180deg, #f472b6, #db2777);
}

.workspace-hero.is-laws {
  background: radial-gradient(circle at 92% 0%, rgba(59, 130, 246, 0.1), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f4f8ff 100%);
}

.workspace-hero.is-media {
  background: radial-gradient(circle at 92% 0%, rgba(139, 92, 246, 0.1), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #f8f6ff 100%);
}

.workspace-hero.is-forms {
  background: radial-gradient(circle at 92% 0%, rgba(245, 158, 11, 0.1), transparent 17rem), linear-gradient(135deg, #ffffff 0%, #fffbf2 100%);
}

.workspace-hero-icon {
  align-items: center;
  background: linear-gradient(145deg, #047857, #065f46);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.9rem;
  box-shadow: 0 8px 18px rgba(6, 78, 59, 0.16);
  color: #ffffff;
  display: flex;
  flex-shrink: 0;
  font-size: 0.875rem;
  font-weight: 800;
  height: 3rem;
  justify-content: center;
  width: 3rem;
}

.workspace-hero.is-cases .workspace-hero-icon {
  background: linear-gradient(145deg, #2563eb, #1d4ed8);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);
}

.workspace-hero.is-clients .workspace-hero-icon {
  background: linear-gradient(145deg, #7c3aed, #6d28d9);
  box-shadow: 0 8px 18px rgba(124, 58, 237, 0.18);
}

.workspace-hero.is-favorite-clients .workspace-hero-icon {
  background: linear-gradient(145deg, #db2777, #be185d);
  box-shadow: 0 8px 18px rgba(219, 39, 119, 0.17);
}

.workspace-hero.is-ip-market .workspace-hero-icon {
  background: linear-gradient(145deg, #0891b2, #0e7490);
  box-shadow: 0 8px 18px rgba(8, 145, 178, 0.18);
}

.workspace-hero.is-business-management .workspace-hero-icon {
  background: linear-gradient(145deg, #d97706, #92400e);
  box-shadow: 0 8px 18px rgba(180, 83, 9, 0.18);
}

.workspace-hero.is-admin-support .workspace-hero-icon {
  background: linear-gradient(145deg, #6366f1, #4338ca);
  box-shadow: 0 8px 18px rgba(79, 70, 229, 0.18);
}

.workspace-hero.is-access-status .workspace-hero-icon {
  background: linear-gradient(145deg, #10b981, #047857);
  box-shadow: 0 8px 18px rgba(5, 150, 105, 0.18);
}

.workspace-hero.is-consultations .workspace-hero-icon {
  background: linear-gradient(145deg, #db2777, #be185d);
  box-shadow: 0 8px 18px rgba(219, 39, 119, 0.17);
}

.workspace-kicker {
  color: #059669;
  font-size: 0.5625rem;
  font-weight: 850;
  letter-spacing: 0.14em;
  margin-bottom: 0.25rem;
}

.workspace-hero.is-cases .workspace-kicker {
  color: #2563eb;
}

.workspace-hero.is-clients .workspace-kicker {
  color: #7c3aed;
}

.workspace-hero.is-favorite-clients .workspace-kicker {
  color: #db2777;
}

.workspace-hero.is-ip-market .workspace-kicker {
  color: #0e7490;
}

.workspace-hero.is-business-management .workspace-kicker {
  color: #b45309;
}

.business-project-form {
  border-bottom: 1px solid #e2e8f0;
  padding: 1.35rem;
  scroll-margin-top: 6rem;
}

.business-section-heading,
.business-attachment-heading,
.business-form-actions,
.business-search-bar,
.business-table-heading {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.business-section-heading h3,
.business-table-heading h3 {
  color: #0f172a;
  font-size: 0.925rem;
  font-weight: 750;
}

.business-section-heading p:not(.business-section-eyebrow),
.business-table-heading p {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
  margin-top: 0.2rem;
}

.business-section-eyebrow {
  color: #b45309;
  font-size: 0.5625rem;
  font-weight: 850;
  letter-spacing: 0.13em;
  margin-bottom: 0.25rem;
}

.business-editing-chip {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 9999px;
  color: #b45309;
  font-size: 0.6875rem;
  font-weight: 800;
  padding: 0.35rem 0.7rem;
}

.business-form-grid {
  display: grid;
  gap: 0.85rem;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  margin-top: 1.1rem;
}

.business-field {
  display: block;
  grid-column: span 2;
  min-width: 0;
}

.business-field-wide {
  grid-column: span 3;
}

.business-field-period,
.business-field-contact {
  grid-column: span 5;
}

.business-field-full {
  grid-column: 1/-1;
}

.business-field > span {
  color: #475569;
  display: block;
  font-size: 0.6875rem;
  font-weight: 750;
  margin-bottom: 0.4rem;
}

.business-field > span em {
  color: #b45309;
  font-size: 0.625rem;
  font-style: normal;
  margin-left: 0.2rem;
}

.business-field input,
.business-field textarea,
.business-search-control input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.6rem;
  color: #0f172a;
  font-size: 0.75rem;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
  width: 100%;
}

.business-field input {
  height: 2.45rem;
  padding: 0 0.7rem;
}

.business-field textarea {
  line-height: 1.55;
  min-height: 4.8rem;
  padding: 0.65rem 0.7rem;
  resize: vertical;
}

.business-field input:focus,
.business-field textarea:focus,
.business-search-control input:focus {
  border-color: #d97706;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);
}

.business-period-inputs,
.business-contact-inputs {
  align-items: center;
  display: grid;
  gap: 0.45rem;
}

.business-period-inputs {
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
}

.business-period-inputs b {
  color: #94a3b8;
  font-size: 0.6875rem;
}

.business-contact-inputs {
  grid-template-columns: minmax(5rem, 0.75fr) minmax(7rem, 1fr) minmax(9rem, 1.35fr);
}

.business-money-input {
  position: relative;
}

.business-money-input input {
  padding-right: 2rem;
  text-align: right;
}

.business-money-input strong {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
  pointer-events: none;
  position: absolute;
  right: 0.7rem;
  top: 0.75rem;
}

.business-attachment-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  margin-top: 1rem;
  padding: 0.9rem;
}

.business-attachment-heading h4 {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 750;
}

.business-attachment-heading p {
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.5;
  margin-top: 0.2rem;
}

.business-attachment-button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d6a43c;
  border-radius: 0.6rem;
  color: #92400e;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 750;
  gap: 0.4rem;
  height: 2.15rem;
  padding: 0 0.75rem;
}

.business-attachment-button.is-busy {
  cursor: wait;
  opacity: 0.55;
}

.business-attachment-button input {
  display: none;
}

.business-attachment-empty {
  align-items: center;
  color: #94a3b8;
  display: flex;
  font-size: 0.6875rem;
  gap: 0.45rem;
  justify-content: center;
  min-height: 3.5rem;
}

.business-attachment-list {
  display: grid;
  gap: 0.45rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 0.75rem;
}

.business-attachment-list li {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  display: flex;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.55rem 0.65rem;
}

.business-attachment-list li > span {
  color: #94a3b8;
  flex-shrink: 0;
  font-size: 0.625rem;
}

.business-attachment-name {
  align-items: center;
  color: #334155;
  display: flex;
  flex: 1;
  font-size: 0.6875rem;
  font-weight: 650;
  gap: 0.45rem;
  min-width: 0;
  text-align: left;
}

.business-attachment-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.business-attachment-name i {
  color: #d97706;
}

.business-attachment-remove {
  color: #94a3b8;
  flex-shrink: 0;
  padding: 0.2rem;
}

.business-attachment-remove:hover {
  color: #dc2626;
}

.business-form-actions {
  border-top: 1px solid #e2e8f0;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 1rem;
}

.business-project-list {
  padding: 1.35rem;
}

.business-search-bar {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  padding: 0.7rem;
}

.business-search-bar > span {
  color: #64748b;
  flex-shrink: 0;
  font-size: 0.6875rem;
  padding-right: 0.35rem;
}

.business-search-bar > span strong {
  color: #b45309;
}

.business-search-control {
  display: block;
  max-width: 34rem;
  position: relative;
  width: 100%;
}

.business-search-control > i {
  color: #94a3b8;
  left: 0.8rem;
  position: absolute;
  top: 0.8rem;
}

.business-search-control input {
  height: 2.5rem;
  padding: 0 2.4rem 0 2.35rem;
}

.business-search-control button {
  color: #94a3b8;
  padding: 0.3rem;
  position: absolute;
  right: 0.5rem;
  top: 0.45rem;
}

.business-table-heading {
  margin-top: 1.2rem;
}

.business-table-heading > span {
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 750;
}

.business-table-wrap {
  border: 1px solid #dbe3ec;
  border-radius: 0.8rem;
  margin-top: 0.75rem;
  overflow-x: auto;
}

.business-project-table {
  border-collapse: collapse;
  min-width: 72rem;
  width: 100%;
}

.business-project-table th {
  background: #f1f5f9;
  border-bottom: 1px solid #cbd5e1;
  color: #475569;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  padding: 0.7rem 0.65rem;
  text-align: left;
  white-space: nowrap;
}

.business-project-table td {
  border-bottom: 1px solid #e2e8f0;
  color: #475569;
  font-size: 0.6875rem;
  line-height: 1.5;
  max-width: 15rem;
  padding: 0.8rem 0.65rem;
  vertical-align: middle;
}

.business-project-table tbody tr:last-child td {
  border-bottom: 0;
}

.business-project-table tbody tr[role=button] {
  cursor: pointer;
  outline: none;
  transition: background-color 150ms ease, box-shadow 150ms ease;
}

.business-project-table tbody tr[role=button]:hover,
.business-project-table tbody tr[role=button]:focus {
  background: #fffbeb;
}

.business-project-table tbody tr.is-selected {
  background: #fff7d6;
  box-shadow: inset 3px 0 0 #d97706;
}

.business-project-table td:first-child strong,
.business-project-name {
  color: #0f172a;
  font-weight: 750;
}

.business-amount {
  color: #0f172a !important;
  font-variant-numeric: tabular-nums;
  font-weight: 750;
  text-align: right;
  white-space: nowrap;
}

.business-contact-cell {
  max-width: 13rem !important;
  word-break: break-word;
}

.business-note-cell {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  min-width: 7rem;
}

.business-note-cell > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.business-note-cell b {
  align-items: center;
  background: #f1f5f9;
  border-radius: 9999px;
  color: #475569;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.625rem;
  gap: 0.25rem;
  padding: 0.2rem 0.4rem;
}

.business-empty-state {
  align-items: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  justify-content: center;
  min-height: 11rem;
  text-align: center;
}

.business-empty-state i {
  font-size: 1.5rem;
}

.business-empty-state strong {
  color: #475569;
  font-size: 0.75rem;
}

.business-empty-state p {
  font-size: 0.6875rem;
}

.workspace-hero.is-admin-support .workspace-kicker {
  color: #4f46e5;
}

.workspace-hero.is-access-status .workspace-kicker {
  color: #047857;
}

.workspace-hero.is-consultations .workspace-kicker {
  color: #db2777;
}

.workspace-title {
  color: #0f172a;
  font-size: 1.125rem;
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.35;
}

.workspace-description {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.5;
  margin-top: 0.25rem;
}

.workspace-hero-actions,
.workspace-toolbar {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.workspace-count-chip,
.workspace-session-chip {
  align-items: center;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid #d7e5de;
  border-radius: 9999px;
  color: #047857;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 800;
  min-height: 2rem;
  padding: 0 0.7rem;
  white-space: nowrap;
}

.workspace-count-chip.is-neutral {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}

.workspace-session-chip {
  color: #475569;
  gap: 0.4rem;
}

.workspace-session-dot {
  background: #10b981;
  border-radius: 9999px;
  box-shadow: 0 0 0 3px #d1fae5;
  height: 0.4rem;
  width: 0.4rem;
}

.workspace-primary-button,
.workspace-secondary-button {
  align-items: center;
  border-radius: 0.65rem;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 750;
  gap: 0.4rem;
  height: 2.25rem;
  justify-content: center;
  padding: 0 0.85rem;
  transition: box-shadow 160ms ease, transform 160ms ease, background-color 160ms ease;
  white-space: nowrap;
}

.workspace-primary-button {
  background: linear-gradient(135deg, #065f46, #047857);
  box-shadow: 0 7px 15px rgba(6, 78, 59, 0.16);
  color: #ffffff;
}

.workspace-primary-button:hover {
  box-shadow: 0 10px 20px rgba(6, 78, 59, 0.22);
  transform: translateY(-1px);
}

.workspace-secondary-button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
}

.workspace-secondary-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.workspace-secondary-button.is-favorite-client {
  background: #fffbeb;
  border-color: #fcd34d;
  color: #b45309;
}

.workspace-body {
  padding: 1.15rem;
}

.consultation-list-filter-bar {
  background: radial-gradient(circle at 100% 0%, rgba(219, 39, 119, 0.06), transparent 12rem), #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.9rem 1rem 1rem;
}

.consultation-list-filter-bar .case-filter-control {
  background: #ffffff;
}

.workspace-filter-bar {
  align-items: end;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  padding: 0.9rem;
}

.workspace-filter-bar input,
.workspace-filter-bar select,
.workspace-toolbar input,
.workspace-toolbar select {
  border-color: #d5dee8;
  border-radius: 0.625rem;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.025);
}

.workspace-result-meta {
  border-bottom: 1px solid #edf1ef;
  padding: 0 0.15rem 0.7rem;
}

.info-system-banner {
  background: radial-gradient(circle at 100% 0%, rgba(16, 185, 129, 0.14), transparent 11rem), #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.8rem;
  padding: 0.9rem;
}

.info-resource-banner {
  align-items: center;
  background: radial-gradient(circle at 100% 0%, rgba(15, 118, 110, 0.08), transparent 12rem), #f8fafc;
  border: 1px solid #dbe4ea;
  border-radius: 0.8rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.9rem;
}

.info-resource-table-shell {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.035);
}

.info-resource-table th {
  white-space: nowrap;
}

.info-resource-table td {
  vertical-align: top;
}

.info-resource-table tbody tr:last-child td {
  border-bottom: 0;
}

.info-resource-detail-grid {
  display: grid;
  gap: 1rem;
}

.info-resource-attachments {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.035);
}

@media (min-width: 1024px) {
  .info-resource-detail-grid {
    align-items: start;
    grid-template-columns: minmax(0, 1.25fr) minmax(22rem, 0.75fr);
  }
}
.info-card {
  background: #ffffff;
  border: 1px solid #e0e7e3;
  border-radius: 0.75rem;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.03);
  position: relative;
}

.info-card::after {
  background: linear-gradient(90deg, #10b981, transparent);
  border-radius: 9999px;
  bottom: 0;
  content: "";
  height: 2px;
  left: 1rem;
  opacity: 0;
  position: absolute;
  right: 1rem;
  transition: opacity 160ms ease;
}

.info-card:hover {
  background: #ffffff;
  border-color: #a7f3d0;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.07);
  transform: translateY(-2px);
}

.info-card:hover::after {
  opacity: 1;
}

.info-card.is-pinned {
  background: #f8fffb;
  border-color: #6ee7b7;
  box-shadow: 0 8px 18px rgba(6, 95, 70, 0.07);
}

.info-card.is-pinned::after {
  opacity: 1;
}

.workspace-empty-state,
.workspace-table-empty {
  background: radial-gradient(circle at 50% 0%, rgba(16, 185, 129, 0.08), transparent 9rem), #fbfdfc;
  color: #64748b;
}

.workspace-empty-state {
  border: 1px dashed #cbd5e1;
  border-radius: 0.8rem;
  padding: 2.5rem 1rem;
  text-align: center;
}

.workspace-pagination {
  border-top: 1px solid #edf1ef;
  padding-top: 0.85rem;
}

.workspace-table-shell {
  background: #ffffff;
  border-top: 1px solid #edf1ef;
}

.workspace-data-table {
  border-collapse: separate;
  border-spacing: 0;
}

.workspace-data-table thead {
  background: linear-gradient(180deg, #f8fafc, #f4f7f5) !important;
  color: #64748b;
  letter-spacing: 0.01em;
}

.workspace-data-table th {
  border-bottom: 1px solid #dfe7e3;
  font-size: 0.6875rem;
  font-weight: 750;
  height: 2.75rem;
}

.workspace-data-table td {
  border-bottom-color: #edf1ef;
}

.workspace-data-row {
  background: #ffffff;
  transition: background-color 140ms ease, box-shadow 140ms ease;
}

.workspace-data-row:hover {
  background: #f8fbf9 !important;
  box-shadow: inset 3px 0 0 #10b981;
}

@keyframes workspace-modal-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes workspace-modal-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.workspace-modal-backdrop {
  animation: workspace-modal-backdrop-in 160ms ease-out;
  background: rgba(2, 6, 23, 0.6);
  backdrop-filter: blur(10px) saturate(110%);
}

.workspace-modal {
  animation: workspace-modal-panel-in 190ms cubic-bezier(0.16, 1, 0.3, 1);
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.26), 0 3px 12px rgba(15, 23, 42, 0.08);
  transform-origin: center top;
}

.workspace-modal input,
.workspace-modal select,
.workspace-modal textarea {
  border-color: #d5dee8;
  border-radius: 0.625rem;
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.workspace-modal input:focus,
.workspace-modal select:focus,
.workspace-modal textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
}

.client-mail-history-modal.workspace-modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 3rem);
  max-width: 70rem;
  min-height: min(38rem, 100vh - 3rem);
  overflow: hidden;
  padding: 0;
}

.client-mail-history-header {
  align-items: flex-start;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex: 0 0 auto;
  gap: 1rem;
  justify-content: space-between;
  padding: 1.5rem 1.75rem 1.35rem;
}

.client-mail-history-close {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.65rem;
  color: #64748b;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 1.25rem;
  height: 2.5rem;
  justify-content: center;
  line-height: 1;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
  width: 2.5rem;
}

.client-mail-history-close:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

.client-mail-history-count {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  color: #047857;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 700;
  height: 1.75rem;
  padding: 0 0.65rem;
}

.client-mail-history-body {
  background: #f8fafc;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem 1.75rem;
}

.client-mail-history-state {
  align-items: center;
  background: #ffffff;
  border: 1px dashed #a7f3d0;
  border-radius: 1rem;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  min-height: 19rem;
  padding: 2rem;
  text-align: center;
}

.client-mail-history-state.is-error {
  background: #fffbeb;
  border-color: #fcd34d;
}

.client-mail-history-state-label {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  color: #047857;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  padding: 0.35rem 0.75rem;
}

.client-mail-history-state-label.is-loading {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
}

.client-mail-history-state-label.is-error {
  background: #ffffff;
  border-color: #fcd34d;
  color: #b45309;
}

.client-mail-history-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.client-mail-history-summary {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 1rem;
  justify-content: space-between;
  padding: 0 0 0.75rem;
}

.client-mail-history-table-wrap {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.client-mail-history-footer {
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex: 0 0 auto;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem 1.75rem;
}

.client-detail-header {
  align-items: flex-start;
  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
  border-bottom: 1px solid #dfe7e3;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  padding: 1.5rem;
}

.client-detail-body {
  background: #f8fafc;
  display: grid;
  gap: 1.25rem;
  grid-template-columns: minmax(15rem, 18rem) minmax(0, 1fr);
  padding: 1.5rem;
}

.client-detail-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  padding: 1.25rem;
}

.client-detail-avatar {
  align-items: center;
  background: linear-gradient(135deg, #047857, #10b981);
  border-radius: 1rem;
  box-shadow: 0 10px 24px rgba(4, 120, 87, 0.2);
  color: #ffffff;
  display: flex;
  font-size: 1.25rem;
  font-weight: 800;
  height: 4rem;
  justify-content: center;
  margin: 1.25rem auto 0;
  width: 4rem;
}

.client-detail-metric {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem;
}

.client-detail-metric span {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 650;
}

.client-detail-metric strong {
  color: #0f172a;
  font-size: 1.125rem;
}

.client-detail-label {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
}

.client-detail-value {
  color: #1e293b;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.5;
  margin-top: 0.45rem;
}

.client-detail-input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  font-size: 0.8125rem;
  height: 2.5rem;
  margin-top: 0.4rem;
  padding: 0 0.75rem;
  width: 100%;
}

.client-panel-title {
  align-items: center;
  background: linear-gradient(180deg, #ffffff, #fbfcfd);
  border-bottom: 1px solid #e6ece9;
  display: flex;
  justify-content: space-between;
  min-height: 4.6rem;
  padding: 1rem 1.15rem;
}

.client-list {
  max-height: 33.25rem;
  overflow-y: auto;
}

.client-search-bar {
  background: #ffffff;
  border-bottom: 1px solid #e6ece9;
  padding: 0.75rem 1rem;
}

.client-search-field {
  align-items: center;
  display: flex;
  position: relative;
}

.client-search-field input {
  background: #f8fafc;
  border: 1px solid #dbe3ec;
  border-radius: 0.65rem;
  color: #334155;
  font-size: 0.75rem;
  height: 2.25rem;
  outline: none;
  padding: 0 2.25rem 0 2.2rem;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
  width: 100%;
}

.client-search-field input:focus {
  background: #ffffff;
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.12);
}

.client-search-field input::placeholder {
  color: #94a3b8;
}

.client-search-icon {
  color: #94a3b8;
  left: 0.75rem;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.client-search-clear {
  align-items: center;
  border-radius: 9999px;
  color: #94a3b8;
  display: flex;
  height: 1.6rem;
  justify-content: center;
  position: absolute;
  right: 0.4rem;
  width: 1.6rem;
}

.client-search-clear:hover {
  background: #ede9fe;
  color: #6d28d9;
}

.client-list-empty,
.client-detail-empty {
  color: #94a3b8;
  padding: 3rem 1rem;
  text-align: center;
}

.client-list-empty svg {
  margin: 0 auto;
}

.client-list-item {
  background: #ffffff;
  border-left: 3px solid transparent;
  transition: background-color 140ms ease, border-color 140ms ease;
}

.client-list-item:hover {
  background: #faf8ff;
}

.client-list-item.is-selected {
  background: linear-gradient(90deg, #f5f3ff, #ffffff);
  border-left-color: #8b5cf6;
}

.client-info-card,
.client-contact-card,
.client-metric-card {
  background: linear-gradient(145deg, #ffffff, #fafcfd);
  border: 1px solid #e2e8f0;
  border-radius: 0.8rem;
  padding: 0.9rem;
}

.client-contact-card {
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.client-contact-card:hover {
  border-color: #c4b5fd;
  box-shadow: 0 8px 18px rgba(124, 58, 237, 0.06);
}

.client-metric-card {
  min-height: 5.2rem;
  position: relative;
}

.client-metric-card.is-cases {
  background: linear-gradient(145deg, #eff6ff, #ffffff);
  border-color: #bfdbfe;
}

.client-metric-card.is-consultations {
  background: linear-gradient(145deg, #fdf2f8, #ffffff);
  border-color: #fbcfe8;
}

.favorite-client-card,
.market-preview-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.875rem;
  padding: 1rem;
}

.favorite-client-card {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.favorite-client-card:hover {
  border-color: #f9a8d4;
  box-shadow: 0 12px 25px rgba(219, 39, 119, 0.09);
  transform: translateY(-2px);
}

.market-preview-card {
  background: linear-gradient(145deg, #ffffff, #f3fbfd);
  border-color: #cffafe;
}

@keyframes workspace-enter {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-filter-select {
  min-width: 7.25rem;
}

.case-filter-select-wide {
  min-width: 8.25rem;
}

.case-applicant-scope-select {
  min-width: 11.25rem;
}

.case-stage-select {
  min-width: 5.6rem;
}

.case-list-shell {
  overflow-x: auto;
}

.case-filter-toolbar {
  align-items: center;
  display: flex;
  flex: 1 1 64rem;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
  min-width: 0;
}

.case-filter-control,
.case-filter-reset {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  color: #334155;
  font-size: 0.75rem;
  height: 2.25rem;
  padding: 0 0.65rem;
}

.case-filter-control {
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.case-filter-control:focus {
  border-color: #34d399;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
}

.case-filter-reset {
  color: #047857;
  cursor: pointer;
  font-weight: 700;
  transition: background-color 140ms ease, border-color 140ms ease;
}

.case-filter-reset:hover {
  background: #ecfdf5;
  border-color: #6ee7b7;
}

.case-filter-right {
  width: 9.5rem;
}

.case-filter-party {
  width: 15rem;
}

.case-filter-number {
  width: 14rem;
}

.case-detail-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.case-detail-action {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  color: #334155;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  height: 2rem;
  padding: 0 0.75rem;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}

.case-detail-action:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.case-detail-action.is-change {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.case-detail-action.is-examination,
.case-detail-action.is-dispute {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.case-detail-action.is-foreign {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.case-detail-action.is-active {
  background: #0f172a;
  border-color: #0f172a;
  color: #ffffff;
}

.case-detail-action:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.dispute-summary-component {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(4, 9.25rem);
  justify-content: start;
  padding: 0.75rem 1rem;
}

.dispute-summary-card {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  display: flex;
  justify-content: space-between;
  min-height: 3.4rem;
  padding: 0.65rem 0.75rem;
  position: relative;
}

.dispute-summary-card::before {
  background: #64748b;
  border-radius: 999px;
  content: "";
  height: 1.8rem;
  left: 0;
  position: absolute;
  width: 0.2rem;
}

.dispute-summary-card.is-total::before {
  background: #2563eb;
}

.dispute-summary-card.is-objection::before {
  background: #d97706;
}

.dispute-summary-card.is-trial::before {
  background: #7c3aed;
}

.dispute-summary-card.is-litigation::before {
  background: #e11d48;
}

.dispute-summary-label {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
}

.dispute-summary-value {
  color: #0f172a;
  font-size: 1.05rem;
  letter-spacing: -0.02em;
}

.dispute-case-list-shell {
  border-top: 1px solid #e2e8f0;
}

.dispute-case-table {
  min-width: 1480px;
  table-layout: fixed;
}

.dispute-case-table th {
  white-space: nowrap;
}

.dispute-case-row td {
  overflow-wrap: anywhere;
  vertical-align: top;
}

.dispute-interest-column {
  width: 2.75rem;
}

.dispute-status-column {
  width: 4.75rem;
}

.dispute-right-column {
  width: 4.75rem;
}

.dispute-category-column {
  width: 5rem;
}

.dispute-number-column {
  width: 7rem;
}

.dispute-name-column {
  width: 11rem;
}

.dispute-client-column {
  width: 7.25rem;
}

.dispute-claimant-column {
  width: 7.25rem;
}

.dispute-respondent-column {
  width: 7rem;
}

.dispute-base-column {
  width: 8.25rem;
}

.dispute-history-column {
  width: 6rem;
}

.dispute-inspection-column {
  width: 7.5rem;
}

.dispute-manager-column {
  width: 6.5rem;
}

.dispute-memo-column {
  width: 9.5rem;
}

@media (min-width: 1440px) {
  .dispute-case-list-shell {
    overflow-x: visible;
  }
  .dispute-case-table {
    min-width: 100%;
  }
  .dispute-interest-column {
    width: 3%;
  }
  .dispute-status-column {
    width: 5%;
  }
  .dispute-right-column {
    width: 5%;
  }
  .dispute-category-column {
    width: 5%;
  }
  .dispute-number-column {
    width: 8%;
  }
  .dispute-name-column {
    width: 12%;
  }
  .dispute-client-column {
    width: 8%;
  }
  .dispute-claimant-column {
    width: 8%;
  }
  .dispute-respondent-column {
    width: 7%;
  }
  .dispute-base-column {
    width: 9%;
  }
  .dispute-history-column {
    width: 6%;
  }
  .dispute-inspection-column {
    width: 8%;
  }
  .dispute-manager-column {
    width: 6%;
  }
  .dispute-memo-column {
    width: 10%;
  }
}
.dispute-status-badge,
.dispute-category-badge {
  align-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 700;
  min-height: 1.55rem;
  padding: 0 0.55rem;
  white-space: nowrap;
}

.dispute-status-badge.is-objection {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

.dispute-status-badge.is-trial {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.dispute-status-badge.is-litigation {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #be123c;
}

.dispute-category-badge {
  background: #f8fafc;
  border-radius: 0.375rem;
  color: #475569;
}

.dispute-history-load-button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 700;
  min-height: 1.8rem;
  padding: 0 0.6rem;
  white-space: nowrap;
}

.dispute-history-load-button:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.foreign-case-list-shell {
  border-top: 1px solid #e2e8f0;
}

.foreign-case-table {
  min-width: 1480px;
  table-layout: fixed;
}

.foreign-case-table th {
  white-space: nowrap;
}

.foreign-case-row td {
  overflow-wrap: anywhere;
  vertical-align: top;
}

.foreign-interest-column {
  width: 3rem;
}

.foreign-direction-column {
  width: 5rem;
}

.foreign-right-column {
  width: 5rem;
}

.foreign-registration-column {
  width: 8rem;
}

.foreign-name-column {
  width: 12rem;
}

.foreign-entry-column {
  width: 6.5rem;
}

.foreign-country-column {
  width: 7rem;
}

.foreign-application-column {
  width: 8rem;
}

.foreign-applicant-column {
  width: 8rem;
}

.foreign-history-column {
  width: 6rem;
}

.foreign-inspection-column {
  width: 8rem;
}

.foreign-manager-column {
  width: 6rem;
}

.foreign-memo-column {
  width: 9rem;
}

@media (min-width: 1440px) {
  .foreign-case-list-shell {
    overflow-x: visible;
  }
  .foreign-case-table {
    min-width: 100%;
  }
  .foreign-interest-column {
    width: 3%;
  }
  .foreign-direction-column {
    width: 5%;
  }
  .foreign-right-column {
    width: 5%;
  }
  .foreign-registration-column {
    width: 9%;
  }
  .foreign-name-column {
    width: 14%;
  }
  .foreign-entry-column {
    width: 7%;
  }
  .foreign-country-column {
    width: 8%;
  }
  .foreign-application-column {
    width: 9%;
  }
  .foreign-applicant-column {
    width: 9%;
  }
  .foreign-history-column {
    width: 7%;
  }
  .foreign-inspection-column {
    width: 9%;
  }
  .foreign-manager-column {
    width: 6%;
  }
  .foreign-memo-column {
    width: 9%;
  }
}
.domestic-case-list-shell {
  border-top: 1px solid #e2e8f0;
}

.domestic-case-table {
  min-width: 1680px;
  table-layout: fixed;
}

.domestic-case-table th {
  white-space: nowrap;
}

.domestic-case-row td {
  overflow-wrap: anywhere;
  vertical-align: top;
}

.domestic-interest-column {
  width: 3.25rem;
}

.domestic-right-column {
  width: 6.5rem;
}

.domestic-name-column {
  width: 15rem;
}

.domestic-applicant-column {
  width: 11rem;
}

.domestic-status-column {
  width: 7rem;
}

.domestic-filing-column {
  width: 10rem;
}

.domestic-registration-column {
  width: 9.5rem;
}

.domestic-renewal-column {
  width: 9rem;
}

.domestic-inspection-column {
  width: 10rem;
}

.domestic-manager-column {
  width: 8rem;
}

.domestic-memo-column {
  width: 13rem;
}

@media (max-width: 900px) {
  .dispute-summary-component {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.domestic-sort-button {
  align-items: center;
  color: #475569;
  display: inline-flex;
  font: inherit;
  font-weight: 700;
  gap: 0.3rem;
}

.domestic-sort-button:hover {
  color: #1d4ed8;
}

.domestic-sort-state {
  color: #2563eb;
  font-size: 0.65rem;
  white-space: nowrap;
}

.domestic-favorite-button {
  color: #f59e0b;
  font-size: 1.15rem;
  line-height: 1;
}

.domestic-favorite-button:disabled {
  color: #cbd5e1;
  cursor: not-allowed;
}

.domestic-overseas-badge {
  align-items: center;
  background: #f5f3ff;
  border: 1px solid #c4b5fd;
  border-radius: 0.375rem;
  color: #6d28d9;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 700;
  gap: 0.3rem;
  min-height: 1.35rem;
  padding: 0 0.45rem;
}

.domestic-overseas-dot {
  background: #7c3aed;
  border-radius: 9999px;
  height: 0.35rem;
  width: 0.35rem;
}

.domestic-name-cell {
  align-items: flex-start;
  display: flex;
  gap: 0.6rem;
  min-width: 0;
}

.domestic-mark-image,
.domestic-mark-placeholder {
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  flex: 0 0 3rem;
  height: 3rem;
  object-fit: contain;
  width: 3rem;
}

.domestic-mark-placeholder {
  align-items: center;
  background: #f8fafc;
  color: #64748b;
  display: flex;
  font-size: 0.625rem;
  font-weight: 700;
  justify-content: center;
  overflow: hidden;
  padding: 0.25rem;
  text-align: center;
}

.domestic-title-button {
  color: #0f172a;
  display: -webkit-box;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
  overflow: hidden;
  text-align: left;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.domestic-title-button:hover {
  color: #1d4ed8;
}

.domestic-status-badge {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 700;
  min-height: 1.5rem;
  padding: 0 0.55rem;
  white-space: nowrap;
}

.domestic-status-badge.is-examination {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.domestic-status-badge.is-priority {
  background: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}

.domestic-status-badge.is-response {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.domestic-status-badge.is-publication {
  background: #ecfeff;
  border-color: #a5f3fc;
  color: #0e7490;
}

.domestic-status-badge.is-registration {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.domestic-status-badge.is-stopped {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.domestic-history-button {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
  min-height: 1.75rem;
  padding: 0 0.5rem;
}

.domestic-history-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.domestic-memo-input {
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #334155;
  font-size: 0.6875rem;
  line-height: 1.35;
  min-height: 3.25rem;
  padding: 0.45rem 0.5rem;
  resize: vertical;
  width: 100%;
}

.case-list-table {
  min-width: 980px;
  table-layout: fixed;
}

.case-list-table th {
  white-space: nowrap;
}

.case-list-table td {
  overflow-wrap: anywhere;
  vertical-align: top;
}

.case-star-column {
  width: 3.25rem;
}

.case-stage-column {
  width: 7.5rem;
}

.case-title-column {
  width: 30%;
}

.case-client-column {
  width: 22%;
}

.case-date-column {
  width: 12.75rem;
}

.case-owner-column {
  width: 17rem;
}

.case-star-cell {
  text-align: center;
}

.case-title-button {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.case-kind-badge,
.case-type-badge,
.case-mark-badge,
.case-field-pill {
  align-items: center;
  border-radius: 0.375rem;
  display: inline-flex;
  min-height: 1.5rem;
  min-width: 0;
}

.case-kind-badge {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 0 0.5rem;
}

.case-kind-badge-patent {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.case-kind-badge-trademark {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.case-kind-badge-design {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.case-type-badge,
.case-mark-badge {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 0 0.5rem;
}

.case-mark-badge {
  color: #0f172a;
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.case-inline-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  min-width: 0;
}

.case-field-pill {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 0.6875rem;
  padding: 0 0.5rem;
}

.info-list-item {
  display: block;
  width: 100%;
}

.notice-board {
  background: #ffffff;
  border: 1px solid #dfe6e3;
  border-radius: 0.75rem;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.035);
  overflow: hidden;
}

.notice-board-head,
.notice-board-row {
  display: grid;
  grid-template-columns: 4.25rem minmax(0, 1fr) 9rem 5.5rem 7.5rem;
}

.notice-board-head {
  align-items: center;
  background: #f8faf9;
  border-bottom: 1px solid #e2e8e5;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
  min-height: 2.5rem;
  text-align: center;
}

.notice-board-head span:nth-child(2) {
  text-align: left;
}

.notice-board-row {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  color: inherit;
  min-height: 5.25rem;
  padding: 0;
  text-align: left;
  transition: background-color 150ms ease, box-shadow 150ms ease;
  width: 100%;
}

.notice-board-row:last-child {
  border-bottom: 0;
}

.notice-board-row:hover {
  background: #f8faf9;
}

.notice-board-row:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(4, 120, 87, 0.55);
  outline: none;
  position: relative;
  z-index: 1;
}

.notice-board-row.is-pinned {
  background: #f6fdf9;
}

.notice-board-row.is-pinned:hover {
  background: #eefaf4;
}

.notice-board-order,
.notice-board-author,
.notice-board-attachment,
.notice-board-date {
  align-items: center;
  color: #64748b;
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  min-width: 0;
  padding: 0 0.75rem;
  text-align: center;
}

.notice-board-pin {
  align-items: center;
  background: #dff7e9;
  border: 1px solid #b7ebce;
  border-radius: 9999px;
  color: #047857;
  display: inline-flex;
  font-size: 0.875rem;
  height: 2rem;
  justify-content: center;
  transform: rotate(-20deg);
  width: 2rem;
}

.notice-board-number {
  color: #94a3b8;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.notice-board-content {
  display: block;
  min-width: 0;
  padding: 0.875rem 1rem 0.875rem 0;
}

.notice-board-title-line {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  min-width: 0;
}

.notice-board-title {
  color: #0f172a;
  display: block;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.35;
  max-width: min(42rem, 70%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-board-category,
.notice-board-scope {
  border-radius: 9999px;
  flex-shrink: 0;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.375rem;
  padding: 0 0.5rem;
}

.notice-board-category {
  background: #f1f5f9;
  color: #475569;
}

.notice-board-scope {
  background: #ffffff;
  border: 1px solid #d9e2df;
  color: #64748b;
}

.notice-board-scope.is-system,
.notice-board-scope.is-admin {
  border-color: #b7ebce;
  color: #047857;
}

.notice-board-preview {
  color: #64748b;
  display: block;
  font-size: 0.75rem;
  line-height: 1.35rem;
  margin-top: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-board-preview.is-empty {
  color: #94a3b8;
}

.notice-board-author {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-board-attachment,
.notice-board-date {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .notice-board-head {
    display: none;
  }
  .notice-board-row {
    align-items: start;
    grid-template-columns: 3rem minmax(0, 1fr) auto auto;
    min-height: 0;
    padding: 0.875rem 0.875rem 0.875rem 0;
  }
  .notice-board-order {
    grid-column: 1;
    grid-row: 1/span 2;
    padding: 0.1rem 0;
  }
  .notice-board-content {
    grid-column: 2/-1;
    padding: 0;
  }
  .notice-board-author,
  .notice-board-attachment,
  .notice-board-date {
    display: inline-flex;
    grid-row: 2;
    justify-content: flex-start;
    margin-top: 0.55rem;
    padding: 0;
    text-align: left;
  }
  .notice-board-author {
    grid-column: 2;
    max-width: 9rem;
  }
  .notice-board-attachment {
    grid-column: 3;
    margin-left: 1rem;
  }
  .notice-board-date {
    grid-column: 4;
    justify-self: end;
    margin-left: 1rem;
  }
}
@media (max-width: 520px) {
  .notice-board-row {
    grid-template-columns: 2.75rem minmax(0, 1fr) auto;
  }
  .notice-board-title-line {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 0.35rem;
  }
  .notice-board-title {
    flex-basis: 100%;
    max-width: 100%;
  }
  .notice-board-author {
    max-width: 6.5rem;
  }
  .notice-board-attachment {
    grid-column: 3;
    margin-left: 0.75rem;
  }
  .notice-board-date {
    grid-column: 2/-1;
    grid-row: 3;
    justify-self: start;
    margin-left: 0;
    margin-top: 0.25rem;
  }
}
.info-list-item:focus-visible {
  border-color: #047857;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.18);
  outline: none;
}

.case-patent-client-no {
  color: #334155;
  font-weight: 600;
}

.case-next-due-input {
  max-width: 10rem;
  min-width: 0;
  width: 100%;
}

.case-memo-input {
  min-width: 0;
  width: 100%;
}

.calendar-count-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-top: 0.5rem;
  min-height: 1.625rem;
  pointer-events: none;
}

.calendar-count-badge {
  align-items: center;
  appearance: none;
  border: 1px solid transparent;
  border-radius: 9999px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 700;
  gap: 0.25rem;
  line-height: 1;
  min-height: 1.375rem;
  padding: 0 0.4375rem;
  pointer-events: auto;
  transition: box-shadow 150ms ease, filter 150ms ease;
  white-space: nowrap;
}

.calendar-count-badge:hover {
  filter: brightness(0.97);
}

.calendar-count-badge:focus-visible {
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.24);
  outline: none;
}

.calendar-count-dot {
  border-radius: 9999px;
  display: inline-block;
  height: 0.5rem;
  width: 0.5rem;
}

.calendar-count-badge-week {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #047857;
}

.calendar-count-badge-week .calendar-count-dot {
  background: #10b981;
}

.calendar-count-badge-due {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #be123c;
}

.calendar-count-badge-due .calendar-count-dot {
  background: #f43f5e;
}

.case-workspace-shell.is-dispute {
  --case-accent: #b45309;
  --case-accent-strong: #92400e;
  --case-accent-light: #fbbf24;
  --case-accent-soft: #fffbeb;
  --case-accent-soft-strong: #fef3c7;
  --case-accent-border: #fde68a;
  --case-accent-glow: rgba(245, 158, 11, 0.16);
  --case-accent-shadow: rgba(180, 83, 9, 0.2);
}

.case-workspace-shell.is-foreign {
  --case-accent: #7c3aed;
  --case-accent-strong: #6d28d9;
  --case-accent-light: #a78bfa;
  --case-accent-soft: #f5f3ff;
  --case-accent-soft-strong: #ede9fe;
  --case-accent-border: #ddd6fe;
  --case-accent-glow: rgba(124, 58, 237, 0.14);
  --case-accent-shadow: rgba(109, 40, 217, 0.2);
}

.case-workspace-shell.is-dispute .workspace-hero.is-cases,
.case-workspace-shell.is-foreign .workspace-hero.is-cases {
  background: radial-gradient(circle at 92% 0%, var(--case-accent-glow), transparent 17rem), linear-gradient(135deg, #ffffff 0%, var(--case-accent-soft) 100%);
  border-bottom-color: var(--case-accent-border);
}

.case-workspace-shell.is-dispute .workspace-hero.is-cases::after,
.case-workspace-shell.is-foreign .workspace-hero.is-cases::after {
  background: linear-gradient(180deg, var(--case-accent-light), var(--case-accent-strong));
}

.case-workspace-shell.is-dispute .workspace-hero.is-cases .workspace-hero-icon,
.case-workspace-shell.is-foreign .workspace-hero.is-cases .workspace-hero-icon {
  background: linear-gradient(145deg, var(--case-accent), var(--case-accent-strong));
  box-shadow: 0 8px 18px var(--case-accent-shadow);
}

.case-workspace-shell.is-dispute .workspace-hero.is-cases .workspace-kicker,
.case-workspace-shell.is-foreign .workspace-hero.is-cases .workspace-kicker {
  color: var(--case-accent);
}

.case-workspace-shell.is-dispute .workspace-data-row:hover,
.case-workspace-shell.is-foreign .workspace-data-row:hover {
  background: var(--case-accent-soft) !important;
  box-shadow: inset 3px 0 0 var(--case-accent);
}

.case-workspace-shell.is-dispute .case-title-button:hover,
.case-workspace-shell.is-foreign .case-title-button:hover {
  color: var(--case-accent-strong);
}

.case-workspace-shell.is-dispute .case-pagination button[aria-current=page],
.case-workspace-shell.is-foreign .case-pagination button[aria-current=page] {
  background: var(--case-accent);
  border-color: var(--case-accent);
  color: #ffffff;
}

.case-workspace-shell.is-dispute .dispute-summary-component {
  background: var(--case-accent-soft);
  border-top-color: var(--case-accent-border);
}

.case-workspace-shell.is-dispute .dispute-summary-card.is-total::before {
  background: var(--case-accent);
}

.case-workspace-shell.is-dispute .dispute-history-load-button:hover {
  background: var(--case-accent-soft);
  border-color: var(--case-accent-border);
  color: var(--case-accent-strong);
}

@media (max-width: 1100px) {
  .case-list-table {
    min-width: 900px;
  }
  .case-date-column {
    width: 11.25rem;
  }
  .case-owner-column {
    width: 14.5rem;
  }
}
.registration-additional-panel {
  animation: registration-additional-slide-down 220ms ease-out;
  scroll-margin-top: 1rem;
  transform-origin: top center;
}

.consultation-modal-layout {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
}

.consultation-side-panel {
  align-self: start;
  min-height: 100%;
}

@media (min-width: 1180px) {
  .consultation-modal-layout {
    grid-template-columns: minmax(0, 1fr) 22rem;
  }
  .consultation-side-panel {
    max-height: calc(88vh - 7.5rem);
    overflow-y: auto;
    position: sticky;
    top: 0;
  }
}
@keyframes registration-additional-slide-down {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .minihome-work-card,
  .deadline-item,
  .info-card,
  .workspace-primary-button,
  .workspace-data-row,
  .client-list-item,
  .workspace-page {
    animation: none;
    transition: none;
  }
  .minihome-work-card:hover {
    transform: none;
  }
  .info-card:hover,
  .workspace-primary-button:hover {
    transform: none;
  }
  .registration-additional-panel {
    animation: none;
  }
}
@media (max-width: 1023px) {
  .dashboard-intro {
    min-height: 13.5rem;
  }
  .dashboard-intro-content {
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    min-height: 10.5rem;
  }
  .dashboard-intro-copy {
    padding: 0 2rem;
  }
  .dashboard-today-card {
    position: static;
    width: auto;
  }
  .workspace-hero {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
  }
  .workspace-hero-actions,
  .workspace-toolbar {
    justify-content: flex-start;
    width: 100%;
  }
}
@media (max-width: 767px) {
  .minihome-main {
    padding-left: 0.85rem !important;
    padding-right: 0.85rem !important;
  }
  .dashboard-intro {
    background-position: center 58%;
    border-radius: 1rem;
    min-height: 15rem;
    padding: 1.25rem;
  }
  .dashboard-intro::before {
    left: 1.25rem;
    right: 1.25rem;
  }
  .dashboard-intro-content {
    min-height: 12.5rem;
  }
  .dashboard-intro-copy {
    padding: 0;
  }
  .dashboard-title {
    font-size: 1.125rem;
  }
  .dashboard-subtitle {
    font-size: 0.6875rem;
  }
  .dashboard-today-card {
    min-width: 0;
    width: 100%;
  }
  .dashboard-week-count {
    display: none;
  }
  .dashboard-panel-header {
    align-items: flex-start;
    flex-direction: column;
    min-height: 0;
  }
  .deadline-panel-header {
    align-items: center;
    flex-direction: row;
  }
  .dashboard-calendar-meta {
    justify-content: space-between;
    width: 100%;
  }
  .dashboard-calendar-body {
    overflow-x: auto;
    padding: 0 0.75rem 0.75rem;
  }
  .dashboard-weekdays,
  .dashboard-calendar-grid {
    min-width: 40rem;
  }
  .dashboard-calendar-day {
    min-height: 5.5rem !important;
  }
  .workspace-hero {
    border-radius: 0.9rem;
    padding: 1.1rem;
  }
  .workspace-shell > .workspace-hero {
    border-radius: 0;
  }
  .workspace-hero-icon {
    height: 2.65rem;
    width: 2.65rem;
  }
  .workspace-toolbar select,
  .workspace-toolbar input {
    flex: 1 1 9rem;
    width: auto !important;
  }
  .workspace-primary-button {
    flex: 1 1 auto;
  }
  .workspace-modal {
    border-radius: 1rem;
    padding: 1rem !important;
  }
  .client-mail-history-modal.workspace-modal {
    max-height: calc(100vh - 1.5rem);
    min-height: min(35rem, 100vh - 1.5rem);
    padding: 0 !important;
  }
  .client-mail-history-header {
    padding: 1.15rem 1.1rem 1rem;
  }
  .client-mail-history-body {
    padding: 1rem;
  }
  .client-mail-history-state {
    min-height: 17rem;
    padding: 1.5rem 1rem;
  }
  .client-mail-history-footer {
    padding: 0.9rem 1rem;
  }
  .client-detail-header {
    flex-direction: column;
    padding: 1.1rem;
  }
  .client-detail-body {
    grid-template-columns: minmax(0, 1fr);
    padding: 1rem;
  }
}
.quote-composer-page {
  min-width: 0;
}

.quote-template-grid {
  display: grid;
  gap: 0.9rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.quote-template-card {
  align-items: stretch;
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 0.85rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 9rem minmax(0, 1fr);
  min-height: 13.75rem;
  padding: 0.9rem;
  text-align: left;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.quote-template-card:hover,
.quote-template-card:focus-visible {
  border-color: #34d399;
  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.1);
  outline: 0;
  transform: translateY(-2px);
}

.quote-template-thumbnail-frame {
  align-self: start;
  aspect-ratio: 210/297;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.08);
  margin: 0;
  overflow: hidden;
  position: relative;
}

.quote-template-thumbnail-image {
  display: block;
  height: 100%;
  object-fit: contain;
  object-position: center top;
  width: 100%;
}

.quote-template-card-copy {
  min-width: 0;
  padding: 0.15rem 0;
}

.quote-template-card-title {
  color: #0f172a;
  font-size: 0.78rem;
  font-weight: 750;
  line-height: 1.45;
}

.quote-template-page-badge {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 9999px;
  color: #047857;
  flex-shrink: 0;
  font-size: 0.625rem;
  font-weight: 800;
  padding: 0.25rem 0.45rem;
}

.standard-quote-manager {
  background: #f8fafc;
  padding: 0 1.25rem 1.25rem;
}

.standard-quote-manager-summary {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  list-style: none;
  padding: 1.1rem 0;
}

.standard-quote-manager-summary::-webkit-details-marker {
  display: none;
}

.standard-quote-manager-summary > span {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  color: #475569;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.4rem 0.65rem;
}

.standard-quote-manager[open] .standard-quote-manager-summary > span {
  color: transparent;
  position: relative;
}

.standard-quote-manager[open] .standard-quote-manager-summary > span::after {
  color: #475569;
  content: "접기";
  inset: 0;
  padding: 0.4rem 0.65rem;
  position: absolute;
}

.standard-quote-detail-shell {
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 1rem;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.standard-quote-detail-header {
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
}

.standard-quote-detail-body {
  display: grid;
  grid-template-columns: 17rem minmax(0, 1fr);
  min-height: 45rem;
}

.standard-quote-detail-info {
  border-right: 1px solid #e2e8f0;
  padding: 1.4rem;
}

.standard-quote-detail-info dt {
  color: #64748b;
  font-size: 0.65rem;
  font-weight: 650;
}

.standard-quote-detail-info dd {
  color: #0f172a;
  font-size: 0.78rem;
  font-weight: 750;
  margin-top: 0.25rem;
}

.standard-quote-preview-stage,
.quote-document-preview-stage {
  background: #eef2f4;
  min-width: 0;
}

.standard-quote-preview-stage {
  display: grid;
  gap: 1.25rem;
  justify-items: center;
  overflow: auto;
  padding: 1.75rem;
}

.standard-quote-actual-page {
  background: #ffffff;
  border: 1px solid #d5dde7;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.16);
  margin: 0;
  overflow: hidden;
  width: min(100%, 56rem);
}

.standard-quote-actual-page img {
  display: block;
  height: auto;
  width: 100%;
}

.standard-quote-actual-page figcaption {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.55rem 0.75rem;
  text-align: center;
}

.quote-document-workspace {
  align-items: start;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(21rem, 0.72fr) minmax(34rem, 1.28fr);
  min-width: 0;
}

.quote-document-editor {
  background: #f8fafc;
  border: 1px solid #dbe4ee;
  border-radius: 0.9rem;
  min-width: 0;
  overflow: hidden;
}

.quote-editor-heading {
  align-items: flex-start;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem;
}

.quote-editor-heading h4,
.quote-document-preview-toolbar h4 {
  color: #0f172a;
  font-size: 0.875rem;
  font-weight: 800;
  margin-top: 0.2rem;
}

.quote-editor-heading p:not(.quote-composer-eyebrow) {
  color: #64748b;
  font-size: 0.68rem;
  margin-top: 0.25rem;
}

.quote-editor-heading > span {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 9999px;
  color: #047857;
  flex-shrink: 0;
  font-size: 0.625rem;
  font-weight: 800;
  padding: 0.35rem 0.6rem;
}

.quote-editor-section {
  border-top: 1px solid #e2e8f0;
  padding: 1rem;
}

.quote-editor-section:first-of-type {
  border-top: 0;
}

.quote-editor-section h5 {
  color: #0f172a;
  font-size: 0.75rem;
  font-weight: 800;
  margin-bottom: 0.75rem;
}

.quote-editor-section label {
  color: #475569;
  display: block;
  font-size: 0.65rem;
  font-weight: 700;
  margin-top: 0.65rem;
}

.quote-editor-section label:first-of-type {
  margin-top: 0;
}

.quote-editor-section input,
.quote-editor-section select,
.quote-editor-section textarea {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  color: #0f172a;
  font-size: 0.72rem;
  margin-top: 0.3rem;
  min-height: 2.25rem;
  padding: 0.48rem 0.6rem;
  width: 100%;
}

.quote-editor-section textarea {
  line-height: 1.55;
  resize: vertical;
}

.quote-editor-form-reference {
  align-items: start;
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 0.65rem;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: 4.25rem minmax(0, 1fr);
  margin-top: 0.7rem;
  padding: 0.65rem;
}

.quote-editor-form-reference figure {
  aspect-ratio: 210/297;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  margin: 0;
  overflow: hidden;
}

.quote-editor-form-reference img {
  display: block;
  height: 100%;
  object-fit: contain;
  object-position: center top;
  width: 100%;
}

.quote-editor-form-reference strong,
.quote-editor-form-reference span,
.quote-editor-form-reference em {
  display: block;
}

.quote-editor-form-reference strong {
  color: #0f172a;
  font-size: 0.72rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.45;
}

.quote-editor-form-reference span {
  color: #64748b;
  font-size: 0.62rem;
  line-height: 1.5;
  margin-top: 0.25rem;
}

.quote-editor-form-reference em {
  color: #047857;
  font-size: 0.61rem;
  font-style: normal;
  font-weight: 750;
  margin-top: 0.35rem;
}

.quote-editor-inline-grid {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quote-editor-cost-list {
  display: grid;
  gap: 0.65rem;
}

.quote-editor-cost-row {
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 0.65rem;
  padding: 0.75rem;
}

.quote-editor-remove-row {
  color: #be123c;
  font-size: 0.625rem;
  font-weight: 700;
  margin-top: 0.55rem;
}

.quote-editor-remove-row:disabled {
  color: #cbd5e1;
}

.quote-document-preview-stage {
  border: 1px solid #dbe4ee;
  border-radius: 0.9rem;
  min-width: 0;
  overflow: hidden;
}

.quote-document-preview-toolbar {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #dbe4ee;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.9rem 1rem;
}

.quote-preview-toolbar-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.quote-preview-form-name {
  background: #f8fafc;
  border: 1px solid #dbe4ee;
  border-radius: 9999px;
  color: #334155;
  font-size: 0.625rem;
  font-weight: 750;
  max-width: 18rem;
  overflow: hidden;
  padding: 0.35rem 0.6rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-a4-scroll {
  display: grid;
  gap: 1.25rem;
  justify-items: center;
  max-height: 76rem;
  overflow: auto;
  padding: 1.5rem;
}

.quote-source-document {
  aspect-ratio: 893/1263;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16);
  box-sizing: border-box;
  container-type: inline-size;
  isolation: isolate;
  margin: 0;
  overflow: hidden;
  position: relative;
  width: min(100%, 47.5rem);
}

.quote-source-document *,
.quote-source-document *::before,
.quote-source-document *::after {
  box-sizing: border-box;
}

.quote-source-document-image {
  display: block;
  height: 100%;
  object-fit: contain;
  position: relative;
  width: 100%;
  z-index: 0;
}

.quote-patent-form-editor {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.8rem;
  display: grid;
  gap: 0.85rem;
  margin-top: 0.9rem;
  padding: 0.85rem;
}

.quote-patent-editor-intro strong {
  color: #0f172a;
  display: block;
  font-size: 0.76rem;
  font-weight: 850;
}

.quote-patent-editor-intro p {
  color: #64748b;
  font-size: 0.63rem;
  line-height: 1.55;
  margin-top: 0.2rem;
}

.quote-patent-form-editor fieldset {
  border: 1px solid #dbe4ee;
  border-radius: 0.65rem;
  margin: 0;
  min-width: 0;
  padding: 0.7rem;
}

.quote-patent-form-editor legend {
  color: #065f46;
  font-size: 0.66rem;
  font-weight: 850;
  padding: 0 0.3rem;
}

.quote-patent-form-editor h6 {
  color: #334155;
  font-size: 0.62rem;
  font-weight: 800;
  margin: 0.3rem 0 0.45rem;
}

.quote-patent-form-editor h6:not(:first-of-type) {
  border-top: 1px dashed #dbe4ee;
  margin-top: 0.75rem;
  padding-top: 0.7rem;
}

.quote-patent-field-grid {
  display: grid;
  gap: 0.55rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quote-patent-field-grid label {
  color: #475569;
  font-size: 0.59rem;
  font-weight: 750;
  min-width: 0;
}

.quote-patent-field-grid label.is-wide {
  grid-column: 1/-1;
}

.quote-patent-field-grid input,
.quote-patent-field-grid textarea {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.42rem;
  color: #0f172a;
  display: block;
  font-size: 0.65rem;
  margin-top: 0.25rem;
  padding: 0.45rem 0.5rem;
  width: 100%;
}

.quote-patent-field-grid input:not([type=file]) {
  height: 2rem;
}

.quote-patent-field-grid input[type=file] {
  font-size: 0.58rem;
  padding: 0.35rem;
}

.quote-patent-field-grid textarea {
  line-height: 1.5;
  resize: vertical;
}

.quote-patent-file-status {
  color: #047857;
  display: inline-block;
  font-size: 0.56rem;
  margin-top: 0.35rem;
}

.quote-patent-logo-remove {
  color: #be123c;
  font-size: 0.56rem;
  font-weight: 750;
  margin-left: 0.5rem;
}

.is-hidden-for-patent {
  display: none !important;
}

.quote-patent-document {
  align-self: start;
  display: block;
  height: auto;
  justify-self: center;
  color: #111111;
  font-family: "SUIT", "Noto Sans KR", "Malgun Gothic", sans-serif;
}

.quote-patent-paper {
  background: #ffffff;
  height: 141.433cqw;
  min-height: 141.433cqw;
  padding: 9cqw 8.4cqw 6cqw;
  width: 100%;
}

.quote-patent-paper:not(.is-page-two) {
  padding: 0;
  position: relative;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-letterhead,
.quote-patent-paper:not(.is-page-two) .quote-patent-meta,
.quote-patent-paper:not(.is-page-two) .quote-patent-subject-row,
.quote-patent-paper:not(.is-page-two) .quote-patent-total-heading,
.quote-patent-paper:not(.is-page-two) .quote-patent-fee-section {
  left: 8.4%;
  margin-top: 0;
  position: absolute;
  right: 8.4%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-letterhead {
  top: 8.2%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-meta {
  top: 18.2%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-subject-row {
  top: 35.8%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-total-heading {
  top: 41.2%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-fee-section {
  top: 47.8%;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-fee-section h4 {
  margin: 0 0 1.35cqw;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-fee-section h5 {
  margin-bottom: 0.7cqw;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-fee-section .quote-patent-fee-table + h5 {
  margin-top: 2cqw;
}

.quote-patent-paper:not(.is-page-two) .quote-patent-fee-table th,
.quote-patent-paper:not(.is-page-two) .quote-patent-fee-table td {
  font-size: 1.25cqw;
  height: 2.85cqw;
  line-height: 1;
  padding-bottom: 0.5cqw;
  padding-top: 0.05cqw;
}

.quote-patent-letterhead {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.quote-patent-brand {
  align-items: center;
  display: flex;
  gap: 1.2cqw;
  min-width: 0;
  width: 58%;
}

.quote-patent-brand img,
.quote-patent-logo-placeholder {
  flex: 0 0 auto;
  height: 7.2cqw;
  object-fit: contain;
  width: 11cqw;
}

.quote-patent-logo-placeholder {
  align-items: center;
  border: 0.16cqw dashed #94a3b8;
  color: #94a3b8;
  display: flex;
  font-size: 1.45cqw;
  font-weight: 800;
  justify-content: center;
}

.quote-patent-brand strong {
  font-size: 2.85cqw;
  font-weight: 850;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.quote-patent-title {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}

.quote-patent-title span {
  font-size: 2.15cqw;
  font-weight: 650;
}

.quote-patent-title b {
  font-size: 5.2cqw;
  font-weight: 500;
  line-height: 1.05;
}

.quote-patent-meta {
  align-items: end;
  display: grid;
  gap: 2.5cqw;
  grid-template-columns: 32% minmax(0, 1fr);
  margin-top: 4cqw;
}

.quote-patent-recipient-box {
  border-bottom: 0.17cqw solid #111111;
  display: grid;
  font-size: 1.6cqw;
  gap: 0.45cqw;
  padding: 0 0.7cqw 0.9cqw;
}

.quote-patent-recipient-box strong {
  border-bottom: 0.17cqw solid #111111;
  font-size: 1.85cqw;
  font-weight: 850;
  margin: 0 -0.7cqw 0.4cqw;
  min-height: 3.6cqw;
  padding: 0 0.7cqw 0.55cqw;
}

.quote-patent-provider-table,
.quote-patent-fee-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.quote-patent-provider-table th,
.quote-patent-provider-table td {
  border: 0.14cqw solid #111111;
  font-size: 1.34cqw;
  height: 2.75cqw;
  line-height: 1;
  overflow: hidden;
  padding: 0 0.5cqw 0.4cqw;
  vertical-align: middle;
}

.quote-patent-provider-table th {
  font-weight: 650;
  text-align: center;
  width: 17%;
}

.quote-patent-provider-table td {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-patent-provider-table .is-provider {
  line-height: 1.3;
  padding: 0;
  width: 6%;
}

.quote-patent-subject-row {
  align-items: center;
  border-bottom: 0.18cqw solid #111111;
  border-top: 0.18cqw solid #111111;
  display: flex;
  font-size: 1.55cqw;
  justify-content: space-between;
  margin-top: 2.2cqw;
  min-height: 5cqw;
  padding: 0 0.7cqw;
}

.quote-patent-subject-row strong {
  font-weight: 700;
}

.quote-patent-total-heading {
  border-bottom: 0.18cqw solid #111111;
  font-size: 2.2cqw;
  font-weight: 800;
  margin-top: 1.6cqw;
  padding: 0.7cqw 0.7cqw 1.1cqw;
}

.quote-patent-total-heading span {
  font-size: 1.55cqw;
  font-weight: 650;
}

.quote-patent-fee-section h4,
.quote-patent-notes h4 {
  color: #ef1f1f;
  font-size: 1.9cqw;
  font-weight: 850;
  margin: 3.3cqw 0 1.8cqw;
}

.quote-patent-fee-section h5 {
  font-size: 1.75cqw;
  font-weight: 850;
  margin: 0 0 1cqw 0.8cqw;
}

.quote-patent-fee-section .quote-patent-fee-table + h5 {
  margin-top: 3cqw;
}

.quote-patent-fee-table th,
.quote-patent-fee-table td {
  border: 0.14cqw solid #222222;
  font-size: 1.35cqw;
  height: 3cqw;
  line-height: 1;
  padding: 0 0.42cqw 0.5cqw;
  text-align: center;
  vertical-align: middle;
}

.quote-patent-fee-table th:nth-child(1),
.quote-patent-fee-table td:nth-child(1) {
  width: 20%;
}

.quote-patent-fee-table thead th {
  background: #f1d7ec;
  font-weight: 600;
}

.quote-patent-fee-table tfoot th,
.quote-patent-fee-table tfoot td {
  background: #f8e9c8;
  font-weight: 600;
}

.quote-patent-fee-table tfoot tr:last-child th,
.quote-patent-fee-table tfoot tr:last-child td:not([rowspan]) {
  background: #e4f1ce;
}

.quote-patent-fee-table .is-money {
  text-align: right;
  white-space: nowrap;
}

.quote-patent-fee-table em {
  color: #ef1f1f;
  font-style: normal;
}

.quote-patent-paper.is-page-two {
  padding-top: 5.8cqw;
}

.quote-patent-paper.is-page-two .quote-patent-fee-section h4 {
  margin-top: 0;
}

.quote-patent-notes h4 {
  margin-bottom: 1.4cqw;
}

.quote-patent-notes ol {
  font-size: 1.55cqw;
  line-height: 1.7;
  margin: 0;
  padding-left: 4.5cqw;
}

.quote-patent-bank {
  font-size: 1.55cqw;
  margin: 1.7cqw 0 0 5.2cqw;
}

.quote-patent-bank strong {
  color: #ef1f1f;
  margin-left: 0.7cqw;
}

.quote-patent-signature {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 2.2cqw;
}

.quote-patent-signature strong {
  font-size: 3.1cqw;
  font-weight: 850;
}

.quote-patent-signature span {
  font-size: 1.65cqw;
  margin-top: 0.8cqw;
}

.quote-patent-disclaimer {
  background: #f8d8d8;
  border: 0.14cqw solid #222222;
  font-size: 1.4cqw;
  font-weight: 750;
  line-height: 1.45;
  margin-top: 4cqw;
  padding: 1.2cqw 1.4cqw;
}

.quote-patent-disclaimer p + p {
  margin-top: 0.35cqw;
}

.quote-derived-cost-row {
  border-top: 1px dashed #dbe4ee;
  padding-top: 0.65rem;
}

.quote-derived-cost-row:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.quote-derived-cost-row > strong {
  color: #334155;
  display: block;
  font-size: 0.61rem;
  font-weight: 800;
  margin-bottom: 0.45rem;
}

.quote-overseas-exchange-field {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.55rem;
  display: flex;
  gap: 0.65rem;
  justify-content: space-between;
  margin-bottom: 0.7rem;
  padding: 0.6rem;
}

.quote-overseas-exchange-field > div {
  display: grid;
  gap: 0.16rem;
  min-width: 0;
}

.quote-overseas-exchange-field span {
  color: #047857;
  font-size: 0.57rem;
  font-weight: 750;
}

.quote-overseas-exchange-field strong {
  color: #064e3b;
  font-size: 0.75rem;
  font-weight: 850;
}

.quote-overseas-exchange-field small {
  color: #047857;
  display: block;
  font-size: 0.56rem;
  font-weight: 600;
  line-height: 1.45;
  margin-top: 0.3rem;
}

.quote-overseas-exchange-field button {
  background: #ffffff;
  border: 1px solid #6ee7b7;
  border-radius: 0.42rem;
  color: #047857;
  flex: 0 0 auto;
  font-size: 0.57rem;
  font-weight: 800;
  padding: 0.46rem 0.55rem;
}

.quote-overseas-exchange-field button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.quote-derived-form-editor input[readonly] {
  background: #f1f5f9;
  color: #475569;
}

.quote-derived-document {
  align-self: start;
  color: #111111;
  display: block;
  font-family: "SUIT", "Noto Sans KR", "Malgun Gothic", sans-serif;
  height: auto;
  justify-self: center;
}

.quote-derived-paper {
  background: #ffffff;
  height: 141.433cqw;
  min-height: 141.433cqw;
  position: relative;
  width: 100%;
}

.quote-derived-letterhead,
.quote-derived-meta,
.quote-derived-subject,
.quote-derived-cost-section,
.quote-derived-notes,
.quote-derived-signature {
  left: 8.8%;
  margin: 0;
  position: absolute;
  right: 8.8%;
}

.quote-derived-letterhead {
  top: 7.5%;
}

.quote-derived-meta {
  top: 17.3%;
}

.quote-derived-subject {
  top: 34.1%;
}

.quote-derived-cost-section {
  top: 39.9%;
}

.quote-derived-cost-section.is-overseas,
.quote-derived-cost-section.is-integrated {
  top: 40.2%;
}

.quote-derived-letterhead .quote-patent-brand strong {
  font-size: 2.65cqw;
}

.quote-derived-meta.quote-patent-meta {
  margin-top: 0;
}

.quote-derived-meta .quote-patent-provider-table th,
.quote-derived-meta .quote-patent-provider-table td {
  font-size: 1.28cqw;
  height: 2.6cqw;
}

.quote-derived-subject.quote-patent-subject-row {
  margin-top: 0;
  min-height: 4.8cqw;
}

.quote-derived-total-heading {
  border-bottom: 0.16cqw solid #111111;
  font-size: 1.9cqw;
  font-weight: 850;
  min-height: 5.5cqw;
  padding: 0.8cqw 0.6cqw 1cqw;
}

.quote-derived-total-heading span {
  font-size: 1.45cqw;
  font-weight: 650;
}

.quote-derived-fee-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.quote-derived-total-heading + .quote-derived-fee-table {
  margin-top: 1.6cqw;
}

.quote-derived-fee-table th,
.quote-derived-fee-table td {
  border: 0.14cqw solid #222222;
  font-size: 1.25cqw;
  height: 3cqw;
  line-height: 1;
  overflow: hidden;
  padding: 0 0.4cqw 0.45cqw;
  text-align: center;
  vertical-align: middle;
}

.quote-derived-fee-table thead th,
.quote-derived-fee-table .is-agent-heading th {
  background: #f1d7ec;
  font-weight: 650;
}

.quote-derived-fee-table tfoot th,
.quote-derived-fee-table tfoot td {
  background: #f8e9c8;
  font-weight: 650;
}

.quote-derived-fee-table .is-grand-total th,
.quote-derived-fee-table .is-grand-total td {
  background: #e4f1ce;
}

.quote-derived-fee-table .is-money {
  text-align: right;
  white-space: nowrap;
}

.quote-derived-fee-table small {
  display: block;
  font-size: 1.05cqw;
  line-height: 1.2;
}

.quote-derived-madrid-table .is-group-label {
  background: #dedede;
  font-weight: 600;
  line-height: 1.35;
  width: 18%;
}

.quote-derived-madrid-table tbody td:last-child {
  line-height: 1.35;
  width: 18%;
}

.quote-derived-madrid-table tbody td {
  height: 3.15cqw;
}

.quote-derived-overseas-table tbody td {
  height: 5.1cqw;
}

.quote-derived-integrated-table tbody td {
  height: 3.15cqw;
}

.quote-derived-integrated-table th:first-child,
.quote-derived-integrated-table td:first-child {
  width: 20%;
}

.quote-derived-notes {
  font-size: 1.25cqw;
  line-height: 1.45;
  top: 73.2%;
}

.is-form-overseas-trademark .quote-derived-notes {
  top: 67.7%;
}

.quote-derived-notes p {
  margin: 0.35cqw 0;
}

.quote-derived-bank {
  font-size: 1.35cqw;
  margin-top: 2.8cqw !important;
  text-align: center;
}

.quote-derived-bank strong {
  color: #ef1f1f;
  margin-left: 0.7cqw;
}

.quote-derived-signature {
  top: 87.5%;
}

.is-form-overseas-trademark .quote-derived-signature {
  top: 84.5%;
}

.quote-derived-signature.quote-patent-signature {
  margin-top: 0;
}

.quote-derived-signature.quote-patent-signature strong {
  font-size: 2.75cqw;
}

.quote-derived-paper.is-page-two {
  padding: 9cqw 9.5cqw;
}

.quote-derived-page-two-notes {
  font-size: 1.55cqw;
  line-height: 1.75;
}

.quote-derived-page-two-notes p {
  margin: 0.45cqw 0;
}

.quote-derived-paper.is-page-two .quote-derived-bank {
  margin-top: 3cqw !important;
}

.quote-derived-paper.is-page-two .quote-derived-signature {
  left: 24%;
  right: 24%;
  top: 31%;
}

.quote-source-live-layer {
  inset: 0;
  isolation: isolate;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.quote-source-mask {
  background: #ffffff;
  display: block;
  outline: 0.35cqw solid #ffffff;
  position: absolute;
  z-index: 1;
}

.quote-source-mask.is-recipient-mask {
  height: 9.2%;
  left: 10.4%;
  top: 25.3%;
  width: 28%;
}

.quote-source-mask.is-provider-mask {
  height: 15.7%;
  left: 39.2%;
  top: 19.8%;
  width: 51.5%;
}

.quote-source-mask.is-subject-mask {
  height: 6.5%;
  left: 10.2%;
  top: 36%;
  width: 80%;
}

.quote-source-mask.is-cost-mask {
  height: 57%;
  left: 9.9%;
  top: 41%;
  width: 80.4%;
}

.quote-source-mask.is-notes-mask {
  height: 12.5%;
  left: 9.2%;
  top: 74%;
  width: 80.8%;
}

.quote-source-mask.is-signature-mask {
  height: 9%;
  left: 22%;
  top: 85.5%;
  width: 56%;
}

.quote-source-recipient,
.quote-source-provider,
.quote-source-subject,
.quote-source-cost-area,
.quote-source-notes,
.quote-source-signature {
  background: #ffffff;
  color: #111111;
  font-family: "Noto Sans KR", "Malgun Gothic", sans-serif;
  position: absolute;
  z-index: 2;
}

.quote-source-recipient {
  border-bottom: 0.16cqw solid #222222;
  display: flex;
  flex-direction: column;
  left: 10.8%;
  min-height: 7.2%;
  padding: 0.35cqw 0.9cqw 0.5cqw;
  top: 25.8%;
  width: 26.4%;
}

.quote-source-recipient strong {
  font-size: 1.85cqw;
  font-weight: 800;
  line-height: 1.35;
  margin-bottom: 0.55cqw;
  min-height: 2.2cqw;
}

.quote-source-recipient span {
  font-size: 1.45cqw;
  line-height: 1.55;
  min-height: 2cqw;
}

.quote-source-provider {
  border-collapse: collapse;
  height: 15%;
  left: 39.8%;
  table-layout: fixed;
  top: 20.4%;
  width: 50.2%;
}

.quote-source-provider th,
.quote-source-provider td {
  border: 0.12cqw solid #222222;
  font-size: 1.28cqw;
  height: 2.25cqw;
  line-height: 1.2;
  overflow: hidden;
  padding: 0.22cqw 0.48cqw;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-source-provider th {
  font-weight: 700;
  text-align: center;
  width: 17%;
}

.quote-source-provider td {
  width: 30%;
}

.quote-source-provider .quote-source-provider-label {
  line-height: 1.25;
  padding: 0;
  width: 6%;
}

.quote-source-subject {
  align-items: center;
  border-bottom: 0.18cqw solid #222222;
  border-top: 0.18cqw solid #222222;
  display: flex;
  justify-content: space-between;
  left: 10.6%;
  min-height: 4.8%;
  padding: 0 0.8cqw;
  top: 36.7%;
  width: 79.1%;
}

.quote-source-subject span {
  font-size: 1.5cqw;
}

.quote-source-subject strong {
  font-size: 1.5cqw;
  font-weight: 800;
  max-width: 58%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-source-cost-area {
  left: 10.6%;
  min-height: 43%;
  overflow: hidden;
  padding: 0.2cqw 0;
  top: 42.5%;
  width: 79.1%;
}

.quote-source-total {
  border-bottom: 0.14cqw solid #222222;
  font-size: 2cqw;
  font-weight: 800;
  min-height: 4.2cqw;
  padding: 0.6cqw 0.5cqw;
}

.quote-source-section-title {
  color: #e11d48;
  font-size: 1.75cqw;
  font-weight: 850;
  margin: 2.3cqw 0 1.2cqw;
}

.quote-source-cost-area .quote-paper-fee-matrix,
.quote-source-cost-area .quote-paper-country-matrix {
  margin-top: 0;
}

.quote-source-cost-area .quote-paper-fee-matrix th,
.quote-source-cost-area .quote-paper-fee-matrix td,
.quote-source-cost-area .quote-paper-country-matrix th,
.quote-source-cost-area .quote-paper-country-matrix td {
  border-color: #333333;
  font-size: 1.35cqw;
  height: 2.7cqw;
  padding: 0.3cqw 0.42cqw;
}

.quote-source-cost-area .quote-paper-fee-matrix thead th,
.quote-source-cost-area .quote-paper-country-matrix thead th {
  background: #f1d7ec;
}

.quote-source-cost-area .quote-paper-fee-matrix tfoot th,
.quote-source-cost-area .quote-paper-fee-matrix tfoot td,
.quote-source-cost-area .quote-paper-country-matrix tfoot th,
.quote-source-cost-area .quote-paper-country-matrix tfoot td {
  background: #f8e9c8;
}

.quote-source-cost-area .quote-paper-fee-matrix tfoot tr:last-child th,
.quote-source-cost-area .quote-paper-fee-matrix tfoot tr:last-child td,
.quote-source-cost-area .quote-paper-country-matrix tfoot tr:last-child th,
.quote-source-cost-area .quote-paper-country-matrix tfoot tr:last-child td {
  background: #e4f1ce;
}

.quote-source-secondary-matrix {
  margin-top: 3.1cqw;
}

.quote-source-secondary-matrix h5 {
  font-size: 1.65cqw;
  font-weight: 850;
  margin-bottom: 1cqw;
}

.quote-source-notes {
  font-size: 1.25cqw;
  left: 9.6%;
  line-height: 1.55;
  min-height: 10.5%;
  padding: 0.6cqw 0;
  top: 75.1%;
  width: 79.6%;
}

.quote-source-notes p {
  margin: 0.2cqw 0;
}

.quote-source-notes strong {
  display: block;
  font-size: 1.35cqw;
  margin-top: 2cqw;
  text-align: center;
}

.quote-source-signature {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 24%;
  min-height: 7.2%;
  top: 86.4%;
  width: 52%;
}

.quote-source-signature strong {
  font-size: 2.35cqw;
  font-weight: 800;
}

.quote-source-signature span {
  font-size: 1.45cqw;
  margin-top: 0.7cqw;
}

.quote-source-document.is-form-madrid .quote-source-recipient {
  left: 9.7%;
  top: 23.1%;
  width: 26.7%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-recipient-mask {
  height: 8%;
  left: 9.2%;
  top: 22.8%;
  width: 28%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-provider-mask {
  height: 14%;
  left: 38.3%;
  top: 19.3%;
  width: 51.5%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-subject-mask {
  height: 5.8%;
  left: 9.2%;
  top: 33.7%;
  width: 80%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-cost-mask {
  height: 34.8%;
  left: 9.2%;
  top: 39.4%;
  width: 80%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-notes-mask {
  height: 12.5%;
  left: 8.9%;
  top: 73.8%;
  width: 81%;
}

.quote-source-document.is-form-madrid .quote-source-mask.is-signature-mask {
  height: 8.5%;
  left: 20%;
  top: 86%;
  width: 60%;
}

.quote-source-document.is-form-madrid .quote-source-provider {
  height: 13.2%;
  left: 38.8%;
  top: 19.8%;
  width: 50.2%;
}

.quote-source-document.is-form-madrid .quote-source-subject {
  left: 9.7%;
  top: 34.2%;
  width: 79.2%;
}

.quote-source-document.is-form-madrid .quote-source-cost-area {
  height: 33.8%;
  left: 9.7%;
  min-height: 0;
  overflow: hidden;
  top: 39.9%;
  width: 79.2%;
}

.quote-source-document.is-form-madrid .quote-source-cost-area .quote-paper-country-matrix {
  height: 100%;
}

.quote-source-document.is-form-patent .quote-source-notes,
.quote-source-document.is-form-patent .quote-source-signature,
.quote-source-document.is-form-integrated .quote-source-notes,
.quote-source-document.is-form-integrated .quote-source-signature {
  display: none;
}

.quote-source-document.is-form-patent .quote-source-provider {
  height: 14.7%;
}

.quote-source-document.is-form-patent .quote-source-mask.is-provider-mask {
  height: 16%;
  left: 39.1%;
  top: 19.6%;
  width: 51.8%;
}

.quote-source-document.is-form-patent .quote-source-mask.is-cost-mask {
  height: 57.5%;
  left: 9.7%;
  top: 40.8%;
  width: 80.8%;
}

.quote-source-document.is-form-patent .quote-source-cost-area {
  height: 55.5%;
  min-height: 0;
  overflow: hidden;
  top: 42%;
}

.quote-source-document.is-form-integrated .quote-source-recipient {
  top: 24.6%;
  width: 28.1%;
}

.quote-source-document.is-form-integrated .quote-source-mask.is-recipient-mask {
  height: 8.5%;
  left: 11.7%;
  top: 24.1%;
  width: 29.5%;
}

.quote-source-document.is-form-integrated .quote-source-mask.is-provider-mask {
  height: 14%;
  left: 40.7%;
  top: 20.6%;
  width: 51.5%;
}

.quote-source-document.is-form-integrated .quote-source-mask.is-subject-mask {
  height: 5.5%;
  left: 11.6%;
  top: 34.8%;
  width: 79.5%;
}

.quote-source-document.is-form-integrated .quote-source-mask.is-cost-mask {
  height: 45.5%;
  left: 11.6%;
  top: 39.2%;
  width: 79.5%;
}

.quote-source-document.is-form-integrated .quote-source-provider {
  height: 13.2%;
  left: 41.2%;
  top: 21.1%;
  width: 50.2%;
}

.quote-source-document.is-form-integrated .quote-source-subject {
  left: 12.1%;
  top: 35.3%;
  width: 78.6%;
}

.quote-source-document.is-form-integrated .quote-source-cost-area {
  height: 44.5%;
  left: 12.1%;
  min-height: 0;
  overflow: hidden;
  top: 39.7%;
  width: 78.6%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-recipient-mask {
  height: 8.5%;
  left: 11.7%;
  top: 24.5%;
  width: 28.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-provider-mask {
  height: 14%;
  left: 40.5%;
  top: 20.5%;
  width: 51.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-subject-mask {
  height: 6%;
  left: 11.5%;
  top: 35%;
  width: 79.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-cost-mask {
  height: 34%;
  left: 11.5%;
  top: 41%;
  width: 79.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-notes-mask {
  height: 10%;
  left: 11.5%;
  top: 74%;
  width: 79.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-mask.is-signature-mask {
  height: 9%;
  left: 24%;
  top: 84%;
  width: 52%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-cost-area {
  height: 32%;
  min-height: 0;
  overflow: hidden;
  top: 42.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-notes {
  top: 72.5%;
}

.quote-source-document.is-form-overseas-trademark .quote-source-signature {
  top: 85%;
}

.quote-a4-sheet {
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16);
  color: #111827;
  display: flex;
  flex-direction: column;
  font-family: "Noto Sans KR", "Malgun Gothic", sans-serif;
  min-height: 67rem;
  padding: 3.25rem 3.4rem 2.8rem;
  width: min(100%, 47.5rem);
}

.quote-a4-sheet.is-example {
  min-height: 63rem;
}

.quote-paper-header {
  align-items: flex-end;
  border-bottom: 2px solid #0f172a;
  display: flex;
  justify-content: space-between;
  min-height: 5rem;
  padding-bottom: 1rem;
}

.quote-paper-header > div {
  display: flex;
  flex-direction: column;
  min-width: 12rem;
}

.quote-paper-header > div strong {
  font-size: 1rem;
  min-height: 1.5rem;
}

.quote-paper-header > div span {
  color: #475569;
  font-size: 0.68rem;
  min-height: 1rem;
}

.quote-paper-header h3 {
  font-size: 1.8rem;
  font-weight: 850;
  letter-spacing: 0.22em;
}

.quote-paper-meta {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: minmax(0, 0.75fr) minmax(0, 1.25fr);
  margin-top: 1.75rem;
}

.quote-paper-recipient {
  border-bottom: 1px solid #94a3b8;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 0.65rem;
}

.quote-paper-recipient strong {
  font-size: 0.83rem;
  min-height: 1.25rem;
}

.quote-paper-recipient span {
  color: #475569;
  font-size: 0.65rem;
  min-height: 1rem;
}

.quote-paper-meta table,
.quote-paper-cost-table {
  border-collapse: collapse;
  width: 100%;
}

.quote-paper-meta th,
.quote-paper-meta td {
  border: 1px solid #64748b;
  font-size: 0.62rem;
  height: 1.35rem;
  padding: 0.22rem 0.35rem;
}

.quote-paper-meta th {
  background: #f1f5f9;
  font-weight: 750;
  width: 4.5rem;
}

.quote-paper-subject {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.quote-paper-subject span {
  color: #475569;
  font-size: 0.67rem;
}

.quote-paper-subject strong {
  font-size: 0.75rem;
  min-height: 1.1rem;
  min-width: 11rem;
  text-align: right;
}

.quote-paper-form-section {
  color: #b91c1c;
  font-size: 0.7rem;
  font-weight: 850;
  margin-top: 1rem;
}

.quote-paper-total {
  border-bottom: 1px solid #64748b;
  border-top: 1px solid #64748b;
  font-size: 0.82rem;
  font-weight: 850;
  margin-top: 1rem;
  min-height: 2.5rem;
  padding: 0.7rem 0.3rem;
}

.quote-paper-cost-table {
  margin-top: 1rem;
  table-layout: fixed;
}

.quote-paper-cost-table th,
.quote-paper-cost-table td {
  border: 1px solid #64748b;
  font-size: 0.64rem;
  height: 1.8rem;
  padding: 0.35rem 0.45rem;
}

.quote-paper-cost-table thead th {
  background: #f3e8f2;
  font-weight: 800;
}

.quote-paper-cost-table th:nth-child(1) {
  width: 23%;
}

.quote-paper-cost-table th:nth-child(2) {
  width: 31%;
}

.quote-paper-cost-table th:nth-child(3) {
  width: 21%;
}

.quote-paper-cost-table th:nth-child(4) {
  width: 25%;
}

.quote-paper-cost-table tfoot th,
.quote-paper-cost-table tfoot td {
  background: #eef6df;
  font-weight: 800;
}

.quote-paper-fee-matrix {
  border-collapse: collapse;
  margin-top: 0.75rem;
  table-layout: fixed;
  width: 100%;
}

.quote-paper-fee-matrix th,
.quote-paper-fee-matrix td {
  border: 1px solid #64748b;
  font-size: 0.61rem;
  height: 1.65rem;
  padding: 0.3rem 0.38rem;
  vertical-align: middle;
}

.quote-paper-fee-matrix thead th {
  background: #f3e8f2;
  font-weight: 800;
  text-align: center;
}

.quote-paper-fee-matrix tbody td:nth-child(1),
.quote-paper-fee-matrix tbody td:nth-child(3) {
  width: 24%;
}

.quote-paper-fee-matrix tbody td:nth-child(2),
.quote-paper-fee-matrix tbody td:nth-child(4) {
  width: 16%;
}

.quote-paper-fee-matrix tbody td:nth-child(5) {
  width: 20%;
}

.quote-paper-fee-matrix tfoot th,
.quote-paper-fee-matrix tfoot td {
  background: #fbf3df;
  font-weight: 800;
}

.quote-paper-fee-matrix tfoot tr:last-child th,
.quote-paper-fee-matrix tfoot tr:last-child td {
  background: #eef6df;
}

.quote-paper-country-matrix {
  border-collapse: collapse;
  margin-top: 0.75rem;
  table-layout: fixed;
  width: 100%;
}

.quote-paper-country-matrix th,
.quote-paper-country-matrix td {
  border: 1px solid #64748b;
  font-size: 0.59rem;
  height: 1.65rem;
  padding: 0.3rem 0.35rem;
  vertical-align: middle;
}

.quote-paper-country-matrix thead th {
  background: #f3e8f2;
  font-weight: 800;
  text-align: center;
}

.quote-paper-country-matrix tfoot th,
.quote-paper-country-matrix tfoot td {
  background: #eef6df;
  font-weight: 800;
}

.quote-paper-country-matrix.is-madrid th:nth-child(1) {
  width: 18%;
}

.quote-paper-country-matrix.is-madrid th:nth-child(2) {
  width: 28%;
}

.quote-paper-country-matrix.is-madrid th:nth-child(3) {
  width: 18%;
}

.quote-paper-country-matrix.is-madrid th:nth-child(4) {
  width: 14%;
}

.quote-paper-country-matrix.is-madrid th:nth-child(5) {
  width: 22%;
}

.quote-paper-country-matrix.is-overseas-trademark th:nth-child(1) {
  width: 12%;
}

.quote-paper-country-matrix.is-overseas-trademark th:nth-child(2),
.quote-paper-country-matrix.is-overseas-trademark th:nth-child(4) {
  width: 20%;
}

.quote-paper-country-matrix.is-overseas-trademark th:nth-child(3),
.quote-paper-country-matrix.is-overseas-trademark th:nth-child(5) {
  width: 15%;
}

.quote-paper-country-matrix.is-overseas-trademark th:nth-child(6) {
  width: 18%;
}

.quote-a4-sheet.is-form-madrid .quote-paper-form-section {
  color: #9f1239;
}

.quote-a4-sheet.is-form-madrid .quote-paper-header {
  border-bottom-color: #7c2d12;
}

.quote-a4-sheet.is-form-madrid .quote-paper-total {
  display: none;
}

.quote-a4-sheet.is-form-integrated .quote-paper-form-section {
  color: #0f172a;
}

.quote-a4-sheet.is-form-integrated .quote-paper-fee-matrix tbody tr:nth-child(3n+1) td:first-child {
  border-left: 3px solid #334155;
}

.quote-a4-sheet.is-form-overseas-trademark .quote-paper-form-section {
  color: #b45309;
}

.quote-a4-sheet.is-form-overseas-trademark .quote-paper-header {
  border-bottom-color: #92400e;
}

.quote-paper-guide {
  margin-top: 1.5rem;
  min-height: 10rem;
}

.quote-paper-guide.is-compact {
  min-height: 6.5rem;
}

.quote-paper-guide > strong {
  color: #dc2626;
  font-size: 0.73rem;
}

.quote-paper-guide ol {
  list-style: decimal;
  margin: 0.65rem 0 0 1.15rem;
  min-height: 4rem;
}

.quote-paper-guide li,
.quote-paper-account {
  font-size: 0.66rem;
  line-height: 1.7;
}

.quote-paper-account {
  font-weight: 700;
  margin-top: 1rem;
  min-height: 1rem;
  text-align: center;
}

.quote-paper-signature {
  border-top: 1px solid #cbd5e1;
  font-size: 0.78rem;
  font-weight: 800;
  margin-top: auto;
  min-height: 3.5rem;
  padding-top: 1rem;
  text-align: center;
}

.quote-paper-continuation-header {
  align-items: flex-end;
  border-bottom: 2px solid #0f172a;
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
}

.quote-paper-continuation-header span {
  color: #475569;
  font-size: 0.72rem;
}

.quote-paper-continuation-header strong {
  font-size: 1.3rem;
}

.quote-paper-continuation-block {
  border: 1px solid #94a3b8;
  margin-top: 1.5rem;
  min-height: 13rem;
  padding: 1rem;
}

.quote-paper-continuation-block h4 {
  border-bottom: 1px solid #cbd5e1;
  font-size: 0.78rem;
  font-weight: 800;
  padding-bottom: 0.65rem;
}

.quote-paper-continuation-block p {
  font-size: 0.68rem;
  line-height: 1.8;
  margin-top: 1rem;
}

.quote-paper-blank-row {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  margin-top: 0.8rem;
}

.quote-paper-blank-row span {
  font-size: 0.65rem;
}

.quote-paper-blank-row i {
  border-bottom: 1px solid #e2e8f0;
  flex: 1;
  height: 0.75rem;
}

.quote-paper-page-number {
  color: #64748b;
  font-size: 0.65rem;
  margin-top: auto;
  text-align: center;
}

.quote-composer-page-shell {
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 1rem;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.08);
  min-width: 0;
  overflow-x: hidden;
}

.quote-composer-page-header {
  border-bottom: 1px solid #e2e8f0;
  margin: -1.25rem -1.25rem 0;
  padding: 1.1rem 1.25rem;
}

.quote-composer-back-button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  color: #334155;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 0.4rem;
  height: 2.25rem;
  padding: 0 0.85rem;
  transition: background 140ms ease, border-color 140ms ease, color 140ms ease;
}

.quote-composer-back-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}

.quote-composer-page-actions {
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #e2e8f0;
  bottom: 0;
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding: 1rem 1.25rem 0;
  position: sticky;
  z-index: 4;
}

.quote-compose-meta {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.9rem;
}

.quote-composer-layout {
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  max-width: 100%;
  min-width: 0;
}

.quote-composer-layout > * {
  max-width: 100%;
  min-width: 0;
}

.quote-applied-template-summary {
  background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
  border: 1px solid #a5b4fc;
  border-radius: 0.8rem;
  padding: 0.9rem 1rem;
}

.quote-applied-template-heading {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.quote-applied-template-heading h4 {
  color: #312e81;
  font-size: 0.85rem;
  font-weight: 800;
  margin-top: 0.2rem;
}

.quote-applied-template-heading p:not(.quote-composer-eyebrow) {
  color: #6366f1;
  font-size: 0.68rem;
  margin-top: 0.2rem;
}

.quote-applied-template-heading > strong {
  color: #312e81;
  flex-shrink: 0;
  font-size: 1rem;
}

.quote-applied-template-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.75rem;
}

.quote-applied-template-chip {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c7d2fe;
  border-radius: 9999px;
  color: #4338ca;
  display: inline-flex;
  font-size: 0.625rem;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.35rem 0.55rem;
}

.quote-applied-template-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-applied-template-chip strong {
  flex-shrink: 0;
}

.quote-part-library,
.quote-document-preview {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
  min-width: 0;
  padding: 1rem;
}

.quote-document-preview {
  background: #ffffff;
  border-color: #cbd5e1;
}

.quote-composer-section-heading {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.quote-composer-section-heading h4 {
  color: #0f172a;
  font-size: 0.875rem;
  font-weight: 750;
  line-height: 1.35;
  margin-top: 0.2rem;
}

.quote-composer-section-heading p:not(.quote-composer-eyebrow) {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
  margin-top: 0.25rem;
}

.quote-composer-eyebrow {
  color: #047857;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.quote-composer-selection-count,
.quote-live-badge {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 9999px;
  color: #047857;
  flex-shrink: 0;
  font-size: 0.625rem;
  font-weight: 800;
  padding: 0.35rem 0.6rem;
}

.quote-part-selector-list,
.quote-preview-stack {
  display: grid;
  gap: 0.75rem;
  margin-top: 1rem;
}

.quote-part-selector-row {
  align-items: stretch;
  border-top: 1px solid #e2e8f0;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: 6.5rem minmax(0, 1fr);
  padding-top: 0.75rem;
}

.quote-part-selector-row:first-child {
  border-top: 0;
  padding-top: 0;
}

.quote-part-selector-label {
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.75rem;
}

.quote-part-selector-label strong {
  color: #0f172a;
  font-size: 0.75rem;
}

.quote-part-selector-label span {
  color: #94a3b8;
  font-size: 0.6rem;
  line-height: 1.35;
  margin-top: 0.25rem;
}

.quote-part-option-list {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quote-part-option {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.65rem;
  min-height: 3.5rem;
  padding: 0.65rem 0.75rem;
  text-align: left;
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.quote-part-option:hover {
  border-color: #6ee7b7;
  transform: translateY(-1px);
}

.quote-part-option:focus-visible {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);
  outline: 2px solid #059669;
  outline-offset: 1px;
}

.quote-part-option.is-selected {
  background: #ecfdf5;
  border-color: #34d399;
  box-shadow: inset 0 0 0 1px #6ee7b7;
}

.quote-part-option.is-direct.is-selected {
  background: #f1f5f9;
  border-color: #94a3b8;
  box-shadow: inset 0 0 0 1px #cbd5e1;
}

.quote-part-option.is-combined.is-selected {
  background: #eef2ff;
  border-color: #6366f1;
  box-shadow: inset 0 0 0 1px #a5b4fc;
}

.quote-part-option.is-combined .quote-part-option-name {
  color: #312e81;
}

.quote-part-option.is-combined .quote-part-option-meta {
  color: #6366f1;
}

.quote-part-option-name,
.quote-part-option-meta {
  display: block;
}

.quote-part-option-name {
  color: #0f172a;
  font-size: 0.7rem;
  font-weight: 750;
  line-height: 1.35;
}

.quote-part-option-meta {
  color: #64748b;
  font-size: 0.6rem;
  margin-top: 0.25rem;
}

.quote-preview-card {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.7rem;
  padding: 0.85rem;
}

.quote-preview-card.is-title {
  border-top: 3px solid #047857;
}

.quote-preview-card-heading {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.quote-preview-card-heading > div {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  min-width: 0;
}

.quote-preview-part-label {
  background: #f1f5f9;
  border-radius: 0.35rem;
  color: #475569;
  font-size: 0.6rem;
  font-weight: 800;
  padding: 0.25rem 0.4rem;
}

.quote-preview-card-heading strong {
  color: #0f172a;
  font-size: 0.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-preview-edit-label {
  color: #059669;
  flex-shrink: 0;
  font-size: 0.6rem;
  font-weight: 750;
}

.quote-preview-textarea {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  font-size: 0.75rem !important;
  line-height: 1.65 !important;
  margin-top: 0.65rem;
  min-height: 4.75rem;
  padding: 0.7rem 0.75rem !important;
  resize: vertical;
  width: 100%;
}

.quote-cost-editor {
  margin-top: 0.65rem;
}

.quote-cost-table-wrap {
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.quote-cost-table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 0;
  table-layout: fixed;
  width: 100%;
}

.quote-cost-table th:nth-child(1) {
  width: 20%;
}

.quote-cost-table th:nth-child(2) {
  width: 27%;
}

.quote-cost-table th:nth-child(3) {
  width: 16%;
}

.quote-cost-table th:nth-child(4) {
  width: 29%;
}

.quote-cost-table th:nth-child(5) {
  width: 8%;
}

.quote-cost-table th {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 750;
  padding: 0.45rem;
  text-align: left;
}

.quote-cost-table td {
  border-bottom: 1px solid #f1f5f9;
  min-width: 0;
  padding: 0.35rem;
}

.quote-cost-table input,
.quote-cost-table select {
  font-size: 0.68rem !important;
  height: 2rem !important;
  padding-left: 0.45rem !important;
  padding-right: 1.25rem !important;
  min-width: 0;
  width: 100%;
}

.quote-cost-table .is-amount {
  text-align: right;
}

.quote-cost-table .is-manage {
  text-align: center;
}

.quote-cost-remove-button {
  border: 1px solid #fecdd3;
  border-radius: 0.4rem;
  color: #be123c;
  font-size: 0.6rem;
  height: 2rem;
  padding: 0 0.45rem;
}

.quote-cost-remove-button:disabled {
  opacity: 0.35;
}

.quote-cost-add-button {
  background: #064e3b;
  border-radius: 0.45rem;
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: 750;
  min-height: 2rem;
  padding: 0.4rem 0.65rem;
}

.quote-cost-total {
  text-align: right;
}

.quote-cost-total span {
  color: #64748b;
  font-size: 0.625rem;
  margin-right: 0.5rem;
}

.quote-cost-total strong {
  color: #064e3b;
  font-size: 0.85rem;
}

.quote-composer-total {
  align-items: center;
  background: #064e3b;
  border-radius: 0.75rem;
  color: #ffffff;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.quote-composer-total p {
  font-size: 0.75rem;
  font-weight: 800;
}

.quote-composer-total span {
  color: #a7f3d0;
  display: block;
  font-size: 0.625rem;
  margin-top: 0.15rem;
}

.quote-composer-total strong {
  font-size: 1.05rem;
}

@media (max-width: 1180px) {
  .quote-composer-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-template-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quote-document-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .standard-quote-detail-body {
    grid-template-columns: minmax(0, 1fr);
  }
  .standard-quote-detail-info {
    border-bottom: 1px solid #e2e8f0;
    border-right: 0;
  }
}
@media (max-width: 767px) {
  .quote-composer-page-shell {
    border-radius: 0.75rem;
  }
  .quote-composer-page-header {
    align-items: flex-start;
  }
  .quote-template-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-template-card {
    grid-template-columns: 6.25rem minmax(0, 1fr);
  }
  .standard-quote-detail-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .standard-quote-detail-header .workspace-primary-button {
    width: 100%;
  }
  .standard-quote-preview-stage,
  .quote-a4-scroll {
    padding: 0.75rem;
  }
  .quote-a4-sheet {
    min-height: 51rem;
    padding: 1.6rem 1.25rem;
  }
  .quote-paper-meta {
    gap: 0.75rem;
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-paper-header h3 {
    font-size: 1.25rem;
  }
  .quote-editor-inline-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-cost-table {
    min-width: 620px;
  }
  .quote-part-selector-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-part-selector-label {
    min-height: 3.5rem;
  }
  .quote-part-option-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-composer-section-heading,
  .quote-applied-template-heading,
  .quote-composer-total {
    align-items: flex-start;
    flex-direction: column;
  }
  .quote-applied-template-heading > strong {
    align-self: flex-end;
  }
  .quote-composer-total strong {
    align-self: flex-end;
  }
}
.quote-modular-workspace {
  border: 1px solid #dbe4ee;
  border-radius: 0.85rem;
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  min-width: 0;
  overflow: hidden;
}

.quote-modular-library,
.quote-modular-preview {
  min-width: 0;
}

.quote-modular-library {
  background: #ffffff;
  border-right: 1px solid #dbe4ee;
  padding: 1rem;
}

.quote-modular-heading,
.quote-modular-preview-heading,
.quote-part-selector-heading,
.quote-cost-sheet-toolbar,
.quote-composer-sticky-actions,
.quote-composer-action-buttons,
.quote-composer-action-summary {
  align-items: center;
  display: flex;
}

.quote-modular-heading,
.quote-modular-preview-heading,
.quote-part-selector-heading,
.quote-cost-sheet-toolbar,
.quote-composer-sticky-actions {
  justify-content: space-between;
}

.quote-modular-heading {
  gap: 1rem;
}

.quote-modular-heading h4,
.quote-modular-preview-heading h4 {
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 800;
  margin-top: 0.18rem;
}

.quote-modular-heading p:not(.quote-composer-eyebrow),
.quote-modular-preview-heading p:not(.quote-composer-eyebrow) {
  color: #64748b;
  font-size: 0.68rem;
  line-height: 1.55;
  margin-top: 0.25rem;
}

.quote-composition-summary,
.quote-modular-preview-summary {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.quote-composition-summary {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  margin-top: 0.9rem;
  padding: 0.55rem 0.65rem;
}

.quote-base-form-select {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  display: grid;
  gap: 0.65rem;
  grid-template-columns: 5.5rem minmax(0, 1fr);
  margin-top: 0.9rem;
  padding: 0.55rem 0.65rem;
}

.quote-base-form-select span {
  color: #475569;
  font-size: 0.62rem;
  font-weight: 800;
}

.quote-base-form-select select {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  color: #0f172a;
  font-size: 0.66rem;
  height: 2.1rem;
  padding: 0 0.55rem;
  width: 100%;
}

.quote-composition-summary strong {
  color: #047857;
  font-size: 0.62rem;
  margin-right: 0.15rem;
}

.quote-composition-summary span,
.quote-modular-preview-summary span {
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 0.4rem;
  color: #475569;
  font-size: 0.6rem;
  font-weight: 700;
  max-width: 100%;
  overflow: hidden;
  padding: 0.28rem 0.4rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quote-composition-summary i {
  color: #94a3b8;
  font-size: 0.62rem;
  font-style: normal;
}

.quote-part-selector {
  border-top: 1px solid #e2e8f0;
  margin-top: 0.9rem;
  padding-top: 0.9rem;
  scroll-margin-top: 6rem;
}

.quote-part-selector-heading {
  gap: 0.75rem;
}

.quote-part-selector-heading h5 {
  color: #0f172a;
  font-size: 0.76rem;
  font-weight: 800;
}

.quote-part-selector-heading p {
  color: #94a3b8;
  font-size: 0.6rem;
  margin-top: 0.15rem;
}

.quote-part-selected-status,
.quote-part-direct-status {
  border-radius: 9999px;
  flex-shrink: 0;
  font-size: 0.58rem;
  font-weight: 800;
  padding: 0.25rem 0.45rem;
}

.quote-part-selected-status {
  background: #ecfdf5;
  color: #047857;
}

.quote-part-direct-status {
  background: #f1f5f9;
  color: #64748b;
}

.quote-part-choice-grid {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 0.6rem;
}

.quote-part-choice {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.65rem;
  display: flex;
  flex-direction: column;
  min-height: 4.4rem;
  padding: 0.65rem 0.7rem;
  position: relative;
  text-align: left;
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.quote-part-choice:hover {
  border-color: #6ee7b7;
  transform: translateY(-1px);
}

.quote-part-choice:focus-visible {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);
  outline: 2px solid #059669;
  outline-offset: 1px;
}

.quote-part-choice.is-selected {
  background: #ecfdf5;
  border-color: #10b981;
  box-shadow: inset 0 0 0 1px #6ee7b7;
}

.quote-part-choice strong {
  color: #0f172a;
  font-size: 0.69rem;
  line-height: 1.35;
  padding-right: 1.25rem;
}

.quote-part-choice small {
  color: #64748b;
  display: -webkit-box;
  font-size: 0.59rem;
  line-height: 1.4;
  margin-top: 0.28rem;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.quote-part-choice em {
  align-self: flex-end;
  color: #047857;
  font-size: 0.56rem;
  font-style: normal;
  font-weight: 800;
  margin-top: auto;
  padding-top: 0.3rem;
}

.quote-office-info-editor {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 0.7rem;
  margin-top: 0.7rem;
  padding: 0.75rem;
}

.quote-office-info-editor-heading {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.quote-office-info-editor-heading strong {
  color: #0f172a;
  display: block;
  font-size: 0.72rem;
}

.quote-office-info-editor-heading p {
  color: #64748b;
  font-size: 0.58rem;
  line-height: 1.5;
  margin-top: 0.16rem;
}

.quote-office-info-editor-heading > span {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 9999px;
  color: #047857;
  flex-shrink: 0;
  font-size: 0.56rem;
  font-weight: 800;
  padding: 0.25rem 0.45rem;
}

.quote-office-info-group {
  border-top: 1px solid #e2e8f0;
  margin-top: 0.65rem;
  padding-top: 0.65rem;
}

.quote-office-info-group h6 {
  color: #334155;
  font-size: 0.62rem;
  font-weight: 800;
  margin-bottom: 0.45rem;
}

.quote-office-info-grid {
  display: grid;
  gap: 0.55rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quote-office-info-grid label {
  color: #475569;
  font-size: 0.58rem;
  font-weight: 700;
}

.quote-office-info-grid label.is-wide {
  grid-column: 1/-1;
}

.quote-office-info-grid input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  color: #0f172a;
  display: block;
  font-size: 0.64rem;
  height: 2.05rem;
  margin-top: 0.24rem;
  padding: 0 0.55rem;
  width: 100%;
}

.quote-office-info-grid input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
  outline: 0;
}

.quote-cost-sheet {
  background: #f8fafc;
  border: 1px solid #dbe4ee;
  border-radius: 0.65rem;
  margin-top: 0.65rem;
  overflow: hidden;
}

.quote-cost-sheet-toolbar {
  gap: 0.75rem;
  padding: 0.65rem 0.75rem;
}

.quote-cost-sheet-toolbar strong {
  color: #0f172a;
  font-size: 0.67rem;
}

.quote-cost-sheet-toolbar p {
  color: #64748b;
  font-size: 0.58rem;
  margin-top: 0.15rem;
}

.quote-cost-sheet-toolbar > span {
  color: #047857;
  flex-shrink: 0;
  font-size: 0.66rem;
  font-weight: 800;
}

.quote-cost-sheet-table-wrap {
  overflow-x: auto;
}

.quote-cost-sheet-table {
  border-collapse: collapse;
  min-width: 610px;
  table-layout: fixed;
  width: 100%;
}

.quote-cost-sheet-table th,
.quote-cost-sheet-table td {
  border-top: 1px solid #e2e8f0;
  padding: 0.35rem;
}

.quote-cost-sheet-table th {
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.58rem;
  font-weight: 800;
  text-align: left;
}

.quote-cost-sheet-table th:nth-child(1) {
  width: 20%;
}

.quote-cost-sheet-table th:nth-child(2) {
  width: 28%;
}

.quote-cost-sheet-table th:nth-child(3) {
  width: 17%;
}

.quote-cost-sheet-table th:nth-child(4) {
  width: 27%;
}

.quote-cost-sheet-table th:nth-child(5) {
  width: 8%;
}

.quote-cost-sheet-table input,
.quote-cost-sheet-table select {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.4rem;
  font-size: 0.63rem;
  height: 1.95rem;
  padding: 0 0.45rem;
  width: 100%;
}

.quote-cost-sheet-table input[type=number] {
  text-align: right;
}

.quote-cost-sheet-table td button {
  border: 1px solid #fecdd3;
  border-radius: 0.4rem;
  color: #be123c;
  font-size: 0.57rem;
  height: 1.9rem;
  padding: 0 0.45rem;
}

.quote-cost-sheet-table td button:disabled {
  opacity: 0.35;
}

.quote-cost-sheet-table tfoot td {
  background: #ecfdf5;
  color: #064e3b;
  font-size: 0.66rem;
  font-weight: 800;
}

.quote-cost-sheet-table tfoot button {
  background: #047857;
  border-color: #047857;
  color: #ffffff;
  float: right;
}

.quote-modular-preview {
  background: #f8fafc;
  padding: 1rem;
}

.quote-modular-preview-heading {
  gap: 1rem;
}

.quote-modular-preview-heading-actions {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.quote-modular-preview-heading-actions span {
  background: #ffffff;
  border: 1px solid #dbe4ee;
  border-radius: 9999px;
  color: #475569;
  font-size: 0.59rem;
  font-weight: 700;
  padding: 0.28rem 0.5rem;
}

.quote-modular-preview-heading-actions button {
  background: #047857;
  border-radius: 0.45rem;
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 800;
  height: 2rem;
  padding: 0 0.65rem;
}

.quote-modular-preview-summary {
  margin-top: 0.75rem;
}

.quote-modular-preview-summary span {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}

.quote-assembled-document {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  margin-top: 0.75rem;
  overflow: hidden;
}

.quote-assembled-section {
  border-top: 1px solid #dbe4ee;
  display: grid;
  grid-template-columns: 4.75rem minmax(0, 1fr);
}

.quote-assembled-section:first-child {
  border-top: 0;
}

.quote-assembled-section-label {
  background: #f8fafc;
  color: #64748b;
  font-size: 0.62rem;
  font-weight: 800;
  padding: 0.85rem 0.7rem;
}

.quote-assembled-section-body {
  color: #334155;
  font-size: 0.66rem;
  line-height: 1.65;
  min-width: 0;
  padding: 0.85rem;
}

.quote-assembled-section.is-title .quote-assembled-section-body {
  padding-bottom: 0.7rem;
  text-align: center;
}

.quote-assembled-office-title {
  color: #475569;
  font-size: 0.62rem;
  font-weight: 700;
}

.quote-assembled-section.is-title h3 {
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 850;
  margin-top: 0.25rem;
}

.quote-assembled-title-rule {
  background: #047857;
  height: 2px;
  margin-top: 0.65rem;
  width: 100%;
}

.quote-assembled-recipient {
  display: grid;
  gap: 0.15rem;
  grid-template-columns: minmax(0, 1fr) auto;
  margin-bottom: 0.65rem;
}

.quote-assembled-recipient strong {
  color: #0f172a;
  font-size: 0.72rem;
  grid-row: span 2;
}

.quote-assembled-recipient span {
  color: #64748b;
  font-size: 0.58rem;
}

.quote-assembled-info-table,
.quote-assembled-cost-table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.quote-assembled-info-table th,
.quote-assembled-info-table td,
.quote-assembled-cost-table th,
.quote-assembled-cost-table td {
  border: 1px solid #cbd5e1;
  padding: 0.35rem 0.45rem;
}

.quote-assembled-info-table th {
  background: #f8fafc;
  color: #475569;
  width: 5rem;
}

.quote-assembled-cost-table th {
  background: #f1f5f9;
  color: #475569;
  font-size: 0.59rem;
  text-align: left;
}

.quote-assembled-cost-table th:nth-child(1) {
  width: 21%;
}

.quote-assembled-cost-table th:nth-child(2) {
  width: 31%;
}

.quote-assembled-cost-table th:nth-child(3) {
  width: 20%;
}

.quote-assembled-cost-table th:nth-child(4) {
  width: 28%;
}

.quote-assembled-cost-table tfoot th,
.quote-assembled-cost-table tfoot td {
  background: #eff6d8;
  color: #1e3a2f;
  font-weight: 800;
}

.quote-assembled-part-copy {
  margin-top: 0.6rem;
}

.quote-assembled-account {
  border-top: 1px dashed #cbd5e1;
  color: #0f172a;
  font-weight: 700;
  margin-top: 0.65rem;
  padding-top: 0.55rem;
}

.quote-assembled-section.is-seal .quote-assembled-section-body {
  text-align: center;
}

.quote-assembled-section.is-seal strong {
  color: #0f172a;
  font-size: 0.76rem;
}

.quote-assembled-editor {
  margin-top: 0.55rem;
  text-align: left;
}

.quote-assembled-editor summary,
.quote-assembled-edit-link {
  color: #047857;
  cursor: pointer;
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 800;
  text-decoration: none;
}

.quote-assembled-edit-link.is-prominent,
.quote-assembled-editor summary {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 0.4rem;
  padding: 0.28rem 0.48rem;
}

.quote-assembled-edit-link.is-prominent {
  margin-top: 0.55rem;
}

.quote-assembled-editor summary {
  list-style: none;
}

.quote-assembled-editor summary::-webkit-details-marker {
  display: none;
}

.quote-assembled-editor[open] summary {
  margin-bottom: 0.55rem;
}

.quote-assembled-editor-fields {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  display: grid;
  gap: 0.55rem;
  padding: 0.65rem;
}

.quote-assembled-editor-fields.is-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quote-assembled-editor-fields label {
  color: #475569;
  font-size: 0.58rem;
  font-weight: 700;
}

.quote-assembled-editor-fields label.is-wide {
  grid-column: 1/-1;
}

.quote-assembled-editor-fields input,
.quote-assembled-editor-fields select,
.quote-assembled-editor-fields textarea {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.4rem;
  color: #0f172a;
  display: block;
  font-size: 0.65rem;
  margin-top: 0.25rem;
  padding: 0.45rem 0.5rem;
  width: 100%;
}

.quote-assembled-editor-fields input {
  height: 2rem;
}

.quote-assembled-editor-fields select {
  height: 2rem;
}

.quote-modular-preview.is-fullscreen {
  border: 1px solid #cbd5e1;
  border-radius: 0.9rem;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.24);
  inset: 1rem;
  overflow-y: auto;
  position: fixed;
  z-index: 80;
}

.quote-modular-preview.is-fullscreen .quote-modular-preview-heading,
.quote-modular-preview.is-fullscreen .quote-modular-preview-summary,
.quote-modular-preview.is-fullscreen .quote-assembled-document {
  margin-left: auto;
  margin-right: auto;
  max-width: 920px;
}

.quote-composer-sticky-actions {
  gap: 1rem;
  padding-bottom: 1rem;
}

.quote-composer-action-summary {
  gap: 0.55rem;
}

.quote-composer-action-summary span {
  color: #64748b;
  font-size: 0.66rem;
}

.quote-composer-action-summary strong {
  color: #047857;
  font-size: 0.92rem;
}

.quote-composer-action-buttons {
  gap: 0.5rem;
}

.quote-action-secondary,
.quote-action-primary {
  border-radius: 0.5rem;
  font-size: 0.7rem;
  font-weight: 800;
  height: 2.35rem;
  padding: 0 0.9rem;
}

.quote-action-secondary {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
}

.quote-action-secondary:hover {
  background: #f8fafc;
}

.quote-action-secondary.is-emphasis {
  border-color: #34d399;
  color: #047857;
}

.quote-action-secondary.is-pdf {
  border-color: #0f766e;
  color: #0f766e;
}

.quote-action-secondary.is-pdf:hover {
  background: #f0fdfa;
}

.quote-action-secondary:disabled {
  cursor: wait;
  opacity: 0.55;
}

.quote-action-primary {
  background: #047857;
  color: #ffffff;
  min-width: 8rem;
}

.quote-action-primary:hover {
  background: #065f46;
}

@media (max-width: 1180px) {
  .quote-modular-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-modular-library {
    border-bottom: 1px solid #dbe4ee;
    border-right: 0;
  }
}
@media (max-width: 767px) {
  .quote-part-choice-grid,
  .quote-office-info-grid,
  .quote-assembled-editor-fields.is-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-office-info-grid label.is-wide,
  .quote-assembled-editor-fields label.is-wide {
    grid-column: auto;
  }
  .quote-office-info-editor-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .quote-assembled-section {
    grid-template-columns: minmax(0, 1fr);
  }
  .quote-assembled-section-label {
    border-bottom: 1px solid #e2e8f0;
    padding: 0.5rem 0.7rem;
  }
  .quote-composer-sticky-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .quote-composer-action-summary {
    justify-content: space-between;
  }
  .quote-composer-action-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .quote-action-secondary,
  .quote-action-primary {
    width: 100%;
  }
  .quote-modular-preview.is-fullscreen {
    border-radius: 0;
    inset: 0;
  }
}
.annuity-card {
  min-height: 7.25rem;
}

.case-detail-page input[type=date]:not([data-auto-date=true]) {
  cursor: pointer;
}

.case-detail-page input[type=date]:not([data-auto-date=true])::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 1;
}

.case-detail-page input[type=date][data-auto-date=true] {
  cursor: default;
}

.case-detail-page input[type=date][data-auto-date=true]::-webkit-calendar-picker-indicator {
  opacity: 0.35;
  pointer-events: none;
}

.annuity-view-button {
  align-items: center;
  background: #047857;
  border: 1px solid #047857;
  border-radius: 0.45rem;
  color: #ffffff;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 750;
  height: 1.9rem;
  justify-content: center;
  padding: 0 0.65rem;
  transition: background 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.annuity-view-button:hover {
  background: #065f46;
  border-color: #065f46;
}

.annuity-view-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.22);
  outline: none;
}

.annuity-modal {
  max-height: calc(100vh - 3rem);
  overflow-y: auto;
}

.annuity-table-shell {
  max-height: min(54vh, 36rem);
  overflow: auto;
}

.annuity-table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.annuity-table tbody tr:hover {
  background: #f8fafc;
}

.annuity-payment-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 750;
  justify-content: center;
  min-width: 5.2rem;
  padding: 0.28rem 0.55rem;
}

.annuity-payment-status.is-paid {
  background: #d1fae5;
  color: #065f46;
}

.annuity-payment-status.is-pending {
  background: #f1f5f9;
  color: #64748b;
}

.renewal-card {
  min-height: 7.25rem;
}

.renewal-view-button {
  align-items: center;
  background: #6d28d9;
  border: 1px solid #6d28d9;
  border-radius: 0.45rem;
  color: #ffffff;
  display: inline-flex;
  font-size: 0.6875rem;
  font-weight: 750;
  height: 1.9rem;
  justify-content: center;
  padding: 0 0.65rem;
  transition: background 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.renewal-view-button:hover {
  background: #5b21b6;
  border-color: #5b21b6;
}

.renewal-view-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.22);
  outline: none;
}

.renewal-term-option {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 0.45rem;
  color: #475569;
  cursor: pointer;
  display: flex;
  font-size: 0.6875rem;
  font-weight: 700;
  gap: 0.4rem;
  justify-content: center;
  min-height: 2rem;
  padding: 0.35rem 0.5rem;
}

.renewal-term-option.is-selected {
  background: #f5f3ff;
  border-color: #8b5cf6;
  color: #5b21b6;
}

.renewal-term-option:has(input:disabled) {
  cursor: default;
  opacity: 0.7;
}

.renewal-modal {
  max-height: calc(100vh - 3rem);
  overflow-y: auto;
}

.renewal-table-shell {
  max-height: min(48vh, 28rem);
  overflow: auto;
}

.renewal-table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.renewal-table tbody tr:hover {
  background: #fafafa;
}

.renewal-payment-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.625rem;
  font-weight: 750;
  justify-content: center;
  min-width: 5.6rem;
  padding: 0.28rem 0.55rem;
}

.renewal-payment-status.is-paid {
  background: #ede9fe;
  color: #5b21b6;
}

.renewal-payment-status.is-pending {
  background: #f1f5f9;
  color: #64748b;
}

@media (max-width: 767px) {
  .annuity-modal {
    max-height: calc(100vh - 1rem);
  }
  .renewal-modal {
    max-height: calc(100vh - 1rem);
  }
}
@media (max-width: 1199px) {
  .business-form-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .business-field,
  .business-field-wide {
    grid-column: span 3;
  }
  .business-field-period,
  .business-field-contact,
  .business-field-full {
    grid-column: 1/-1;
  }
}
@media (max-width: 767px) {
  .business-project-form,
  .business-project-list {
    padding: 1rem;
  }
  .business-section-heading,
  .business-attachment-heading,
  .business-search-bar,
  .business-table-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .business-form-grid {
    display: block;
  }
  .business-field + .business-field {
    margin-top: 0.8rem;
  }
  .business-period-inputs,
  .business-contact-inputs {
    grid-template-columns: 1fr;
  }
  .business-period-inputs b {
    display: none;
  }
  .business-attachment-button,
  .business-search-control {
    justify-content: center;
    max-width: none;
    width: 100%;
  }
  .business-attachment-list {
    grid-template-columns: 1fr;
  }
  .business-form-actions .workspace-secondary-button,
  .business-form-actions .workspace-primary-button {
    flex: 1;
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public query: string = '';
    public caseSearchQuery: string = '';
    public caseNumberSearchQuery: string = '';
    public caseFilingSort: string = 'desc';
    public consultationTypeFilter: string = '';
    public consultationConsultantQuery: string = '';
    public consultationApplicationNoQuery: string = '';
    public consultationRegistrationNoQuery: string = '';
    public clientSearchQuery: string = '';
    public activeWorkspace: string = 'dashboard';
    public selectedWorkCard: string = 'domestic';
    public selectedCase: any = null;
    public caseDetailReturnCategory: string = 'domestic';
    public caseDetailReturnWorkspace: string = 'cases';
    public selectedClient: any = null;
    public clientDetailLoading: boolean = false;
    public clientDetailError: string = '';
    public selectedConsultation: any = null;
    public selectedInfoItem: any = null;
    public selectedInfoWorkspace: string = 'notices';
    public selectedCaseTab: string = 'documents';
    public selectedDeadlineDate: string = '';
    public selectedDeadlineStatus: string = '';
    public isCaseSummaryEditing: boolean = false;
    public infoSearchQuery: string = '';
    public infoCategoryFilter: string = 'all';
    public infoPage: number = 1;
    public infoPageSize: number = 5;
    public casePage: number = 1;
    public casePageSize: number = 10;
    public caseTotalCount: number = 0;
    public clientPage: number = 1;
    public clientPageSize: number = 20;
    public clientTotalCount: number = 0;
    public clientDirectoryTotalCount: number = 0;
    public clientListError: string = '';
    public clientStatusFilter: string = '';
    public clientStatusOptions: any[] = [
        { code: 'ACTIVE', label: '활성' },
        { code: 'INACTIVE', label: '비활성' }
    ];
    public clientGroupFilter: string = '';
    public clientGroupOptions: string[] = ['출원인', '기업담당자', '서류수령자', '상담자', '의뢰인'];
    public clientGroupCounts: any = {};
    public clientMailSelectedIds: string[] = [];
    public clientMailSending: boolean = false;
    public clientMailHistoryLoading: boolean = false;
    public clientMailHistoryError: string = '';
    public clientMailHistory: any[] = [];
    public clientMailDraft: any = {
        scope: 'all',
        subject: '',
        content: '',
        files: []
    };
    public clientMailPickerOpen: boolean = false;
    public clientMailPickerLoading: boolean = false;
    public clientMailPickerItems: any[] = [];
    public clientMailPickerSearch: string = '';
    public clientMailPickerGroup: string = '';
    public clientMailPickerPage: number = 1;
    public clientMailPickerPageSize: number = 10;
    public clientMailPickerTotalCount: number = 0;
    public rightPage: number = 1;
    public rightPageSize: number = 20;
    public rightTotalCount: number = 0;
    public rightSearchQuery: string = '';
    public rightStatusFilter: string = '';
    public rightTypeFilter: string = '';
    public rightStatusOptions: string[] = [];
    private caseSearchTimer: any = null;
    private clientSearchTimer: any = null;
    private clientMailPickerSearchTimer: any = null;
    private rightSearchTimer: any = null;
    private accessHeartbeatTimer: any = null;
    public selectedDeadlinePage: number = 1;
    public selectedDeadlinePageSize: number = 4;
    public weekDeadlinePage: number = 1;
    public weekDeadlinePageSize: number = 5;
    public activeRegistrationStep: number = 1;
    public activeConsultationRegistrationTab: string = 'common';
    public showRegistrationForm: boolean = false;
    public showRegistrationAdditionalForm: boolean = false;
    public showDocumentForm: boolean = false;
    public showAnnuityHistory: boolean = false;
    public annuitySaving: boolean = false;
    private annuityEditSnapshot: any = null;
    public showTrademarkRenewalHistory: boolean = false;
    public trademarkRenewalSaving: boolean = false;
    private trademarkRenewalEditSnapshot: any = null;
    public showCaseDeleteConfirm: boolean = false;
    public showInfoUploadForm: boolean = false;
    public showQuoteForm: boolean = false;
    public quoteComposerReturnWorkspace: string = 'standardQuotes';
    public selectedStandardQuoteTemplate: any = null;
    public showConsultationForm: boolean = false;
    public showConsultationDraftHistory: boolean = false;
    public showSelectedConsultationHistory: boolean = false;
    public showCaseConsultationHistory: boolean = false;
    public showCaseChangeHistory: boolean = false;
    public caseChangeHistoryLoading: boolean = false;
    public caseChangeHistory: any[] = [];
    public showAdminSupportForm: boolean = false;
    public showClientMailForm: boolean = false;
    public showClientMailHistory: boolean = false;
    public showFavoriteClientForm: boolean = false;
    public activeConsultationSidePanel: string = 'pull';
    public consultationClientSearchQuery: string = '';
    public pendingConsultationTransfer: any = null;
    public adminSupportSearchQuery: string = '';
    public adminSupportError: string = '';
    public adminNoticeItems: any[] = [];
    public adminNoticeLoading: boolean = false;
    public adminNoticeErrorCode: string = '';
    public readonly adminNoticeFrontendRevision: string = '20261009-admin-notice-detail-roles-v4';
    public adminNoticeLoaded: boolean = false;
    public adminNoticeState: string = 'idle';
    public adminNoticeStateMessage: string = '';
    public adminNoticePage: number = 1;
    public adminNoticeLimit: number = 20;
    public adminNoticeTotalCount: number = 0;
    public adminNoticeHasNext: boolean = false;
    public adminNoticeDetailLoading: boolean = false;
    public adminNoticeDetailError: string = '';
    public adminNoticeDetailErrorCode: string = '';
    public selectedAdminNoticeRevisionNo: number | null = null;
    public selectedAdminNoticeDeliveryId: string = '';
    public adminNoticePdfBusyId: string = '';
    public adminNoticeDownloadBusyId: string = '';
    public adminNoticePdfError: string = '';
    public adminNoticePreviewMessageId: string = '';
    public adminNoticePreviewUrl: string = '';
    public adminNoticePreviewSafeUrl: SafeResourceUrl | null = null;
    public caseDeleteConfirmText: string = '';
    public documentFormMode: string = 'add';
    public documentUploadCategory: string = '출원심사서류';
    public documentUploading: boolean = false;
    public documentUploadProgress: number = 0;
    public documentFileUsage: any = {
        used_bytes: 0,
        quota_bytes: 0,
        max_file_size_bytes: 50 * 1024 * 1024
    };
    public documentDraft: any = {
        id: '',
        uploadedAt: '',
        category: '출원심사서류',
        name: '',
        fileName: '',
        uploader: '',
        note: '',
        dueDate: '',
        deadlineRule: 'manual',
        deadlineTask: '',
        deadlineAssignee: '',
        file: null
    };
    public businessProjects: any[] = [];
    public businessSearchQuery: string = '';
    public businessDraft: any = this.emptyBusinessProject();
    public businessFormMode: string = 'add';
    public businessAttachmentBusy: boolean = false;

    public today: string = this.dateKey(new Date());
    public consultationDraft: any = this.emptyConsultationDraft();
    public consultationHistoryDraft: any = this.emptyConsultationHistoryDraft();
    public infoUploadDraft: any = {
        workspace: 'notices',
        title: '',
        date: this.today,
        category: '사무소 공지',
        source: '',
        publisher: '',
        updated: this.today,
        format: '',
        fileName: '',
        file: null,
        uploader: '',
        summary: '',
        scope: 'admin',
        pinned: false,
        pinnedAt: ''
    };
    public infoDetailAttachmentDraft: any = {
        file: null,
        fileName: '',
        note: ''
    };
    public quoteDraft: any = {
        source: '',
        clientName: '',
        rightType: '특허/실용신안',
        caseType: '국내출원',
        templateId: 'patent-domestic',
        standardFormId: 'form-patent',
        selectedTemplateIds: [],
        authoringMode: 'standard',
        selectedPartIds: { title: '', info: '', cost: '', guide: '', seal: '' },
        parts: { title: '', info: '', guide: '', seal: '' },
        costItems: [],
        officialFee: 0,
        serviceFee: 0,
        vat: 0,
        etcFee: 0,
        officeName: '',
        officeSubtitle: '',
        officeRegistrationNo: '',
        representative: '',
        officeAddress: '',
        officePhone: '',
        officeEmail: '',
        recipient: '',
        recipientEmail: '',
        quoteNo: '',
        quoteDate: '',
        subject: '',
        validity: '',
        accountInfo: '',
        guide: '',
        sealText: ''
    };
    public consultationQuoteStatusMessage: string = '';
    public quoteFullPreviewOpen: boolean = false;
    public quotePdfPrinting: boolean = false;
    public quoteExchangeRateLoading: boolean = false;
    public quoteExchangeRateStatus: string = '';
    private quotePdfFrame: HTMLIFrameElement | null = null;
    public dashboardApiErrorMessage: string = '';
    public standardQuotePartTypes: any[] = [
        { id: 'title', label: '1. 타이틀', description: '사무소명과 견적서 제목' },
        { id: 'info', label: '2. 정보', description: '수신인·공급자·견적 기본정보' },
        { id: 'cost', label: '3. 비용', description: '관납료·수임료 등 자유 비용행' },
        { id: 'guide', label: '4. 안내', description: '참고·확인사항과 계좌 안내' },
        { id: 'seal', label: '5. 직인', description: '대표자·직인 표시 문구' }
    ];
    public standardQuoteParts: any[] = [];
    public activeStandardQuotePartType: string = 'title';
    public standardQuotePartDraft: any = {
        id: '', partType: 'title', name: '', content: '', costItems: [], sortOrder: 0
    };
    public standardQuotePartSaving: boolean = false;
    public adminSupportDraft: any = this.emptyAdminSupportDraft();
    public dashboard: any = {
        cards: [], calendar: {}, notices: [], laws: [], media: [], forms: [], resourceCounts: {},
        coreNoticesStatus: { available: true, code: 'OK', message: '', count: 0 },
        coreContentStatus: {}
    };
    public consultations: any[] = [];
    public cases: any[] = [];
    public clients: any[] = [];
    public rightRecords: any[] = [];
    public quotes: any[] = [];
    public deadlines: any[] = [];
    public calendarWeeks: any[][] = [];
    public favoriteClientRecords: any[] = [];
    public favoritePatentClientNos: string[] = [];
    public selectedFavoriteClient: any = null;
    public favoriteClientCases: any[] = [];
    public favoriteCasePage: number = 1;
    public favoriteCasePageSize: number = 20;
    public favoriteCaseTotalCount: number = 0;
    public favoriteClientSaving: boolean = false;
    public favoriteClientDraft: any = {
        patentClientNo: '',
        applicant: '',
        note: ''
    };
    public adminConsultations: any[] = [];
    public staffAccess: any[] = [];
    public selectedAdminConsultation: any = null;
    public selectedAdminConsultationAnswer: any = null;

    public weekdays: string[] = ['월', '화', '수', '목', '금', '토', '일'];
    public caseCategories: any[] = [
        { id: 'consultation', label: '상담/행정' },
        { id: 'domestic', label: '국내출원' },
        { id: 'dispute', label: '이의/심판/소송' },
        { id: 'foreign', label: '해외출원' }
    ];
    public topMenus: any[] = [
        { id: 'clients', label: '고객리스트' },
        { id: 'favoriteClients', label: '관심고객' },
        { id: 'standardQuotes', label: '표준견적서' },
        { id: 'businessManagement', label: '사업관리' },
        { id: 'ipMarket', label: 'IP-MARKET' },
        { id: 'ipo', label: '지식재산처' },
        { id: 'kipris', label: 'KIPRIS' }
    ];
    public caseTabs: any[] = [
        { id: 'documents', label: '서류정보' },
        { id: 'common', label: '공통정보' },
        { id: 'additional', label: '추가정보' },
        { id: 'memos', label: '메모' },
        { id: 'consultation', label: '상담내용' },
        { id: 'quote', label: '견적서' }
    ];
    public caseStages: string[] = ['상담/접수', '출원/심사', '등록', '거절', '중단', '심판', '소송'];
    public detailedCaseStatuses: string[] = ['심사중', '출원공고', '우선심사신청', '우선심사결정', '의견제출', '답변제출', '등록결정', '등록납부', '중단·포기', '거절결정', '직접입력'];
    public rights: string[] = ['특허/실용신안', '상표', '디자인'];
    public caseStageFilter: string = '';
    public caseRightFilter: string = '';
    public caseApplicantScope: string = 'all';
    public caseApplicantKeyword: string = '';
    public disputeSummaryCounts: any = { all: 0, objection: 0, trial: 0, litigation: 0 };
    public applicantScopeOptions: any[] = [
        { id: 'all', label: '출원인 범위 전체' },
        { id: 'registered', label: '출원인 등록 건' },
        { id: 'missing', label: '출원인 미등록 건' },
        { id: 'different', label: '고객명과 다른 건' }
    ];
    public domesticRightOptions: any[] = [
        { value: '', label: '권리 전체' },
        { value: '특허', label: '특허' },
        { value: '실용신안', label: '실용신안' },
        { value: '상표', label: '상표' },
        { value: '디자인', label: '디자인' }
    ];
    public foreignRightOptions: any[] = [
        { value: '', label: '권리 전체' },
        { value: '특허/실용신안', label: '특허' },
        { value: '상표', label: '상표' },
        { value: '디자인', label: '디자인' }
    ];
    public foreignEntryTypeOptions: string[] = ['PCT', '마드리드', '헤이그', '개별국'];
    public foreignCurrentStatusOptions: string[] = ['WIPO', '각국진입', '포기·취하'];
    public foreignProgressStatusOptions: string[] = ['심사중', '의견제출', '답변제출', '포기·취하', '등록결정', '거절결정', '직접입력'];
    public disputeRelationTypes: any[] = [
        { value: '1', label: '1. 제3자가 우리 고객의 특정 사건에 제기', description: '우리 고객의 등록사건이 공격 대상이 되는 형태입니다.' },
        { value: '2', label: '2. 우리 고객이 자신의 특정 사건을 매개로 제기', description: '우리 고객 사건과 제3자의 등록사건이 함께 연결되는 형태입니다.' },
        { value: '3', label: '3. 우리 고객이 매개 사건 없이 제3자 사건에 제기', description: '우리 고객의 연결 사건 없이 제3자의 등록사건만 대상으로 입력합니다.' }
    ];
    public disputeStatusOptions: string[] = ['이의', '심판', '소송'];
    public disputeCategoryOptions: string[] = ['이의', '무효', '취소', '불복', '확인', '침해'];
    public disputeTrialCategoryOptions: string[] = ['무효', '취소', '불복', '확인', '침해'];
    public disputeRightOptions: string[] = ['특허', '실용', '상표', '디자인'];
    public disputeInstitutionOptions: string[] = ['특허심판원', '특허법원', '대법원'];
    public registrationRightTabs: string[] = ['특허/실용신안', '상표', '디자인'];
    public caseTypeOptions: string[] = ['국내출원', '해외출원', '이의/심판/소송'];
    public consultationTypeOptions: string[] = ['출원/등록', '이의/심판/소송', '해외출원', '연차(특허·실용, 디자인)', '갱신(상표)', '경고장/확인서', '권리이전', '기타'];
    public consultationRegistrationTabs: any[] = [
        { id: 'common', label: '공통정보' },
        { id: 'contacts', label: '관계인정보' },
        { id: 'additional', label: '사건상세' }
    ];
    public consultationSidePanelTabs: any[] = [
        { id: 'pull', label: '끌어오기' },
        { id: 'history', label: '상담이력' },
        { id: 'quote', label: '견적서' }
    ];
    public adminSupportCategories: string[] = ['일반상담', '시스템오류', '특정사건', '개선건의', '기타'];
    public quoteTemplates: any[] = [
        { id: 'patent-domestic', label: '특허/실용신안 국내출원 기본', rightType: '특허/실용신안', caseType: '국내출원', officialFee: 46000, serviceFee: 700000, vat: 70000, etcFee: 0 },
        { id: 'trademark-domestic', label: '상표 국내출원 기본', rightType: '상표', caseType: '국내출원', officialFee: 56000, serviceFee: 250000, vat: 25000, etcFee: 0 },
        { id: 'design-domestic', label: '디자인 국내출원 기본', rightType: '디자인', caseType: '국내출원', officialFee: 94000, serviceFee: 350000, vat: 35000, etcFee: 0 },
        { id: 'overseas-application', label: '해외출원 의뢰 기본', rightType: '특허/실용신안', caseType: '해외출원', officialFee: 0, serviceFee: 500000, vat: 50000, etcFee: 0 },
        { id: 'dispute-start', label: '특허/실용신안 이의·심판·소송 착수 기본', rightType: '특허/실용신안', caseType: '이의/심판/소송', officialFee: 0, serviceFee: 1000000, vat: 100000, etcFee: 0 },
        { id: 'trial-start', label: '심판사건 착수 기본', rightType: '특허/실용신안', caseType: '이의/심판/소송', disputeType: '심판', officialFee: 0, serviceFee: 1000000, vat: 100000, etcFee: 0 },
        { id: 'litigation-start', label: '소송사건 착수 기본', rightType: '특허/실용신안', caseType: '이의/심판/소송', disputeType: '소송', officialFee: 0, serviceFee: 1000000, vat: 100000, etcFee: 0 },
        { id: 'trademark-objection', label: '상표 이의신청 기본', rightType: '상표', caseType: '이의/심판/소송', officialFee: 0, serviceFee: 800000, vat: 80000, etcFee: 0 },
        { id: 'design-objection', label: '디자인 이의신청 기본', rightType: '디자인', caseType: '이의/심판/소송', officialFee: 0, serviceFee: 800000, vat: 80000, etcFee: 0 },
        { id: 'office-custom', label: '특허사무소 자체 양식', rightType: '특허/실용신안', caseType: '국내출원', officialFee: 0, serviceFee: 0, vat: 0, etcFee: 0, custom: true }
    ];
    public standardQuoteForms: any[] = [
        {
            id: 'form-madrid-trademark',
            label: '마드리드 상표출원 견적서',
            rightType: '상표',
            caseType: '해외출원',
            pageCount: 1,
            thumbnail: '/assets/quotes/standard-quote-madrid.png',
            previewPages: ['/assets/quotes/standard-quote-madrid.png'],
            quoteTemplateId: 'overseas-application',
            layout: 'madrid',
            documentSubtitle: '마드리드 국제상표 출원',
            defaultSubject: '마드리드(흑백상표 기준), 원단위',
            sectionLabel: '대상: 마드리드 국제출원',
            officialFeeTitle: '마드리드 관납료',
            agentFeeTitle: '국내 대리인 수임료',
            secondPageTitle: '',
            description: '마드리드 국제상표 출원국가별 관납료와 국내 대리인 수임료를 안내하는 양식입니다.',
            composition: '마드리드 관납료 · 국내 대리인 수임료'
        },
        {
            id: 'form-patent',
            label: '특허 출원·등록 견적서',
            rightType: '특허/실용신안',
            caseType: '국내출원',
            pageCount: 2,
            thumbnail: '/assets/quotes/standard-quote-patent.png',
            previewPages: [
                '/assets/quotes/standard-quote-patent.png',
                '/assets/quotes/standard-quote-patent-page-2.png'
            ],
            quoteTemplateId: 'patent-domestic',
            layout: 'patent',
            documentSubtitle: '지식재산권 출원·등록',
            defaultSubject: '특허 1건 견적',
            sectionLabel: '① 특허 일반심사',
            officialFeeTitle: '특허청 관납료',
            agentFeeTitle: '대리인 수임료',
            secondPageTitle: '특허 우선심사·등록 비용',
            description: '특허 출원부터 우선심사와 등록까지 단계별 비용을 2페이지로 안내하는 양식입니다.',
            composition: '출원 · 우선심사 · 등록 관납료 및 대리인 수임료'
        },
        {
            id: 'form-integrated-rights',
            label: '특허·상표·디자인 통합 견적서',
            rightType: '지식재산권 통합',
            caseType: '국내출원',
            pageCount: 2,
            thumbnail: '/assets/quotes/standard-quote-combined.png',
            previewPages: [
                '/assets/quotes/standard-quote-combined.png',
                '/assets/quotes/standard-quote-combined-page-2.png'
            ],
            quoteTemplateId: 'patent-domestic',
            layout: 'integrated',
            documentSubtitle: '지식재산권 출원',
            defaultSubject: '특허(2)/디자인(1)/상표(1) 견적',
            sectionLabel: '특허·상표·디자인 통합 견적',
            officialFeeTitle: '특허청 관납료',
            agentFeeTitle: '대리인 수임료',
            secondPageTitle: '업무 안내 및 참고사항',
            description: '특허·상표·디자인 출원과 우선심사 비용을 한 문서에서 함께 확인하는 통합 양식입니다.',
            composition: '특허 · 상표 · 디자인 권리별 출원·우선심사 비용'
        },
        {
            id: 'form-overseas-trademark-china',
            label: '해외상표(중국) 출원 견적서',
            rightType: '상표',
            caseType: '해외출원',
            pageCount: 1,
            thumbnail: '/assets/quotes/standard-quote-overseas-trademark.png',
            previewPages: ['/assets/quotes/standard-quote-overseas-trademark.png'],
            quoteTemplateId: 'overseas-application',
            layout: 'overseas-trademark',
            documentSubtitle: '지식재산권 해외출원',
            defaultSubject: '해외상표(1) 견적',
            sectionLabel: '대상: 해외상표(중국) 출원',
            officialFeeTitle: '해외 관납료',
            agentFeeTitle: '해외 대리인 수임료',
            secondPageTitle: '',
            description: '중국 상표출원의 현지 관납료와 해외 대리인 수임료를 원화로 안내하는 양식입니다.',
            composition: '중국 관납료 · 해외 대리인 수임료'
        }
    ];
    public registrationContactGroups: any[] = [
        { key: 'clients', label: '의뢰인' },
        { key: 'applicants', label: '출원인' },
        { key: 'companyContacts', label: '기업담당자' },
        { key: 'documentReceivers', label: '서류수령자' }
    ];
    public trademarkApplicationTypes: any[] = [
        { key: 'original', label: '원출원' },
        { key: 'divisional', label: '분할출원' },
        { key: 'additional', label: '추가출원' }
    ];
    public designApplicationTypes: any[] = [
        { key: 'original', label: '원출원' },
        { key: 'divisional', label: '분할출원' }
    ];
    public documentCategories: string[] = ['출원전서류', '출원심사서류', '최종서류', '기타'];
    public deadlineRuleOptions: any[] = [
        { id: 'auto', label: '법정 점검일 자동' },
        { id: 'manual', label: '담당자 직접입력' },
        { id: 'none', label: '점검일정 없음' }
    ];
    public registrationDraft: any = {
        caseKey: '',
        right: '특허/실용신안',
        caseNo: '',
        applicationNo: '',
        filingDate: '',
        registrationNo: '',
        registrationDate: '',
        titleKo: '',
        titleEn: '',
        markImageName: '',
        productName: '',
        patentClientNo: '',
        caseType: '국내출원',
        stage: '출원/심사',
        type: '국내출원',
        clients: [{ name: '', phone: '', email: '' }],
        applicants: [{ name: '', phone: '', email: '' }],
        companyContacts: [{ name: '', phone: '', email: '' }],
        documentReceivers: [{ name: '', phone: '', email: '' }],
        attorney: '',
        assignee: '',
        expeditedExam: false,
        partialExam: false,
        detailedStatus: '심사중',
        customDetailedStatus: '',
        memo: '',
        nextDue: '',
        nextDueNote: '',
        relatedSourceCaseId: '',
        documents: [{
            category: '출원심사서류',
            name: '',
            fileName: '',
            file: null,
            dueDate: '',
            deadlineRule: 'manual',
            deadlineTask: '',
            deadlineAssignee: '',
            note: ''
        }],
        detail: null,
        additional: {
            '특허/실용신안': {
                ipcClass: '',
                claims: '',
                examRequestDate: '',
                internationalApplicationNo: '',
                priorityClaim: '',
                overseasApplications: [],
                trials: [],
                lawsuits: []
            },
            '상표': {
                products: [{ productClass: '', productName: '', addedAt: '' }],
                relatedApplicationNo: '',
                internationalApplicationNo: '',
                priorityClaim: '',
                overseasApplications: [],
                trials: [],
                lawsuits: []
            },
            '디자인': {
                articleClass: '',
                productName: '',
                internationalApplicationNo: '',
                priorityClaim: '',
                overseasApplications: [],
                trials: [],
                lawsuits: []
            }
        }
    };

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        this.loadBusinessProjectsFromStorage();
        await this.load();
        this.startAccessHeartbeat();
    }

    public ngOnDestroy() {
        if (this.accessHeartbeatTimer) clearInterval(this.accessHeartbeatTimer);
        this.revokeAdminNoticePreview();
        this.finishQuotePdfPrint(false);
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const clientToday = this.dateKey(new Date());
        this.today = clientToday;

        const { code, data } = await wiz.call('overview', { today: clientToday });
        if (code === 401) {
            this.redirectToAccess();
            return;
        }
        if (code === 200) {
            this.dashboard = data.dashboard || this.dashboard;
            this.syncCalendarToToday();
            this.consultations = data.consultations || [];
            this.cases = data.cases || [];
            this.clients = data.clients || [];
            this.quotes = data.quotes || [];
            this.standardQuoteParts = data.standardQuoteParts || [];
            this.adminConsultations = data.adminConsultations || [];
            this.staffAccess = data.staffAccess || [];
            this.selectedAdminConsultation = null;
            const resourceCounts = this.dashboard.resourceCounts || {};
            this.clientTotalCount = Number(resourceCounts.clients || this.clients.length || 0);
            this.caseTotalCount = Number(resourceCounts.cases || this.cases.length || 0);
            this.rightTotalCount = Number(resourceCounts.rights || 0);
            const serverDeadlines = this.normalizeDeadlineRows(data.deadlines || []);
            this.deadlines = serverDeadlines;
            this.normalizeCaseData();
            this.rebuildDeadlinesFromCases();
            if (serverDeadlines.length > 0) this.deadlines = serverDeadlines;
            this.deadlines = this.sortDeadlineRows(this.deadlines);
            this.deadlines = this.ensureVisibleCalendarCoverage(this.deadlines);
            this.selectedConsultation = this.consultations[0] || null;
            this.selectedDeadlineDate = this.today;
            this.selectedDeadlineStatus = '';
            this.selectedDeadlinePage = 1;
            this.weekDeadlinePage = 1;
            this.syncWorkspaceFromLocation();
            this.buildCalendar();
            if (this.activeWorkspace !== 'favoriteClients') {
                await this.loadFavoriteClients(false, false);
            }
            await this.loadActiveWorkspacePage(false);
            if (this.activeWorkspace !== 'clientDetail') this.selectedClient = this.clients[0] || null;
            this.selectedCase = this.filteredCases[0] || null;
        }

        this.loading = false;
        await this.service.render();
    }

    private redirectToAccess() {
        const returnTo = `${location.pathname}${location.search}${location.hash}`;
        const safeReturnTo = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/dashboard';
        location.href = `/access?returnTo=${encodeURIComponent(safeReturnTo)}`;
    }

    public workspaceTitle() {
        const titleMap: any = {
            dashboard: '홈',
            notices: '공지사항',
            laws: '법령/기준',
            media: '언론보도',
            forms: '각종 양식',
            adminSupport: '상담(관리자)',
            accessStatus: '접속현황',
            standardQuoteDetail: '표준양식 상세',
            quoteComposer: '새 견적서 작성',
            infoDetail: `${this.infoWorkspaceTitle(this.selectedInfoWorkspace)} 상세`
        };
        if (titleMap[this.activeWorkspace]) return titleMap[this.activeWorkspace];
        const found = this.topMenus.find((menu) => menu.id === this.activeWorkspace);
        if (found) return found.label;
        if (this.activeWorkspace === 'intakeConsultations') return '상담/행정';
        if (this.activeWorkspace === 'intakeConsultationDetail') return '상담/행정 상세';
        if (this.activeWorkspace === 'clientDetail') return '개별고객';
        if (this.activeWorkspace === 'caseDetail') return '사건 상세';
        return '홈';
    }

    public workspaceHelpItems(): string[] {
        if (this.activeWorkspace === 'clientDetail') return [
            '고객의 기본 연락처·주소·특허고객번호와 관련사건·상담 현황을 한 화면에서 확인할 수 있습니다.',
            '정보수정에서 이름·연락처·이메일·주소를 변경하고 수정저장을 누르면 고객리스트에도 반영됩니다.',
            '고객 주요정보 변경 전후 값과 변경자·시각은 별도 변경이력에 저장됩니다.'
        ];
        if (this.activeWorkspace === 'clients') return [
            '출원인·기업담당자·서류수령자·상담자·의뢰인을 한 목록에서 검색하고 직접 수정할 수 있습니다.',
            '전체 또는 선택한 고객에게 이메일과 첨부서류를 일괄 발송하며, 발송 결과는 발송이력에 남습니다.',
            '고객 주요정보를 수정하면 변경 전후 값과 변경자·시각이 별도 변경이력에 저장됩니다.'
        ];
        if (this.activeWorkspace === 'favoriteClients') return [
            '특허고객번호를 기준으로 중요고객을 지정하며, 번호가 없는 고객은 먼저 고객정보에서 번호를 입력해야 합니다.',
            '고객을 선택하면 해당 번호에 연결된 국내출원·분쟁·해외 사건을 한 번에 확인할 수 있습니다.',
            '관심고객 사건은 다른 사건 목록에서도 별표로 구분됩니다.'
        ];
        if (this.activeWorkspace === 'standardQuotes') return [
            '표준양식 목록에서 업무에 맞는 양식을 먼저 확인하고 예시 화면에서 문서 구성을 살펴볼 수 있습니다.',
            '새 견적서 작성은 별도 페이지에서 왼쪽 입력값을 오른쪽 A4 문서에 실시간 반영합니다.',
            '한글·PDF 등 사무소 자체 견적서를 업로드해 발송할 수 있으며 비용 합계는 자동 계산됩니다.'
        ];
        if (this.activeWorkspace === 'standardQuoteDetail') return [
            '선택한 표준양식의 문서 구성과 예상 페이지 수를 실제 견적서와 비슷한 형태로 확인합니다.',
            '이 양식으로 작성 버튼을 누르면 모든 고객·금액 정보가 비어 있는 새 견적서 페이지가 열립니다.'
        ];
        if (this.activeWorkspace === 'businessManagement') return [
            '순수 변리업 외 용역사업 등 주요 사업의 기본정보, 계약금액, 수행기간과 담당자를 한곳에서 관리합니다.',
            '목록의 사업을 클릭하면 등록 영역에서 내용을 수정하고 첨부서류를 확인하거나 추가할 수 있습니다.',
            '연도·사업명·주관기관을 함께 검색해 필요한 사업을 빠르게 찾을 수 있습니다.'
        ];
        if (this.activeWorkspace === 'caseDetail') return [
            '수정 버튼으로 주요정보를 편집한 뒤 수정저장을 누르면 변경 전후 값이 자동으로 기록됩니다.',
            '변경이력에서 출원인·대리인·고객·메모·견적서의 변경자와 변경시각을 확인할 수 있습니다.',
            '서류정보의 점검일정은 사건 점검일정과 달력에 함께 반영됩니다.'
        ];
        if (this.activeWorkspace === 'cases') {
            const category = this.activeCaseCategory();
            if (category === 'dispute') return [
                '이의·심판·소송 유형과 권리별로 사건을 검색하고, 개별사건에서 기초사건과 연관사건을 관리합니다.',
                '심사이력은 기초사건에 입력된 출원번호 또는 등록번호를 기준으로 불러옵니다.',
                '메모를 포함한 주요정보 수정은 개별사건 변경이력에 자동 저장됩니다.'
            ];
            if (category === 'foreign') return [
                '하나의 국내 기초출원에 여러 국가 진행정보와 국가별 현지대리인을 등록할 수 있습니다.',
                '해외→국내 진입 사건은 국내출원 화면에서 확인하며, 국내출원번호가 있으면 심사이력을 연계할 수 있습니다.',
                '국가별 대리인과 메모 변경도 개별사건 변경이력에 포함됩니다.'
            ];
            return [
                '출원인·권리·출원번호와 현재상태를 조합해 국내출원 사건을 검색할 수 있습니다.',
                '개별사건에서 관계인, 서류, 점검일정, 상담과 견적 업무를 함께 관리합니다.',
                '복수 출원인·고객 입력과 주요정보 수정은 변경이력에 자동 저장됩니다.'
            ];
        }
        if (this.activeWorkspace === 'intakeConsultations' || this.activeWorkspace === 'intakeConsultationDetail') return [
            '상담 내용을 먼저 기록한 뒤 국내출원·이의/심판/소송·해외출원 사건으로 이관할 수 있습니다.',
            '고객 연락처 끌어오기와 상담이력을 이용하면 중복 입력을 줄일 수 있습니다.',
            '상담과 이후 등록되는 사건은 동일한 사건키를 유지하여 진행단계별 기록을 연결합니다.'
        ];
        if (this.activeWorkspace === 'adminSupport') return [
            '일반상담·시스템오류·특정사건·개선건의·기타 중 상담구분을 선택해 관리자에게 문의합니다.',
            '특정사건 문의는 사건번호를 함께 입력하면 확인과 답변이 빨라집니다.',
            '답변이 등록되면 신청일자와 답변일자를 목록에서 함께 확인할 수 있습니다.'
        ];
        if (this.activeWorkspace === 'accessStatus') return [
            '직원별 최초 접속과 최근 접속, 접속 횟수를 확인하는 관리자용 현황입니다.',
            '접속기록은 계정 보안과 운영 확인을 위한 정보이며 업무 목적 범위에서만 사용합니다.'
        ];
        if (this.activeWorkspace === 'ipMarket') return [
            'IP-MARKET은 별도 사이트에서 제공되며, 이동 버튼을 누르면 새 탭으로 열립니다.',
            '거래·라이선스 정보는 IP-MARKET 페이지에서 확인하고 관리합니다.'
        ];
        if (['notices', 'laws', 'media', 'forms'].indexOf(this.activeWorkspace) >= 0) return [
            '검색과 분류 필터를 함께 사용해 필요한 자료를 빠르게 찾을 수 있습니다.',
            '자료를 선택하면 상세 내용과 첨부정보를 확인할 수 있습니다.'
        ];
        if (this.activeWorkspace === 'ipo' || this.activeWorkspace === 'kipris') return [
            '공식 외부 사이트가 새 탭에서 열리며, 조회 결과는 해당 기관 사이트 기준으로 확인합니다.'
        ];
        return [];
    }

    public async openTopMenu(id: string) {
        this.setWorkspace(id);
        await this.loadActiveWorkspacePage(false);
        this.syncLocationForWorkspace(id);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public filteredBusinessProjects() {
        const query = String(this.businessSearchQuery || '').trim().toLowerCase();
        const rows = [...(this.businessProjects || [])].sort((a: any, b: any) => {
            const yearOrder = Number(b?.year || 0) - Number(a?.year || 0);
            if (yearOrder !== 0) return yearOrder;
            return String(b?.updatedAt || '').localeCompare(String(a?.updatedAt || ''));
        });
        if (!query) return rows;
        return rows.filter((item: any) => [
            item?.year,
            item?.category,
            item?.name,
            item?.organizer,
            item?.executionManager,
            item?.organizerManagerName,
            item?.memo
        ].some((value) => String(value || '').toLowerCase().includes(query)));
    }

    public businessPeriodLabel(item: any) {
        const start = this.businessDateLabel(item?.periodStart);
        const end = this.businessDateLabel(item?.periodEnd);
        if (start && end) return `${start} ~ ${end}`;
        return start || end || '-';
    }

    public businessContractAmountLabel(item: any) {
        const amount = Number(item?.contractAmount || 0);
        return amount > 0 ? `${this.money(amount)}원` : '-';
    }

    public businessContactLabel(item: any) {
        return [item?.organizerManagerName, item?.organizerManagerContact, item?.organizerManagerEmail]
            .map((value) => String(value || '').trim())
            .filter((value) => !!value)
            .join(' · ') || '-';
    }

    public openBusinessProject(item: any) {
        if (!item) return;
        this.businessFormMode = 'edit';
        this.businessDraft = this.cloneBusinessProject(item);
        this.service.render();
        setTimeout(() => document.getElementById('business-project-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
    }

    public newBusinessProject() {
        this.businessFormMode = 'add';
        this.businessDraft = this.emptyBusinessProject();
        this.service.render();
    }

    public async saveBusinessProject() {
        const checked = validateFormDraft(this.businessDraft || {}, 'business');
        if (checked.error) { await this.service.modal.warning(checked.error); return; }
        const draft = checked.value;
        const year = Number(draft.year || 0);
        if (!Number.isInteger(year) || year < 2000 || year > 2100) {
            await this.service.modal.warning('연도를 2000년부터 2100년 사이로 입력해 주세요.');
            return;
        }
        if (!String(draft.name || '').trim()) {
            await this.service.modal.warning('사업명을 입력해 주세요.');
            return;
        }
        if (!String(draft.organizer || '').trim()) {
            await this.service.modal.warning('주관기관을 입력해 주세요.');
            return;
        }
        if (draft.periodStart && draft.periodEnd && draft.periodStart > draft.periodEnd) {
            await this.service.modal.warning('사업 종료일은 시작일보다 빠를 수 없습니다.');
            return;
        }

        const now = new Date().toISOString();
        const saved = {
            ...this.cloneBusinessProject(draft),
            id: String(draft.id || this.businessId('project')),
            year,
            category: String(draft.category || '').trim(),
            name: String(draft.name || '').trim(),
            organizer: String(draft.organizer || '').trim(),
            contractAmount: Math.max(0, Number(draft.contractAmount || 0)),
            executionManager: String(draft.executionManager || '').trim(),
            organizerManagerName: String(draft.organizerManagerName || '').trim(),
            organizerManagerContact: String(draft.organizerManagerContact || '').trim(),
            organizerManagerEmail: String(draft.organizerManagerEmail || '').trim(),
            memo: String(draft.memo || '').trim(),
            createdAt: draft.createdAt || now,
            updatedAt: now
        };
        const index = this.businessProjects.findIndex((item: any) => item.id === saved.id);
        if (index >= 0) this.businessProjects[index] = saved;
        else this.businessProjects.unshift(saved);
        this.persistBusinessProjects();
        this.businessFormMode = 'edit';
        this.businessDraft = this.cloneBusinessProject(saved);
        await this.service.render();
        await this.service.modal.success(index >= 0 ? '사업정보가 수정되었습니다.' : '사업이 등록되었습니다.');
    }

    public async handleBusinessAttachmentFiles(event: any) {
        const files = Array.from(event?.target?.files || []) as File[];
        if (event?.target) event.target.value = '';
        if (!files.length || this.businessAttachmentBusy) return;
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = 20 * 1024 * 1024;
        this.businessAttachmentBusy = true;
        try {
            for (const file of files) {
                const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
                if (allowed.indexOf(extension) < 0) {
                    await this.service.modal.warning(`${file.name}: 지원하지 않는 파일 형식입니다.`);
                    continue;
                }
                if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
                    await this.service.modal.warning(`${file.name}: 파일은 20MB 이하만 첨부할 수 있습니다.`);
                    continue;
                }
                const attachment = {
                    id: this.businessId('attachment'),
                    name: file.name,
                    size: file.size,
                    type: file.type || 'application/octet-stream',
                    createdAt: new Date().toISOString()
                };
                await this.storeBusinessAttachment(attachment.id, file);
                this.businessDraft.attachments = [...(this.businessDraft.attachments || []), attachment];
            }
            await this.service.render();
        } catch (error) {
            await this.service.modal.error('첨부서류를 저장하지 못했습니다. 브라우저 저장공간을 확인해 주세요.');
        } finally {
            this.businessAttachmentBusy = false;
            await this.service.render();
        }
    }

    public async downloadBusinessAttachment(attachment: any, event?: any) {
        event?.stopPropagation?.();
        const record = await this.readBusinessAttachment(attachment?.id);
        if (!record?.blob) {
            await this.service.modal.warning('이 브라우저에서 첨부파일 원본을 찾을 수 없습니다.');
            return;
        }
        const url = URL.createObjectURL(record.blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = attachment?.name || record.name || 'attachment';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    public async removeBusinessAttachment(attachment: any, event?: any) {
        event?.stopPropagation?.();
        this.businessDraft.attachments = (this.businessDraft.attachments || []).filter((item: any) => item.id !== attachment?.id);
        await this.deleteBusinessAttachmentBlob(attachment?.id);
        await this.service.render();
    }

    private emptyBusinessProject() {
        return {
            id: '',
            year: new Date().getFullYear(),
            category: '',
            name: '',
            organizer: '',
            periodStart: '',
            periodEnd: '',
            contractAmount: null,
            executionManager: '',
            organizerManagerName: '',
            organizerManagerContact: '',
            organizerManagerEmail: '',
            memo: '',
            attachments: [],
            createdAt: '',
            updatedAt: ''
        };
    }

    private cloneBusinessProject(item: any) {
        return {
            ...(item || {}),
            attachments: (item?.attachments || []).map((attachment: any) => ({ ...attachment }))
        };
    }

    private businessDateLabel(value: string) {
        if (!value) return '';
        return String(value).replace(/-/g, '.');
    }

    private businessStorageKey() {
        const tenant = String(this.service?.auth?.session?.tenant_id || this.service?.auth?.session?.id || 'local');
        return `wiz-business-projects:${tenant}`;
    }

    private loadBusinessProjectsFromStorage() {
        try {
            const saved = JSON.parse(localStorage.getItem(this.businessStorageKey()) || '[]');
            this.businessProjects = Array.isArray(saved) ? saved : [];
        } catch (error) {
            this.businessProjects = [];
        }
    }

    private persistBusinessProjects() {
        localStorage.setItem(this.businessStorageKey(), JSON.stringify(this.businessProjects || []));
    }

    private businessId(prefix: string) {
        const random = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID().replace(/-/g, '')
            : `${Date.now()}${Math.random().toString(16).slice(2)}`;
        return `${prefix}-${random}`;
    }

    private openBusinessAttachmentDatabase(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open('wiz-business-management', 1);
            request.onupgradeneeded = () => {
                const database = request.result;
                if (!database.objectStoreNames.contains('attachments')) database.createObjectStore('attachments', { keyPath: 'id' });
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }

    private async storeBusinessAttachment(id: string, file: File) {
        const database = await this.openBusinessAttachmentDatabase();
        await new Promise<void>((resolve, reject) => {
            const transaction = database.transaction('attachments', 'readwrite');
            transaction.objectStore('attachments').put({ id, blob: file, name: file.name, type: file.type, size: file.size });
            transaction.oncomplete = () => resolve();
            transaction.onerror = () => reject(transaction.error);
        });
        database.close();
    }

    private async readBusinessAttachment(id: string): Promise<any> {
        if (!id) return null;
        const database = await this.openBusinessAttachmentDatabase();
        const result = await new Promise<any>((resolve, reject) => {
            const request = database.transaction('attachments', 'readonly').objectStore('attachments').get(id);
            request.onsuccess = () => resolve(request.result || null);
            request.onerror = () => reject(request.error);
        });
        database.close();
        return result;
    }

    private async deleteBusinessAttachmentBlob(id: string) {
        if (!id) return;
        const database = await this.openBusinessAttachmentDatabase();
        await new Promise<void>((resolve, reject) => {
            const transaction = database.transaction('attachments', 'readwrite');
            transaction.objectStore('attachments').delete(id);
            transaction.oncomplete = () => resolve();
            transaction.onerror = () => reject(transaction.error);
        });
        database.close();
    }

    public async openWorkCard(card: any) {
        await this.openCaseCategory(card?.id || 'domestic');
    }

    public async openCaseCategory(category: string) {
        const nextCategory = this.normalizeCaseCategory(category) || 'domestic';
        if (this.selectedWorkCard !== nextCategory) {
            this.caseStageFilter = '';
            this.caseRightFilter = '';
            this.caseApplicantScope = 'all';
            this.caseApplicantKeyword = '';
            this.caseNumberSearchQuery = '';
            this.caseFilingSort = 'desc';
        }
        this.selectedWorkCard = nextCategory;
        this.casePage = 1;
        if (nextCategory === 'consultation') {
            this.activeWorkspace = 'intakeConsultations';
        } else {
            this.activeWorkspace = 'cases';
            await this.loadCasePage(1, false);
        }
        this.syncLocationForWorkspace(this.activeWorkspace);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public activeCaseCategory() {
        if (this.activeWorkspace === 'intakeConsultations' || this.activeWorkspace === 'intakeConsultationDetail') return 'consultation';
        return this.normalizeCaseCategory(this.selectedWorkCard) || 'domestic';
    }

    public favoriteClients() {
        return this.favoriteClientRecords.slice();
    }

    public filteredAdminConsultations() {
        const query = String(this.adminSupportSearchQuery || '').trim().toLowerCase();
        const items = this.canViewMonthlyQuotes()
            ? [...this.adminNoticeItems, ...this.adminConsultations]
            : this.adminConsultations.slice();
        if (!query) return items;
        return items.filter((item: any) => {
            const haystack = [
                item.applicationDate,
                item.createdAt,
                item.counselor,
                item.createdBy,
                item.title,
                item.category,
                item.question,
                item.answer,
                item.billingMonth,
                item.revisionNo
            ].map((value: any) => String(value || '').toLowerCase()).join(' ');
            return haystack.indexOf(query) >= 0;
        });
    }

    public canViewMonthlyQuotes() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return role === 'TENANT_OWNER' || role === 'TENANT_ADMIN';
    }

    public async loadAdminNoticeList(page: number = 1, force: boolean = false) {
        if (!this.canViewMonthlyQuotes()) {
            this.adminNoticeItems = [];
            this.adminNoticeLoaded = true;
            this.adminNoticeState = 'hidden';
            this.adminNoticeStateMessage = '';
            this.adminNoticeErrorCode = '';
            return;
        }
        const targetPage = Math.max(1, Math.floor(Number(page) || 1));
        if (this.adminNoticeLoading || (this.adminNoticeLoaded && !force && targetPage === this.adminNoticePage)) return;
        this.adminNoticeLoading = true;
        this.adminNoticeState = 'loading';
        this.adminNoticeStateMessage = '';
        this.adminNoticeErrorCode = '';
        // Rendering is best-effort. The BFF request must not be skipped when a render promise rejects.
        try {
            Promise.resolve(this.service.render()).catch(() => undefined);
        } catch (_error) { }

        try {
            const response = await wiz.call('admin_notice_list', {
                page: targetPage,
                limit: this.adminNoticeLimit
            });
            const { code, data } = this.normalizeAdminNoticeWizResponse(response);
            this.adminNoticeLoaded = true;
            if (code === 200 && Array.isArray(data?.items)) {
                this.adminNoticeItems = data.items;
                this.adminNoticePage = Number(data.page || targetPage);
                this.adminNoticeLimit = Number(data.limit || this.adminNoticeLimit);
                this.adminNoticeTotalCount = Number(data.totalCount || 0);
                this.adminNoticeHasNext = data.hasNext === true;
                this.adminNoticeState = this.adminNoticeItems.length ? 'ready' : 'empty';
                this.adminNoticeStateMessage = this.adminNoticeItems.length
                    ? ''
                    : '전달된 관리자 안내가 없습니다.';
                this.adminNoticeErrorCode = '';
            } else if (code === 502) {
                this.applyAdminNoticeFailure(code, data);
            } else {
                this.applyAdminNoticeFailure(code, data);
            }
        } catch (error) {
            this.adminNoticeLoaded = true;
            const normalized = this.normalizeAdminNoticeWizResponse(error);
            this.applyAdminNoticeFailure(normalized.code, normalized.data);
        } finally {
            this.adminNoticeLoading = false;
            try {
                await this.service.render();
            } catch (_error) { }
        }
    }

    private normalizeAdminNoticeWizResponse(response: any) {
        const directCode = Number(response?.code || 0);
        if (directCode > 0 && response?.data && typeof response.data === 'object') {
            return { code: directCode, data: response.data };
        }

        const payload = response?.responseJSON && typeof response.responseJSON === 'object'
            ? response.responseJSON
            : (response && typeof response === 'object' ? response : null);
        const httpStatus = Number(response?.status || 0);
        if (payload?.ok === true) {
            return {
                code: httpStatus >= 200 && httpStatus < 300 ? httpStatus : 200,
                data: payload
            };
        }
        if (payload?.ok === false) {
            return {
                code: httpStatus || Number(payload?.status || 0),
                data: {
                    reason: this.safeAdminNoticeDiagnostic(payload?.reason || payload?.code),
                    field: this.safeAdminNoticeDiagnostic(payload?.field),
                    message: typeof payload?.message === 'string' ? payload.message : ''
                }
            };
        }
        return {
            code: httpStatus,
            data: {
                reason: this.safeAdminNoticeDiagnostic(payload?.reason || payload?.code),
                field: this.safeAdminNoticeDiagnostic(payload?.field),
                message: ''
            }
        };
    }

    private safeAdminNoticeDiagnostic(value: any) {
        const normalized = String(value || '').trim().toUpperCase();
        return /^[A-Z][A-Z0-9_]{0,63}$/.test(normalized) ? normalized : '';
    }

    private applyAdminNoticeFailure(code: any, data: any) {
        this.adminNoticeItems = [];
        this.adminNoticeTotalCount = 0;
        this.adminNoticeHasNext = false;
        const status = Number(code || 0);
        const reason = this.safeAdminNoticeDiagnostic(data?.reason);
        const field = this.safeAdminNoticeDiagnostic(data?.field);
        this.adminNoticeErrorCode = `WIZ ${status || 'UNKNOWN'}${reason ? ` / ${reason}` : ''}${field ? ` / ${field}` : ''}`;
        if (status === 401 && reason === 'IP_AUTH_ASSERTION_REQUIRED') {
            this.adminNoticeState = 'authentication';
            this.adminNoticeStateMessage = '로그인 세션을 다시 확인해 주세요.';
        } else if (status === 401 && reason === 'ASSERTION_INVALID') {
            this.adminNoticeState = 'authentication';
            this.adminNoticeStateMessage = '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        } else if (status === 401) {
            this.adminNoticeState = 'authentication';
            this.adminNoticeStateMessage = '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        } else if (status === 403 && reason === 'TENANT_ADMIN_ROLE_REQUIRED') {
            this.adminNoticeState = 'forbidden';
            this.adminNoticeStateMessage = 'Tenant 관리자 권한이 필요합니다.';
        } else if (status === 403) {
            this.adminNoticeState = 'forbidden';
            this.adminNoticeStateMessage = 'IP 관리 이용 권한을 확인해 주세요.';
        } else if (status === 404) {
            this.adminNoticeState = 'not-found';
            this.adminNoticeStateMessage = '상담 또는 문서를 찾을 수 없습니다.';
        } else if (status === 502) {
            this.adminNoticeState = 'unavailable';
            this.adminNoticeStateMessage = 'Core 관리자 안내 조회에 실패했습니다. 잠시 후 다시 시도해 주세요.';
        } else {
            this.adminNoticeState = 'unavailable';
            this.adminNoticeStateMessage = '관리자 안내를 불러오지 못했습니다. 다시 시도해 주세요.';
        }
    }

    public async refreshAdminNotice(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (this.adminNoticeLoading) return;
        this.revokeAdminNoticePreview();
        this.adminNoticeLoaded = false;
        this.adminNoticeState = 'idle';
        this.adminNoticeStateMessage = '';
        this.adminNoticeErrorCode = '';
        await this.loadAdminNoticeList(1, true);
    }

    public async changeAdminNoticePage(page: number) {
        if (this.adminNoticeLoading || page < 1 || (page > this.adminNoticePage && !this.adminNoticeHasNext)) return;
        await this.loadAdminNoticeList(page, true);
    }

    public clearAdminSupportSearch() {
        this.adminSupportSearchQuery = '';
        this.service.render();
    }

    public adminSupportOpenCount() {
        return this.adminConsultations.filter((item: any) => item.status === 'open' || item.status === 'in_progress').length;
    }

    public adminSupportAnsweredCount() {
        return this.adminConsultations.filter((item: any) => item.status === 'answered' || item.status === 'closed').length;
    }

    public async openAdminSupportForm() {
        this.adminSupportDraft = this.emptyAdminSupportDraft();
        this.adminSupportError = '';
        this.showAdminSupportForm = true;
        await this.service.render();
    }

    public async closeAdminSupportForm() {
        this.showAdminSupportForm = false;
        this.adminSupportError = '';
        await this.service.render();
    }

    public async selectAdminConsultation(item: any) {
        this.revokeAdminNoticePreview();
        this.adminNoticePdfError = '';
        this.selectedAdminConsultation = item;
        this.adminNoticeDetailError = '';
        this.adminNoticeDetailErrorCode = '';
        this.adminNoticeDetailLoading = item?.sourceType === 'core-admin-notice';
        this.selectedAdminNoticeRevisionNo = item?.sourceType === 'core-admin-notice'
            ? Number(item?.revisionNo || 0)
            : null;
        this.selectedAdminNoticeDeliveryId = item?.sourceType === 'core-admin-notice'
            ? String(item?.deliveryId || '')
            : '';
        this.selectedAdminConsultationAnswer = item?.sourceType === 'core-admin-notice'
            ? null
            : this.parseAdminConsultationAnswer(item?.answer);
        await this.service.render();
        if (item?.sourceType !== 'core-admin-notice') return;

        const consultationId = String(item?.consultationId || '');
        try {
            const response = await wiz.call('admin_notice_detail', {
                consultation_id: consultationId,
                delivery_id: this.selectedAdminNoticeDeliveryId,
                revision_no: this.selectedAdminNoticeRevisionNo,
                document_id: String(item?.document?.id || '')
            });
            const { code, data } = this.normalizeAdminNoticeWizResponse(response);
            if (String(this.selectedAdminConsultation?.consultationId || '') !== consultationId) return;
            if (code === 200 && data?.item) {
                this.selectedAdminConsultation = data.item;
            } else {
                this.applyAdminNoticeDetailFailure(code, data);
            }
        } catch (error) {
            const normalized = this.normalizeAdminNoticeWizResponse(error);
            this.applyAdminNoticeDetailFailure(normalized.code, normalized.data);
        } finally {
            if (String(this.selectedAdminConsultation?.consultationId || '') === consultationId) {
                this.adminNoticeDetailLoading = false;
                await this.service.render();
            }
        }
    }

    public async closeAdminConsultationDetail() {
        this.revokeAdminNoticePreview();
        this.adminNoticePdfError = '';
        this.adminNoticeDetailError = '';
        this.adminNoticeDetailErrorCode = '';
        this.adminNoticeDetailLoading = false;
        this.selectedAdminNoticeRevisionNo = null;
        this.selectedAdminNoticeDeliveryId = '';
        this.selectedAdminConsultation = null;
        this.selectedAdminConsultationAnswer = null;
        await this.service.render();
    }

    private applyAdminNoticeDetailFailure(code: any, data: any) {
        const status = Number(code || 0);
        const reason = this.safeAdminNoticeDiagnostic(data?.reason);
        const field = this.safeAdminNoticeDiagnostic(data?.field);
        this.adminNoticeDetailError = this.adminNoticeRequestErrorMessage(status, reason);
        const structured = [reason, field].filter((value) => !!value);
        this.adminNoticeDetailErrorCode = status
            ? `WIZ ${status}${structured.length ? ` / ${structured.join(' / ')}` : ''}`
            : (structured.length ? structured.join(' / ') : 'WIZ UNKNOWN');
    }

    public adminNoticeDate(value: any) {
        const raw = String(value || '').trim();
        if (!raw) return '-';
        const parsed = new Date(raw);
        if (Number.isNaN(parsed.getTime())) return '-';
        const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Seoul',
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(parsed).reduce((result: any, part: Intl.DateTimeFormatPart) => {
            result[part.type] = part.value;
            return result;
        }, {});
        return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
    }

    public adminNoticeVatLabel(value: any) {
        if (value === true) return '부가세 포함';
        if (value === false) return '부가세 별도';
        return '-';
    }

    public async previewAdminNoticePdf(message: any) {
        const documentId = String(message?.document?.id || '');
        if (!documentId || !message?.consultationId) {
            this.adminNoticePdfError = '상담 또는 문서를 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        this.revokeAdminNoticePreview();
        this.adminNoticePdfBusyId = String(message.id || '');
        this.adminNoticePdfError = '';
        await this.service.render();
        try {
            const response = await this.fetchAdminNoticePdf(message);
            const blob = await response.blob();
            if (!blob.size || blob.type.split(';')[0].toLowerCase() !== 'application/pdf') {
                throw { status: 502, reason: 'INVALID_PDF_RESPONSE' };
            }
            this.adminNoticePreviewUrl = URL.createObjectURL(blob);
            this.adminNoticePreviewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.adminNoticePreviewUrl);
            this.adminNoticePreviewMessageId = String(message.id || '');
        } catch (error: any) {
            this.adminNoticePdfError = this.adminNoticePdfErrorMessage(error, 'preview');
        } finally {
            this.adminNoticePdfBusyId = '';
            await this.service.render();
        }
    }

    public async downloadAdminNoticePdf(message: any) {
        const documentId = String(message?.document?.id || '');
        if (!documentId || !message?.consultationId) {
            this.adminNoticePdfError = '상담 또는 문서를 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        this.adminNoticeDownloadBusyId = String(message.id || '');
        this.adminNoticePdfError = '';
        await this.service.render();
        try {
            const response = await this.fetchAdminNoticePdf(message);
            const blob = await response.blob();
            if (!blob.size || blob.type.split(';')[0].toLowerCase() !== 'application/pdf') {
                throw { status: 502, reason: 'INVALID_PDF_RESPONSE' };
            }
            const fallbackName = `${String(message?.document?.title || '월-견적서').trim() || '월-견적서'}.pdf`;
            const filename = this.adminNoticeDownloadFilename(response.headers.get('content-disposition'), fallbackName);
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            link.rel = 'noopener';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        } catch (error: any) {
            this.adminNoticePdfError = this.adminNoticePdfErrorMessage(error, 'download');
        } finally {
            this.adminNoticeDownloadBusyId = '';
            await this.service.render();
        }
    }

    public async closeAdminNoticePreview() {
        this.revokeAdminNoticePreview();
        await this.service.render();
    }

    private async fetchAdminNoticePdf(message: any): Promise<Response> {
        const endpoint = new URL(wiz.url('admin_notice_pdf'), window.location.origin);
        endpoint.searchParams.set('consultation_id', String(message?.consultationId || ''));
        endpoint.searchParams.set('document_id', String(message?.document?.id || ''));
        const response = await fetch(endpoint.toString(), {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/pdf' }
        });
        const contentType = String(response.headers.get('content-type') || '').toLowerCase();
        if (!response.ok || !contentType.startsWith('application/pdf')) {
            let reason = '';
            if (contentType.includes('application/json')) {
                try {
                    const payload = await response.json();
                    reason = String(payload?.reason || '');
                } catch (_error) {
                    reason = '';
                }
            }
            throw { status: response.status, reason };
        }
        return response;
    }

    private adminNoticePdfErrorMessage(error: any, mode: 'preview' | 'download') {
        const status = Number(error?.status || 0);
        const reason = String(error?.reason || '');
        if (status === 401 && reason === 'IP_AUTH_ASSERTION_REQUIRED') return '로그인 세션을 다시 확인해 주세요.';
        if (status === 401 && reason === 'ASSERTION_INVALID') return '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        if (status === 401) return '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        if (status === 403 && reason === 'TENANT_ADMIN_ROLE_REQUIRED') return 'Tenant 관리자 권한이 필요합니다.';
        if (status === 403) return 'IP 관리 이용 권한을 확인해 주세요.';
        if (status === 404 || reason === 'DOCUMENT_NOT_FOUND' || reason === 'CONSULTATION_NOT_FOUND') {
            return '상담 또는 문서를 찾을 수 없습니다.';
        }
        if (status === 416) return '견적서 파일의 요청 범위를 처리할 수 없습니다.';
        return mode === 'preview'
            ? 'PDF 미리보기에 실패했습니다. 잠시 후 다시 시도해 주세요.'
            : 'PDF 다운로드에 실패했습니다. 잠시 후 다시 시도해 주세요.';
    }

    private adminNoticeRequestErrorMessage(status: number, reason: string) {
        if (status === 401 && reason === 'IP_AUTH_ASSERTION_REQUIRED') return '로그인 세션을 다시 확인해 주세요.';
        if (status === 401 && reason === 'ASSERTION_INVALID') return '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        if (status === 401) return '로그인 정보가 만료되었습니다. 다시 로그인해 주세요.';
        if (status === 403 && reason === 'TENANT_ADMIN_ROLE_REQUIRED') return 'Tenant 관리자 권한이 필요합니다.';
        if (status === 403) return 'IP 관리 이용 권한을 확인해 주세요.';
        if (status === 404) return '상담 또는 문서를 찾을 수 없습니다.';
        if (status === 502) return 'Core 관리자 안내 조회에 실패했습니다. 잠시 후 다시 시도해 주세요.';
        return '관리자 안내를 불러오지 못했습니다. 다시 시도해 주세요.';
    }

    private adminNoticeDownloadFilename(contentDisposition: string | null, fallback: string) {
        const header = String(contentDisposition || '');
        const encoded = header.match(/filename\*=UTF-8''([^;]+)/i);
        const basic = header.match(/filename="?([^";]+)"?/i);
        let filename = fallback;
        try {
            if (encoded?.[1]) filename = decodeURIComponent(encoded[1]);
            else if (basic?.[1]) filename = basic[1].trim();
        } catch (_error) {
            filename = fallback;
        }
        if (!filename || filename.length > 255 || /[\\/\u0000-\u001f\u007f]/.test(filename)) return fallback;
        return filename;
    }

    private revokeAdminNoticePreview() {
        if (this.adminNoticePreviewUrl) URL.revokeObjectURL(this.adminNoticePreviewUrl);
        this.adminNoticePreviewUrl = '';
        this.adminNoticePreviewSafeUrl = null;
        this.adminNoticePreviewMessageId = '';
    }

    public adminConsultationAnswerPreview(answer: any) {
        const parsed = this.parseAdminConsultationAnswer(answer);
        if (!parsed) return String(answer || '');
        return [parsed.title, parsed.body].filter((value: string) => !!value).join('\n');
    }

    public parseAdminConsultationAnswer(answer: any) {
        const original = String(answer || '');
        const lines = original.replace(/\r\n?/g, '\n').split('\n');
        const title = lines[0]?.trim();
        const hasStructuredTitle = /^\[[^\[\]\n]+\](?:\s+.+)?$/.test(title || '');
        if (!hasStructuredTitle || lines.length < 6 || lines[1].trim() !== '') return null;

        let attachmentHeadingIndex = -1;
        for (let index = lines.length - 1; index >= 2; index -= 1) {
            if (lines[index].trim() === '첨부서류') {
                attachmentHeadingIndex = index;
                break;
            }
        }
        if (attachmentHeadingIndex < 3) return null;

        const body = lines.slice(2, attachmentHeadingIndex).join('\n').trim();
        if (!body) return null;

        const attachments: any[] = [];
        let index = attachmentHeadingIndex + 1;
        let attachmentPairCount = 0;
        while (index < lines.length) {
            if (!lines[index].trim()) {
                index += 1;
                continue;
            }
            const fileMatch = lines[index].match(/^\s*-\s+(.+?)\s*$/);
            if (!fileMatch || index + 1 >= lines.length) return null;
            const fileName = fileMatch[1].trim();
            const rawUrl = lines[index + 1].trim();
            if (!fileName || !/^https?:\/\/\S+$/.test(rawUrl)) return null;
            attachmentPairCount += 1;

            const safeUrl = this.safeAdminConsultationAttachmentUrl(rawUrl);
            if (safeUrl) {
                const extensionMatch = fileName.match(/\.([^./\\]+)$/);
                attachments.push({
                    fileName,
                    extension: String(extensionMatch?.[1] || 'FILE').slice(0, 12).toUpperCase(),
                    url: safeUrl
                });
            }
            index += 2;
        }
        if (!attachmentPairCount) return null;

        return {
            title,
            body,
            attachments
        };
    }

    private safeAdminConsultationAttachmentUrl(value: any) {
        try {
            const url = new URL(String(value || '').trim());
            const allowedOrigin = 'https://admin.woongbin.seasonai.net';
            const allowedPath = '/ip-management/consultation-documents/';
            if (url.protocol !== 'https:' || url.origin !== allowedOrigin) return '';
            if (url.username || url.password || url.search || url.hash) return '';
            if (!url.pathname.startsWith(allowedPath) || url.pathname.length <= allowedPath.length) return '';
            return url.href;
        } catch (_error) {
            return '';
        }
    }

    public downloadAdminConsultationAttachment(attachment: any) {
        const safeUrl = this.safeAdminConsultationAttachmentUrl(attachment?.url);
        if (!safeUrl) return;
        const downloadWindow = window.open(safeUrl, '_blank', 'noopener,noreferrer');
        if (downloadWindow) downloadWindow.opener = null;
    }

    public async saveAdminSupportDraft() {
        this.adminSupportError = '';
        if (!String(this.adminSupportDraft.question || '').trim()) {
            this.adminSupportError = '상담내용을 입력해 주세요.';
            await this.service.render();
            return;
        }
        if (this.adminSupportDraft.category === '특정사건' && !String(this.adminSupportDraft.caseNo || '').trim()) {
            this.adminSupportError = '특정사건 상담은 사건번호를 입력해 주세요.';
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call('save_admin_consultation', {
            payload: JSON.stringify(this.adminSupportDraft)
        });
        if (code !== 200) {
            this.adminSupportError = data?.message || data?.error || '관리자 상담 신청에 실패했습니다.';
            await this.service.render();
            return;
        }
        this.adminConsultations = data.items || [];
        this.selectedAdminConsultation = null;
        this.selectedAdminConsultationAnswer = null;
        this.adminSupportSearchQuery = '';
        this.showAdminSupportForm = false;
        this.adminSupportDraft = this.emptyAdminSupportDraft();
        await this.service.render();
    }

    public adminSupportStatusClass(status: string) {
        const normalized = String(status || '').toLowerCase();
        if (normalized === 'answered' || normalized === 'completed') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (normalized === 'closed' || normalized === 'cancelled') return 'border-slate-200 bg-slate-100 text-slate-600';
        if (normalized === 'in_progress' || normalized === 'on_hold') return 'border-amber-200 bg-amber-50 text-amber-800';
        return 'border-blue-200 bg-blue-50 text-blue-800';
    }

    public staffAccessCount(status: string) {
        if (status === 'attended') return this.staffAccess.filter((item: any) => item.attendance === '출근').length;
        return this.staffAccess.filter((item: any) => item.status === status).length;
    }

    public staffAccessStatusLabel(status: string) {
        if (status === 'online') return '접속 중';
        if (status === 'away') return '자리 비움';
        if (status === 'offline') return '접속 종료';
        return '오늘 미접속';
    }

    public staffAccessStatusClass(status: string) {
        if (status === 'online') return 'is-online';
        if (status === 'away') return 'is-away';
        if (status === 'offline') return 'is-offline';
        return 'is-not-accessed';
    }

    public staffWorkTime(item: any) {
        const minutes = Number(item?.workMinutes || 0);
        if (!item?.firstAccess) return '-';
        if (minutes < 60) return `${minutes}분`;
        return `${Math.floor(minutes / 60)}시간 ${minutes % 60}분`;
    }

    public async refreshStaffAccess() {
        const { code, data } = await wiz.call('access_status', {});
        if (code === 200) this.staffAccess = data.items || [];
        await this.service.render();
    }

    private startAccessHeartbeat() {
        if (this.accessHeartbeatTimer) clearInterval(this.accessHeartbeatTimer);
        this.accessHeartbeatTimer = setInterval(async () => {
            await this.refreshStaffAccess();
        }, 5 * 60 * 1000);
    }

    private favoritePatentNo(value: any) {
        return String(value || '').trim();
    }

    private testFavoriteClientRecord() {
        return {
            id: 'test-favorite-client-001',
            patentClientNo: 'TEST-CLIENT-001',
            applicant: '관심고객 테스트',
            domesticCount: 1,
            objectionCount: 0,
            trialCount: 0,
            litigationCount: 0,
            foreignCount: 0,
            totalCount: 1,
            note: '관심고객 목록과 개별 사건 화면 확인용 테스트 고객입니다.',
            createdAt: this.today || this.dateKey(new Date()),
            _testFavorite: true
        };
    }

    private testFavoriteClientCase() {
        return {
            id: 'test-favorite-case-001',
            clientId: 'test-favorite-client-001',
            clientName: '관심고객 테스트',
            applicant: '관심고객 테스트',
            patentClientNo: 'TEST-CLIENT-001',
            type: '국내출원',
            right: '상표',
            rightDisplay: '상표',
            title: '관심고객 테스트 상표',
            displayName: '관심고객 테스트 상표',
            statusLabel: '심사중',
            detailedStatus: '심사중',
            stage: '출원/심사',
            workflow: '국내출원',
            applicationNo: '40-2026-9999999',
            filingDate: this.today || this.dateKey(new Date()),
            nextDue: '2026-08-25',
            nextDueNote: '테스트 점검일정',
            assignee: '관리자',
            consultationCount: 0,
            memo: '관심고객 화면과 개별사건 진입을 확인하기 위한 테스트 사건입니다.',
            starred: true,
            documents: [],
            memos: [],
            detail: {},
            additional: {},
            _testFavorite: true
        };
    }

    private applyFavoriteClientTestFallback() {
        if (this.favoriteClientRecords.length > 0) return;
        this.favoriteClientRecords = [this.testFavoriteClientRecord()];
    }

    public isFavoriteClient(client: any) {
        const patentClientNo = this.favoritePatentNo(client?.patentClientNo);
        return !!patentClientNo && this.favoritePatentClientNos.indexOf(patentClientNo) >= 0;
    }

    public async toggleFavoriteClient(client: any, event?: any) {
        event?.stopPropagation();
        await this.toggleFavoriteByPatentNo(
            client?.patentClientNo,
            client?.name || client?.applicant || '',
            event
        );
    }

    public async loadFavoriteClients(
        render: boolean = true,
        showError: boolean = this.activeWorkspace === 'favoriteClients'
    ) {
        try {
            const selectedNumber = this.favoritePatentNo(this.selectedFavoriteClient?.patentClientNo);
            const { code, data } = await wiz.call('favorite_clients', { action: 'list' });
            if (code === 401) {
                this.redirectToAccess();
                return;
            }
            if (code !== 200) {
                if (showError) {
                    await this.service.modal.error(data?.message || data?.error || '관심고객 목록을 불러오지 못했습니다.');
                }
                return;
            }
            this.favoriteClientRecords = data.items || [];
            this.applyFavoriteClientTestFallback();
            const patentClientNos = (data.patent_client_nos || []).length > 0
                ? data.patent_client_nos
                : this.favoriteClientRecords.map((item: any) => item.patentClientNo);
            this.favoritePatentClientNos = patentClientNos
                .map((value: any) => this.favoritePatentNo(value))
                .filter((value: string) => !!value);
            this.selectedFavoriteClient = this.favoriteClientRecords.find(
                (item: any) => this.favoritePatentNo(item.patentClientNo) === selectedNumber
            ) || this.favoriteClientRecords[0] || null;
            if (!this.selectedFavoriteClient) {
                this.favoriteClientCases = [];
                this.favoriteCaseTotalCount = 0;
                this.favoriteCasePage = 1;
            }
        } catch (error) {
            console.error('dashboard favorite_clients failed', error);
            if (showError) await this.service.modal.error('관심고객 목록을 불러오지 못했습니다.');
        }
        if (render) await this.service.render();
    }

    public async selectFavoriteClient(item: any) {
        if (!item) return;
        this.selectedFavoriteClient = item;
        this.favoriteCasePage = 1;
        await this.loadFavoriteClientCases(1);
        document.querySelector('.favorite-client-case-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async loadFavoriteClientCases(page: number = this.favoriteCasePage, render: boolean = true) {
        const patentClientNo = this.favoritePatentNo(this.selectedFavoriteClient?.patentClientNo);
        if (!patentClientNo) {
            this.favoriteClientCases = [];
            this.favoriteCaseTotalCount = 0;
            if (render) await this.service.render();
            return;
        }
        const targetPage = Math.max(1, Number(page || 1));
        if (this.selectedFavoriteClient?._testFavorite) {
            const testCase = this.testFavoriteClientCase();
            this.ensureCaseDetailShape(testCase);
            this.favoriteCasePage = 1;
            this.favoriteCaseTotalCount = 1;
            this.favoriteClientCases = [testCase];
            if (render) await this.service.render();
            return;
        }
        try {
            const { code, data } = await wiz.call('favorite_client_cases', {
                page: targetPage,
                page_size: this.favoriteCasePageSize,
                patent_client_no: patentClientNo,
                today: this.today
            });
            if (code === 400 && targetPage !== 1) {
                await this.loadFavoriteClientCases(1, render);
                return;
            }
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '관심고객 사건을 불러오지 못했습니다.');
                return;
            }
            this.favoriteCasePage = Number(data.page || 1);
            this.favoriteCaseTotalCount = Number(data.total_count || 0);
            this.favoriteClientCases = data.items || [];
            for (const item of this.favoriteClientCases) this.ensureCaseDetailShape(item);
        } catch (error) {
            console.error('dashboard favorite_client_cases failed', error);
            await this.service.modal.error('관심고객 사건을 불러오지 못했습니다.');
        }
        if (render) await this.service.render();
    }

    public favoriteCaseTotalPages() {
        return Math.max(1, Math.ceil(this.favoriteCaseTotalCount / this.favoriteCasePageSize));
    }

    public favoriteCasePageNumbers() {
        return this.visiblePageNumbers(this.favoriteCasePage, this.favoriteCaseTotalPages());
    }

    public favoriteCasePageSummary() {
        return this.pageSummary(this.favoriteCasePage, this.favoriteCasePageSize, this.favoriteCaseTotalCount);
    }

    public favoriteCaseRowNumber(index: number) {
        return (this.favoriteCasePage - 1) * this.favoriteCasePageSize + index + 1;
    }

    public async setFavoriteCasePage(page: number) {
        await this.loadFavoriteClientCases(
            Math.max(1, Math.min(page, this.favoriteCaseTotalPages())),
            false
        );
        await this.service.render();
        document.querySelector('.favorite-client-case-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async previousFavoriteCasePage() {
        await this.setFavoriteCasePage(this.favoriteCasePage - 1);
    }

    public async nextFavoriteCasePage() {
        await this.setFavoriteCasePage(this.favoriteCasePage + 1);
    }

    public openFavoriteClientForm(source: any = null) {
        this.favoriteClientDraft = {
            patentClientNo: this.favoritePatentNo(source?.patentClientNo),
            applicant: String(source?.applicant || source?.clientName || source?.name || '').trim(),
            note: ''
        };
        this.showFavoriteClientForm = true;
        this.service.render();
    }

    public closeFavoriteClientForm() {
        if (this.favoriteClientSaving) return;
        this.showFavoriteClientForm = false;
        this.service.render();
    }

    public async saveFavoriteClient() {
        const patentClientNo = this.favoritePatentNo(this.favoriteClientDraft?.patentClientNo);
        const applicant = String(this.favoriteClientDraft?.applicant || '').trim();
        if (!patentClientNo) {
            await this.service.modal.error('관심고객 등록에는 특허고객번호가 반드시 필요합니다.');
            return;
        }
        if (!applicant) {
            await this.service.modal.error('출원인 명을 입력해 주세요.');
            return;
        }
        this.favoriteClientSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('favorite_clients', {
                action: 'save',
                payload: JSON.stringify({
                    patentClientNo,
                    applicant,
                    note: String(this.favoriteClientDraft?.note || '').trim()
                })
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '관심고객을 등록하지 못했습니다.');
                return;
            }
            this.showFavoriteClientForm = false;
            this.favoriteClientRecords = data.items || [];
            this.favoritePatentClientNos = (data.patent_client_nos || this.favoriteClientRecords.map((item: any) => item.patentClientNo))
                .map((value: any) => this.favoritePatentNo(value));
            this.selectedFavoriteClient = this.favoriteClientRecords.find(
                (item: any) => this.favoritePatentNo(item.patentClientNo) === patentClientNo
            ) || this.favoriteClientRecords[0] || null;
            this.favoriteCasePage = 1;
            await this.loadFavoriteClientCases(1, false);
            await this.service.modal.success('관심고객이 등록되었습니다.');
        } catch (error) {
            console.error('dashboard favorite_clients save failed', error);
            await this.service.modal.error('관심고객을 등록하지 못했습니다.');
        } finally {
            this.favoriteClientSaving = false;
            await this.service.render();
        }
    }

    private async removeFavoriteClient(patentClientNo: string) {
        const { code, data } = await wiz.call('favorite_clients', {
            action: 'delete',
            payload: JSON.stringify({ patentClientNo })
        });
        if (code !== 200) {
            await this.service.modal.error(data?.message || data?.error || '관심고객 지정을 해제하지 못했습니다.');
            return false;
        }
        this.favoriteClientRecords = data.items || [];
        this.applyFavoriteClientTestFallback();
        this.favoritePatentClientNos = this.favoriteClientRecords
            .map((item: any) => this.favoritePatentNo(item.patentClientNo))
            .filter((value: string) => !!value);
        this.selectedFavoriteClient = this.favoriteClientRecords[0] || null;
        this.favoriteCasePage = 1;
        if (this.activeWorkspace === 'favoriteClients' && this.selectedFavoriteClient) {
            await this.loadFavoriteClientCases(1, false);
        } else if (!this.selectedFavoriteClient) {
            this.favoriteClientCases = [];
            this.favoriteCaseTotalCount = 0;
        }
        return true;
    }

    private async toggleFavoriteByPatentNo(patentClientNoValue: any, applicant: string, event?: any) {
        event?.stopPropagation();
        const patentClientNo = this.favoritePatentNo(patentClientNoValue);
        if (!patentClientNo) {
            await this.service.modal.warning('관심고객으로 등록하려면 고객 정보에 특허고객번호를 먼저 입력해 주세요.');
            return;
        }
        if (patentClientNo === 'TEST-CLIENT-001') {
            await this.service.modal.warning('테스트 관심고객은 화면 확인용 항목입니다. 실제 관심고객이 등록되면 자동으로 사라집니다.');
            return;
        }
        if (this.favoritePatentClientNos.indexOf(patentClientNo) >= 0) {
            await this.removeFavoriteClient(patentClientNo);
            await this.service.render();
            return;
        }
        this.openFavoriteClientForm({ patentClientNo, applicant });
    }

    public caseWorkspaceTitle() {
        const titles: any = {
            domestic: '국내출원',
            dispute: '이의/심판/소송',
            foreign: '해외출원'
        };
        return titles[this.selectedWorkCard] || '국내출원';
    }

    public dashboardCardTitle(card: any) {
        if (card?.id === 'consultation' || card?.title === '상담/접수') return '상담/행정';
        return card?.title || '';
    }

    public caseWorkspaceDescription() {
        const descriptions: any = {
            domestic: '순수 내국인의 국내출원과 해외에서 국내단계로 진입한 출원을 함께 관리합니다.',
            dispute: '입력 항목이 유사한 이의신청, 심판, 소송 사건을 한 흐름에서 관리합니다.',
            foreign: '해외출원과 국가별 현지대리인 업무를 별도 흐름으로 관리합니다.'
        };
        return descriptions[this.selectedWorkCard] || descriptions.domestic;
    }

    public caseStageLabel(stage: string) {
        return stage === '상담/접수' ? '상담/행정' : stage;
    }

    public caseCategoryDetail(item: any) {
        const details = Array.isArray(item?.additional) ? item.additional : [];
        let patterns: string[] = [];
        if (this.selectedWorkCard === 'dispute') patterns = ['심판번호'];
        if (this.selectedWorkCard === 'foreign') patterns = ['국제출원번호', 'PCT', '우선권 주장'];
        if (this.selectedWorkCard === 'domestic') patterns = ['IPC', '청구항', '심사청구일', '우선권 주장'];
        const matched = details.filter((detail: any) => patterns.some((pattern) => String(detail || '').indexOf(pattern) === 0));
        return matched.join(' · ') || '-';
    }

    public casePrimaryDateLabel() {
        if (this.selectedWorkCard === 'dispute') return '분쟁 기준일';
        if (this.selectedWorkCard === 'foreign') return '해외출원일';
        return '출원일';
    }

    public caseOwnerLabel() {
        if (this.selectedWorkCard === 'dispute') return '분쟁 담당자';
        if (this.selectedWorkCard === 'foreign') return '해외출원 담당자';
        return '국내출원 담당자';
    }

    public async showDashboard() {
        this.setWorkspace('dashboard');
        this.syncLocationForWorkspace('dashboard');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    @HostListener('window:dashboard:navigate', ['$event'])
    public async handleDashboardNavigate(event: any) {
        this.setWorkspace(event?.detail?.workspace || 'dashboard');
        await this.loadActiveWorkspacePage(false);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    @HostListener('window:dashboard:category', ['$event'])
    public async handleDashboardCategory(event: any) {
        await this.openCaseCategory(event?.detail?.category || 'foreign');
    }

    @HostListener('window:dashboard:search', ['$event'])
    public async handleDashboardSearch(event: any) {
        this.query = String(event?.detail?.query || '');
        this.setWorkspace('search');
        this.syncLocationForWorkspace('search');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    @HostListener('window:popstate')
    public async handlePopState() {
        this.syncWorkspaceFromLocation();
        await this.loadActiveWorkspacePage(false);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public isInfoWorkspace() {
        return ['notices', 'laws', 'media', 'forms'].indexOf(this.activeWorkspace) >= 0;
    }

    public isInfoDetailWorkspace() {
        return this.activeWorkspace === 'infoDetail' && !!this.selectedInfoItem;
    }

    public infoWorkspaceTitle(workspace: string = this.currentInfoWorkspace()) {
        const map: any = {
            notices: '공지사항',
            laws: '법령/기준',
            media: '언론보도',
            forms: '각종 양식'
        };
        return map[workspace] || '자료모음';
    }

    public infoWorkspaceDescription(workspace: string = this.currentInfoWorkspace()) {
        const map: any = {
            notices: '웅빈 시스템 공지와 사무소 업무 공지를 함께 확인합니다.',
            laws: '개정 법령, 심사기준, 실무 체크리스트를 업무 기준으로 정리합니다.',
            media: '지식재산 관련 언론보도와 시장 이슈를 한 곳에서 확인합니다.',
            forms: '위임장, 의견서, 심판 자료 등 반복 업무 양식을 관리합니다.'
        };
        return map[workspace] || '';
    }

    public coreNoticesUnavailable() {
        return this.dashboard?.coreNoticesStatus?.available === false;
    }

    public coreNoticesStatusMessage() {
        return this.dashboard?.coreNoticesStatus?.message || '시스템 공지를 일시적으로 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
    }

    public coreResourceUnavailable() {
        const category = this.activeWorkspace === 'media' ? 'press' : this.activeWorkspace;
        return this.dashboard?.coreContentStatus?.[category]?.available === false;
    }

    public coreResourceStatusMessage() {
        const category = this.activeWorkspace === 'media' ? 'press' : this.activeWorkspace;
        return this.dashboard?.coreContentStatus?.[category]?.message || '시스템 자료를 일시적으로 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
    }

    public infoWorkspaceItems(workspace: string = this.currentInfoWorkspace()) {
        const map: any = {
            notices: this.dashboard.notices || [],
            laws: this.dashboard.laws || [],
            media: this.dashboard.media || [],
            forms: this.dashboard.forms || []
        };
        const items = (map[workspace] || []).slice();
        if (workspace === 'notices' && !items.some((item: any) => item.guideKey === 'ip-management-system-guide-v1')) {
            items.push(this.defaultIpManagementGuideNotice());
        }
        return items.sort((a: any, b: any) => {
            const pinnedDifference = Number(this.infoItemPinned(b)) - Number(this.infoItemPinned(a));
            if (pinnedDifference !== 0) return pinnedDifference;
            return this.infoItemUploadTimestamp(b).localeCompare(this.infoItemUploadTimestamp(a));
        });
    }

    public canManageNotices() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return role === 'TENANT_OWNER' || role === 'TENANT_ADMIN';
    }

    public infoItemPinned(item: any) {
        return !!item?.pinned;
    }

    public filteredInfoWorkspaceItems() {
        let list = this.infoWorkspaceItems();
        if (this.infoCategoryFilter !== 'all') {
            list = list.filter((item: any) => this.infoItemTypeLabel(item) === this.infoCategoryFilter);
        }

        const keyword = this.infoSearchQuery.trim().toLowerCase();
        if (keyword) {
            list = list.filter((item: any) => this.infoItemSearchText(item).indexOf(keyword) >= 0);
        }

        return list;
    }

    public paginatedInfoWorkspaceItems() {
        const list = this.filteredInfoWorkspaceItems();
        const page = this.normalizedInfoPage(list.length);
        const start = (page - 1) * this.infoPageSize;
        return list.slice(start, start + this.infoPageSize);
    }

    public noticeListNumber(index: number) {
        const offset = (this.normalizedInfoPage(this.filteredInfoWorkspaceItems().length) - 1) * this.infoPageSize;
        return Math.max(1, this.filteredInfoWorkspaceItems().length - offset - index);
    }

    public infoItemTitle(item: any) {
        return item.title || item.name || '';
    }

    public infoItemMeta(item: any, workspace: string = this.currentInfoWorkspace()) {
        const scope = item.scope === 'system' ? '웅빈 시스템' : (item.scope === 'admin' ? '관리자 업로드' : '사무소 업로드');
        if (workspace === 'notices') return `${scope} · ${item.category || '공지'} · ${item.date || ''}`;
        if (workspace === 'laws') return `${scope} · ${item.source || '기준'} · ${item.date || ''}`;
        if (workspace === 'media') return `${scope} · ${item.publisher || '언론'} · ${item.date || ''}`;
        if (workspace === 'forms') return `${scope} · ${item.updated || ''}`;
        return '';
    }

    public infoItemBadge(item: any, workspace: string = this.currentInfoWorkspace()) {
        if (item.scope === 'system') return '시스템';
        if (workspace === 'forms') return item.format || '';
        if (item.fileName) return '첨부';
        return item.priority || '';
    }

    public infoAdminItemCount() {
        return this.infoWorkspaceItems().filter((item: any) => item.scope === 'admin' || item.scope === 'system').length;
    }

    public infoWorkspaceCategories() {
        const counts: any = {};
        for (const item of this.infoWorkspaceItems()) {
            const label = this.infoItemTypeLabel(item);
            counts[label] = (counts[label] || 0) + 1;
        }
        return Object.keys(counts).map((label) => ({ label, count: counts[label] }));
    }

    public infoCategoryOptions() {
        return [
            { label: '전체', value: 'all', count: this.infoWorkspaceItems().length },
            ...this.infoWorkspaceCategories().map((item: any) => ({ label: item.label, value: item.label, count: item.count }))
        ];
    }

    public infoItemInitial(item: any) {
        const label = this.infoItemTypeLabel(item) || this.infoItemTitle(item) || this.workspaceTitle();
        return label.charAt(0);
    }

    public infoItemToneClass(item: any, workspace: string = this.currentInfoWorkspace()) {
        if (item.scope === 'admin' || item.scope === 'system') return 'bg-emerald-900 text-white';
        if (workspace === 'laws') return 'bg-blue-50 text-blue-700';
        if (workspace === 'media') return 'bg-violet-50 text-violet-700';
        if (workspace === 'forms') return 'bg-amber-50 text-amber-700';
        return 'bg-slate-100 text-slate-700';
    }

    public infoItemScopeLabel(item: any) {
        if (item.scope === 'system') return '웅빈 시스템';
        if (item.scope === 'admin') return '[관리자]';
        return item.scope === 'office' ? '사무소' : '공유';
    }

    public infoItemScopeClass(item: any) {
        if (item.scope === 'admin' || item.scope === 'system') return 'bg-emerald-900 text-white';
        return 'bg-slate-100 text-slate-600';
    }

    public infoItemTypeLabel(item: any, workspace: string = this.currentInfoWorkspace()) {
        if (workspace === 'laws') return item.category || item.source || '기준';
        if (workspace === 'media') return item.category || item.publisher || '언론';
        if (workspace === 'forms') return item.format || item.category || '양식';
        return item.category || '공지';
    }

    public infoItemSummary(item: any) {
        return item.summary || item.description || item.content || '';
    }

    public infoItemDate(item: any) {
        return item.date || item.updated || '';
    }

    public infoItemLatestUploadDate(item: any) {
        const timestamp = item?.latestAttachmentAt
            || this.infoItemAttachments(item)[0]?.uploadedAt
            || item?.createdAt
            || item?.updatedAt
            || this.infoItemDate(item);
        return String(timestamp || '').slice(0, 10);
    }

    public infoItemListSource(item: any, workspace: string = this.currentInfoWorkspace()) {
        const source = workspace === 'laws'
            ? (item?.source || item?.category)
            : workspace === 'media'
                ? (item?.publisher || item?.category)
                : (item?.category || item?.format);
        return source ? `[${source}]` : '-';
    }

    public infoItemAttachments(item: any) {
        const stored = Array.isArray(item?.attachments) ? item.attachments.filter((attachment: any) => !!attachment) : [];
        const attachments = stored.length ? stored.slice() : (item?.fileName ? [{
            documentId: item.attachmentDocumentId || '',
            fileId: item.attachmentFileId || '',
            name: item.fileName,
            uploadedAt: item.latestAttachmentAt || item.updatedAt || item.updated || item.date || '',
            uploader: item.uploader || '',
            note: '',
            size: item.attachmentSize || 0,
            mime: item.attachmentMime || '',
            scanStatus: item.attachmentScanStatus || '',
            downloadable: !!item.attachmentDownloadable
        }] : []);
        return attachments.sort((a: any, b: any) => String(b?.uploadedAt || '').localeCompare(String(a?.uploadedAt || '')));
    }

    public canAddInfoItemAttachment(item: any) {
        return ['laws', 'media', 'forms'].indexOf(this.selectedInfoWorkspace) >= 0 && !!item?.tenantId;
    }

    public async toggleNoticePin(item: any, event?: any) {
        event?.stopPropagation();
        if (!item || !this.canManageNotices()) return;
        const pinned = !this.infoItemPinned(item);
        const saved = await this.saveInfoItemRecord({
            ...item,
            workspace: 'notices',
            pinned,
            pinnedAt: pinned ? new Date().toISOString() : ''
        });
        if (!saved) {
            await this.service.modal.error('공지사항 고정 상태를 변경하지 못했습니다.');
            return;
        }
        this.dashboard.notices = [saved, ...(this.dashboard.notices || []).filter((row: any) => row.id !== saved.id)];
        if (this.selectedInfoItem?.id === item.id) this.selectedInfoItem = saved;
        this.infoPage = 1;
        await this.service.render();
    }

    public async downloadInfoAttachment(item: any) {
        const fileId = item?.fileId || item?.attachmentFileId || '';
        const documentId = item?.documentId || item?.attachmentDocumentId || '';
        if (!fileId) return;
        if (documentId) {
            const { code, data } = await wiz.call('save_document', {
                file_action: 'list',
                document_id: documentId
            });
            if (code === 200) {
                const currentFile = (data?.files || []).find((file: any) => file.id === fileId);
                if (currentFile) {
                    item.scanStatus = currentFile.scan_status || '';
                    item.downloadable = !!currentFile.downloadable;
                    item.size = currentFile.size_bytes || item.size || 0;
                }
            }
        }
        const scanStatus = item.scanStatus || item.attachmentScanStatus || '';
        const downloadable = item.downloadable ?? item.attachmentDownloadable;
        if (scanStatus !== 'CLEAN' || !downloadable) {
            await this.service.modal.warning('보안 검사가 완료된 첨부자료만 다운로드할 수 있습니다.');
            await this.service.render();
            return;
        }
        const link = document.createElement('a');
        link.href = `${wiz.url('save_document')}?file_action=download&file_id=${encodeURIComponent(fileId)}`;
        link.download = item.name || item.fileName || 'attachment';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    public infoItemSource(item: any, workspace: string = this.currentInfoWorkspace()) {
        if (workspace === 'laws') return item.source || '';
        if (workspace === 'media') return item.publisher || '';
        if (workspace === 'forms') return item.category || item.format || '';
        return item.uploader || '';
    }

    public infoDetailRows() {
        const item = this.selectedInfoItem || {};
        const workspace = this.selectedInfoWorkspace;
        const rows = [
            { label: '자료함', value: this.infoWorkspaceTitle(workspace) },
            { label: '구분', value: this.infoItemTypeLabel(item, workspace) },
            { label: workspace === 'forms' ? '수정일' : '기준일', value: this.infoItemDate(item) },
            { label: workspace === 'laws' ? '출처' : workspace === 'media' ? '매체' : '작성자', value: this.infoItemSource(item, workspace) },
            { label: '첨부자료', value: this.infoItemAttachments(item).length ? `${this.infoItemAttachments(item).length}개` : '' },
            { label: '최신 업로드', value: this.infoItemLatestUploadDate(item) }
        ];
        return rows.filter((row) => !!row.value);
    }

    public infoPageNumbers() {
        const total = this.infoTotalPages();
        const start = Math.max(1, Math.min(this.normalizedInfoPage(this.filteredInfoWorkspaceItems().length) - 2, Math.max(1, total - 4)));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public infoTotalPages() {
        return Math.max(1, Math.ceil(this.filteredInfoWorkspaceItems().length / this.infoPageSize));
    }

    public infoPageSummary() {
        const total = this.filteredInfoWorkspaceItems().length;
        if (total === 0) return '0건';
        const page = this.normalizedInfoPage(total);
        const start = (page - 1) * this.infoPageSize + 1;
        const end = Math.min(total, page * this.infoPageSize);
        return `${start}-${end} / ${total}건`;
    }

    public resetInfoPage() {
        this.infoPage = 1;
    }

    public async resetInfoFilters() {
        this.infoSearchQuery = '';
        this.infoCategoryFilter = 'all';
        this.infoPage = 1;
        await this.service.render();
    }

    public async setInfoPage(page: number) {
        this.infoPage = Math.max(1, Math.min(page, this.infoTotalPages()));
        await this.service.render();
    }

    public async previousInfoPage() {
        await this.setInfoPage(this.normalizedInfoPage(this.filteredInfoWorkspaceItems().length) - 1);
    }

    public async nextInfoPage() {
        await this.setInfoPage(this.normalizedInfoPage(this.filteredInfoWorkspaceItems().length) + 1);
    }

    private async loadActiveWorkspacePage(render: boolean = true) {
        if (this.activeWorkspace === 'cases') await this.loadCasePage(this.casePage, false);
        if (this.activeWorkspace === 'clients') await this.loadClientPage(this.clientPage, false);
        if (this.activeWorkspace === 'adminSupport') await this.loadAdminNoticeList(this.adminNoticePage, false);
        if (this.activeWorkspace === 'clientDetail') {
            const clientId = new URLSearchParams(location.search).get('client') || this.selectedClient?.id || this.selectedClient?.clientId || '';
            if (clientId) await this.loadClientDetail(clientId, false);
            else this.clientDetailError = '선택한 고객 정보가 없습니다.';
        }
        if (this.activeWorkspace === 'favoriteClients') {
            await this.loadFavoriteClients(false);
            if (this.selectedFavoriteClient) await this.loadFavoriteClientCases(this.favoriteCasePage, false);
        }
        if (render) await this.service.render();
    }

    public async loadCasePage(page: number = this.casePage, render: boolean = true) {
        const targetPage = Math.max(1, Number(page || 1));
        const isDomestic = this.selectedWorkCard === 'domestic';
        const isDispute = this.selectedWorkCard === 'dispute';
        const isForeign = this.selectedWorkCard === 'foreign';
        const { code, data } = await wiz.call('cases', {
            page: targetPage,
            page_size: this.casePageSize,
            today: this.today,
            search: isDomestic || isDispute || isForeign ? '' : this.caseSearchQuery.trim(),
            status: isDomestic || isDispute || isForeign ? '' : this.caseStageFilter,
            right: this.caseRightFilter,
            applicant_scope: 'all',
            applicant_search: isDomestic || isDispute || isForeign ? this.caseApplicantKeyword.trim() : '',
            number_search: isDomestic || isDispute || isForeign ? this.caseNumberSearchQuery.trim() : '',
            sort: isDomestic ? `filing_${this.caseFilingSort}` : 'updated_desc',
            case_category: ['domestic', 'dispute', 'foreign'].indexOf(this.selectedWorkCard) >= 0 ? this.selectedWorkCard : ''
        });
        if (code === 401) {
            this.redirectToAccess();
            return;
        }
        if (code === 400 && targetPage !== 1) {
            await this.loadCasePage(1, render);
            return;
        }
        if (code !== 200) {
            this.cases = [];
            this.caseTotalCount = 0;
            this.selectedCase = null;
            if (isDispute) {
                this.disputeSummaryCounts = { all: 0, objection: 0, trial: 0, litigation: 0 };
            }
            await this.service.modal.error(data?.message || data?.error || '사건 목록을 불러오지 못했습니다.');
            if (render) await this.service.render();
            return;
        }
        if (code === 200) {
            this.casePage = Number(data.page || 1);
            this.caseTotalCount = Number(data.total_count || 0);
            if (isDispute) {
                const summary = data.summary_counts || {};
                this.disputeSummaryCounts = {
                    all: Number(summary.all || 0),
                    objection: Number(summary.objection || 0),
                    trial: Number(summary.trial || 0),
                    litigation: Number(summary.litigation || 0)
                };
            }
            this.cases = data.items || [];
            this.normalizeCaseData();
            if (!this.selectedCase || !this.cases.some((item: any) => item.id === this.selectedCase?.id)) {
                this.selectedCase = this.cases[0] || null;
            }
        }
        if (render) await this.service.render();
    }

    public async loadClientPage(page: number = this.clientPage, render: boolean = true) {
        const targetPage = Math.max(1, Number(page || 1));
        this.clientListError = '';
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call('clients', {
                page: targetPage,
                page_size: this.clientPageSize,
                search: this.clientSearchQuery.trim(),
                status: this.clientStatusFilter
            });
            if (code === 401) {
                this.redirectToAccess();
                return;
            }
            if (code === 400 && targetPage !== 1) {
                await this.loadClientPage(1, render);
                return;
            }
            if (code !== 200) {
                this.clients = [];
                this.clientPage = 1;
                this.clientTotalCount = 0;
                this.clientDirectoryTotalCount = 0;
                this.selectedClient = null;
                this.clientListError = data?.message || data?.error || '고객 목록을 불러오지 못했습니다.';
                return;
            }

            this.clientPage = Number(data.page || 1);
            this.clientTotalCount = Number(data.total_count || 0);
            this.clientDirectoryTotalCount = Number(data.directory_total_count || data.total_count || 0);
            this.clients = (data.items || []).map((item: any) => ({ ...item }));
            const statuses = Array.isArray(data.available_statuses) ? data.available_statuses : [];
            if (statuses.length > 0) {
                this.clientStatusOptions = statuses.map((status: string) => ({
                    code: status,
                    label: this.clientStatusLabel(status)
                }));
            }
            if (!this.selectedClient || !this.clients.some((item: any) => item.id === this.selectedClient?.id)) {
                this.selectedClient = this.clients[0] || null;
            }
        } catch (error) {
            console.error('dashboard Core managed-clients failed', error);
            this.clients = [];
            this.clientPage = 1;
            this.clientTotalCount = 0;
            this.clientDirectoryTotalCount = 0;
            this.selectedClient = null;
            this.clientListError = '고객 목록을 불러오지 못했습니다. 네트워크 연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            if (render) await this.service.render();
        }
    }

    public async loadRightPage(page: number = this.rightPage, render: boolean = true) {
        const targetPage = Math.max(1, Number(page || 1));
        const { code, data } = await wiz.call('rights', {
            page: targetPage,
            page_size: this.rightPageSize,
            search: this.rightSearchQuery.trim(),
            status: this.rightStatusFilter,
            right: this.rightTypeFilter
        });
        if (code === 401) {
            this.redirectToAccess();
            return;
        }
        if (code === 400 && targetPage !== 1) {
            await this.loadRightPage(1, render);
            return;
        }
        if (code === 200) {
            this.rightPage = Number(data.page || 1);
            this.rightTotalCount = Number(data.total_count || 0);
            this.rightRecords = data.items || [];
            this.rightStatusOptions = data.available_statuses || [];
        }
        if (render) await this.service.render();
    }

    public workCardCount(card: any) {
        const id = card?.id || '';
        const resourceCounts = this.dashboard?.resourceCounts || {};
        if (Object.prototype.hasOwnProperty.call(resourceCounts, id)) {
            const count = Number(resourceCounts[id]);
            return Number.isFinite(count) ? Math.max(0, count) : 0;
        }
        if (id === 'consultation') {
            return this.consultations.length;
        }
        if (['domestic', 'dispute', 'foreign'].indexOf(id) >= 0) {
            return this.cases.filter((item) => this.isCaseListItem(item) && this.caseCategory(item) === id).length;
        }
        return 0;
    }

    private adjustWorkCardCount(cardId: string, delta: number) {
        const resourceCounts = this.dashboard?.resourceCounts || {};
        if (!Object.prototype.hasOwnProperty.call(resourceCounts, cardId)) return;
        const current = Number(resourceCounts[cardId]);
        if (!Number.isFinite(current)) return;
        resourceCounts[cardId] = Math.max(0, current + delta);
    }

    public get filteredCases() {
        return this.cases.filter((item) => this.isCaseListItem(item));
    }

    public paginatedCases() {
        return this.filteredCases;
    }

    public caseCurrentPage() {
        return Math.max(1, this.casePage);
    }

    public caseTotalPages() {
        return Math.max(1, Math.ceil(this.caseTotalCount / this.casePageSize));
    }

    public casePageNumbers() {
        const total = this.caseTotalPages();
        const current = this.caseCurrentPage();
        const start = Math.max(1, Math.min(current - 2, Math.max(1, total - 4)));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public casePageSummary() {
        const total = this.caseTotalCount;
        if (total === 0) return '0건';
        const current = this.caseCurrentPage();
        const start = (current - 1) * this.casePageSize + 1;
        const end = Math.min(total, current * this.casePageSize);
        return `${start}-${end} / ${total}건`;
    }

    public resetCasePage() {
        this.casePage = 1;
    }

    public async setCasePage(page: number) {
        await this.loadCasePage(Math.max(1, Math.min(page, this.caseTotalPages())), false);
        await this.service.render();
        document.querySelector('.case-list-shell')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async previousCasePage() {
        await this.setCasePage(this.caseCurrentPage() - 1);
    }

    public async nextCasePage() {
        await this.setCasePage(this.caseCurrentPage() + 1);
    }

    public async onCaseFiltersChange() {
        this.casePage = 1;
        await this.loadCasePage(1);
    }

    public scheduleCaseSearch() {
        if (this.caseSearchTimer) clearTimeout(this.caseSearchTimer);
        this.caseSearchTimer = setTimeout(async () => {
            this.casePage = 1;
            await this.loadCasePage(1);
        }, 300);
    }

    public async resetDomesticCaseFilters() {
        this.caseSearchQuery = '';
        this.caseStageFilter = '';
        this.caseRightFilter = '';
        this.caseApplicantScope = 'all';
        this.caseApplicantKeyword = '';
        this.caseNumberSearchQuery = '';
        this.caseFilingSort = 'desc';
        this.casePage = 1;
        await this.loadCasePage(1);
    }

    public async resetDisputeCaseFilters() {
        this.caseSearchQuery = '';
        this.caseStageFilter = '';
        this.caseRightFilter = '';
        this.caseApplicantKeyword = '';
        this.caseNumberSearchQuery = '';
        this.casePage = 1;
        await this.loadCasePage(1);
    }

    public async resetForeignCaseFilters() {
        this.caseSearchQuery = '';
        this.caseStageFilter = '';
        this.caseRightFilter = '';
        this.caseApplicantKeyword = '';
        this.caseNumberSearchQuery = '';
        this.casePage = 1;
        await this.loadCasePage(1);
    }

    public isPrimaryCaseCategory() {
        return ['domestic', 'dispute', 'foreign'].indexOf(this.selectedWorkCard) >= 0;
    }

    public primaryCaseRightOptions() {
        return this.selectedWorkCard === 'foreign' ? this.foreignRightOptions : this.domesticRightOptions;
    }

    public primaryCaseNumberPlaceholder() {
        if (this.selectedWorkCard === 'dispute') return '사건번호 / 등록번호';
        if (this.selectedWorkCard === 'foreign') return '국제등록번호 / 국내출원번호';
        return '출원번호 / 등록번호 / 고객번호';
    }

    public primaryCaseNumberAriaLabel() {
        if (this.selectedWorkCard === 'dispute') return '사건번호 또는 등록번호 검색';
        if (this.selectedWorkCard === 'foreign') return '국제등록번호 또는 국내출원번호 검색';
        return '출원번호 등록번호 또는 고객번호 검색';
    }

    public primaryCasePartyPlaceholder() {
        if (this.selectedWorkCard === 'dispute') return '의뢰인 / 청구인 / 피청구인';
        if (this.selectedWorkCard === 'foreign') return '출원인';
        return '출원인 / 기업체 담당자';
    }

    public primaryCasePartyAriaLabel() {
        if (this.selectedWorkCard === 'dispute') return '의뢰인 청구인 또는 피청구인 검색';
        if (this.selectedWorkCard === 'foreign') return '출원인 검색';
        return '출원인 또는 기업체 담당자 검색';
    }

    public async resetPrimaryCaseFilters() {
        if (this.selectedWorkCard === 'dispute') {
            await this.resetDisputeCaseFilters();
            return;
        }
        if (this.selectedWorkCard === 'foreign') {
            await this.resetForeignCaseFilters();
            return;
        }
        await this.resetDomesticCaseFilters();
    }

    public async toggleCaseFilingSort() {
        this.caseFilingSort = this.caseFilingSort === 'desc' ? 'asc' : 'desc';
        this.casePage = 1;
        await this.loadCasePage(1);
    }

    public caseFilingSortLabel() {
        return this.caseFilingSort === 'desc'
            ? '현재 최근 출원일순입니다. 클릭하면 과거 출원일순으로 변경됩니다.'
            : '현재 과거 출원일순입니다. 클릭하면 최근 출원일순으로 변경됩니다.';
    }

    public caseFilingAriaSort() {
        return this.caseFilingSort === 'desc' ? 'descending' : 'ascending';
    }

    private caseCategory(item: any) {
        if (item?.workflow === 'dispute') return 'dispute';
        if (item?.type === '해외출원') return 'foreign';
        return 'domestic';
    }

    public get filteredConsultations() {
        let list = this.consultations.slice();
        if (this.consultationTypeFilter) {
            list = list.filter((item) => this.normalizeConsultationType(item?.consultationType, item?.rightType) === this.normalizeConsultationType(this.consultationTypeFilter));
        }
        if (this.consultationConsultantQuery.trim()) {
            list = list.filter((item) => this.matchesConsultationQuickSearch(
                this.consultationConsultantQuery,
                [item?.consultant, item?.clientContactName]
            ));
        }
        if (this.consultationApplicationNoQuery.trim()) {
            list = list.filter((item) => this.matchesConsultationQuickSearch(
                this.consultationApplicationNoQuery,
                this.consultationApplicationNumberValues(item)
            ));
        }
        if (this.consultationRegistrationNoQuery.trim()) {
            list = list.filter((item) => this.matchesConsultationQuickSearch(
                this.consultationRegistrationNoQuery,
                this.consultationRegistrationNumberValues(item)
            ));
        }
        if (this.query.trim()) {
            list = list.filter((item) => this.matches(item, [
                'receiptNo', 'title', 'clientName', 'consultant', 'consultationType',
                'rightType', 'assignee', 'applicationNo', 'registrationNo', 'status'
            ]));
        }
        return list;
    }

    private normalizeConsultationType(value: any, rightType: any = '') {
        const text = String(value || '').trim();
        if (text !== '연차/갱신') return text;
        return String(rightType || '').trim() === '상표'
            ? '갱신(상표)'
            : '연차(특허·실용, 디자인)';
    }

    public consultationTypeLabel(value: any, rightType: any = '') {
        return this.normalizeConsultationType(value, rightType) || '기타';
    }

    public consultationFiltersActive() {
        return !!(
            this.consultationTypeFilter
            || this.consultationConsultantQuery.trim()
            || this.consultationApplicationNoQuery.trim()
            || this.consultationRegistrationNoQuery.trim()
        );
    }

    public async onConsultationFiltersChange() {
        await this.service.render();
    }

    public async resetConsultationFilters() {
        this.consultationTypeFilter = '';
        this.consultationConsultantQuery = '';
        this.consultationApplicationNoQuery = '';
        this.consultationRegistrationNoQuery = '';
        await this.service.render();
    }

    public consultationApplicationNo(item: any) {
        return this.consultationApplicationNumberValues(item).join(', ');
    }

    public consultationRegistrationNo(item: any) {
        return this.consultationRegistrationNumberValues(item).join(', ');
    }

    public get searchResults() {
        const q = this.query.trim().toLowerCase();
        if (!q) return [];
        const rows: any[] = [];
        for (const item of this.cases.filter((row) => this.isCaseListItem(row))) {
            if (this.matches(item, ['title', 'applicationNo', 'registrationNo', 'clientName', 'applicant', 'patentClientNo', 'memo'])) {
                rows.push({ type: '사건', title: item.title, subtitle: `${item.clientName} · ${item.applicationNo || '출원번호 없음'}`, item });
            }
        }
        for (const item of this.consultations) {
            if (this.matches(item, ['receiptNo', 'title', 'clientName', 'rightType', 'assignee', 'status'])) {
                rows.push({ type: '상담', title: item.title, subtitle: `${item.clientName} · ${item.status}`, item });
            }
        }
        for (const item of this.clients) {
            if (this.matches(item, ['name', 'type', 'patentClientNo', 'owner'])) {
                rows.push({ type: '고객', title: item.name, subtitle: `${item.type} · ${item.patentClientNo}`, item });
            }
        }
        return rows.slice(0, 12);
    }

    private matches(item: any, fields: string[]) {
        const q = this.query.trim().toLowerCase();
        if (!q) return true;
        return fields.some((field) => String(item[field] || '').toLowerCase().indexOf(q) >= 0);
    }

    private matchesConsultationQuickSearch(query: string, values: any[]) {
        const keyword = this.normalizeConsultationSearchValue(query);
        if (!keyword) return true;
        return (values || []).some((value) => this.normalizeConsultationSearchValue(value).indexOf(keyword) >= 0);
    }

    private normalizeConsultationSearchValue(value: any) {
        return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '');
    }

    private consultationApplicationNumberValues(item: any) {
        const registrationDraft = item?.registrationDraft || {};
        const detail = registrationDraft?.detail || {};
        const dispute = detail?.dispute || {};
        const foreign = detail?.foreign || {};
        const values: any[] = [
            item?.applicationNo,
            registrationDraft?.applicationNo,
            dispute?.baseApplicationNo,
            dispute?.customerMatterNumberType === 'application' ? dispute?.customerMatterNumber : '',
            foreign?.domesticApplicationNo,
            foreign?.internationalApplicationNo
        ];
        this.appendConsultationApplicationBranchNumbers(values, detail?.trademark?.applications);
        this.appendConsultationApplicationBranchNumbers(values, detail?.design?.applications);
        for (const application of (foreign?.countryApplications || [])) {
            values.push(
                application?.applicationNo,
                application?.localApplicationNo,
                application?.internationalApplicationNo
            );
        }
        return this.uniqueConsultationSearchValues(values);
    }

    private consultationRegistrationNumberValues(item: any) {
        const registrationDraft = item?.registrationDraft || {};
        const detail = registrationDraft?.detail || {};
        const dispute = detail?.dispute || {};
        const foreign = detail?.foreign || {};
        const values: any[] = [
            item?.registrationNo,
            registrationDraft?.registrationNo,
            dispute?.baseRegistrationNo,
            dispute?.customerMatterNumberType === 'registration' ? dispute?.customerMatterNumber : '',
            foreign?.internationalRegistrationNo
        ];
        for (const application of (foreign?.countryApplications || [])) {
            values.push(
                application?.registrationNo,
                application?.localRegistrationNo,
                application?.internationalRegistrationNo
            );
        }
        return this.uniqueConsultationSearchValues(values);
    }

    private appendConsultationApplicationBranchNumbers(values: any[], applications: any) {
        for (const key of Object.keys(applications || {})) {
            values.push(applications[key]?.applicationNo);
        }
    }

    private uniqueConsultationSearchValues(values: any[]) {
        return (values || [])
            .map((value) => String(value || '').trim())
            .filter((value, index, rows) => !!value && rows.indexOf(value) === index);
    }

    private currentUserName() {
        return String(this.service?.auth?.session?.name || this.service?.auth?.session?.email || '').trim();
    }

    private currentUserId() {
        return String(this.service?.auth?.session?.id || '').trim();
    }

    private personKey(value: any) {
        return String(value || '').replace(/\s/g, '').toLowerCase();
    }

    private matchesCurrentUser(value: any) {
        const userKey = this.personKey(this.currentUserName());
        const valueKey = this.personKey(value);
        if (!userKey || !valueKey) return false;
        return userKey === valueKey;
    }

    private matchesCurrentUserId(value: any) {
        const userId = this.currentUserId();
        const valueId = String(value || '').trim();
        return !!userId && !!valueId && userId === valueId;
    }

    private isAssignedToCurrentUser(item: any) {
        return this.matchesCurrentUserId(item?.managerId)
            || this.matchesCurrentUserId(item?.assigneeId)
            || this.matchesCurrentUserId(item?.attorneyId)
            || this.matchesCurrentUser(item?.assignee)
            || this.matchesCurrentUser(item?.attorney)
            || this.matchesCurrentUser(item?.consultant);
    }

    private setWorkspace(id: string) {
        const workspace = this.normalizeWorkspace(id) || 'dashboard';
        const previousWorkspace = this.activeWorkspace;
        this.activeWorkspace = workspace;
        if (workspace !== 'adminSupport') {
            this.revokeAdminNoticePreview();
            this.adminNoticePdfError = '';
        }
        if (workspace !== 'adminSupport' || previousWorkspace !== 'adminSupport') {
            this.selectedAdminConsultation = null;
            this.selectedAdminConsultationAnswer = null;
        }
        if (workspace === 'quoteComposer') {
            this.showQuoteForm = true;
            if (!(this.quoteDraft?.costItems || []).length) this.quoteDraft = this.emptyQuoteDraft(null);
        } else if (workspace === 'standardQuoteDetail') {
            this.selectedStandardQuoteTemplate = this.selectedStandardQuoteTemplate || this.standardQuoteForms[0] || null;
        } else if (previousWorkspace === 'quoteComposer') {
            this.showQuoteForm = false;
        }
        if (this.normalizeInfoWorkspace(workspace)) {
            this.selectedInfoWorkspace = workspace;
            this.selectedInfoItem = null;
            if (previousWorkspace !== workspace) {
                this.infoSearchQuery = '';
                this.infoCategoryFilter = 'all';
                this.infoPage = 1;
            }
        }
        if (workspace === 'cases' && !this.normalizeCaseCategory(this.selectedWorkCard)) this.selectedWorkCard = 'domestic';
        if (workspace === 'intakeConsultations') this.selectedWorkCard = 'consultation';
        if (workspace === 'clients' && !this.selectedClient) this.selectedClient = this.clients[0] || null;
        if (workspace === 'search') this.query = this.query || '';
    }

    private syncLocationForWorkspace(id: string, replace: boolean = false) {
        if (location.pathname !== '/dashboard') return;
        const workspace = this.normalizeWorkspace(id);
        if (!workspace) return;

        let nextUrl = workspace === 'dashboard' ? '/dashboard' : `/dashboard?workspace=${workspace}`;
        if (workspace === 'cases' || workspace === 'caseDetail') {
            const params = new URLSearchParams({
                workspace,
                category: this.normalizeCaseCategory(this.selectedWorkCard) || 'domestic'
            });
            nextUrl = `/dashboard?${params.toString()}`;
        }
        if (workspace === 'intakeConsultations' || workspace === 'intakeConsultationDetail') {
            const params = new URLSearchParams({ workspace, category: 'consultation' });
            nextUrl = `/dashboard?${params.toString()}`;
        }
        if (workspace === 'infoDetail') {
            const params = new URLSearchParams({
                workspace: 'infoDetail',
                infoWorkspace: this.selectedInfoWorkspace || 'notices'
            });
            if (this.selectedInfoItem?.id) params.set('item', String(this.selectedInfoItem.id));
            nextUrl = `/dashboard?${params.toString()}`;
        }
        if (workspace === 'clientDetail') {
            const params = new URLSearchParams({ workspace: 'clientDetail' });
            const clientId = this.selectedClient?.id || this.selectedClient?.clientId || '';
            if (clientId) params.set('client', String(clientId));
            nextUrl = `/dashboard?${params.toString()}`;
        }
        const currentUrl = `${location.pathname}${location.search}${location.hash}`;
        if (currentUrl !== nextUrl) {
            if (replace) history.replaceState({ workspace }, '', nextUrl);
            else history.pushState({ workspace }, '', nextUrl);
        }
    }

    private notifyWorkspaceChanged() {
        window.dispatchEvent(new CustomEvent('dashboard:workspace-changed', { detail: { workspace: this.activeWorkspace } }));
    }

    private syncWorkspaceFromLocation() {
        const params = new URLSearchParams(location.search);
        const requestedWorkspace = params.get('workspace') || '';
        const workspace = this.workspaceFromLocation();
        const category = this.normalizeCaseCategory(params.get('category') || '');
        if ((workspace === 'cases' || workspace === 'caseDetail') && category) this.selectedWorkCard = category;
        if (workspace === 'cases' && !category) this.selectedWorkCard = 'domestic';
        if (workspace) this.setWorkspace(workspace);
        if (workspace === 'infoDetail') this.syncInfoDetailFromLocation();
        if (requestedWorkspace === 'consultations') {
            params.set('workspace', 'intakeConsultations');
            params.set('category', 'consultation');
            history.replaceState({ workspace: 'intakeConsultations' }, '', `/dashboard?${params.toString()}`);
        }
    }

    private workspaceFromLocation() {
        const params = new URLSearchParams(location.search);
        const fromQuery = this.normalizeWorkspace(params.get('workspace') || '');
        if (fromQuery) return fromQuery;
        return this.normalizeWorkspace(location.hash.replace('#', ''));
    }

    private normalizeWorkspace(id: string) {
        if (id === 'consultations') return 'intakeConsultations';
        if (id === 'consultationDetail') return 'intakeConsultationDetail';
        const allowed = ['dashboard', 'search', 'cases', 'clients', 'clientDetail', 'favoriteClients', 'standardQuotes', 'standardQuoteDetail', 'quoteComposer', 'businessManagement', 'ipMarket', 'ipo', 'kipris', 'adminSupport', 'accessStatus', 'intakeConsultations', 'intakeConsultationDetail', 'caseDetail', 'infoDetail', 'notices', 'laws', 'media', 'forms'];
        if (allowed.indexOf(id) >= 0) return id;
        return '';
    }

    private normalizeCaseCategory(id: string) {
        const allowed = ['consultation', 'domestic', 'dispute', 'foreign'];
        if (allowed.indexOf(id) >= 0) return id;
        return '';
    }

    private normalizeInfoWorkspace(id: string) {
        const allowed = ['notices', 'laws', 'media', 'forms'];
        if (allowed.indexOf(id) >= 0) return id;
        return '';
    }

    private currentInfoWorkspace() {
        return this.normalizeInfoWorkspace(this.activeWorkspace) || this.selectedInfoWorkspace || 'notices';
    }

    private infoItemSearchText(item: any) {
        return [
            this.infoItemTitle(item),
            this.infoItemSummary(item),
            this.infoItemTypeLabel(item),
            this.infoItemDate(item),
            this.infoItemSource(item),
            item.fileName,
            this.infoItemAttachments(item).map((attachment: any) => [attachment.name, attachment.note, attachment.uploader].join(' ')).join(' '),
            item.priority,
            this.infoItemScopeLabel(item)
        ].map((value) => String(value || '').toLowerCase()).join(' ');
    }

    private normalizedInfoPage(totalItems: number) {
        const totalPages = Math.max(1, Math.ceil(totalItems / this.infoPageSize));
        return Math.max(1, Math.min(this.infoPage, totalPages));
    }

    private syncInfoDetailFromLocation() {
        const params = new URLSearchParams(location.search);
        const workspace = this.normalizeInfoWorkspace(params.get('infoWorkspace') || '') || this.selectedInfoWorkspace || 'notices';
        const itemId = params.get('item') || '';
        this.selectedInfoWorkspace = workspace;
        const items = this.infoWorkspaceItems(workspace);
        this.selectedInfoItem = items.find((item: any) => String(item.id || '') === itemId) || items[0] || null;
        if (!this.selectedInfoItem) {
            this.setWorkspace(workspace);
            this.syncLocationForWorkspace(workspace);
        }
    }

    public async openSearchResult(result: any) {
        if (result.type === '사건') await this.openCase(result.item);
        if (result.type === '상담') await this.openConsultation(result.item);
        if (result.type === '고객') await this.openClient(result.item);
    }

    public async openInfoDetail(item: any) {
        if (!item) return;
        this.selectedInfoWorkspace = this.normalizeInfoWorkspace(this.activeWorkspace) || this.selectedInfoWorkspace || 'notices';
        this.selectedInfoItem = item;
        this.infoDetailAttachmentDraft = this.emptyInfoDetailAttachmentDraft();
        this.activeWorkspace = 'infoDetail';
        this.syncLocationForWorkspace('infoDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async backToInfoWorkspace() {
        const workspace = this.selectedInfoWorkspace || 'notices';
        this.selectedInfoItem = null;
        this.infoDetailAttachmentDraft = this.emptyInfoDetailAttachmentDraft();
        this.setWorkspace(workspace);
        this.syncLocationForWorkspace(workspace);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async openCase(item: any) {
        if (!item) return;
        const sourceWorkspace = this.activeWorkspace;
        const listCategory = sourceWorkspace === 'cases'
            ? this.normalizeCaseCategory(this.selectedWorkCard)
            : '';
        this.caseDetailReturnWorkspace = sourceWorkspace === 'favoriteClients'
            ? 'favoriteClients'
            : (sourceWorkspace === 'clientDetail' ? 'clientDetail' : 'cases');
        this.caseDetailReturnCategory = listCategory || this.caseCategory(item);
        this.selectedWorkCard = this.caseDetailReturnCategory;
        this.selectedCase = item;
        this.ensureCaseDetailShape(this.selectedCase);
        this.selectedCaseTab = 'documents';
        this.isCaseSummaryEditing = false;
        this.showCaseConsultationHistory = false;
        this.showCaseChangeHistory = false;
        this.showAnnuityHistory = false;
        this.annuityEditSnapshot = null;
        this.showTrademarkRenewalHistory = false;
        this.trademarkRenewalEditSnapshot = null;
        this.caseChangeHistory = [];
        this.activeWorkspace = 'caseDetail';
        this.syncLocationForWorkspace('caseDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
        if (!item?._testFavorite) {
            try {
                await this.loadDocumentFilesForCase(item, false);
            } catch (error) {
                console.error('dashboard case document metadata load failed', error);
            }
        }
        await this.service.render();
    }

    public async backToCaseList() {
        this.isCaseSummaryEditing = false;
        this.showCaseConsultationHistory = false;
        this.showCaseChangeHistory = false;
        this.showAnnuityHistory = false;
        this.annuityEditSnapshot = null;
        this.showTrademarkRenewalHistory = false;
        this.trademarkRenewalEditSnapshot = null;
        if (this.caseDetailReturnWorkspace === 'favoriteClients') {
            this.activeWorkspace = 'favoriteClients';
            this.syncLocationForWorkspace('favoriteClients');
            this.notifyWorkspaceChanged();
            await this.loadFavoriteClients(false);
            if (this.selectedFavoriteClient) await this.loadFavoriteClientCases(this.favoriteCasePage, false);
            await this.service.render();
            return;
        }
        if (this.caseDetailReturnWorkspace === 'clientDetail' && this.selectedClient) {
            this.activeWorkspace = 'clientDetail';
            this.syncLocationForWorkspace('clientDetail');
            this.notifyWorkspaceChanged();
            await this.service.render();
            return;
        }
        const category = this.normalizeCaseCategory(this.caseDetailReturnCategory)
            || this.normalizeCaseCategory(this.selectedWorkCard)
            || 'domestic';
        await this.openCaseCategory(category);
    }

    public async toggleCaseSummaryEdit() {
        if (this.isCaseSummaryEditing && this.selectedCase) {
            if (!await this.allowDraftInput(this.selectedCase, 'save_case')) return;
            this.applyPriorityApplicationNumber(this.selectedCase);
                this.syncCaseFromDetail(this.selectedCase);
            const saved = await this.saveCaseRecord(this.selectedCase);
            if (saved) {
                this.ensureCaseDetailShape(saved);
                this.replaceCase(saved);
                if (this.showCaseChangeHistory) await this.loadCaseChangeHistory(false);
            }
        }
        this.isCaseSummaryEditing = !this.isCaseSummaryEditing;
        await this.service.render();
    }

    public openCaseDetailDatePicker(event: any) {
        const input = event?.target;
        if (!input || String(input.tagName || '').toLowerCase() !== 'input' || String(input.type || '').toLowerCase() !== 'date') return;
        if (input.disabled || input.getAttribute?.('data-auto-date') === 'true') return;
        event.__systemDatePickerHandled = true;
        if (input.readOnly && !this.isCaseSummaryEditing) {
            this.isCaseSummaryEditing = true;
            input.readOnly = false;
            this.service.render();
        }
        if (input.readOnly) return;
        try {
            input.focus({ preventScroll: true });
            if (typeof input.showPicker === 'function') input.showPicker();
        } catch (error) {
            input.focus();
        }
    }

    public async toggleCaseConsultationHistory() {
        this.showCaseConsultationHistory = !this.showCaseConsultationHistory;
        await this.service.render();
        if (this.showCaseConsultationHistory) this.focusCaseSection('case-consultation-history');
    }

    public async toggleCaseChangeHistory() {
        this.showCaseChangeHistory = !this.showCaseChangeHistory;
        if (this.showCaseChangeHistory) await this.loadCaseChangeHistory();
        await this.service.render();
        if (this.showCaseChangeHistory) this.focusCaseSection('case-change-history');
    }

    public async loadCaseChangeHistory(showError: boolean = true) {
        if (!this.selectedCase?.id) return;
        this.caseChangeHistoryLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('change_history', { matter_id: this.selectedCase.id });
            if (code === 200) {
                this.caseChangeHistory = Array.isArray(data?.history) ? data.history : [];
                return;
            }
            if (showError) await this.service.modal.error(data?.message || '변경이력을 불러오지 못했습니다.');
        } catch (error) {
            console.error('dashboard change_history failed', error);
            if (showError) await this.service.modal.error('변경이력을 불러오지 못했습니다.');
        } finally {
            this.caseChangeHistoryLoading = false;
            await this.service.render();
        }
    }

    public changeHistoryOperationLabel(value: string) {
        if (value === 'create') return '최초 등록';
        if (value === 'delete') return '삭제';
        return '수정';
    }

    public changeHistoryValue(value: any) {
        const text = String(value || '').trim();
        if (!text) return '(입력 없음)';
        try {
            return JSON.stringify(JSON.parse(text), null, 2);
        } catch (_) {
            return text;
        }
    }

    public caseConsultationHistories() {
        if (!this.selectedCase?.id) return [];
        const histories: any[] = [];
        const caseKey = String(this.selectedCase?.caseKey || this.selectedCase?.detail?.caseKey || '').trim();
        for (const consultation of this.consultations.filter((item) =>
            item.transferredMatterId === this.selectedCase.id
            || (!!caseKey && String(item.caseKey || item.transferKey || '').trim() === caseKey)
        )) {
            for (const history of consultation.histories || []) {
                histories.push({ ...history, title: consultation.title || consultation.receiptNo || '상담' });
            }
        }
        return histories.sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')));
    }

    public focusCaseSection(id: string) {
        window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 0);
    }

    public addTrademarkProduct() {
        const detail = this.ensureCaseDetailShape(this.selectedCase);
        detail.trademark.products.push({ productClass: '', productName: '' });
        this.service.render();
    }

    public removeTrademarkProduct(index: number) {
        const detail = this.ensureCaseDetailShape(this.selectedCase);
        if (detail.trademark.products.length <= 1) return;
        detail.trademark.products.splice(index, 1);
        this.service.render();
    }

    public async openRelatedCaseRegistration(target: string) {
        if (!this.selectedCase || this.caseTypeOptions.indexOf(target) < 0) return;
        this.resetRegistrationDraft();
        this.pendingConsultationTransfer = null;
        const detail = this.ensureCaseDetailShape(this.selectedCase);
        this.registrationDraft.caseKey = this.selectedCase.caseKey || detail.caseKey || this.generateCaseKey();
        this.registrationDraft.right = this.selectedCase.right || '특허/실용신안';
        this.registrationDraft.caseType = target;
        this.registrationDraft.type = target;
        this.registrationDraft.stage = target === '이의/심판/소송' ? '심판' : '출원/심사';
        this.registrationDraft.titleKo = this.selectedCase.title || '';
        this.registrationDraft.titleEn = detail.titleEn || '';
        if (target === '해외출원') {
            this.registrationDraft.applicationNo = this.selectedCase.applicationNo || '';
            this.registrationDraft.filingDate = this.selectedCase.filingDate || '';
        }
        this.registrationDraft.productName = this.selectedCase.productName || '';
        this.registrationDraft.markImageName = this.selectedCase.markText || '';
        this.registrationDraft.patentClientNo = this.selectedCase.patentClientNo || '';
        const savedContacts = detail.contacts || {};
        this.registrationDraft.clients = this.cloneValue(savedContacts.clients?.length
            ? savedContacts.clients
            : [{ name: this.selectedCase.clientName || '', phone: '', email: '' }]);
        this.registrationDraft.applicants = this.cloneValue(savedContacts.applicants?.length
            ? savedContacts.applicants
            : [{ name: this.selectedCase.applicant || '', phone: '', email: '' }]);
        this.registrationDraft.companyContacts = this.cloneValue(savedContacts.companyContacts?.length
            ? savedContacts.companyContacts
            : [detail.companyContact]);
        this.registrationDraft.documentReceivers = this.cloneValue(savedContacts.documentReceivers?.length
            ? savedContacts.documentReceivers
            : [detail.documentReceiver]);
        this.registrationDraft.attorney = this.selectedCase.attorney || '';
        this.registrationDraft.assignee = this.selectedCase.assignee || '';
        this.registrationDraft.memo = this.selectedCase.memo || '';
        this.registrationDraft.nextDue = this.selectedCase.nextDue || '';
        this.registrationDraft.nextDueNote = this.selectedCase.nextDueNote || '';
        this.registrationDraft.relatedSourceCaseId = this.selectedCase.id || '';
        this.registrationDraft.detail = this.cloneValue(detail);
        this.ensureRegistrationDraftDetail();
        this.activeWorkspace = 'cases';
        this.selectedWorkCard = this.transferWorkspaceCategory(target);
        this.showRegistrationForm = true;
        this.syncLocationForWorkspace('cases');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async openCaseDeleteConfirm() {
        this.caseDeleteConfirmText = '';
        this.showCaseDeleteConfirm = true;
        await this.service.render();
    }

    public async closeCaseDeleteConfirm() {
        this.showCaseDeleteConfirm = false;
        this.caseDeleteConfirmText = '';
        await this.service.render();
    }

    public caseDeleteName() {
        return this.selectedCase?.title || this.caseSubjectValue(this.selectedCase) || '';
    }

    public canDeleteSelectedCase() {
        return !!this.selectedCase && this.caseDeleteConfirmText.trim() === this.caseDeleteName();
    }

    public async confirmDeleteCase() {
        if (!this.canDeleteSelectedCase()) return;
        const deletedId = this.selectedCase.id;
        const deletedCategory = this.caseCategory(this.selectedCase);
        await this.deleteCaseRecord(deletedId);
        this.cases = this.cases.filter((item) => item.id !== deletedId);
        this.adjustWorkCardCount(deletedCategory, -1);
        this.selectedCase = null;
        this.isCaseSummaryEditing = false;
        this.showCaseDeleteConfirm = false;
        this.caseDeleteConfirmText = '';
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        this.activeWorkspace = 'cases';
        this.syncLocationForWorkspace('cases');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async openDeadlineCase(deadline: any) {
        const caseId = String(deadline?.caseId || '').trim();
        if (!caseId) return;
        let item = this.cases.find((row) => String(row.id || '') === caseId) || null;
        if (!item) item = await this.loadCaseById(caseId);
        if (!item) {
            await this.service.modal.warning('해당 사건 정보를 불러오지 못했습니다.');
            return;
        }
        await this.openCase(item);
    }

    private async loadCaseById(caseId: string) {
        try {
            const { code, data } = await wiz.call('cases', {
                page: 1,
                page_size: 1,
                today: this.today,
                case_id: caseId
            });
            if (code === 401) {
                this.redirectToAccess();
                return null;
            }
            if (code !== 200) return null;
            const item = (data?.items || []).find((row: any) => String(row.id || '') === caseId) || null;
            if (item) this.ensureCaseDetailShape(item);
            return item;
        } catch (error) {
            console.error('dashboard deadline case load failed', error);
            return null;
        }
    }

    public async openConsultation(item: any, event?: any) {
        event?.stopPropagation();
        this.selectedConsultation = item;
        this.showSelectedConsultationHistory = false;
        this.activeWorkspace = 'intakeConsultationDetail';
        this.syncLocationForWorkspace('intakeConsultationDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async openConsultationForm() {
        this.consultationDraft = this.emptyConsultationDraft();
        this.resetRegistrationDraft();
        this.syncConsultationRegistrationDraft();
        this.quoteDraft = this.emptyQuoteDraft(this.consultationQuoteSource(this.consultationDraft));
        this.consultationQuoteStatusMessage = '';
        this.pendingConsultationTransfer = null;
        this.consultationHistoryDraft = this.emptyConsultationHistoryDraft();
        this.consultationClientSearchQuery = '';
        this.activeConsultationSidePanel = 'pull';
        this.activeConsultationRegistrationTab = 'common';
        this.showConsultationDraftHistory = false;
        this.showConsultationForm = true;
        await this.service.render();
    }

    public async closeConsultationForm() {
        this.showConsultationForm = false;
        this.showConsultationDraftHistory = false;
        this.consultationHistoryDraft = this.emptyConsultationHistoryDraft();
        this.consultationClientSearchQuery = '';
        await this.service.render();
    }

    public onConsultantLookup(value: string) {
        this.consultationDraft.consultant = value || '';
        this.consultationDraft.clientContactName = value || '';
        this.consultationClientSearchQuery = value || '';
        this.activeConsultationSidePanel = 'pull';
        this.syncConsultationRegistrationDraft();
        this.service.render();
    }

    public onConsultationTypeChange(value: string) {
        this.consultationDraft.consultationType = value || '기타';
        let caseType = this.consultationDraft.caseType || '국내출원';
        if (value === '이의/심판/소송') caseType = '이의/심판/소송';
        if (value === '해외출원') caseType = '해외출원';
        if (value === '출원/등록') caseType = '국내출원';
        this.consultationDraft.caseType = caseType;
        this.onConsultationRegistrationCaseTypeChange(caseType);
    }

    public onConsultationRightChange(value: string) {
        this.consultationDraft.rightType = value || '특허/실용신안';
        this.syncConsultationRegistrationDraft();
        this.service.render();
    }

    public onConsultationRegistrationCaseTypeChange(value: string) {
        const caseType = value || '국내출원';
        this.consultationDraft.caseType = caseType;
        this.onRegistrationCaseTypeChange(caseType);
    }

    public onRegistrationCaseTypeChange(value: string) {
        this.registrationDraft.caseType = value || '국내출원';
        this.registrationDraft.type = this.registrationDraft.caseType;
        const detail = this.ensureRegistrationDraftDetail();
        if (this.registrationDraft.caseType === '이의/심판/소송') {
            detail.dispute.type = detail.dispute.type || '이의';
            detail.dispute.category = detail.dispute.category || '이의';
            detail.dispute.relationType = detail.dispute.relationType || '1';
            detail.dispute.right = detail.dispute.right || this.registrationDisputeRightFromGroup(this.registrationDraft.right);
            this.registrationDraft.stage = detail.dispute.type === '소송' ? '소송' : (detail.dispute.type === '심판' ? '심판' : '출원/심사');
        } else if (this.registrationDraft.caseType === '해외출원') {
            this.registrationDraft.stage = '출원/심사';
            const applications = this.foreignRegistrationApplications();
            if (applications.length === 0) applications.push(this.emptyRegistrationAdditionalRow('overseasApplications'));
        }
        this.service.render();
    }

    public syncConsultationRegistrationDraft() {
        this.ensureConsultationDraftShape();
        const draft = this.consultationDraft;
        this.registrationDraft.caseKey = draft.caseKey || draft.transferKey || this.registrationDraft.caseKey || this.generateCaseKey();
        const right = this.rights.indexOf(draft.rightType) >= 0 ? draft.rightType : '특허/실용신안';
        this.registrationDraft.right = right;
        this.registrationDraft.titleKo = draft.title || this.registrationDraft.titleKo || '';
        this.registrationDraft.productName = right === '디자인' ? (draft.title || this.registrationDraft.productName || '') : this.registrationDraft.productName || '';
        this.registrationDraft.patentClientNo = draft.patentClientNo || this.registrationDraft.patentClientNo || '';
        this.registrationDraft.assignee = draft.assignee || this.registrationDraft.assignee || '';
        this.registrationDraft.clients = [this.mergeRegistrationContact(this.registrationDraft.clients?.[0], {
            name: draft.clientName || '',
            phone: draft.clientPhone || '',
            email: draft.clientEmail || ''
        })];
        this.registrationDraft.applicants = [this.mergeRegistrationContact(this.registrationDraft.applicants?.[0], {
            name: draft.clientName || '',
            phone: draft.clientPhone || '',
            email: draft.clientEmail || ''
        })];
        this.registrationDraft.companyContacts = [this.mergeRegistrationContact(this.registrationDraft.companyContacts?.[0], {
            name: draft.consultant || draft.clientContactName || '',
            phone: draft.clientPhone || '',
            email: draft.clientEmail || ''
        })];
        this.ensureRegistrationAdditional(right);
        this.ensureRegistrationDraftDetail();
    }

    private mergeRegistrationContact(current: any, incoming: any) {
        return {
            name: incoming?.name || current?.name || '',
            phone: incoming?.phone || current?.phone || '',
            email: incoming?.email || current?.email || ''
        };
    }

    public pullConsultationDraft() {
        this.activeConsultationSidePanel = 'pull';
        this.showConsultationDraftHistory = false;
        this.service.render();
    }

    public toggleConsultationDraftHistory() {
        this.activeConsultationSidePanel = 'history';
        if (!this.showConsultationDraftHistory) {
            this.ensureConsultationDraftShape();
            this.consultationHistoryDraft = this.emptyConsultationHistoryDraft(this.consultationDraft.summary);
        }
        this.showConsultationDraftHistory = true;
        this.service.render();
    }

    public async openConsultationSidePanel(tabId: string) {
        const exists = this.consultationSidePanelTabs.some((tab) => tab.id === tabId);
        if (!exists) return;
        this.activeConsultationSidePanel = tabId;
        if (tabId === 'history') {
            this.ensureConsultationDraftShape();
            this.consultationHistoryDraft = this.emptyConsultationHistoryDraft(this.consultationDraft.summary);
            this.showConsultationDraftHistory = true;
        } else if (tabId === 'quote') {
            this.syncConsultationQuoteDraftSource();
            this.showConsultationDraftHistory = false;
        } else {
            this.showConsultationDraftHistory = false;
        }
        await this.service.render();
    }

    public async setConsultationRegistrationTab(tabId: string) {
        const exists = this.consultationRegistrationTabs.some((tab) => tab.id === tabId);
        if (!exists) return;
        this.ensureConsultationDraftShape();
        this.activeConsultationRegistrationTab = tabId;
        await this.service.render();
    }

    public addConsultationDraftHistory() {
        this.ensureConsultationDraftShape();
        const text = String(this.consultationHistoryDraft?.text || '').trim();
        if (!text) return;
        const date = this.consultationHistoryDraft?.date || this.consultationDraft.date || this.today;
        this.consultationDraft.histories.push({ date, text });
        if (!String(this.consultationDraft.summary || '').trim()) this.consultationDraft.summary = text;
        this.consultationHistoryDraft = this.emptyConsultationHistoryDraft();
        this.service.render();
    }

    public removeConsultationDraftHistory(index: number) {
        this.ensureConsultationDraftShape();
        if (index < 0 || index >= this.consultationDraft.histories.length) return;
        this.consultationDraft.histories.splice(index, 1);
        this.service.render();
    }

    public filteredConsultationClients() {
        const keyword = this.consultationSideSearchKeyword();
        const rows = keyword
            ? this.clients.filter((client) => this.clientSearchText(client).indexOf(keyword) >= 0)
            : this.clients.slice();
        return rows.slice(0, 8);
    }

    public consultationPullMatches() {
        const keyword = this.consultationSideSearchKeyword();
        const matches: any[] = [];
        for (const client of this.clients) {
            const contacts = client?.contacts?.length ? client.contacts : [{}];
            for (const contact of contacts) {
                const text = [
                    client?.name,
                    client?.patentClientNo,
                    client?.type,
                    contact?.name,
                    contact?.phone,
                    contact?.email
                ].map((value) => String(value || '').toLowerCase()).join(' ');
                if (!keyword || text.indexOf(keyword) >= 0) {
                    matches.push({ client, name: contact?.name || client?.name || '', phone: contact?.phone || client?.phone || '', email: contact?.email || client?.email || '' });
                }
            }
        }
        return matches.slice(0, 8);
    }

    public consultationSearchRecords() {
        const keyword = this.consultationSideSearchKeyword() || this.personKey(this.consultationDraft?.clientName);
        const records: any[] = [];

        for (const item of this.consultations) {
            const text = [
                item.receiptNo,
                item.title,
                item.clientName,
                item.rightType,
                item.caseType,
                item.assignee,
                item.summary
            ].map((value) => String(value || '').toLowerCase()).join(' ');
            if (!keyword || text.indexOf(keyword) >= 0) {
                records.push({ kind: '상담', item, title: item.title || item.receiptNo || '상담 기록', subtitle: `${item.clientName || '-'} · ${item.date || ''}` });
            }
        }

        for (const item of this.cases.filter((row) => this.isCaseListItem(row))) {
            const text = [
                item.title,
                item.clientName,
                item.applicant,
                item.applicationNo,
                item.registrationNo,
                item.patentClientNo,
                item.right,
                item.type
            ].map((value) => String(value || '').toLowerCase()).join(' ');
            if (!keyword || text.indexOf(keyword) >= 0) {
                records.push({ kind: '사건', item, title: item.title || '사건 기록', subtitle: `${item.clientName || '-'} · ${item.right || ''} · ${item.type || ''}` });
            }
        }

        return records.slice(0, 8);
    }

    public applyConsultationClient(client: any) {
        this.applyConsultationClientSource(client);
        this.syncConsultationRegistrationDraft();
        this.activeConsultationRegistrationTab = 'common';
        this.service.render();
    }

    public applyConsultationPullMatch(match: any) {
        if (!match?.client) return;
        this.applyConsultationClientSource(match.client);
        this.consultationDraft.consultant = match.name || this.consultationDraft.consultant || '';
        this.consultationDraft.clientContactName = match.name || this.consultationDraft.clientContactName || '';
        this.consultationDraft.clientPhone = match.phone || this.consultationDraft.clientPhone || '';
        this.consultationDraft.clientEmail = match.email || this.consultationDraft.clientEmail || '';
        this.consultationClientSearchQuery = match.name || match.client.name || '';
        this.syncConsultationRegistrationDraft();
        this.activeConsultationRegistrationTab = 'common';
        this.service.render();
    }

    public applyConsultationSearchRecord(record: any) {
        const item = record?.item;
        if (!item) return;
        if (record.kind === '상담') {
            this.applyConsultationClientSource(item);
            this.consultationDraft.rightType = this.rights.indexOf(item.rightType) >= 0 ? item.rightType : this.consultationDraft.rightType;
            this.consultationDraft.caseType = item.caseType || this.consultationDraft.caseType;
            if (!this.consultationDraft.title) this.consultationDraft.title = item.title || '';
        }
        if (record.kind === '사건') {
            this.applyConsultationClientSource({
                clientId: item.clientId || '',
                clientName: item.clientName || '',
                patentClientNo: item.patentClientNo || '',
                clientContactName: item.companyContact || '',
                clientPhone: '',
                clientEmail: ''
            });
            this.consultationDraft.rightType = item.right || this.consultationDraft.rightType;
            this.consultationDraft.caseType = item.type || this.consultationDraft.caseType;
            if (!this.consultationDraft.title) this.consultationDraft.title = item.title || '';
        }
        this.syncConsultationRegistrationDraft();
        this.activeConsultationRegistrationTab = 'common';
        this.service.render();
    }

    public applyConsultationQuoteTemplate(template: any) {
        if (!template) return;
        this.consultationQuoteStatusMessage = '';
        const selectedIds = Array.isArray(this.quoteDraft.selectedTemplateIds)
            ? [...this.quoteDraft.selectedTemplateIds]
            : [];
        const selectedIndex = selectedIds.indexOf(template.id);
        if (selectedIndex >= 0) selectedIds.splice(selectedIndex, 1);
        else selectedIds.push(template.id);
        this.quoteDraft.selectedTemplateIds = selectedIds;
        this.rebuildConsultationQuoteTemplateSelection();
        this.quoteDraft.source = this.consultationDraft.title || template.label;
        this.quoteDraft.clientName = this.consultationDraft.clientName || '';
        const selectedTemplates = this.consultationSelectedQuoteTemplates();
        if (selectedTemplates.length === 1) {
            const selectedTemplate = selectedTemplates[0];
            this.consultationDraft.rightType = selectedTemplate.rightType || this.consultationDraft.rightType;
            this.consultationDraft.caseType = selectedTemplate.caseType || this.consultationDraft.caseType;
        }
        this.activeConsultationRegistrationTab = 'common';
        this.service.render();
    }

    public consultationQuoteTemplateIsSelected(templateId: string) {
        return (this.quoteDraft?.selectedTemplateIds || []).indexOf(templateId) >= 0;
    }

    public consultationSelectedQuoteTemplates() {
        const selectedIds = this.quoteDraft?.selectedTemplateIds || [];
        return selectedIds
            .map((templateId: string) => this.quoteTemplates.find((template: any) => template.id === templateId))
            .filter((template: any) => !!template);
    }

    public consultationSelectedQuoteTemplateTotal(template: any) {
        return this.numberValue(template?.officialFee)
            + this.numberValue(template?.serviceFee)
            + this.numberValue(template?.vat)
            + this.numberValue(template?.etcFee);
    }

    public consultationQuoteSelectionLabel() {
        const selectedTemplates = this.consultationSelectedQuoteTemplates();
        if (!selectedTemplates.length) return '선택된 견적 없음';
        if (selectedTemplates.length === 1) return selectedTemplates[0].label;
        return `${selectedTemplates.length}개 견적 조합`;
    }

    public async saveConsultationQuote(send: boolean = false) {
        this.syncConsultationQuoteDraftSource();
        await this.saveQuoteDraft(send);
        this.consultationQuoteStatusMessage = send
            ? '견적서가 발송 상태로 저장되었습니다.'
            : '견적서가 작성되었습니다.';
        await this.service.render();
    }

    public toggleSelectedConsultationHistory() {
        this.showSelectedConsultationHistory = !this.showSelectedConsultationHistory;
        this.service.render();
    }

    public async saveConsultationDraft() {
        this.syncConsultationRegistrationDraft();
        const item = this.buildConsultationFromDraft();
        const saved = await this.saveConsultationRecord(item);
        const savedWithDocument = saved ? await this.persistConsultationRegistrationDocument(saved) : null;
        if (saved && !savedWithDocument) return;
        const nextItem = savedWithDocument || saved || item;
        const isNewConsultation = !this.consultations.some((row) => row.id === item.id || row.id === nextItem.id);
        this.consultations = [nextItem, ...this.consultations.filter((row) => row.id !== nextItem.id)];
        if (isNewConsultation) this.adjustWorkCardCount('consultation', 1);
        this.selectedConsultation = nextItem;
        this.showConsultationForm = false;
        this.showConsultationDraftHistory = false;
        this.activeWorkspace = 'intakeConsultationDetail';
        this.syncLocationForWorkspace('intakeConsultationDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async openConsultationDraftQuote() {
        await this.openConsultationSidePanel('quote');
    }

    public async openSelectedConsultationQuote() {
        await this.openQuoteForm(this.consultationQuoteSource(this.selectedConsultation));
    }

    public async pullSelectedConsultationToRegistration() {
        const target = this.selectedConsultation?.transferredTo || this.selectedConsultation?.caseType || '국내출원';
        this.fillRegistrationDraftFromConsultation(this.selectedConsultation, true);
        this.pendingConsultationTransfer = {
            consultationId: this.selectedConsultation?.id || '',
            caseKey: this.selectedConsultation?.caseKey || this.selectedConsultation?.transferKey || this.generateCaseKey(),
            target: this.caseTypeOptions.indexOf(target) >= 0 ? target : '국내출원'
        };
        this.activeWorkspace = 'cases';
        this.selectedWorkCard = this.transferWorkspaceCategory(this.pendingConsultationTransfer.target);
        this.syncLocationForWorkspace('cases');
        this.notifyWorkspaceChanged();
        this.showRegistrationForm = true;
        await this.service.render();
    }

    public async transferConsultation(target: string) {
        if (this.caseTypeOptions.indexOf(target) < 0) return;
        this.syncConsultationRegistrationDraft();
        const item = this.buildConsultationFromDraft();
        let saved = await this.saveConsultationRecord(item);
        if (!saved?.id) return;
        saved = await this.persistConsultationRegistrationDocument(saved);
        if (!saved?.id) return;

        const isNewConsultation = !this.consultations.some((row) => row.id === item.id || row.id === saved.id);
        this.consultations = [saved, ...this.consultations.filter((row) => row.id !== saved.id)];
        if (isNewConsultation) this.adjustWorkCardCount('consultation', 1);
        this.selectedConsultation = saved;
        this.consultationDraft = this.emptyConsultationDraft(saved);
        this.fillRegistrationDraftFromConsultation(saved, false);
        this.registrationDraft.caseType = target;
        this.registrationDraft.type = target;
        this.registrationDraft.stage = target === '이의/심판/소송' ? '심판' : '출원/심사';
        this.pendingConsultationTransfer = {
            consultationId: saved.id,
            caseKey: saved.caseKey || saved.transferKey || item.caseKey || item.transferKey,
            target
        };
        this.showConsultationForm = false;
        this.activeWorkspace = 'cases';
        this.selectedWorkCard = this.transferWorkspaceCategory(target);
        this.syncLocationForWorkspace('cases');
        this.notifyWorkspaceChanged();
        this.showRegistrationForm = true;
        await this.service.render();
    }

    private transferWorkspaceCategory(target: string) {
        if (target === '해외출원') return 'foreign';
        if (target === '이의/심판/소송') return 'dispute';
        return 'domestic';
    }

    public consultationUpdatedAt(item: any) {
        return item?.updatedAt || item?.updated || item?.date || '';
    }

    public consultationActionLabel(item: any) {
        return item?.converted ? '전환완료' : '상세';
    }

    public async openClient(item: any, event: any = null) {
        const target = event?.target as HTMLElement;
        if (item?._editing || target?.closest?.('button, input, select, textarea, label, a')) return;
        if (!item) return;
        this.clientDetailError = '';
        this.selectedClient = item?.sourceType
            ? { ...item, _editing: false, _saving: false }
            : null;
        this.activeWorkspace = 'clientDetail';
        if (!this.selectedClient) await this.loadClientDetail(item?.id || item?.clientId || '', false);
        this.syncLocationForWorkspace('clientDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async loadClientDetail(identifier: string, render: boolean = true) {
        const targetId = String(identifier || '').trim();
        if (!targetId) {
            this.selectedClient = null;
            this.clientDetailError = '선택한 고객 정보가 없습니다.';
            if (render) await this.service.render();
            return;
        }
        this.clientDetailLoading = true;
        this.clientDetailError = '';
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call('clients', { export_all: '1' });
            if (code === 401) {
                this.redirectToAccess();
                return;
            }
            if (code !== 200) {
                this.selectedClient = null;
                this.clientDetailError = data?.message || data?.error || '고객 정보를 불러오지 못했습니다.';
                return;
            }
            const items = data?.items || [];
            const exact = items.find((client: any) => String(client?.id || '') === targetId);
            const linked = items.filter((client: any) => String(client?.clientId || '') === targetId);
            const matched = exact
                || linked.find((client: any) => client?.sourceType === 'client')
                || linked[0]
                || null;
            this.selectedClient = matched ? { ...matched, _editing: false, _saving: false } : null;
            if (!matched) this.clientDetailError = '선택한 고객 정보를 찾을 수 없습니다.';
        } catch (error) {
            console.error('dashboard loadClientDetail failed', error);
            this.selectedClient = null;
            this.clientDetailError = '고객 정보를 불러오지 못했습니다.';
        } finally {
            this.clientDetailLoading = false;
            if (render) await this.service.render();
        }
    }

    public async backToClientList() {
        if (this.selectedClient?._editSnapshot) Object.assign(this.selectedClient, this.selectedClient._editSnapshot);
        if (this.selectedClient) {
            this.selectedClient._editing = false;
            this.selectedClient._saving = false;
            delete this.selectedClient._editSnapshot;
        }
        this.activeWorkspace = 'clients';
        await this.loadClientPage(this.clientPage, false);
        this.syncLocationForWorkspace('clients');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public clientDetailCases() {
        const clientId = String(this.selectedClient?.clientId || '');
        const clientName = String(this.selectedClient?.companyName || this.selectedClient?.name || '').trim().toLowerCase();
        return this.cases.filter((item: any) => {
            if (!this.isCaseListItem(item)) return false;
            if (clientId && String(item?.clientId || '') === clientId) return true;
            return !!clientName && String(item?.clientName || '').trim().toLowerCase() === clientName;
        }).slice(0, 5);
    }

    public clientDetailConsultations() {
        const clientId = String(this.selectedClient?.clientId || '');
        const clientName = String(this.selectedClient?.companyName || this.selectedClient?.name || '').trim().toLowerCase();
        return this.consultations.filter((item: any) => {
            if (clientId && String(item?.clientId || '') === clientId) return true;
            return !!clientName && String(item?.clientName || '').trim().toLowerCase() === clientName;
        }).slice(0, 5);
    }

    public filteredClients() {
        return this.clients.slice();
    }

    public onClientSearchChange() {
        if (this.clientSearchTimer) clearTimeout(this.clientSearchTimer);
        this.clientSearchTimer = setTimeout(async () => {
            this.clientPage = 1;
            this.clientMailSelectedIds = [];
            await this.loadClientPage(1);
        }, 300);
    }

    public async clearClientSearch() {
        this.clientSearchQuery = '';
        this.clientPage = 1;
        this.clientMailSelectedIds = [];
        await this.loadClientPage(1);
    }

    public async onClientGroupChange() {
        this.clientPage = 1;
        this.clientMailSelectedIds = [];
        await this.loadClientPage(1);
    }

    public async onClientStatusChange() {
        this.clientPage = 1;
        await this.loadClientPage(1);
    }

    public clientStatusLabel(status: string) {
        return String(status || '').toUpperCase() === 'ACTIVE' ? '활성' : '비활성';
    }

    public clientStatusClass(status: string) {
        return String(status || '').toUpperCase() === 'ACTIVE'
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public async resetClientDirectoryFilters() {
        this.clientSearchQuery = '';
        this.clientStatusFilter = '';
        this.clientPage = 1;
        this.clientMailSelectedIds = [];
        await this.loadClientPage(1);
    }

    public clientGroupCount(group: string) {
        return Number(this.clientGroupCounts?.[group] || 0);
    }

    public clientTotalPages() {
        return Math.max(1, Math.ceil(this.clientTotalCount / this.clientPageSize));
    }

    public clientPageNumbers() {
        return this.visiblePageNumbers(this.clientPage, this.clientTotalPages());
    }

    public clientPageSummary() {
        return this.pageSummary(this.clientPage, this.clientPageSize, this.clientTotalCount);
    }

    public async setClientPage(page: number) {
        await this.loadClientPage(Math.max(1, Math.min(page, this.clientTotalPages())), false);
        await this.service.render();
        document.querySelector('.client-list-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async previousClientPage() {
        await this.setClientPage(this.clientPage - 1);
    }

    public async nextClientPage() {
        await this.setClientPage(this.clientPage + 1);
    }

    public isClientMailSelected(item: any) {
        return !!item?.id && this.clientMailSelectedIds.indexOf(item.id) >= 0;
    }

    public toggleClientMailSelection(item: any, event: any = null) {
        event?.stopPropagation();
        if (!item?.id) return;
        if (this.isClientMailSelected(item)) {
            this.clientMailSelectedIds = this.clientMailSelectedIds.filter((id: string) => id !== item.id);
        } else {
            this.clientMailSelectedIds = [...this.clientMailSelectedIds, item.id];
        }
        this.service.render();
    }

    public allVisibleClientsSelected() {
        const visibleIds = this.clients.filter((item: any) => !!item?.id).map((item: any) => item.id);
        return visibleIds.length > 0 && visibleIds.every((id: string) => this.clientMailSelectedIds.indexOf(id) >= 0);
    }

    public toggleAllVisibleClients(event: any) {
        const checked = !!event?.target?.checked;
        const visibleIds = this.clients.filter((item: any) => !!item?.id).map((item: any) => item.id);
        if (checked) {
            this.clientMailSelectedIds = Array.from(new Set([...this.clientMailSelectedIds, ...visibleIds]));
        } else {
            this.clientMailSelectedIds = this.clientMailSelectedIds.filter((id: string) => visibleIds.indexOf(id) < 0);
        }
        this.service.render();
    }

    public beginClientDirectoryEdit(item: any, event: any = null) {
        event?.stopPropagation();
        item._editSnapshot = {
            name: item.name || '',
            phone: item.phone || '',
            email: item.email || '',
            address: item.address || ''
        };
        item._editing = true;
        this.service.render();
    }

    public cancelClientDirectoryEdit(item: any, event: any = null) {
        event?.stopPropagation();
        if (item?._editSnapshot) Object.assign(item, item._editSnapshot);
        item._editing = false;
        item._saving = false;
        delete item._editSnapshot;
        this.service.render();
    }

    public async saveClientDirectoryItem(item: any, event: any = null) {
        event?.stopPropagation();
        if (!String(item?.name || '').trim()) {
            await this.service.modal.error('업체명 또는 성명을 입력해 주세요.');
            return;
        }
        item._saving = true;
        const stayingInClientDetail = this.activeWorkspace === 'clientDetail';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save_client_directory', {
                payload: JSON.stringify({
                    id: item.id,
                    sourceType: item.sourceType,
                    sourceId: item.sourceId,
                    clientId: item.clientId,
                    group: item.group,
                    originalName: item.originalName,
                    name: String(item.name || '').trim(),
                    phone: String(item.phone || '').trim(),
                    email: String(item.email || '').trim(),
                    address: String(item.address || '').trim()
                })
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '고객 정보를 수정하지 못했습니다.');
                return;
            }
            if (data?.client) Object.assign(item, data.client);
            item._editing = false;
            delete item._editSnapshot;
            await this.service.modal.success('고객 정보가 수정되었습니다.');
            if (stayingInClientDetail) {
                this.selectedClient = item;
                this.clientDetailError = '';
                this.syncLocationForWorkspace('clientDetail');
            } else {
                await this.loadClientPage(this.clientPage, false);
            }
        } catch (error) {
            console.error('dashboard save_client_directory failed', error);
            await this.service.modal.error('고객 정보를 수정하지 못했습니다.');
        } finally {
            item._saving = false;
            await this.service.render();
        }
    }

    public async openClientMailForm() {
        this.clientMailDraft = {
            scope: this.clientMailSelectedIds.length > 0 ? 'selected' : 'all',
            subject: '',
            content: '',
            files: []
        };
        this.clientMailPickerSearch = '';
        this.clientMailPickerGroup = '';
        this.clientMailPickerPage = 1;
        this.clientMailPickerItems = [];
        this.clientMailPickerTotalCount = 0;
        this.clientMailPickerOpen = this.clientMailDraft.scope === 'selected';
        this.showClientMailForm = true;
        await this.service.render();
        if (this.clientMailPickerOpen) await this.loadClientMailPicker(1);
    }

    public closeClientMailForm() {
        if (this.clientMailSending || this.documentUploading) return;
        if (this.clientMailPickerSearchTimer) clearTimeout(this.clientMailPickerSearchTimer);
        this.showClientMailForm = false;
        this.clientMailPickerOpen = false;
        this.clientMailPickerLoading = false;
        this.clientMailPickerItems = [];
        this.service.render();
    }

    public async onClientMailScopeChange(scope: string) {
        this.clientMailDraft.scope = scope;
        this.clientMailPickerOpen = scope === 'selected';
        await this.service.render();
        if (this.clientMailPickerOpen && this.clientMailPickerItems.length === 0) {
            await this.loadClientMailPicker(1);
        }
    }

    public async loadClientMailPicker(page: number = this.clientMailPickerPage, render: boolean = true) {
        const targetPage = Math.max(1, Number(page || 1));
        this.clientMailPickerLoading = true;
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call('clients', {
                page: targetPage,
                page_size: this.clientMailPickerPageSize,
                search: this.clientMailPickerSearch.trim(),
                group: this.clientMailPickerGroup
            });
            if (code === 401) {
                this.redirectToAccess();
                return;
            }
            if (code === 400 && targetPage !== 1) {
                await this.loadClientMailPicker(1, render);
                return;
            }
            if (code !== 200) {
                this.clientMailPickerItems = [];
                this.clientMailPickerTotalCount = 0;
                await this.service.modal.error(data?.message || data?.error || '발송 대상 고객을 불러오지 못했습니다.');
                return;
            }
            this.clientMailPickerPage = Number(data.page || 1);
            this.clientMailPickerTotalCount = Number(data.total_count || 0);
            this.clientMailPickerItems = (data.items || []).map((item: any) => ({ ...item }));
        } finally {
            this.clientMailPickerLoading = false;
            if (render) await this.service.render();
        }
    }

    public onClientMailPickerSearchChange() {
        if (this.clientMailPickerSearchTimer) clearTimeout(this.clientMailPickerSearchTimer);
        this.clientMailPickerSearchTimer = setTimeout(async () => {
            this.clientMailPickerPage = 1;
            await this.loadClientMailPicker(1);
        }, 300);
    }

    public async clearClientMailPickerSearch() {
        this.clientMailPickerSearch = '';
        this.clientMailPickerPage = 1;
        await this.loadClientMailPicker(1);
    }

    public async onClientMailPickerGroupChange() {
        this.clientMailPickerPage = 1;
        await this.loadClientMailPicker(1);
    }

    public clientMailPickerTotalPages() {
        return Math.max(1, Math.ceil(this.clientMailPickerTotalCount / this.clientMailPickerPageSize));
    }

    public clientMailPickerPageNumbers() {
        return this.visiblePageNumbers(this.clientMailPickerPage, this.clientMailPickerTotalPages());
    }

    public clientMailPickerPageSummary() {
        if (this.clientMailPickerTotalCount === 0) return '0명';
        const start = (this.clientMailPickerPage - 1) * this.clientMailPickerPageSize + 1;
        const end = Math.min(this.clientMailPickerTotalCount, this.clientMailPickerPage * this.clientMailPickerPageSize);
        return `${start}-${end} / ${this.clientMailPickerTotalCount}명`;
    }

    public async setClientMailPickerPage(page: number) {
        const nextPage = Math.max(1, Math.min(page, this.clientMailPickerTotalPages()));
        await this.loadClientMailPicker(nextPage);
    }

    public allClientMailPickerSelected() {
        const visibleIds = this.clientMailPickerItems.filter((item: any) => !!item?.id).map((item: any) => item.id);
        return visibleIds.length > 0 && visibleIds.every((id: string) => this.clientMailSelectedIds.indexOf(id) >= 0);
    }

    public toggleAllClientMailPicker(event: any) {
        const checked = !!event?.target?.checked;
        const visibleIds = this.clientMailPickerItems.filter((item: any) => !!item?.id).map((item: any) => item.id);
        if (checked) {
            this.clientMailSelectedIds = Array.from(new Set([...this.clientMailSelectedIds, ...visibleIds]));
        } else {
            this.clientMailSelectedIds = this.clientMailSelectedIds.filter((id: string) => visibleIds.indexOf(id) < 0);
        }
        this.service.render();
    }

    public clientMailTargetSummary() {
        if (this.clientMailDraft.scope === 'selected') {
            return `선택한 고객 ${this.clientMailSelectedIds.length}명 (이메일 등록 고객만 발송)`;
        }
        const filterLabel = this.clientGroupFilter || '국내고객 전체';
        return `${filterLabel} 검색결과 ${this.clientTotalCount}명 (이메일 등록 고객만 발송)`;
    }

    public async handleClientMailFiles(event: any) {
        const files: any[] = Array.prototype.slice.call(event?.target?.files || []);
        if (event?.target) event.target.value = '';
        if (!files.length) return;
        for (const file of files) {
            const error = this.documentSelectionError(file);
            if (error) { await this.service.modal.error(String(file?.name || '파일') + ': ' + error); continue; }
            if (this.clientMailDraft.files.length >= 10) {
                await this.service.modal.warning('첨부서류는 최대 10개까지 등록할 수 있습니다.');
                break;
            }
            this.clientMailDraft.files.push(file);
        }
        await this.service.render();
    }

    public removeClientMailFile(index: number) {
        this.clientMailDraft.files.splice(index, 1);
        this.service.render();
    }

    public async sendClientMail() {
        const subject = String(this.clientMailDraft.subject || '').trim();
        const content = String(this.clientMailDraft.content || '').trim();
        if (!subject || !content) {
            await this.service.modal.error('발송 제목과 내용을 입력해 주세요.');
            return;
        }
        if (this.clientMailDraft.scope === 'selected' && this.clientMailSelectedIds.length === 0) {
            await this.service.modal.error('발송할 고객을 선택해 주세요.');
            return;
        }
        if (this.clientMailSending) return;
        const files = this.clientMailDraft.files || [];
        if (!Array.isArray(files) || files.length > 10) {
            await this.service.modal.error('첨부서류는 최대 10개까지 등록할 수 있습니다.');
            return;
        }
        for (const file of files) {
            const error = this.documentSelectionError(file);
            if (error) { await this.service.modal.error(String(file?.name || '파일') + ': ' + error); return; }
        }
        this.clientMailSending = true;
        await this.service.render();
        try {
            const attachments: any[] = [];
            for (const file of this.clientMailDraft.files || []) {
                const savedDocument = await this.saveDocumentRecord({
                    id: '',
                    uploadedAt: this.today,
                    category: '고객일괄발송',
                    name: file.name || '발송 첨부서류',
                    fileName: file.name || '',
                    uploader: '',
                    note: '고객 일괄발송 첨부서류',
                    sent: true,
                    sentAt: this.today
                }, {});
                if (!savedDocument?.id) {
                    await this.service.modal.error('발송 첨부서류를 저장하지 못했습니다.');
                    return;
                }
                const uploadResult = await this.uploadDocumentFile(savedDocument.id, file);
                const cleanFile = (uploadResult?.files || []).find((item: any) => item.scan_status === 'CLEAN');
                if (!cleanFile) {
                    await this.service.modal.error(`${file.name}: 보안 검사가 완료된 뒤 발송할 수 있습니다.`);
                    return;
                }
                attachments.push({
                    documentId: savedDocument.id,
                    fileId: cleanFile.id,
                    name: cleanFile.original_filename || file.name
                });
            }
            const { code, data } = await wiz.call('client_mail', {
                action: 'send',
                payload: JSON.stringify({
                    scope: this.clientMailDraft.scope,
                    selectedIds: this.clientMailSelectedIds,
                    subject,
                    content,
                    attachments,
                    group: this.clientGroupFilter,
                    search: this.clientSearchQuery.trim()
                })
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '고객 이메일 발송에 실패했습니다.');
                return;
            }
            this.showClientMailForm = false;
            this.clientMailDraft = { scope: 'all', subject: '', content: '', files: [] };
            this.clientMailSelectedIds = [];
            await this.loadClientMailHistory(false);
            await this.service.modal.success(`${Number(data.sent_count || 0)}명에게 이메일을 발송했습니다.`);
        } catch (error) {
            console.error('dashboard client_mail failed', error);
            await this.service.modal.error('고객 이메일 발송에 실패했습니다.');
        } finally {
            this.clientMailSending = false;
            this.documentUploading = false;
            await this.service.render();
        }
    }

    public async openClientMailHistory() {
        this.clientMailHistoryError = '';
        this.showClientMailHistory = true;
        await this.loadClientMailHistory();
    }

    public closeClientMailHistory() {
        this.showClientMailHistory = false;
        this.clientMailHistoryError = '';
        this.service.render();
    }

    public async startClientMailFromHistory() {
        this.showClientMailHistory = false;
        this.clientMailHistoryError = '';
        await this.openClientMailForm();
    }

    public async loadClientMailHistory(render: boolean = true) {
        this.clientMailHistoryLoading = true;
        this.clientMailHistoryError = '';
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call('client_mail', { action: 'history' });
            if (code === 200) {
                this.clientMailHistory = data.history || [];
            } else {
                this.clientMailHistory = [];
                this.clientMailHistoryError = data?.message || data?.error || '잠시 후 다시 시도해 주세요.';
            }
        } catch (error) {
            console.error('dashboard client_mail history failed', error);
            this.clientMailHistory = [];
            this.clientMailHistoryError = '네트워크 연결을 확인한 뒤 다시 시도해 주세요.';
        } finally {
            this.clientMailHistoryLoading = false;
            if (render) await this.service.render();
        }
    }

    public async downloadClientDirectoryExcel() {
        try {
            const { code, data } = await wiz.call('clients', {
                page: 1,
                page_size: 50,
                export_all: '1',
                search: this.clientSearchQuery.trim(),
                status: this.clientStatusFilter
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '고객 목록을 내려받지 못했습니다.');
                return;
            }
            const escapeCell = (value: any) => `"${String(value ?? '').replace(/"/g, '""')}"`;
            const rows = [
                ['상태', '고객명', '고객 ID', '등록일', '수정일'].map(escapeCell).join(','),
                ...(data.items || []).map((item: any) => [
                    item.statusLabel || this.clientStatusLabel(item.status),
                    item.name,
                    item.id,
                    item.createdAt,
                    item.updatedAt
                ].map(escapeCell).join(','))
            ];
            const blob = new Blob(['\ufeff', rows.join('\r\n')], { type: 'text/csv;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `고객리스트-${this.today}.csv`;
            anchor.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('dashboard client export failed', error);
            await this.service.modal.error('고객 목록을 내려받지 못했습니다.');
        }
    }

    public rightTotalPages() {
        return Math.max(1, Math.ceil(this.rightTotalCount / this.rightPageSize));
    }

    public rightPageNumbers() {
        return this.visiblePageNumbers(this.rightPage, this.rightTotalPages());
    }

    public rightPageSummary() {
        return this.pageSummary(this.rightPage, this.rightPageSize, this.rightTotalCount);
    }

    public async setRightPage(page: number) {
        await this.loadRightPage(Math.max(1, Math.min(page, this.rightTotalPages())), false);
        await this.service.render();
        document.querySelector('.right-list-shell')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public async previousRightPage() {
        await this.setRightPage(this.rightPage - 1);
    }

    public async nextRightPage() {
        await this.setRightPage(this.rightPage + 1);
    }

    public async onRightFiltersChange() {
        this.rightPage = 1;
        await this.loadRightPage(1);
    }

    public scheduleRightSearch() {
        if (this.rightSearchTimer) clearTimeout(this.rightSearchTimer);
        this.rightSearchTimer = setTimeout(async () => {
            this.rightPage = 1;
            await this.loadRightPage(1);
        }, 300);
    }

    private visiblePageNumbers(current: number, total: number) {
        const start = Math.max(1, Math.min(current - 2, Math.max(1, total - 4)));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    private pageSummary(current: number, pageSize: number, total: number) {
        if (total === 0) return '0건';
        const start = (current - 1) * pageSize + 1;
        const end = Math.min(total, current * pageSize);
        return `${start}-${end} / ${total}건`;
    }

    public async toggleStar(item: any, event?: any) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!item || item._favoriteSaving) return;
        const patentClientNo = this.favoritePatentNo(item.patentClientNo);
        if (!patentClientNo) {
            await this.service.modal.warning('관심고객으로 등록하려면 고객 정보에 특허고객번호를 먼저 입력해 주세요.');
            return;
        }

        item._favoriteSaving = true;
        await this.service.render();
        try {
            if (this.favoritePatentClientNos.indexOf(patentClientNo) >= 0) {
                await this.removeFavoriteClient(patentClientNo);
                return;
            }

            const applicantText = this.caseApplicantText(item);
            const applicant = applicantText !== '-' ? applicantText : String(item.clientName || '').trim();
            if (!applicant) {
                await this.service.modal.warning('관심고객 등록을 위해 출원인 또는 고객명을 먼저 입력해 주세요.');
                return;
            }
            const { code, data } = await wiz.call('favorite_clients', {
                action: 'save',
                payload: JSON.stringify({ patentClientNo, applicant, note: '' })
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || data?.error || '관심고객을 등록하지 못했습니다.');
                return;
            }
            this.favoriteClientRecords = data.items || [];
            this.favoritePatentClientNos = (data.patent_client_nos || this.favoriteClientRecords.map((record: any) => record.patentClientNo))
                .map((value: any) => this.favoritePatentNo(value))
                .filter((value: string) => !!value);
        } catch (error) {
            console.error('dashboard domestic favorite toggle failed', error);
            await this.service.modal.error('관심고객 상태를 변경하지 못했습니다.');
        } finally {
            item._favoriteSaving = false;
            await this.service.render();
        }
    }

    public isFavoriteCaseClient(item: any) {
        const patentClientNo = this.favoritePatentNo(item?.patentClientNo);
        return !!patentClientNo && this.favoritePatentClientNos.indexOf(patentClientNo) >= 0;
    }

    public caseApplicantText(item: any) {
        return this.applicantText(item) || '-';
    }

    public isDisputeCaseDetail(item: any = this.selectedCase) {
        if (!item) return false;
        const returnCategory = this.normalizeCaseCategory(this.caseDetailReturnCategory)
            || this.normalizeCaseCategory(this.selectedWorkCard);
        return returnCategory === 'dispute' || this.caseCategory(item) === 'dispute';
    }

    public isForeignCaseDetail(item: any = this.selectedCase) {
        if (!item) return false;
        const returnCategory = this.normalizeCaseCategory(this.caseDetailReturnCategory)
            || this.normalizeCaseCategory(this.selectedWorkCard);
        return returnCategory === 'foreign' || this.caseCategory(item) === 'foreign';
    }

    public foreignCaseCountryApplications(item: any = this.selectedCase) {
        if (!item) return [];
        const detail = this.ensureCaseDetailShape(item);
        return Array.isArray(detail.foreign.countryApplications) ? detail.foreign.countryApplications : [];
    }

    public foreignCaseCountrySummary(item: any = this.selectedCase) {
        const countries = this.foreignCaseCountryApplications(item)
            .map((application: any) => String(application?.country || '').trim())
            .filter((country: string, index: number, values: string[]) => !!country && values.indexOf(country) === index);
        if (!countries.length) return '출원국가 미입력';
        return `${countries.length}개국 · ${countries.join(', ')}`;
    }

    public foreignCaseProgressLabel(application: any) {
        if (application?.progressStatus === '직접입력') return application?.customProgressStatus || '직접입력';
        return application?.progressStatus || '-';
    }

    public addForeignCaseCountryApplication(item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        detail.foreign.countryApplications.push(this.emptyRegistrationAdditionalRow('overseasApplications'));
        this.service.render();
    }

    public removeForeignCaseCountryApplication(index: number, item: any = this.selectedCase) {
        if (!item) return;
        const applications = this.foreignCaseCountryApplications(item);
        applications.splice(index, 1);
        this.service.render();
    }

    public addForeignCaseTrademarkProduct(item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        detail.trademark.products.push({ productClass: '', productName: '' });
        this.service.render();
    }

    public removeForeignCaseTrademarkProduct(index: number, item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        if (detail.trademark.products.length <= 1) return;
        detail.trademark.products.splice(index, 1);
        this.service.render();
    }

    public isTrialOrLitigationCaseDetail(item: any = this.selectedCase) {
        if (!this.isDisputeCaseDetail(item)) return false;
        const type = String(item?.detail?.dispute?.type || item?.disputeStatus || '').trim();
        return type === '심판' || type === '소송';
    }

    public disputeCategoryOptionsFor(item: any = this.selectedCase) {
        if (!this.isTrialOrLitigationCaseDetail(item)) return ['이의'];
        const options = [...this.disputeTrialCategoryOptions];
        const current = String(item?.detail?.dispute?.category || '').trim();
        if (current && current !== '이의' && options.indexOf(current) < 0) options.push(current);
        return options;
    }

    public onDisputeTypeChange(item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        if (this.isTrialOrLitigationCaseDetail(item)) {
            if (!detail.dispute.category || detail.dispute.category === '이의') detail.dispute.category = '무효';
            if (!detail.dispute.currentInstitution) {
                detail.dispute.currentInstitution = detail.dispute.type === '소송' ? '특허법원' : '특허심판원';
            }
        } else {
            detail.dispute.category = '이의';
        }
        this.service.render();
    }

    public disputeRelatedCases(item: any = this.selectedCase) {
        const values = item?.detail?.dispute?.relatedCases;
        if (!Array.isArray(values)) return [];
        return values.map((value: any) => String(value || '').trim()).filter((value: string) => !!value);
    }

    public addDisputeRelatedCase(item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        detail.dispute.relatedCases.push('');
        this.service.render();
    }

    public removeDisputeRelatedCase(index: number, item: any = this.selectedCase) {
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        detail.dispute.relatedCases.splice(index, 1);
        this.service.render();
    }

    public caseDetailedStatus(item: any) {
        if (item?.detailedStatus === '직접입력') return item?.customDetailedStatus || item?.statusLabel || '직접입력';
        return item?.statusLabel || item?.detailedStatus || '심사중';
    }

    public caseDetailedStatusClass(item: any) {
        const status = this.caseDetailedStatus(item);
        if (status.indexOf('등록') >= 0) return 'is-registration';
        if (status.indexOf('거절') >= 0 || status.indexOf('중단') >= 0 || status.indexOf('포기') >= 0) return 'is-stopped';
        if (status.indexOf('의견') >= 0 || status.indexOf('답변') >= 0) return 'is-response';
        if (status.indexOf('우선') >= 0) return 'is-priority';
        if (status.indexOf('공고') >= 0) return 'is-publication';
        return 'is-examination';
    }

    public isTrademarkRight(item: any) {
        return String(item?.rightDisplay || item?.right || '').trim() === '상표';
    }

    public isAnnuityRight(item: any) {
        const right = String(item?.rightDisplay || item?.right || '').trim();
        return ['특허/실용신안', '특허', '실용', '실용신안', '디자인'].indexOf(right) >= 0;
    }

    private normalizedAnnuityDate(value: any) {
        const text = String(value || '').slice(0, 10);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return '';
        const parts = text.split('-').map((part) => parseInt(part, 10));
        const parsed = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
        if (parsed.getUTCFullYear() !== parts[0] || parsed.getUTCMonth() !== parts[1] - 1 || parsed.getUTCDate() !== parts[2]) return '';
        return text;
    }

    private addAnnuityCalendarMonths(value: any, months: number) {
        const date = this.normalizedAnnuityDate(value);
        if (!date) return '';
        const [year, month, day] = date.split('-').map((part) => parseInt(part, 10));
        const monthIndex = year * 12 + month - 1 + Number(months || 0);
        const targetYear = Math.floor(monthIndex / 12);
        const targetMonthIndex = monthIndex % 12;
        const lastDay = new Date(Date.UTC(targetYear, targetMonthIndex + 1, 0)).getUTCDate();
        const result = new Date(Date.UTC(targetYear, targetMonthIndex, Math.min(day, lastDay)));
        return result.toISOString().slice(0, 10);
    }

    private addRenewalCalendarDays(value: any, days: number) {
        const date = this.normalizedAnnuityDate(value);
        if (!date) return '';
        const [year, month, day] = date.split('-').map((part) => parseInt(part, 10));
        const result = new Date(Date.UTC(year, month - 1, day + Number(days || 0)));
        return result.toISOString().slice(0, 10);
    }

    private async allowDraftInput(payload: any, method: string): Promise<boolean> {
        const checked = validateFormDraft(payload, method);
        if (checked.error) {
            await this.service.modal.error(checked.error);
            return false;
        }
        return true;
    }

    private editableAnnuityAmount(value: any): any {
        if (value === undefined) return 0;
        if (value === null || value === '') return value;
        const checked = validateFormDraft({paymentAmount: value}, 'save_case');
        return checked.error ? value : checked.value.paymentAmount;
    }

    private annuityAmountValue(value: any) {
        const amount = parseInt(String(value || 0).replace(/,/g, ''), 10);
        return isNaN(amount) ? 0 : Math.max(0, amount);
    }

    private buildTrademarkRenewalDetail(source: any, disposition: any, legacyAnnuity: any = {}) {
        const rawInput = source && typeof source === 'object' ? source : {};
        if (validateFormDraft(rawInput, 'save_case').error) {
            return {...this.buildTrademarkRenewalDetail({}, disposition, legacyAnnuity), ...rawInput};
        }
        const renewal = source && typeof source === 'object' ? { ...source } : {};
        const paymentTermYears = Number(renewal.paymentTermYears) === 5 ? 5 : 10;
        const existingRows = Array.isArray(renewal.schedule) ? renewal.schedule : [];
        const existingByCycle: any = {};
        for (const row of existingRows) {
            const cycle = Number(row?.cycle ?? -1);
            if (cycle >= 0) existingByCycle[cycle] = row;
        }
        const initialStored = existingByCycle[0] || {};
        const initialNormalDeadline = this.normalizedAnnuityDate(renewal.initialNormalDeadline);
        const initialPaymentDate = this.normalizedAnnuityDate((renewal.initialPaymentDate === undefined ? (disposition?.paymentDate || initialStored.paymentDate) : renewal.initialPaymentDate));
        const initialPaymentAmount = this.editableAnnuityAmount((renewal.initialPaymentAmount === undefined ? initialStored.paymentAmount : renewal.initialPaymentAmount));
        const schedule: any[] = [{
            cycle: 0,
            label: `1~${paymentTermYears}년차`,
            normalDeadline: initialNormalDeadline,
            penaltyDeadline: this.addRenewalCalendarDays(initialNormalDeadline, 30),
            paymentDate: initialPaymentDate,
            paymentAmount: initialPaymentAmount
        }];

        let priorPaymentDate = initialPaymentDate;
        let cycle = 1;
        while (priorPaymentDate && cycle <= 100) {
            const stored = existingByCycle[cycle] || {};
            const normalDeadline = this.addAnnuityCalendarMonths(priorPaymentDate, paymentTermYears * 12);
            const row = {
                cycle,
                label: `${cycle}차 갱신`,
                normalDeadline,
                penaltyDeadline: this.addAnnuityCalendarMonths(normalDeadline, 6),
                paymentDate: this.normalizedAnnuityDate(stored.paymentDate),
                paymentAmount: this.editableAnnuityAmount(stored.paymentAmount)
            };
            schedule.push(row);
            if (!(row.paymentDate && row.paymentAmount > 0)) break;
            priorPaymentDate = row.paymentDate;
            cycle += 1;
        }

        const next = schedule.find((row) => row.normalDeadline && !(row.paymentDate && row.paymentAmount > 0));
        return {
            ...renewal,
            inspectionDate: next?.normalDeadline
                || this.normalizedAnnuityDate(renewal.inspectionDate)
                || this.normalizedAnnuityDate(legacyAnnuity?.inspectionDate),
            paymentTermYears,
            initialNormalDeadline,
            initialExtensionDeadline: this.addRenewalCalendarDays(initialNormalDeadline, 30),
            initialPaymentDate,
            initialPaymentAmount,
            schedule
        };
    }

    private buildAnnuityDetail(source: any, disposition: any) {
        const rawInput = source && typeof source === 'object' ? source : {};
        if (validateFormDraft(rawInput, 'save_case').error) {
            return {...this.buildAnnuityDetail({}, disposition), ...rawInput};
        }
        const annuity = source && typeof source === 'object' ? { ...source } : {};
        const existingRows = Array.isArray(annuity.schedule) ? annuity.schedule : [];
        const existingByYear: any = {};
        for (const row of existingRows) {
            const year = Number(row?.year || 0);
            if (year >= 3) existingByYear[year] = row;
        }
        const initialNormalDeadline = this.normalizedAnnuityDate(annuity.initialNormalDeadline);
        const firstStored = existingByYear[3] || {};
        const initialPaymentDate = this.normalizedAnnuityDate((annuity.initialPaymentDate === undefined ? (disposition?.paymentDate || firstStored.paymentDate) : annuity.initialPaymentDate));
        const initialPaymentAmount = this.editableAnnuityAmount((annuity.initialPaymentAmount === undefined ? firstStored.paymentAmount : annuity.initialPaymentAmount));
        const schedule: any[] = [{
            year: 3,
            label: '1~3년차',
            normalDeadline: initialNormalDeadline,
            penaltyDeadline: this.addAnnuityCalendarMonths(initialNormalDeadline, 6),
            recoveryDeadline: '',
            paymentDate: initialPaymentDate || this.normalizedAnnuityDate(firstStored.paymentDate),
            paymentAmount: initialPaymentAmount
        }];
        for (let year = 4; year <= 20; year += 1) {
            const stored = existingByYear[year] || {};
            const normalDeadline = initialPaymentDate
                ? this.addAnnuityCalendarMonths(initialPaymentDate, (year - 1) * 12)
                : '';
            const penaltyDeadline = this.addAnnuityCalendarMonths(normalDeadline, 6);
            const recoveryDeadline = year === 4 && initialPaymentDate
                ? this.addAnnuityCalendarMonths(initialPaymentDate, 8)
                : this.addAnnuityCalendarMonths(penaltyDeadline, 2);
            schedule.push({
                year,
                label: `${year}년차`,
                normalDeadline,
                penaltyDeadline,
                recoveryDeadline,
                paymentDate: this.normalizedAnnuityDate(stored.paymentDate),
                paymentAmount: this.editableAnnuityAmount(stored.paymentAmount)
            });
        }
        const next = schedule.find((row) => row.normalDeadline && !(row.paymentDate && row.paymentAmount > 0));
        return {
            ...annuity,
            inspectionDate: next?.normalDeadline || this.normalizedAnnuityDate(annuity.inspectionDate),
            initialNormalDeadline,
            initialPenaltyDeadline: this.addAnnuityCalendarMonths(initialNormalDeadline, 6),
            initialPaymentDate,
            initialPaymentAmount,
            schedule
        };
    }

    public rebuildAnnuitySchedule(item: any = this.selectedCase, render: boolean = true) {
        if (validateFormDraft(item?.detail?.annuity || {}, 'save_case').error) return;
        if (!item || !this.isAnnuityRight(item)) return;
        if (!item.detail || typeof item.detail !== 'object') item.detail = this.emptyCaseDetail();
        if (!item.detail.disposition || typeof item.detail.disposition !== 'object') item.detail.disposition = { decisionDate: '', paymentDate: '' };
        item.detail.annuity = this.buildAnnuityDetail(item.detail.annuity, item.detail.disposition);
        item.detail.disposition.paymentDate = item.detail.annuity.initialPaymentDate || '';
        if (render) this.service.render();
    }

    public onInitialAnnuityDeadlineChange(item: any = this.selectedCase) {
        this.rebuildAnnuitySchedule(item);
    }

    public onInitialAnnuityPaymentChange(item: any = this.selectedCase) {
        this.rebuildAnnuitySchedule(item);
    }

    public onAnnuityRowPaymentChange(row: any, item: any = this.selectedCase) {
        if (!item || !row) return;
        if (validateFormDraft(row, 'save_case').error) return;
        row.paymentDate = this.normalizedAnnuityDate(row.paymentDate);
        row.paymentAmount = this.editableAnnuityAmount(row.paymentAmount);
        if (Number(row.year) === 3) {
            item.detail.annuity.initialPaymentDate = row.paymentDate;
            item.detail.annuity.initialPaymentAmount = row.paymentAmount;
        }
        this.rebuildAnnuitySchedule(item);
    }

    public annuityRows(item: any = this.selectedCase) {
        if (!item || !this.isAnnuityRight(item)) return [];
        const schedule = item.detail?.annuity?.schedule;
        return Array.isArray(schedule) ? schedule : [];
    }

    public annuityPaymentStatus(row: any) {
        if (!row?.paymentDate || this.annuityAmountValue(row?.paymentAmount) <= 0) return '미납';
        const year = Number(row.year || 0);
        if (year === 3) return '3년차 납부';
        if (row.recoveryDeadline && row.paymentDate > row.penaltyDeadline) return `${year}년차 회복납부`;
        if (row.penaltyDeadline && row.paymentDate > row.normalDeadline) return `${year}년차 과태납부`;
        return `${year}년차 납부`;
    }

    public annuityNextDeadlineLabel(item: any = this.selectedCase) {
        const row = this.annuityRows(item).find((entry: any) => entry.normalDeadline && this.annuityPaymentStatus(entry) === '미납');
        return row ? `${row.label} 정상기한 ${row.normalDeadline}` : '예정된 미납 연차 없음';
    }

    public async openAnnuityHistory(item: any = this.selectedCase) {
        if (!item || !this.isAnnuityRight(item) || this.showAnnuityHistory) return;
        this.ensureCaseDetailShape(item);
        this.annuityEditSnapshot = {
            annuity: this.cloneValue(item.detail.annuity),
            paymentDate: item.detail.disposition.paymentDate || ''
        };
        this.rebuildAnnuitySchedule(item, false);
        this.showAnnuityHistory = true;
        await this.service.render();
    }

    public closeAnnuityHistory(restore: boolean = true) {
        if (restore && this.selectedCase && this.annuityEditSnapshot) {
            this.selectedCase.detail.annuity = this.cloneValue(this.annuityEditSnapshot.annuity);
            this.selectedCase.detail.disposition.paymentDate = this.annuityEditSnapshot.paymentDate;
        }
        this.annuityEditSnapshot = null;
        this.showAnnuityHistory = false;
        this.service.render();
    }

    public async saveAnnuityHistory() {
        if (!this.selectedCase || this.annuitySaving) return;
        if (!await this.allowDraftInput(this.selectedCase, 'save_case')) return;
        this.annuitySaving = true;
        this.rebuildAnnuitySchedule(this.selectedCase, false);
        this.syncCaseFromDetail(this.selectedCase);
        const saved = await this.saveCaseRecord(this.selectedCase);
        this.annuitySaving = false;
        if (!saved) {
            await this.service.modal.error(this.dashboardApiErrorMessage || '연차내역 저장에 실패했습니다. 잠시 후 다시 시도해주세요.');
            return;
        }
        this.ensureCaseDetailShape(saved);
        this.replaceCase(saved);
        this.annuityEditSnapshot = null;
        this.showAnnuityHistory = false;
        await this.service.render();
    }

    public rebuildTrademarkRenewalSchedule(item: any = this.selectedCase, render: boolean = true) {
        if (validateFormDraft(item?.detail?.renewal || {}, 'save_case').error) return;
        if (!item || !this.isTrademarkRight(item)) return;
        if (!item.detail || typeof item.detail !== 'object') item.detail = this.emptyCaseDetail();
        if (!item.detail.disposition || typeof item.detail.disposition !== 'object') item.detail.disposition = { decisionDate: '', paymentDate: '' };
        item.detail.renewal = this.buildTrademarkRenewalDetail(item.detail.renewal, item.detail.disposition, item.detail.annuity);
        item.detail.disposition.paymentDate = item.detail.renewal.initialPaymentDate || '';
        if (render) this.service.render();
    }

    public onTrademarkRenewalChange(item: any = this.selectedCase) {
        this.rebuildTrademarkRenewalSchedule(item);
    }

    public onTrademarkRenewalRowPaymentChange(row: any, item: any = this.selectedCase) {
        if (!item || !row) return;
        if (validateFormDraft(row, 'save_case').error) return;
        row.paymentDate = this.normalizedAnnuityDate(row.paymentDate);
        row.paymentAmount = this.editableAnnuityAmount(row.paymentAmount);
        if (Number(row.cycle) === 0) {
            item.detail.renewal.initialPaymentDate = row.paymentDate;
            item.detail.renewal.initialPaymentAmount = row.paymentAmount;
        }
        this.rebuildTrademarkRenewalSchedule(item);
    }

    public trademarkRenewalRows(item: any = this.selectedCase) {
        if (!item || !this.isTrademarkRight(item)) return [];
        const schedule = item.detail?.renewal?.schedule;
        return Array.isArray(schedule) ? schedule : [];
    }

    public trademarkRenewalPaymentStatus(row: any) {
        if (!row?.paymentDate || this.annuityAmountValue(row?.paymentAmount) <= 0) return '미납';
        const cycle = Number(row.cycle || 0);
        return cycle === 0 ? '정상납부' : `${cycle}차 갱신납부`;
    }

    public trademarkRenewalNextDeadlineLabel(item: any = this.selectedCase) {
        const row = this.trademarkRenewalRows(item)
            .find((entry: any) => entry.normalDeadline && this.trademarkRenewalPaymentStatus(entry) === '미납');
        return row ? `${row.label} 정상기한 ${row.normalDeadline}` : '다음 갱신은 납부완료 후 자동생성';
    }

    public async openTrademarkRenewalHistory(item: any = this.selectedCase) {
        if (!item || !this.isTrademarkRight(item) || this.showTrademarkRenewalHistory) return;
        this.ensureCaseDetailShape(item);
        this.trademarkRenewalEditSnapshot = {
            renewal: this.cloneValue(item.detail.renewal),
            paymentDate: item.detail.disposition.paymentDate || ''
        };
        this.rebuildTrademarkRenewalSchedule(item, false);
        this.showTrademarkRenewalHistory = true;
        await this.service.render();
    }

    public closeTrademarkRenewalHistory(restore: boolean = true) {
        if (restore && this.selectedCase && this.trademarkRenewalEditSnapshot) {
            this.selectedCase.detail.renewal = this.cloneValue(this.trademarkRenewalEditSnapshot.renewal);
            this.selectedCase.detail.disposition.paymentDate = this.trademarkRenewalEditSnapshot.paymentDate;
        }
        this.trademarkRenewalEditSnapshot = null;
        this.showTrademarkRenewalHistory = false;
        this.service.render();
    }

    public async saveTrademarkRenewalHistory() {
        if (!this.selectedCase || this.trademarkRenewalSaving) return;
        if (!await this.allowDraftInput(this.selectedCase, 'save_case')) return;
        this.trademarkRenewalSaving = true;
        this.rebuildTrademarkRenewalSchedule(this.selectedCase, false);
        this.syncCaseFromDetail(this.selectedCase);
        const saved = await this.saveCaseRecord(this.selectedCase);
        this.trademarkRenewalSaving = false;
        if (!saved) {
            await this.service.modal.error('갱신내역 저장에 실패했습니다. 잠시 후 다시 시도해주세요.');
            return;
        }
        this.ensureCaseDetailShape(saved);
        this.replaceCase(saved);
        this.trademarkRenewalEditSnapshot = null;
        this.showTrademarkRenewalHistory = false;
        await this.service.render();
    }

    public caseRenewalLabel(item: any) {
        if (this.isAnnuityRight(item)) {
            const completed = this.annuityRows(item)
                .filter((row: any) => this.annuityPaymentStatus(row) !== '미납')
                .sort((a: any, b: any) => Number(b.year) - Number(a.year))[0];
            if (completed) return this.annuityPaymentStatus(completed);
            const next = this.annuityRows(item).find((row: any) => row.normalDeadline);
            return next ? `${next.label} 정상기한 (${next.normalDeadline})` : '-';
        }
        if (this.isTrademarkRight(item)) {
            const completed = this.trademarkRenewalRows(item)
                .filter((row: any) => this.trademarkRenewalPaymentStatus(row) !== '미납')
                .sort((a: any, b: any) => Number(b.cycle) - Number(a.cycle))[0];
            if (completed) return this.trademarkRenewalPaymentStatus(completed);
            const next = this.trademarkRenewalRows(item).find((row: any) => row.normalDeadline);
            return next ? `${next.label} 정상기한 (${next.normalDeadline})` : '-';
        }
        return '-';
    }

    public async openCaseConsultationHistoryFromList(item: any, event?: any) {
        event?.stopPropagation();
        await this.openCase(item);
        this.showCaseConsultationHistory = true;
        await this.service.render();
        this.focusCaseSection('case-consultation-history');
    }

    public disputeStatusClass(item: any) {
        const status = item?.disputeStatus || item?.detail?.dispute?.type || '이의';
        return {
            'is-objection': status === '이의',
            'is-trial': status === '심판',
            'is-litigation': status === '소송'
        };
    }

    public disputeExaminationHistoryLabel(item: any) {
        if (!item?.examinationHistoryLoadedAt) return '불러오기';
        return `${Number(item.examinationHistoryCount || 0)}건 불러옴`;
    }

    public foreignRightLabel(item: any) {
        const right = String(item?.rightDisplay || item?.right || '');
        return right === '실용' || right === '실용신안' || right === '특허/실용신안' ? '특허' : (right || '-');
    }

    public canLoadForeignExaminationHistory(item: any) {
        return !!String(item?.foreignDomesticApplicationNo || item?.detail?.foreign?.domesticApplicationNo || item?.applicationNo || '').trim();
    }

    public foreignExaminationHistoryLabel(item: any) {
        if (!this.canLoadForeignExaminationHistory(item)) return '출원번호 없음';
        const history = Array.isArray(item?.detail?.foreign?.examinationHistory)
            ? item.detail.foreign.examinationHistory
            : [];
        const loadedAt = item?.foreignExaminationHistoryLoadedAt
            || item?.detail?.foreign?.examinationHistoryLoadedAt;
        if (!loadedAt) return '불러오기';
        return String(Number(item?.foreignExaminationHistoryCount ?? history.length)) + '건 불러옴';
    }

    public async loadForeignExaminationHistory(item: any, event?: any) {
        event?.stopPropagation();
        if (!item || !this.canLoadForeignExaminationHistory(item)) return;
        const detail = this.ensureCaseDetailShape(item);
        const { code, data } = await wiz.call('load_foreign_examination_history', { case_id: item.id });
        if (code === 401) {
            this.redirectToAccess();
            return;
        }
        if (code !== 200) {
            await this.service.modal.error('심사이력을 불러오지 못했습니다.');
            return;
        }
        if (!data.source_found) {
            await this.service.modal.warning(data.message || '출원번호와 일치하는 국내출원 사건이 없습니다.');
            return;
        }
        detail.foreign.examinationHistory = Array.isArray(data.history) ? data.history : [];
        detail.foreign.examinationHistoryLoadedAt = data.loaded_at || this.today;
        detail.foreign.examinationHistoryReferenceNo = data.reference_no || '';
        detail.foreign.examinationHistorySourceCaseId = data.source_case_id || '';
        item.foreignExaminationHistoryCount = detail.foreign.examinationHistory.length;
        item.foreignExaminationHistoryLoadedAt = detail.foreign.examinationHistoryLoadedAt;
        const saved = await this.saveCaseRecord(item);
        if (saved) this.replaceCase(saved);
        await this.service.render();
    }

    public async loadDisputeExaminationHistory(item: any, event?: any) {
        event?.stopPropagation();
        if (!item) return;
        const detail = this.ensureCaseDetailShape(item);
        const { code, data } = await wiz.call('load_dispute_examination_history', { case_id: item.id });
        if (code === 401) {
            this.redirectToAccess();
            return;
        }
        if (code !== 200) {
            await this.service.modal.error('심사이력을 불러오지 못했습니다.');
            return;
        }
        if (!data.source_found) {
            await this.service.modal.warning(data.message || '연결 번호와 일치하는 국내출원 사건이 없습니다.');
            return;
        }
        detail.dispute.examinationHistory = Array.isArray(data.history) ? data.history : [];
        detail.dispute.examinationHistoryLoadedAt = data.loaded_at || this.today;
        detail.dispute.examinationHistoryReferenceNo = data.reference_no || '';
        detail.dispute.examinationHistorySourceCaseId = data.source_case_id || '';
        detail.dispute.examinationHistorySourceCaseKey = data.case_key || item.caseKey || detail.caseKey || '';
        detail.dispute.examinationHistorySourceCase = data.domestic_case && typeof data.domestic_case === 'object'
            ? this.cloneValue(data.domestic_case)
            : {};
        item.examinationHistoryCount = detail.dispute.examinationHistory.length;
        item.examinationHistoryLoadedAt = detail.dispute.examinationHistoryLoadedAt;
        const saved = await this.saveCaseRecord(item);
        if (saved) this.replaceCase(saved);
        await this.service.render();
    }

    public isTrademarkObjectionDraft() {
        const detail = this.ensureRegistrationDraftDetail();
        return this.registrationDraft.caseType === '이의/심판/소송'
            && detail.dispute.right === '상표'
            && detail.dispute.type === '이의';
    }

    public isTrialOrLitigationRegistrationDraft() {
        const detail = this.ensureRegistrationDraftDetail();
        return this.registrationDraft.caseType === '이의/심판/소송'
            && (detail.dispute.type === '심판' || detail.dispute.type === '소송');
    }

    public disputeRegistrationCategoryOptions() {
        if (!this.isTrialOrLitigationRegistrationDraft()) return ['이의'];
        const detail = this.ensureRegistrationDraftDetail();
        const options = [...this.disputeTrialCategoryOptions];
        const current = String(detail.dispute.category || '').trim();
        if (current && current !== '이의' && options.indexOf(current) < 0) options.push(current);
        return options;
    }

    public onRegistrationDisputeTypeChange(value: string) {
        const detail = this.ensureRegistrationDraftDetail();
        detail.dispute.type = value || '이의';
        if (this.isTrialOrLitigationRegistrationDraft()) {
            if (!detail.dispute.category || detail.dispute.category === '이의') detail.dispute.category = '무효';
            if (!detail.dispute.currentInstitution) {
                detail.dispute.currentInstitution = detail.dispute.type === '소송' ? '특허법원' : '특허심판원';
            }
            this.registrationDraft.stage = detail.dispute.type;
        } else {
            detail.dispute.category = '이의';
            detail.dispute.currentInstitution = '';
            this.registrationDraft.stage = '출원/심사';
        }
        this.service.render();
    }

    public setRegistrationDisputeRight(value: string) {
        const right = this.disputeRightOptions.indexOf(value) >= 0 ? value : '특허';
        const detail = this.ensureRegistrationDraftDetail();
        detail.dispute.right = right;
        const group = right === '특허' || right === '실용' ? '특허/실용신안' : right;
        this.registrationDraft.right = group;
        this.ensureRegistrationAdditional(group);
        this.ensureRegistrationDraftDetail().dispute.right = right;
        this.service.render();
    }

    public addRegistrationDisputeRelatedCase() {
        const detail = this.ensureRegistrationDraftDetail();
        detail.dispute.relatedCases.push('');
        this.service.render();
    }

    public removeRegistrationDisputeRelatedCase(index: number) {
        const detail = this.ensureRegistrationDraftDetail();
        detail.dispute.relatedCases.splice(index, 1);
        this.service.render();
    }

    public registrationContactGroupsForCaseType() {
        if (this.registrationDraft.caseType === '이의/심판/소송') {
            return this.registrationContactGroups.filter((group: any) => group.key === 'clients');
        }
        return this.registrationContactGroups;
    }

    public foreignRegistrationContactGroups() {
        return this.registrationContactGroups.filter((group: any) => group.key !== 'applicants');
    }

    public disputeBaseNumberLabel() {
        return this.isTrademarkObjectionDraft() ? '출원번호' : '등록번호';
    }

    public disputeBaseDateLabel() {
        return this.isTrademarkObjectionDraft() ? '출원일' : '등록일';
    }

    public selectedDisputeRelationDescription() {
        const detail = this.ensureRegistrationDraftDetail();
        return this.disputeRelationTypes.find((item: any) => item.value === detail.dispute.relationType)?.description || '';
    }

    public async saveCaseMemo(item: any) {
        if (!item) return;
        item.memo = item.memo || '';
        const saved = await this.saveCaseRecord(item);
        if (saved) this.replaceCase(saved);
        if (saved && this.showCaseChangeHistory && this.selectedCase?.id === saved.id) {
            await this.loadCaseChangeHistory(false);
        }
        await this.service.render();
    }

    public async openInfoUploadForm() {
        if (this.activeWorkspace === 'notices' && !this.canManageNotices()) {
            await this.service.modal.warning('공지사항 작성은 소속관리자만 할 수 있습니다.');
            return;
        }
        this.infoUploadDraft = this.emptyInfoUploadDraft(this.activeWorkspace);
        this.showInfoUploadForm = true;
        await this.service.render();
    }

    public async closeInfoUploadForm() {
        this.showInfoUploadForm = false;
        await this.service.render();
    }

    private documentSelectionError(file: any): string {
        if (!file || typeof file.name !== 'string') return '첨부할 파일을 선택해 주세요.';
        const extension = '.' + (file.name.split('.').pop() || '').toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        if (!file.name.includes('.') || allowed.indexOf(extension) < 0) return '허용되지 않은 문서 파일 형식입니다.';
        const size = file.size;
        const configuredMax = Number(this.documentFileUsage?.max_file_size_bytes);
        const maxSize = Number.isSafeInteger(configuredMax) && configuredMax > 0 ? configuredMax : 50 * 1024 * 1024;
        if (!Number.isSafeInteger(size) || size <= 0 || size > maxSize) return '파일은 1바이트 이상 ' + this.formatFileSize(maxSize) + ' 이하여야 합니다.';
        return '';
    }

    public async handleInfoUploadFile(event: any) {
        const file = event?.target?.files?.[0];
        if (event?.target) event.target.value = '';
        if (!file) return;
        const error = this.documentSelectionError(file);
        if (error) { await this.service.modal.error(error); return; }
        this.infoUploadDraft.fileName = file.name;
        this.infoUploadDraft.file = file;
        if (!this.infoUploadDraft.title) this.infoUploadDraft.title = file.name;
        await this.service.render();
    }

    public async handleInfoDetailAttachmentFile(event: any) {
        const file = event?.target?.files?.[0];
        if (event?.target) event.target.value = '';
        if (!file) return;
        const error = this.documentSelectionError(file);
        if (error) { await this.service.modal.error(error); return; }
        this.infoDetailAttachmentDraft.file = file;
        this.infoDetailAttachmentDraft.fileName = file.name;
        await this.service.render();
    }

    public async uploadInfoDetailAttachment() {
        const item = this.selectedInfoItem;
        const file = this.infoDetailAttachmentDraft.file;
        const workspace = this.selectedInfoWorkspace;
        if (!item || !file || !this.canAddInfoItemAttachment(item)) {
            await this.service.modal.warning('추가할 첨부자료를 선택해 주세요.');
            return;
        }

        const error = this.documentSelectionError(file);
        if (error) { await this.service.modal.error(error); return; }

        const savedDocument = await this.saveDocumentRecord({
            uploadedAt: this.today,
            category: '자료 첨부파일',
            name: file.name,
            fileName: file.name,
            uploader: this.currentUserName(),
            note: `${this.infoWorkspaceTitle(workspace)}: ${this.infoItemTitle(item)}`,
            deadlineRule: 'none'
        }, {});
        if (!savedDocument?.id) {
            await this.service.modal.error('첨부자료 정보를 저장하지 못했습니다.');
            return;
        }

        const uploadResult = await this.uploadDocumentFile(savedDocument.id, file);
        const currentFile = uploadResult?.files?.[0];
        if (!currentFile?.id) return;

        const uploadedAt = new Date().toISOString();
        const attachment = {
            documentId: savedDocument.id,
            fileId: currentFile.id,
            name: file.name,
            uploadedAt,
            uploader: this.currentUserName(),
            note: String(this.infoDetailAttachmentDraft.note || '').trim(),
            size: currentFile.size_bytes || 0,
            mime: currentFile.detected_mime || '',
            scanStatus: currentFile.scan_status || '',
            downloadable: !!currentFile.downloadable
        };
        const updated = {
            ...item,
            workspace,
            updated: this.today,
            latestAttachmentAt: uploadedAt,
            attachments: [attachment, ...this.infoItemAttachments(item)],
            fileName: attachment.name,
            attachmentDocumentId: attachment.documentId,
            attachmentFileId: attachment.fileId,
            attachmentSize: attachment.size,
            attachmentMime: attachment.mime,
            attachmentScanStatus: attachment.scanStatus,
            attachmentDownloadable: attachment.downloadable
        };
        const saved = await this.saveInfoItemRecord(updated);
        if (!saved) {
            await this.service.modal.error('첨부자료 이력을 저장하지 못했습니다.');
            return;
        }

        this.dashboard[workspace] = [saved, ...(this.dashboard[workspace] || []).filter((row: any) => row.id !== saved.id)];
        this.selectedInfoItem = saved;
        this.infoDetailAttachmentDraft = this.emptyInfoDetailAttachmentDraft();
        await this.service.render();
    }

    public async saveInfoUploadDraft() {
        const workspace = this.infoUploadDraft.workspace || this.activeWorkspace;
        if (['notices', 'laws', 'media', 'forms'].indexOf(workspace) < 0) return;
        if (workspace === 'notices' && !this.canManageNotices()) {
            await this.service.modal.warning('공지사항 작성은 소속관리자만 할 수 있습니다.');
            return;
        }
        const title = (this.infoUploadDraft.title || this.infoUploadDraft.fileName || this.workspaceTitle()).trim();
        const uploadFile = this.infoUploadDraft.file;
        if (uploadFile) {
            const error = this.documentSelectionError(uploadFile);
            if (error) { await this.service.modal.error(error); return; }
        }
        const item = {
            ...this.infoUploadDraft,
            id: this.infoUploadDraft.id || `info-${Date.now()}`,
            title,
            name: title,
            date: this.infoUploadDraft.date || this.today,
            updated: this.infoUploadDraft.updated || this.infoUploadDraft.date || this.today,
            fileName: uploadFile ? '' : (this.infoUploadDraft.fileName || ''),
            scope: this.canManageNotices() ? 'admin' : 'office',
            pinned: workspace === 'notices' && !!this.infoUploadDraft.pinned,
            pinnedAt: workspace === 'notices' && this.infoUploadDraft.pinned ? new Date().toISOString() : '',
            local: true
        };
        delete item.file;

        let saved = await this.saveInfoItemRecord(item);
        if (!saved) {
            await this.service.modal.error('자료를 저장하지 못했습니다.');
            return;
        }

        if (uploadFile) {
            const savedDocument = await this.saveDocumentRecord({
                uploadedAt: this.today,
                category: workspace === 'notices' ? '공지 첨부자료' : '자료 첨부파일',
                name: uploadFile.name,
                fileName: uploadFile.name,
                uploader: this.currentUserName(),
                note: `${this.infoWorkspaceTitle(workspace)}: ${title}`,
                deadlineRule: 'none'
            }, {});
            if (savedDocument?.id) {
                const uploadResult = await this.uploadDocumentFile(savedDocument.id, uploadFile);
                const currentFile = uploadResult?.files?.[0];
                if (currentFile?.id) {
                    const uploadedAt = new Date().toISOString();
                    const attachment = {
                        documentId: savedDocument.id,
                        fileId: currentFile.id,
                        name: uploadFile.name,
                        uploadedAt,
                        uploader: this.currentUserName(),
                        note: '',
                        size: currentFile.size_bytes || 0,
                        mime: currentFile.detected_mime || '',
                        scanStatus: currentFile.scan_status || '',
                        downloadable: !!currentFile.downloadable
                    };
                    const withAttachment = {
                        ...saved,
                        fileName: uploadFile.name,
                        latestAttachmentAt: uploadedAt,
                        attachments: [attachment],
                        attachmentDocumentId: attachment.documentId,
                        attachmentFileId: attachment.fileId,
                        attachmentSize: attachment.size,
                        attachmentMime: attachment.mime,
                        attachmentScanStatus: attachment.scanStatus,
                        attachmentDownloadable: attachment.downloadable
                    };
                    saved = await this.saveInfoItemRecord(withAttachment) || withAttachment;
                }
            }
        }

        const nextItem = saved;
        this.dashboard[workspace] = [nextItem, ...(this.dashboard[workspace] || []).filter((row: any) => row.id !== nextItem.id)];
        this.showInfoUploadForm = false;
        await this.service.render();
    }

    public availableStandardQuoteParts(partType: string) {
        const builtIns = this.defaultStandardQuoteParts().filter((item: any) => item.partType === partType);
        const saved = (this.standardQuoteParts || []).filter((item: any) => item.partType === partType && item.active !== false);
        return [...builtIns, ...saved];
    }

    public standardQuotePartCount(partType: string) {
        return this.availableStandardQuoteParts(partType).length;
    }

    public standardQuotePartTypeLabel(partType: string) {
        return this.standardQuotePartTypes.find((item) => item.id === partType)?.label || partType;
    }

    public standardQuotePartShortLabel(partType: string) {
        return this.standardQuotePartTypeLabel(partType).replace(/^\d+\.\s*/, '');
    }

    public setStandardQuotePartType(partType: string) {
        if (!this.standardQuotePartTypes.some((item) => item.id === partType)) return;
        this.activeStandardQuotePartType = partType;
        this.standardQuotePartDraft = this.emptyStandardQuotePartDraft(partType);
        this.service.render();
    }

    public newStandardQuotePart(partType: string = this.activeStandardQuotePartType) {
        this.activeStandardQuotePartType = partType;
        this.standardQuotePartDraft = this.emptyStandardQuotePartDraft(partType);
        this.service.render();
    }

    public editStandardQuotePart(part: any) {
        if (!part) return;
        this.activeStandardQuotePartType = part.partType || 'title';
        this.standardQuotePartDraft = {
            id: part.builtIn ? '' : (part.id || ''),
            partType: part.partType || 'title',
            name: part.builtIn ? `${part.name} 복사본` : (part.name || ''),
            content: part.content || '',
            costItems: this.cloneValue(part.costItems?.length ? part.costItems : this.emptyQuoteCostItems()),
            sortOrder: Number(part.sortOrder || 0)
        };
        this.service.render();
    }

    public addStandardQuoteCostItem() {
        this.standardQuotePartDraft.costItems = this.standardQuotePartDraft.costItems || [];
        this.standardQuotePartDraft.costItems.push(this.emptyQuoteCostItem());
        this.service.render();
    }

    public removeStandardQuoteCostItem(index: number) {
        const rows = this.standardQuotePartDraft.costItems || [];
        if (rows.length <= 1) return;
        rows.splice(index, 1);
        this.service.render();
    }

    public async saveStandardQuotePart() {
        const draft = this.standardQuotePartDraft || {};
        if (!String(draft.name || '').trim()) {
            await this.service.modal.warning('표준내용 이름을 입력해주세요.');
            return;
        }
        if (draft.partType !== 'cost' && !String(draft.content || '').trim()) {
            await this.service.modal.warning('표준내용을 입력해주세요.');
            return;
        }
        this.standardQuotePartSaving = true;
        await this.service.render();
        const data = await this.callDashboardApi('save_standard_quote_part', {
            ...draft,
            costItems: draft.partType === 'cost' ? (draft.costItems || []) : []
        });
        this.standardQuotePartSaving = false;
        const saved = data?.part;
        if (!saved) {
            await this.service.modal.error('표준견적 내용을 저장하지 못했습니다.');
            await this.service.render();
            return;
        }
        this.standardQuoteParts = [saved, ...this.standardQuoteParts.filter((item: any) => item.id !== saved.id)];
        this.standardQuotePartDraft = this.emptyStandardQuotePartDraft(saved.partType);
        await this.service.render();
    }

    public setQuoteAuthoringMode(mode: string) {
        if (mode !== 'standard' && mode !== 'upload') return;
        this.quoteDraft.authoringMode = mode;
        if (mode === 'upload') this.quoteFullPreviewOpen = false;
        this.service.render();
    }

    public quotePartIsSelected(partType: string, partId: string) {
        return String(this.quoteDraft?.selectedPartIds?.[partType] || '') === String(partId || '');
    }

    public quoteSelectedStandardPartCount() {
        return this.standardQuotePartTypes.filter((partType: any) => !!this.quoteDraft?.selectedPartIds?.[partType.id]).length;
    }

    public quoteSelectedStandardPartName(partType: string) {
        if (partType === 'cost' && this.consultationSelectedQuoteTemplates().length > 0) {
            return this.consultationQuoteSelectionLabel();
        }
        const partId = this.quoteDraft?.selectedPartIds?.[partType] || '';
        if (!partId) return partType === 'cost' ? '직접 입력' : '직접 작성';
        return this.availableStandardQuoteParts(partType).find((item: any) => item.id === partId)?.name
            || (partType === 'cost' ? '직접 입력' : '직접 작성');
    }

    public quoteDirectInputLabel(partType: string) {
        return partType === 'cost' ? '직접 입력' : '직접 작성';
    }

    public selectStandardQuotePart(partType: string, part: any) {
        if (!part?.id || this.quotePartIsSelected(partType, part.id)) {
            this.clearStandardQuotePart(partType);
            return;
        }
        this.applyStandardQuotePart(partType, part.id);
    }

    public clearStandardQuotePart(partType: string) {
        if (!this.quoteDraft.selectedPartIds) this.quoteDraft.selectedPartIds = {};
        this.quoteDraft.selectedPartIds[partType] = '';
        if (partType === 'cost') {
            this.quoteDraft.selectedTemplateIds = [];
            this.quoteDraft.templateId = '';
            this.quoteDraft.costItems = this.emptyQuoteCostItems();
            this.syncQuoteLegacyCosts();
        } else {
            if (!this.quoteDraft.parts) this.quoteDraft.parts = {};
            this.quoteDraft.parts[partType] = '';
        }
        this.service.render();
    }

    public applyStandardQuotePart(partType: string, partId: string) {
        const part = this.availableStandardQuoteParts(partType).find((item: any) => item.id === partId);
        if (!part) {
            this.clearStandardQuotePart(partType);
            return;
        }
        this.quoteDraft.selectedPartIds[partType] = partId || '';
        if (partType === 'cost') {
            const builtInTemplateId = String(partId || '').startsWith('builtin-cost-')
                ? String(partId).replace('builtin-cost-', '')
                : '';
            const builtInTemplate = this.quoteTemplates.find((item: any) => item.id === builtInTemplateId);
            this.quoteDraft.selectedTemplateIds = builtInTemplate ? [builtInTemplate.id] : [];
            if (builtInTemplate) {
                this.quoteDraft.templateId = builtInTemplate.id;
                this.quoteDraft.standardFormId = this.standardQuoteFormForTemplate(builtInTemplate)?.id || this.quoteDraft.standardFormId;
            }
            this.quoteDraft.costItems = this.cloneValue(part.costItems?.length ? part.costItems : this.emptyQuoteCostItems());
            this.syncQuoteLegacyCosts();
        } else {
            this.quoteDraft.parts[partType] = part.content || '';
        }
        this.service.render();
    }

    public addQuoteCostItem() {
        this.quoteDraft.costItems = this.quoteDraft.costItems || [];
        this.quoteDraft.costItems.push(this.emptyQuoteCostItem());
        this.syncQuoteLegacyCosts();
        this.service.render();
    }

    public removeQuoteCostItem(index: number) {
        const rows = this.quoteDraft.costItems || [];
        if (rows.length <= 1) return;
        rows.splice(index, 1);
        this.syncQuoteLegacyCosts();
        this.service.render();
    }

    public quoteCostItemsTotal(rows: any[] = this.quoteDraft?.costItems || []) {
        return (rows || []).reduce((total: number, item: any) => total + this.numberValue(item?.amount), 0);
    }

    public quoteTemplatePageCount(template: any) {
        if (Number(template?.pageCount) > 0) return Number(template.pageCount);
        const templateId = String(template?.id || '');
        return ['patent-domestic', 'dispute-start', 'trial-start', 'litigation-start'].indexOf(templateId) >= 0 ? 2 : 1;
    }

    public quoteTemplateThumbnail(template: any) {
        if (template?.thumbnail) return template.thumbnail;
        const templateId = String(template?.id || '');
        if (templateId === 'office-custom') return '/assets/quotes/standard-quote-madrid.png';
        if (template?.caseType === '해외출원') return '/assets/quotes/standard-quote-overseas-trademark.png';
        if (template?.rightType === '상표' || template?.rightType === '디자인') {
            return '/assets/quotes/standard-quote-combined.png';
        }
        return '/assets/quotes/standard-quote-patent.png';
    }

    public quoteTemplateDescription(template: any) {
        if (template?.description) return template.description;
        if (template?.custom) return '사무소에서 자유롭게 작성한 파일을 첨부해 발송하는 양식입니다.';
        if (template?.caseType === '해외출원') return '해외 관납료·현지대리인 비용·국내 수임료를 구분해 안내하는 양식입니다.';
        if (template?.caseType === '이의/심판/소송') return '착수금과 단계별 비용, 사건 진행 안내를 함께 정리하는 양식입니다.';
        if (template?.rightType === '상표') return '상품류와 지정상품을 기준으로 출원 비용을 안내하는 양식입니다.';
        if (template?.rightType === '디자인') return '디자인 출원 관납료와 대리인 수임료를 정리하는 양식입니다.';
        return '특허·실용신안 국내출원의 기본 비용과 절차 안내를 담은 양식입니다.';
    }

    public standardQuoteFormForTemplate(template: any) {
        if (template?.previewPages) return template;
        if (template?.caseType === '해외출원') {
            return this.standardQuoteForms.find((item: any) => item.id === 'form-overseas-trademark-china') || this.standardQuoteForms[0];
        }
        if (template?.rightType === '상표' || template?.rightType === '디자인') {
            return this.standardQuoteForms.find((item: any) => item.id === 'form-integrated-rights') || this.standardQuoteForms[0];
        }
        return this.standardQuoteForms.find((item: any) => item.id === 'form-patent') || this.standardQuoteForms[0];
    }

    public activeStandardQuoteForm() {
        const selected = this.standardQuoteForms.find((item: any) => item.id === this.quoteDraft?.standardFormId);
        return selected || this.standardQuoteFormForTemplate(this.selectedQuoteTemplate()) || this.standardQuoteForms[0];
    }

    public async onStandardQuoteFormChange() {
        const form = this.activeStandardQuoteForm();
        if (!form) return;
        const template = this.quoteTemplates.find((item: any) => item.id === form.quoteTemplateId) || this.quoteTemplates[0];
        this.quoteDraft.templateId = template.id;
        this.quoteDraft.rightType = form.rightType || template.rightType || this.quoteDraft.rightType;
        this.quoteDraft.caseType = form.caseType || template.caseType || this.quoteDraft.caseType;
        if (!this.quoteDraft.officeSubtitle) this.quoteDraft.officeSubtitle = form.documentSubtitle || '';
        if (this.usesDedicatedQuoteEditor(form.layout)) {
            this.quoteDraft.parts.guide = this.dedicatedQuoteDefaultGuide(form.layout);
            this.quoteDraft.guide = this.quoteDraft.parts.guide;
            this.syncQuoteLegacyCosts();
        }
        await this.service.render();
        if (form.layout === 'overseas-trademark') await this.loadOverseasExchangeRate(false);
    }

    public usesDedicatedQuoteEditor(layout: string = this.activeStandardQuoteForm()?.layout) {
        return ['patent', 'madrid', 'overseas-trademark', 'integrated'].indexOf(String(layout || '')) >= 0;
    }

    public quoteFormLayoutClass() {
        return `is-form-${this.activeStandardQuoteForm()?.layout || 'patent'}`;
    }

    public quoteFormCostMatrixRows() {
        const costs = this.quoteDraft?.costItems || [];
        const official = costs.filter((item: any) => String(item?.category || '').indexOf('관납료') >= 0);
        const agent = costs.filter((item: any) => String(item?.category || '').indexOf('관납료') < 0);
        const rowCount = Math.max(1, official.length, agent.length);
        return Array.from({ length: rowCount }, (_value, index) => ({
            official: official[index] || null,
            agent: agent[index] || null,
            note: official[index]?.note || agent[index]?.note || ''
        }));
    }

    public quoteSourceCostRows(minimumRows: number = 1) {
        const rows = (this.quoteDraft?.costItems || []).map((item: any) => item || this.emptyQuoteCostItem());
        while (rows.length < Math.max(1, minimumRows)) rows.push(this.emptyQuoteCostItem());
        return rows;
    }

    public quoteSourceMatrixRows(minimumRows: number = 1) {
        const rows = this.quoteFormCostMatrixRows();
        while (rows.length < Math.max(1, minimumRows)) rows.push({ official: null, agent: null, note: '' });
        return rows;
    }

    public quoteFormOfficialCostTotal() {
        return (this.quoteDraft?.costItems || [])
            .filter((item: any) => String(item?.category || '').indexOf('관납료') >= 0)
            .reduce((total: number, item: any) => total + this.numberValue(item?.amount), 0);
    }

    public quoteFormAgentCostTotal() {
        return (this.quoteDraft?.costItems || [])
            .filter((item: any) => String(item?.category || '').indexOf('관납료') < 0)
            .reduce((total: number, item: any) => total + this.numberValue(item?.amount), 0);
    }

    public quotePatentApplicationTotal(priority: boolean = false) {
        if (priority) {
            return this.numberValue(this.quoteDraft?.patentPriorityApplicationOfficialFee)
                + this.numberValue(this.quoteDraft?.patentPriorityExaminationOfficialFee)
                + this.numberValue(this.quoteDraft?.patentPriorityApplicationAgentFee);
        }
        return this.numberValue(this.quoteDraft?.patentApplicationOfficialFee)
            + this.numberValue(this.quoteDraft?.patentApplicationAgentFee);
    }

    public quotePatentRegistrationTotal(priority: boolean = false) {
        if (priority) {
            return this.numberValue(this.quoteDraft?.patentPriorityRegistrationOfficialFee)
                + this.numberValue(this.quoteDraft?.patentPriorityRegistrationAgentFee);
        }
        return this.numberValue(this.quoteDraft?.patentRegistrationOfficialFee)
            + this.numberValue(this.quoteDraft?.patentRegistrationAgentFee);
    }

    public quotePatentPriorityOfficialTotal() {
        return this.numberValue(this.quoteDraft?.patentPriorityApplicationOfficialFee)
            + this.numberValue(this.quoteDraft?.patentPriorityExaminationOfficialFee);
    }

    public syncPatentQuoteCosts() {
        if (this.activeStandardQuoteForm()?.layout !== 'patent') return;
        this.quoteDraft.costItems = [
            { category: '관납료', item: '출원관납료', amount: this.numberValue(this.quoteDraft.patentApplicationOfficialFee), note: '출원단계' },
            { category: '대리인 수임료', item: '출원 수임료', amount: this.numberValue(this.quoteDraft.patentApplicationAgentFee), note: '출원단계' },
            { category: '관납료', item: '등록관납료', amount: this.numberValue(this.quoteDraft.patentRegistrationOfficialFee), note: '등록단계' },
            { category: '대리인 수임료', item: '등록 성공수수료', amount: this.numberValue(this.quoteDraft.patentRegistrationAgentFee), note: '등록단계' }
        ];
    }

    public quoteMadridChfTotal() {
        return (this.quoteDraft?.madridRows || [])
            .reduce((total: number, row: any) => total + this.numberValue(row?.unitChf), 0);
    }

    public quoteMadridOfficialTotal() {
        return (this.quoteDraft?.madridRows || [])
            .reduce((total: number, row: any) => total + this.numberValue(row?.amount), 0);
    }

    public quoteMadridDomesticTotal() {
        return this.numberValue(this.quoteDraft?.madridDomesticSupply)
            + this.numberValue(this.quoteDraft?.madridDomesticVat);
    }

    public syncMadridQuoteCosts() {
        if (this.activeStandardQuoteForm()?.layout !== 'madrid') return;
        const rows = (this.quoteDraft?.madridRows || []).map((row: any) => ({
            category: '관납료',
            item: row?.country || '마드리드 국제출원료',
            amount: this.numberValue(row?.amount),
            note: row?.note || ''
        }));
        rows.push({
            category: '대리인 수임료',
            item: '국내대리인',
            amount: this.quoteMadridDomesticTotal(),
            note: '세금계산서 발급'
        });
        this.quoteDraft.costItems = rows;
    }

    public quoteOverseasOfficialTotal() {
        return (this.quoteDraft?.overseasTrademarkRows || [])
            .reduce((total: number, row: any) => total + this.numberValue(row?.officialAmount), 0);
    }

    public quoteOverseasAgentTotal() {
        return (this.quoteDraft?.overseasTrademarkRows || [])
            .reduce((total: number, row: any) => total + this.numberValue(row?.agentAmount), 0);
    }

    public quoteOverseasWonPerYuan() {
        const parsed = parseFloat(String(this.quoteDraft?.overseasExchangeRate || '').replace(/,/g, ''));
        return isFinite(parsed) && parsed > 0 ? parsed : 0;
    }

    public quoteOverseasExchangeRateLabel() {
        const exchangeRate = this.quoteOverseasWonPerYuan();
        return exchangeRate > 0
            ? exchangeRate.toLocaleString('ko-KR', { maximumFractionDigits: 4 })
            : '-';
    }

    public quoteOverseasYuanFromWon(value: any) {
        const exchangeRate = this.quoteOverseasWonPerYuan();
        const won = this.numberValue(value);
        if (exchangeRate <= 0 || won <= 0) return '';
        const yuan = Math.round((won / exchangeRate) * 100) / 100;
        return `${yuan.toLocaleString('ko-KR', { maximumFractionDigits: 2 })}위안`;
    }

    public syncOverseasTrademarkQuoteCosts() {
        if (this.activeStandardQuoteForm()?.layout !== 'overseas-trademark') return;
        const costItems: any[] = [];
        const exchangeRate = this.quoteOverseasWonPerYuan();
        if (exchangeRate > 0 && this.quoteDraft?.parts?.guide) {
            const rateLabel = exchangeRate.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
            this.quoteDraft.parts.guide = String(this.quoteDraft.parts.guide)
                .replace(/환율\s*[\d,.]+원/, `환율 ${rateLabel}원`);
            this.quoteDraft.guide = this.quoteDraft.parts.guide;
        }
        for (const row of this.quoteDraft?.overseasTrademarkRows || []) {
            row.officialForeign = this.quoteOverseasYuanFromWon(row?.officialAmount);
            row.agentForeign = this.quoteOverseasYuanFromWon(row?.agentAmount);
            costItems.push({
                category: '관납료',
                item: `${row?.country || '해외'} 관납료`,
                amount: this.numberValue(row?.officialAmount),
                note: row?.officialForeign || ''
            });
            costItems.push({
                category: '대리인 수임료',
                item: `${row?.country || '해외'} 수임료`,
                amount: this.numberValue(row?.agentAmount),
                note: row?.agentForeign || ''
            });
        }
        this.quoteDraft.costItems = costItems;
    }

    private async fetchPublicCnyKrwRate() {
        const endpoints = [
            { url: 'https://api.frankfurter.dev/v2/rate/CNY/KRW', provider: 'frankfurter' },
            { url: 'https://open.er-api.com/v6/latest/CNY', provider: 'exchange-rate-api' }
        ];
        for (const endpoint of endpoints) {
            try {
                const response = await fetch(endpoint.url, {
                    method: 'GET',
                    headers: { Accept: 'application/json' },
                    cache: 'no-store'
                });
                if (!response.ok) continue;
                const result: any = await response.json();
                const rate = endpoint.provider === 'frankfurter'
                    ? Number(result?.rate || 0)
                    : Number(result?.rates?.KRW || 0);
                if (!rate) continue;
                const updatedAt = Number(result?.time_last_update_unix || 0);
                return {
                    rate,
                    date: result?.date || (updatedAt ? new Date(updatedAt * 1000).toISOString().slice(0, 10) : ''),
                    source: endpoint.provider === 'frankfurter'
                        ? 'Frankfurter 중앙은행 기준환율'
                        : 'ExchangeRate-API 기준환율',
                    direct: true
                };
            } catch (error) {
                continue;
            }
        }
        return null;
    }

    public async loadOverseasExchangeRate(force: boolean = false) {
        if (this.quoteExchangeRateLoading) return;
        this.quoteExchangeRateLoading = true;
        this.quoteExchangeRateStatus = '최신 환율을 불러오는 중입니다.';
        await this.service.render();
        try {
            let rateData: any = null;
            try {
                const response: any = await wiz.call('exchange_rate', { force: force ? '1' : '0' });
                if (response?.code === 200 && Number(response?.data?.rate || 0)) rateData = response.data;
            } catch (error) {
                rateData = null;
            }
            if (!rateData) rateData = await this.fetchPublicCnyKrwRate();
            if (!rateData) {
                const fallbackRate = this.quoteOverseasWonPerYuan();
                this.quoteExchangeRateStatus = fallbackRate > 0
                    ? `자동 조회 지연 · 최근 기준환율 ${this.quoteOverseasExchangeRateLabel()}원 사용 중`
                    : '자동 환율 조회가 지연되고 있습니다.';
                this.syncOverseasTrademarkQuoteCosts();
                return;
            }
            this.quoteDraft.overseasExchangeRate = Number(rateData.rate);
            this.quoteDraft.overseasExchangeRateDate = rateData.date || '';
            this.quoteDraft.overseasExchangeRateSource = rateData.source || '자동 환율';
            this.quoteExchangeRateStatus = rateData.stale
                ? `기준일 ${rateData.date || '-'} · 최근 조회값 사용`
                : `기준일 ${rateData.date || '-'} · 자동 조회 완료`;
            this.syncOverseasTrademarkQuoteCosts();
        } catch (error) {
            this.quoteExchangeRateStatus = `자동 조회 지연 · 최근 기준환율 ${this.quoteOverseasExchangeRateLabel()}원 사용 중`;
            this.syncOverseasTrademarkQuoteCosts();
        } finally {
            this.quoteExchangeRateLoading = false;
            await this.service.render();
        }
    }

    public quoteIntegratedOfficialTotal() {
        return (this.quoteDraft?.integratedRows || []).reduce((total: number, row: any) => (
            total + this.numberValue(row?.applicationOfficialFee) + this.numberValue(row?.priorityOfficialFee)
        ), 0);
    }

    public quoteIntegratedAgentTotal() {
        return (this.quoteDraft?.integratedRows || [])
            .reduce((total: number, row: any) => total + this.numberValue(row?.agentFee), 0);
    }

    public syncIntegratedQuoteCosts() {
        if (this.activeStandardQuoteForm()?.layout !== 'integrated') return;
        const costItems: any[] = [];
        for (const row of this.quoteDraft?.integratedRows || []) {
            const rightLabel = row?.rightLabel || '지식재산권 1건';
            costItems.push({ category: '관납료', item: `${rightLabel} 출원관납료`, amount: this.numberValue(row?.applicationOfficialFee), note: rightLabel });
            costItems.push({ category: '관납료', item: `${rightLabel} 우선심사관납료`, amount: this.numberValue(row?.priorityOfficialFee), note: rightLabel });
            costItems.push({ category: '대리인 수임료', item: `${rightLabel} 수임료`, amount: this.numberValue(row?.agentFee), note: rightLabel });
        }
        this.quoteDraft.costItems = costItems;
    }

    public async handlePatentQuoteLogo(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const allowedTypes = ['image/png', 'image/jpeg', 'image/webp'];
        if (allowedTypes.indexOf(String(file.type || '')) < 0) {
            await this.service.modal.error('로고는 PNG, JPG 또는 WEBP 이미지로 등록해주세요.');
            if (event?.target) event.target.value = '';
            return;
        }
        if (!Number.isSafeInteger(file.size) || file.size <= 0 || file.size > 2 * 1024 * 1024) {
            await this.service.modal.error('로고 파일은 2MB 이하로 등록해주세요.');
            if (event?.target) event.target.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onload = async () => {
            this.quoteDraft.officeLogoDataUrl = String(reader.result || '');
            this.quoteDraft.officeLogoFileName = file.name || '';
            await this.service.render();
        };
        reader.onerror = async () => {
            await this.service.modal.error('로고 파일을 읽지 못했습니다.');
        };
        reader.readAsDataURL(file);
        if (event?.target) event.target.value = '';
    }

    public clearPatentQuoteLogo() {
        this.quoteDraft.officeLogoDataUrl = '';
        this.quoteDraft.officeLogoFileName = '';
        this.service.render();
    }

    public quoteTemplateDocumentTitle(template: any = this.selectedQuoteTemplate()) {
        if (template?.caseType === '해외출원') return '해외 지식재산권 출원 견적서';
        if (template?.caseType === '이의/심판/소송') return '이의·심판·소송 업무 견적서';
        return `${template?.rightType || '지식재산권'} 출원·등록 견적서`;
    }

    public quoteTemplateExampleCostItems(template: any) {
        return this.quoteCostItemsFromLegacy(template).filter((item: any) => this.numberValue(item?.amount) > 0);
    }

    public quotePreviewMoney(value: any) {
        const amount = this.numberValue(value);
        return amount > 0 ? `${this.money(amount)}원` : '';
    }

    public quotePreviewDate(value: any) {
        const date = String(value || '').trim();
        if (!date) return '';
        const match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        return match ? `${match[1]}년 ${match[2]}월 ${match[3]}일` : date;
    }

    public quoteGuideLines() {
        const guide = this.quoteDraft?.parts?.guide || this.quoteDraft?.guide || '';
        return String(guide).split(/\r?\n/).filter((line: string) => !!line.trim());
    }

    public async openStandardQuoteTemplateDetail(template: any) {
        if (!template) return;
        this.selectedStandardQuoteTemplate = template;
        this.activeWorkspace = 'standardQuoteDetail';
        this.syncLocationForWorkspace('standardQuoteDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async closeStandardQuoteTemplateDetail() {
        this.activeWorkspace = 'standardQuotes';
        this.syncLocationForWorkspace('standardQuotes', true);
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async startQuoteFromSelectedTemplate() {
        if (!this.selectedStandardQuoteTemplate) return;
        const templateId = this.selectedStandardQuoteTemplate.quoteTemplateId || this.selectedStandardQuoteTemplate.id;
        const template = this.quoteTemplates.find((item: any) => item.id === templateId) || this.quoteTemplates[0];
        await this.openStandardQuoteTemplate(template, this.selectedStandardQuoteTemplate);
    }

    public onQuoteTemplateChange() {
        const template = this.selectedQuoteTemplate();
        if (!template) return;
        this.quoteDraft.rightType = template.rightType || this.quoteDraft.rightType;
        this.quoteDraft.caseType = template.caseType || this.quoteDraft.caseType;
        this.quoteDraft.standardFormId = this.standardQuoteFormForTemplate(template)?.id || this.quoteDraft.standardFormId;
        this.service.render();
    }

    private openQuoteComposerWorkspace() {
        if (this.activeWorkspace !== 'quoteComposer') {
            this.quoteComposerReturnWorkspace = this.normalizeWorkspace(this.activeWorkspace) || 'standardQuotes';
        }
        this.activeWorkspace = 'quoteComposer';
        this.showQuoteForm = true;
        this.quoteFullPreviewOpen = false;
        this.syncLocationForWorkspace('quoteComposer');
        this.notifyWorkspaceChanged();
    }

    public async openConsultationQuoteComposer(mode: string) {
        this.syncConsultationQuoteDraftSource();
        this.quoteDraft.authoringMode = mode === 'upload' ? 'upload' : 'standard';
        this.openQuoteComposerWorkspace();
        await this.service.render();
    }

    public async openQuoteForm(sourceCase?: any, standalone: boolean = false) {
        const quoteSource = standalone ? null : (sourceCase || this.selectedCase || this.filteredCases[0]);
        this.quoteDraft = this.emptyQuoteDraft(quoteSource);
        this.quoteDraft.authoringMode = 'standard';
        this.openQuoteComposerWorkspace();
        await this.service.render();
    }

    public async openStandardQuoteTemplate(template: any, standardForm: any = null) {
        if (!template) return;
        this.quoteDraft = this.emptyQuoteDraft(null);
        this.quoteDraft.templateId = template.id;
        const form = standardForm || this.standardQuoteFormForTemplate(template);
        this.quoteDraft.standardFormId = form?.id || this.quoteDraft.standardFormId;
        this.quoteDraft.rightType = form?.rightType || template.rightType || this.quoteDraft.rightType;
        this.quoteDraft.caseType = form?.caseType || template.caseType || this.quoteDraft.caseType;
        this.quoteDraft.officeSubtitle = form?.documentSubtitle || '';
        this.quoteDraft.parts.guide = this.usesDedicatedQuoteEditor(form?.layout)
            ? this.dedicatedQuoteDefaultGuide(form?.layout)
            : (this.availableStandardQuoteParts('guide')[0]?.content || '');
        this.quoteDraft.guide = this.quoteDraft.parts.guide;
        this.quoteDraft.selectedPartIds.cost = '';
        if (this.usesDedicatedQuoteEditor(form?.layout)) this.syncQuoteLegacyCosts();
        else this.quoteDraft.costItems = this.emptyQuoteCostItems();
        this.quoteDraft.authoringMode = template.custom ? 'upload' : 'standard';
        this.openQuoteComposerWorkspace();
        await this.service.render();
        if (form?.layout === 'overseas-trademark') await this.loadOverseasExchangeRate(false);
    }

    public async openQuoteHistoryEditor(quote: any) {
        if (!quote) return;
        const detail = quote?.quoteDetail && typeof quote.quoteDetail === 'object'
            ? this.cloneValue(quote.quoteDetail)
            : {};
        const savedDocument = detail?.document && typeof detail.document === 'object'
            ? this.cloneValue(detail.document)
            : {};
        const selectedTemplates = Array.isArray(detail?.selectedTemplates) ? detail.selectedTemplates : [];
        const savedTemplateId = detail?.templateId || selectedTemplates[0]?.id || '';
        const savedTemplate = this.quoteTemplates.find((item: any) => item.id === savedTemplateId)
            || this.quoteTemplates.find((item: any) => item.rightType === (detail?.rightType || quote?.rightType) && item.caseType === (detail?.caseType || quote?.caseType))
            || this.quoteTemplates[0];
        const savedForm = this.standardQuoteForms.find((item: any) => item.id === detail?.standardFormId)
            || this.standardQuoteForms.find((item: any) => item.label === quote?.template)
            || this.standardQuoteFormForTemplate(savedTemplate);
        const draft = this.emptyQuoteDraft(null);

        Object.assign(draft, savedDocument, {
            editingQuoteId: quote.id || '',
            editingQuoteStatus: quote.status || '작성중',
            editingQuoteSentAt: quote.sentAt || '',
            caseId: quote.caseId || '',
            caseNo: quote.caseNo || '',
            source: detail?.source || quote.source || '',
            clientName: quote.clientName || '',
            rightType: detail?.rightType || quote.rightType || savedForm?.rightType || draft.rightType,
            caseType: detail?.caseType || quote.caseType || savedForm?.caseType || draft.caseType,
            templateId: savedTemplate?.id || draft.templateId,
            standardFormId: savedForm?.id || draft.standardFormId,
            authoringMode: detail?.authoringMode === 'upload' ? 'upload' : 'standard',
            selectedTemplateIds: this.cloneValue(detail?.selectedTemplateIds || selectedTemplates.map((item: any) => item.id).filter((id: string) => !!id) || []),
            selectedPartIds: { ...draft.selectedPartIds, ...(detail?.selectedPartIds || {}) },
            parts: { ...draft.parts, ...(detail?.parts || {}) },
            costItems: this.cloneValue(
                Array.isArray(detail?.costItems) && detail.costItems.length
                    ? detail.costItems
                    : (Array.isArray(quote?.costItems) && quote.costItems.length ? quote.costItems : this.quoteCostItemsFromLegacy(quote))
            ),
            customTemplateName: detail?.authoringMode === 'upload' ? (quote.template || '') : '',
            templateFileName: quote.templateFileName || '',
            templateFile: null,
            existingAttachmentDocumentId: detail?.attachmentDocumentId || '',
            existingAttachmentFileId: detail?.attachmentFileId || '',
            existingAttachmentScanStatus: detail?.attachmentScanStatus || '',
            existingAttachmentDownloadable: !!detail?.attachmentDownloadable,
            recipientEmail: savedDocument?.recipientEmail || detail?.recipientEmail || ''
        });
        draft.quoteNo = savedDocument?.quoteNo || quote.id || '';
        draft.quoteDate = savedDocument?.quoteDate || quote.sentAt || this.today;
        if (savedDocument?.guide && !detail?.parts?.guide) draft.parts.guide = savedDocument.guide;
        if (savedDocument?.sealText && !detail?.parts?.seal) draft.parts.seal = savedDocument.sealText;
        draft.guide = draft.parts.guide || savedDocument?.guide || '';
        draft.sealText = draft.parts.seal || savedDocument?.sealText || '';

        this.quoteDraft = draft;
        this.selectedStandardQuoteTemplate = savedForm || null;
        this.quoteExchangeRateStatus = savedDocument?.overseasExchangeRateDate
            ? `저장된 기준일 ${savedDocument.overseasExchangeRateDate} 환율`
            : '';
        this.openQuoteComposerWorkspace();
        await this.service.render();
    }

    public async closeQuoteForm() {
        const returnWorkspace = this.normalizeWorkspace(this.quoteComposerReturnWorkspace) || 'standardQuotes';
        this.showQuoteForm = false;
        this.quoteFullPreviewOpen = false;
        this.activeWorkspace = returnWorkspace;
        this.syncLocationForWorkspace(returnWorkspace, true);
        this.notifyWorkspaceChanged();
        await this.loadActiveWorkspacePage(false);
        await this.service.render();
    }

    public applyQuoteTemplate() {
        const template = this.selectedQuoteTemplate();
        if (!template) return;
        if (template.custom) {
            this.quoteDraft.officialFee = template.officialFee;
            this.quoteDraft.serviceFee = template.serviceFee;
            this.quoteDraft.vat = template.vat;
            this.quoteDraft.etcFee = template.etcFee;
            this.quoteDraft.costItems = this.quoteCostItemsFromLegacy(template);
            this.quoteDraft.selectedPartIds.cost = '';
            this.service.render();
            return;
        }
        this.quoteDraft.rightType = template.rightType;
        this.quoteDraft.caseType = template.caseType;
        this.quoteDraft.officialFee = template.officialFee;
        this.quoteDraft.serviceFee = template.serviceFee;
        this.quoteDraft.vat = template.vat;
        this.quoteDraft.etcFee = template.etcFee;
        this.quoteDraft.costItems = this.quoteCostItemsFromLegacy(template);
        this.quoteDraft.selectedPartIds.cost = `builtin-cost-${template.id}`;
        this.service.render();
    }

    public async saveQuoteDraft(send: boolean = false) {
        if (!await this.allowDraftInput(this.quoteDraft, 'save_quote')) return;
        const template = this.selectedQuoteTemplate();
        const standardForm = this.activeStandardQuoteForm();
        const consultationTemplates = this.consultationSelectedQuoteTemplates();
        const authoringMode = this.quoteDraft.authoringMode === 'upload' ? 'upload' : 'standard';
        if (authoringMode === 'upload' && !this.quoteDraft.templateFile && !this.quoteDraft.existingAttachmentFileId) {
            await this.service.modal.warning('발송할 견적서 파일을 선택해주세요.');
            return;
        }
        if (authoringMode === 'upload' && !this.canManageDocumentFiles()) {
            await this.service.modal.warning('견적서 파일을 업로드할 권한이 없습니다.');
            return;
        }
        const recipientEmail = String(this.quoteDraft.recipientEmail || '').trim().toLowerCase();
        if (send && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
            await this.service.modal.warning('견적서를 받을 이메일 주소를 확인해주세요.');
            return;
        }
        let generatedQuoteFile: File | null = null;
        if (send && authoringMode === 'standard') {
            generatedQuoteFile = await this.saveQuoteAsPdf(false);
            if (!generatedQuoteFile) return;
        }
        if (authoringMode === 'standard') this.syncQuoteLegacyCosts();
        const costItems = authoringMode === 'standard'
            ? this.cloneValue(this.quoteDraft.costItems || [])
            : [];
        const quoteDetail: any = {
            authoringMode,
            templateId: this.quoteDraft.templateId || '',
            source: this.quoteDraft.source || '',
            rightType: this.quoteDraft.rightType || '',
            caseType: this.quoteDraft.caseType || '',
            standardFormId: standardForm?.id || '',
            standardFormLabel: standardForm?.label || '',
            selectedTemplateIds: this.cloneValue(this.quoteDraft.selectedTemplateIds || []),
            selectedTemplates: consultationTemplates.map((item: any) => ({
                id: item.id,
                label: item.label,
                rightType: item.rightType,
                caseType: item.caseType
            })),
            selectedPartIds: this.cloneValue(this.quoteDraft.selectedPartIds || {}),
            parts: this.cloneValue(this.quoteDraft.parts || {}),
            costItems,
            document: {
                officeName: this.quoteDraft.officeName || '',
                officeHeaderName: this.quoteDraft.officeHeaderName || '',
                officeSubtitle: this.quoteDraft.officeSubtitle || '',
                officeLogoDataUrl: this.quoteDraft.officeLogoDataUrl || '',
                officeLogoFileName: this.quoteDraft.officeLogoFileName || '',
                officeRegistrationNo: this.quoteDraft.officeRegistrationNo || '',
                representative: this.quoteDraft.representative || '',
                officeAddress: this.quoteDraft.officeAddress || '',
                officePhone: this.quoteDraft.officePhone || '',
                officeEmail: this.quoteDraft.officeEmail || '',
                officeBusinessType: this.quoteDraft.officeBusinessType || '',
                officeBusinessItem: this.quoteDraft.officeBusinessItem || '',
                recipient: this.quoteDraft.recipient || '',
                recipientEmail,
                quoteNo: this.quoteDraft.quoteNo || '',
                quoteDate: this.quoteDraft.quoteDate || '',
                subject: this.quoteDraft.subject || '',
                validity: this.quoteDraft.validity || '',
                accountInfo: this.quoteDraft.accountInfo || '',
                bankName: this.quoteDraft.bankName || '',
                bankAccountNo: this.quoteDraft.bankAccountNo || '',
                bankAccountHolder: this.quoteDraft.bankAccountHolder || '',
                patentApplicationOfficialFee: this.numberValue(this.quoteDraft.patentApplicationOfficialFee),
                patentApplicationAgentFee: this.numberValue(this.quoteDraft.patentApplicationAgentFee),
                patentRegistrationOfficialFee: this.numberValue(this.quoteDraft.patentRegistrationOfficialFee),
                patentRegistrationAgentFee: this.numberValue(this.quoteDraft.patentRegistrationAgentFee),
                patentPriorityApplicationOfficialFee: this.numberValue(this.quoteDraft.patentPriorityApplicationOfficialFee),
                patentPriorityExaminationOfficialFee: this.numberValue(this.quoteDraft.patentPriorityExaminationOfficialFee),
                patentPriorityApplicationAgentFee: this.numberValue(this.quoteDraft.patentPriorityApplicationAgentFee),
                patentPriorityRegistrationOfficialFee: this.numberValue(this.quoteDraft.patentPriorityRegistrationOfficialFee),
                patentPriorityRegistrationAgentFee: this.numberValue(this.quoteDraft.patentPriorityRegistrationAgentFee),
                madridRows: this.cloneValue(this.quoteDraft.madridRows || []),
                madridExchangeNote: this.quoteDraft.madridExchangeNote || '',
                madridDomesticUnit: this.quoteDraft.madridDomesticUnit || '',
                madridDomesticSupply: this.numberValue(this.quoteDraft.madridDomesticSupply),
                madridDomesticVat: this.numberValue(this.quoteDraft.madridDomesticVat),
                overseasExchangeRate: this.quoteOverseasWonPerYuan(),
                overseasExchangeRateDate: this.quoteDraft.overseasExchangeRateDate || '',
                overseasExchangeRateSource: this.quoteDraft.overseasExchangeRateSource || '',
                overseasTrademarkRows: this.cloneValue(this.quoteDraft.overseasTrademarkRows || []),
                integratedRows: this.cloneValue(this.quoteDraft.integratedRows || []),
                guide: this.quoteDraft.parts?.guide || this.quoteDraft.guide || '',
                sealText: this.quoteDraft.parts?.seal || this.quoteDraft.sealText || ''
            },
            attachmentDocumentId: this.quoteDraft.existingAttachmentDocumentId || '',
            attachmentFileId: this.quoteDraft.existingAttachmentFileId || '',
            attachmentScanStatus: this.quoteDraft.existingAttachmentScanStatus || '',
            attachmentDownloadable: !!this.quoteDraft.existingAttachmentDownloadable
        };
        const quote = {
            id: this.quoteDraft.editingQuoteId || this.quoteDraft.quoteNo || `QT-${this.today.replace(/-/g, '')}-${String(Date.now()).slice(-5)}`,
            source: this.quoteDraft.source || this.quoteDraft.subject || '직접 작성',
            caseId: this.quoteDraft.caseId || '',
            caseNo: this.quoteDraft.caseNo || '',
            clientName: this.quoteDraft.clientName || '',
            rightType: this.quoteDraft.rightType || template?.rightType || '',
            caseType: this.quoteDraft.caseType || template?.caseType || '',
            template: authoringMode === 'upload'
                ? (this.quoteDraft.customTemplateName || this.quoteDraft.templateFileName || '업로드 견적서')
                : (consultationTemplates.length > 1
                    ? `${consultationTemplates.length}개 견적 조합`
                    : (consultationTemplates[0]?.label
                        || (template?.custom ? (this.quoteDraft.customTemplateName || '특허사무소 자체 양식') : (standardForm?.label || template?.label || '표준견적 조합')))),
            templateFileName: this.quoteDraft.templateFileName || '',
            officialFee: authoringMode === 'standard' ? this.numberValue(this.quoteDraft.officialFee) : 0,
            serviceFee: authoringMode === 'standard' ? this.numberValue(this.quoteDraft.serviceFee) : 0,
            vat: authoringMode === 'standard' ? this.numberValue(this.quoteDraft.vat) : 0,
            etcFee: authoringMode === 'standard' ? this.numberValue(this.quoteDraft.etcFee) : 0,
            status: send ? '작성중' : (this.quoteDraft.editingQuoteStatus || '작성중'),
            sentAt: send ? '' : (this.quoteDraft.editingQuoteSentAt || ''),
            costItems,
            quoteDetail,
            local: true
        };

        let saved = await this.saveQuoteRecord(quote);
        let nextQuote = saved || quote;
        const quoteAttachmentFile = generatedQuoteFile || this.quoteDraft.templateFile;
        if (saved && quoteAttachmentFile && this.canManageDocumentFiles()) {
            const linkedCase = this.quoteDraft.caseId && this.selectedCase?.id === this.quoteDraft.caseId ? this.selectedCase : null;
            const linkedClient = this.clients.find((client: any) => client.name === this.quoteDraft.clientName);
            const quoteCaseContext = linkedCase || {
                id: '',
                clientId: linkedClient?.id || '',
                clientName: this.quoteDraft.clientName || '',
                title: this.quoteDraft.source || '견적서',
                caseNo: this.quoteDraft.caseNo || ''
            };
            const quoteDocument = {
                id: `quote-document-${Date.now()}`,
                uploadedAt: this.today,
                category: '출원전서류',
                name: `견적서 · ${nextQuote.template}`,
                fileName: quoteAttachmentFile.name || this.quoteDraft.templateFileName || '',
                uploader: this.currentUserName(),
                note: `견적번호 ${nextQuote.id}`,
                dueDate: '',
                deadlineRule: 'none',
                deadlineTask: '',
                deadlineAssignee: linkedCase?.assignee || ''
            };
            const savedDocument = await this.saveDocumentRecord(quoteDocument, quoteCaseContext);
            if (savedDocument?.id) {
                const uploadResult = await this.uploadDocumentFile(savedDocument.id, quoteAttachmentFile);
                this.applyDocumentFileResult(savedDocument, uploadResult || {});
                const currentFile = uploadResult?.files?.[0];
                quoteDetail.attachmentDocumentId = savedDocument.id;
                quoteDetail.attachmentFileId = currentFile?.id || '';
                quoteDetail.attachmentScanStatus = currentFile?.scan_status || '';
                quoteDetail.attachmentDownloadable = !!currentFile?.downloadable;
                saved = await this.saveQuoteRecord({ ...quote, id: saved.id, quoteDetail }) || saved;
                nextQuote = saved || nextQuote;
                if (linkedCase) {
                    linkedCase.documents = [savedDocument, ...(linkedCase.documents || []).filter((doc: any) => doc.id !== savedDocument.id)];
                }
            }
        }
        if (send) {
            const attachmentFileId = quoteDetail.attachmentFileId || this.quoteDraft.existingAttachmentFileId || '';
            if (!attachmentFileId) {
                await this.service.modal.error('견적서 첨부파일을 저장하지 못해 발송을 중단했습니다.');
                return;
            }
            const response: any = await wiz.call('send_quote', {
                payload: JSON.stringify({
                    quote_id: nextQuote.id,
                    recipient_email: recipientEmail,
                    attachment_file_id: attachmentFileId,
                    subject: `[${nextQuote.id}] ${this.quoteDraft.subject || nextQuote.template || '견적서'}`
                })
            });
            const delivery = this.responsePayload(response);
            if (Number(delivery.code) !== 200) {
                await this.service.modal.error(this.responseMessage(delivery, '견적 이메일 발송에 실패했습니다.'));
                return;
            }
            nextQuote = {
                ...nextQuote,
                status: '발송',
                sentAt: this.quoteDraft.quoteDate || this.today,
                deliveryId: delivery.data?.delivery_id || ''
            };
        }
        this.quotes = [nextQuote, ...this.quotes.filter((row) => row.id !== nextQuote.id)];
        if (this.selectedCase?.id && nextQuote.caseId === this.selectedCase.id) {
            this.selectedCase.quoteHistory = [nextQuote, ...(this.selectedCase.quoteHistory || []).filter((row: any) => row.id !== nextQuote.id)];
            if (this.showCaseChangeHistory) await this.loadCaseChangeHistory(false);
        }
        await this.closeQuoteForm();
    }

    public async saveQuoteAsPdf(download: boolean = true): Promise<File | null> {
        if (!await this.allowDraftInput(this.quoteDraft, 'save_quote')) return null;
        if (this.quoteDraft.authoringMode !== 'standard' || this.quotePdfPrinting) return null;

        this.syncQuoteLegacyCosts();
        if (!this.quoteDraft.quoteNo) {
            this.quoteDraft.quoteNo = `QT-${this.today.replace(/-/g, '')}-${String(Date.now()).slice(-5)}`;
        }
        if (!this.quoteDraft.quoteDate) this.quoteDraft.quoteDate = this.today;

        this.quoteFullPreviewOpen = false;
        this.quotePdfPrinting = true;
        await this.service.render();

        await new Promise<void>((resolve) => {
            window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()));
        });

        const source = document.querySelector('.quote-composer-page .quote-standard-form-preview') as HTMLElement | null;
        if (!source) {
            await this.finishQuotePdfPrint();
            await this.service.modal.error('PDF로 저장할 견적서 내용을 찾지 못했습니다.');
            return null;
        }

        const printFrame = document.createElement('iframe');
        printFrame.setAttribute('aria-hidden', 'true');
        printFrame.setAttribute('title', '견적서 PDF 출력');
        printFrame.style.position = 'fixed';
        printFrame.style.left = '-10000px';
        printFrame.style.top = '0';
        printFrame.style.width = '210mm';
        printFrame.style.height = '297mm';
        printFrame.style.border = '0';
        document.body.appendChild(printFrame);
        this.quotePdfFrame = printFrame;

        const printDocument = printFrame.contentDocument;
        const printWindow = printFrame.contentWindow;
        if (!printDocument || !printWindow) {
            await this.finishQuotePdfPrint();
            await this.service.modal.error('PDF 인쇄 화면을 준비하지 못했습니다.');
            return null;
        }

        printDocument.open();
        printDocument.write('<!doctype html><html lang="ko"><head></head><body><main class="quote-pdf-standalone"></main></body></html>');
        printDocument.close();

        const base = printDocument.createElement('base');
        base.href = document.baseURI;
        printDocument.head.appendChild(base);

        const title = printDocument.createElement('title');
        title.textContent = this.quotePdfFileName();
        printDocument.head.appendChild(title);

        document.querySelectorAll('style, link[rel="stylesheet"]').forEach((node) => {
            printDocument.head.appendChild(node.cloneNode(true));
        });

        const printStyle = printDocument.createElement('style');
        printStyle.textContent = this.quotePdfPrintStyles();
        printDocument.head.appendChild(printStyle);

        const documentCopy = source.cloneNode(true) as HTMLElement;
        documentCopy.classList.add('quote-pdf-document-copy');
        const sourcePages = Array.from(source.querySelectorAll('.quote-source-document')) as HTMLElement[];
        const copiedPages = Array.from(documentCopy.querySelectorAll('.quote-source-document')) as HTMLElement[];
        copiedPages.forEach((page, index) => {
            const sourcePage = sourcePages[index];
            if (!sourcePage) return;
            const bounds = sourcePage.getBoundingClientRect();
            if (bounds.width > 0) page.style.setProperty('--quote-pdf-page-width', `${bounds.width}px`);
            if (bounds.height > 0) page.style.setProperty('--quote-pdf-page-height', `${bounds.height}px`);
        });
        documentCopy.querySelectorAll(
            '.quote-assembled-section-label, .quote-assembled-editor, .quote-assembled-edit-link'
        ).forEach((element) => element.remove());
        printDocument.querySelector('.quote-pdf-standalone')?.appendChild(documentCopy);

        await this.waitForQuotePdfDocument(printDocument, printWindow);

        try {
            const blob = await this.downloadQuotePdf(documentCopy, download);
            const file = new File([blob], `${this.quotePdfFileName()}.pdf`, { type: 'application/pdf' });
            await this.finishQuotePdfPrint();
            return file;
        } catch (error) {
            console.error('quote pdf generation failed', error);
            await this.finishQuotePdfPrint();
            await this.service.modal.error('PDF 파일을 생성하지 못했습니다. 잠시 후 다시 시도해주세요.');
            return null;
        }
    }

    private quotePdfFileName() {
        const clientName = String(this.quoteDraft.clientName || '').trim();
        const parts = ['견적서', this.quoteDraft.quoteNo, clientName].filter((value) => !!value);
        return parts.join('_').replace(/[\\/:*?"<>|]/g, '-');
    }

    private quotePdfPrintStyles() {
        return `
            @page { margin: 12mm; size: A4 portrait; }
            html,
            body {
                background: #ffffff !important;
                display: block !important;
                height: auto !important;
                margin: 0 !important;
                min-height: 0 !important;
                overflow: visible !important;
                width: auto !important;
            }
            body {
                color: #0f172a;
                font-family: SUIT, "Noto Sans KR", "Apple SD Gothic Neo", Arial, sans-serif;
                print-color-adjust: exact;
                -webkit-print-color-adjust: exact;
            }
            *,
            *::before,
            *::after {
                box-sizing: border-box;
            }
            .quote-pdf-standalone,
            .quote-pdf-document-copy,
            .quote-assembled-document {
                background: #ffffff !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                display: block !important;
                height: auto !important;
                margin: 0 !important;
                max-height: none !important;
                max-width: none !important;
                opacity: 1 !important;
                overflow: visible !important;
                padding: 0 !important;
                position: static !important;
                transform: none !important;
                visibility: visible !important;
                width: 100% !important;
            }
            .quote-pdf-document-copy .quote-source-document {
                box-shadow: none !important;
                margin: 0 !important;
                height: var(--quote-pdf-page-height, auto) !important;
                max-width: var(--quote-pdf-page-width, 47.5rem) !important;
                min-height: var(--quote-pdf-page-height, 0) !important;
                width: var(--quote-pdf-page-width, 47.5rem) !important;
            }
            .quote-assembled-section-label,
            .quote-assembled-editor,
            .quote-assembled-edit-link {
                display: none !important;
            }
            .quote-assembled-section {
                break-inside: avoid;
                display: block !important;
                page-break-inside: avoid;
            }
            .quote-assembled-section.is-cost {
                break-inside: auto;
                page-break-inside: auto;
            }
            .quote-assembled-section-body {
                display: block !important;
                font-size: 9pt !important;
                opacity: 1 !important;
                padding: 5mm 2mm !important;
                visibility: visible !important;
                width: 100% !important;
            }
            .quote-assembled-office-title {
                font-size: 9pt !important;
            }
            .quote-assembled-section.is-title h3 {
                font-size: 18pt !important;
            }
            .quote-assembled-info-table,
            .quote-assembled-cost-table {
                border-collapse: collapse !important;
                table-layout: fixed !important;
                width: 100% !important;
            }
            .quote-assembled-info-table thead,
            .quote-assembled-cost-table thead {
                display: table-header-group;
            }
            .quote-assembled-info-table tr,
            .quote-assembled-cost-table tr {
                break-inside: avoid;
                page-break-inside: avoid;
            }
        `;
    }

    private async waitForQuotePdfDocument(printDocument: Document, printWindow: Window) {
        const stylePromises = Array.from(printDocument.querySelectorAll('link[rel="stylesheet"]')).map((node) => {
            const link = node as HTMLLinkElement;
            if (link.sheet) return Promise.resolve();
            return new Promise<void>((resolve) => {
                link.addEventListener('load', () => resolve(), { once: true });
                link.addEventListener('error', () => resolve(), { once: true });
                window.setTimeout(() => resolve(), 3000);
            });
        });
        const imagePromises = Array.from(printDocument.images).map((image) => {
            if (image.complete) return Promise.resolve();
            return new Promise<void>((resolve) => {
                image.addEventListener('load', () => resolve(), { once: true });
                image.addEventListener('error', () => resolve(), { once: true });
            });
        });
        const fontPromise = (printDocument as any).fonts?.ready || Promise.resolve();
        await Promise.all([fontPromise, ...stylePromises, ...imagePromises]);
        await new Promise<void>((resolve) => {
            printWindow.requestAnimationFrame(() => printWindow.requestAnimationFrame(() => resolve()));
        });
    }

    private async downloadQuotePdf(documentElement: HTMLElement, download: boolean = true): Promise<Blob> {
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
            compress: true
        });
        const sourcePages = Array.from(documentElement.querySelectorAll('.quote-source-document')) as HTMLElement[];

        if (sourcePages.length) {
            for (let pageIndex = 0; pageIndex < sourcePages.length; pageIndex += 1) {
                const pageCanvas = await this.captureQuotePdfCanvas(sourcePages[pageIndex]);
                if (pageIndex > 0) pdf.addPage('a4', 'portrait');
                pdf.addImage(
                    pageCanvas.toDataURL('image/jpeg', 0.98),
                    'JPEG',
                    0,
                    0,
                    210,
                    297,
                    undefined,
                    'FAST'
                );
            }
            return this.finalizeQuotePdf(pdf, download);
        }

        const canvas = await this.captureQuotePdfCanvas(documentElement);
        const marginMm = 12;
        const pageWidthMm = 210;
        const pageHeightMm = 297;
        const contentWidthMm = pageWidthMm - (marginMm * 2);
        const contentHeightMm = pageHeightMm - (marginMm * 2);
        const pageHeightPx = Math.max(1, Math.floor((contentHeightMm / contentWidthMm) * canvas.width));
        let sourceY = 0;
        let pageIndex = 0;

        while (sourceY < canvas.height) {
            const sliceHeightPx = Math.min(pageHeightPx, canvas.height - sourceY);
            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = sliceHeightPx;
            const context = pageCanvas.getContext('2d');
            if (!context) throw new Error('quote pdf canvas context unavailable');
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
            context.drawImage(
                canvas,
                0,
                sourceY,
                canvas.width,
                sliceHeightPx,
                0,
                0,
                canvas.width,
                sliceHeightPx
            );

            if (pageIndex > 0) pdf.addPage('a4', 'portrait');
            const sliceHeightMm = (sliceHeightPx / canvas.width) * contentWidthMm;
            pdf.addImage(
                pageCanvas.toDataURL('image/jpeg', 0.98),
                'JPEG',
                marginMm,
                marginMm,
                contentWidthMm,
                sliceHeightMm,
                undefined,
                'FAST'
            );
            sourceY += sliceHeightPx;
            pageIndex += 1;
        }

        return this.finalizeQuotePdf(pdf, download);
    }

    private async captureQuotePdfCanvas(documentElement: HTMLElement) {
        const canvas = await html2canvas(documentElement, {
            backgroundColor: '#ffffff',
            logging: false,
            scale: 2,
            useCORS: true,
            width: documentElement.scrollWidth,
            height: documentElement.scrollHeight,
            windowWidth: documentElement.scrollWidth,
            windowHeight: documentElement.scrollHeight,
            scrollX: 0,
            scrollY: 0
        });
        if (!canvas.width || !canvas.height) throw new Error('empty quote canvas');
        return canvas;
    }

    private finalizeQuotePdf(pdf: jsPDF, download: boolean = true): Blob {
        const fileName = this.quotePdfFileName();
        pdf.setProperties({
            title: fileName,
            subject: '견적서',
            creator: 'IP Management System'
        });
        const blob = pdf.output('blob');
        if (download) pdf.save(`${fileName}.pdf`);
        return blob;
    }

    private async finishQuotePdfPrint(render: boolean = true) {
        if (!this.quotePdfPrinting && !this.quotePdfFrame) return;
        this.quotePdfFrame?.remove();
        this.quotePdfFrame = null;
        this.quotePdfPrinting = false;
        if (render) await this.service.render();
    }

    public quoteUsesUploadedFile(quote: any) {
        return quote?.quoteDetail?.authoringMode === 'upload';
    }

    public quoteHasDownloadableAttachment(quote: any) {
        return !!quote?.quoteDetail?.attachmentFileId;
    }

    public async downloadQuoteAttachment(quote: any, event: any = null) {
        event?.preventDefault();
        event?.stopPropagation();
        const detail = quote?.quoteDetail || {};
        await this.downloadInfoAttachment({
            documentId: detail.attachmentDocumentId || '',
            fileId: detail.attachmentFileId || '',
            scanStatus: detail.attachmentScanStatus || '',
            downloadable: !!detail.attachmentDownloadable
        });
    }

    public quoteDraftIsEditing() {
        return !!this.quoteDraft?.editingQuoteId;
    }

    public async handleQuoteTemplateFile(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = Number(this.documentFileUsage?.max_file_size_bytes || 50 * 1024 * 1024);
        if (allowed.indexOf(extension) < 0) {
            await this.service.modal.error('허용되지 않은 견적서 파일 형식입니다.');
            if (event?.target) event.target.value = '';
            return;
        }
        if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
            await this.service.modal.error(`파일은 1바이트 이상 ${this.formatFileSize(maxSize)} 이하여야 합니다.`);
            if (event?.target) event.target.value = '';
            return;
        }
        this.quoteDraft.templateFileName = file?.name || '';
        this.quoteDraft.templateFile = file || null;
        if (!this.quoteDraft.customTemplateName && file?.name) this.quoteDraft.customTemplateName = file.name;
        if (event?.target) event.target.value = '';
        this.service.render();
    }

    public caseQuoteHistory() {
        if (!this.selectedCase) return [];
        const direct = this.selectedCase.quoteHistory || [];
        const global = this.quotes.filter((quote) => quote.caseId === this.selectedCase.id);
        const merged = [...direct, ...global];
        const seen = new Set();
        return merged.filter((quote) => {
            const key = quote.id || `${quote.template}-${quote.sentAt}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        }).sort((a, b) => String(b.sentAt || '').localeCompare(String(a.sentAt || '')));
    }

    public async sendQuote(quote: any) {
        if (!quote) return;
        quote.status = '발송';
        quote.sentAt = quote.sentAt || this.today;
        quote.local = true;
        const saved = await this.saveQuoteRecord(quote);
        if (saved) this.replaceQuote(saved);
        await this.service.render();
    }

    public quoteTotal(quote: any) {
        if (Array.isArray(quote?.costItems) && quote.costItems.length) return this.quoteCostItemsTotal(quote.costItems);
        return this.numberValue(quote?.officialFee) + this.numberValue(quote?.serviceFee) + this.numberValue(quote?.vat) + this.numberValue(quote?.etcFee);
    }

    public async openRegistrationForm() {
        const category = this.normalizeCaseCategory(this.selectedWorkCard) || 'domestic';
        const target = category === 'dispute' ? '이의/심판/소송' : (category === 'foreign' ? '해외출원' : '국내출원');
        this.resetRegistrationDraft();
        this.onRegistrationCaseTypeChange(target);
        this.ensureRegistrationDraftDetail();
        this.showRegistrationAdditionalForm = true;
        this.showRegistrationForm = true;
        this.registrationDraft.right = this.registrationDraft.right || this.registrationRightTabs[0];
        await this.service.render();
    }

    public async closeRegistrationForm() {
        this.showRegistrationForm = false;
        this.showRegistrationAdditionalForm = false;
        this.pendingConsultationTransfer = null;
        await this.service.render();
    }

    public async backToSelectedConsultationFromRegistration() {
        this.showRegistrationForm = false;
        this.showRegistrationAdditionalForm = false;
        this.pendingConsultationTransfer = null;
        this.activeWorkspace = 'intakeConsultationDetail';
        this.syncLocationForWorkspace('intakeConsultationDetail');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public async setRegistrationRight(right: string) {
        this.registrationDraft.right = right;
        this.ensureRegistrationAdditional(right);
        this.ensureRegistrationDraftDetail();
        await this.service.render();
    }

    public get registrationAdditional() {
        return this.ensureRegistrationAdditional(this.registrationDraft.right);
    }

    public async openRegistrationAdditionalForm() {
        this.ensureRegistrationAdditional(this.registrationDraft.right);
        this.showRegistrationAdditionalForm = true;
        await this.service.render();
        window.setTimeout(() => {
            document.getElementById('registration-additional-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
    }

    public closeRegistrationAdditionalForm() {
        this.showRegistrationAdditionalForm = false;
        this.service.render();
    }

    public saveRegistrationAdditionalForm() {
        this.showRegistrationAdditionalForm = false;
        this.service.render();
    }

    public addRegistrationAdditionalRow(collectionKey: string) {
        const additional = this.ensureRegistrationAdditional(this.registrationDraft.right);
        if (!additional[collectionKey]) additional[collectionKey] = [];
        additional[collectionKey].push(this.emptyRegistrationAdditionalRow(collectionKey));
        this.service.render();
    }

    public removeRegistrationAdditionalRow(collectionKey: string, index: number) {
        const additional = this.ensureRegistrationAdditional(this.registrationDraft.right);
        const rows = additional[collectionKey] || [];
        if (rows.length <= 1) return;
        rows.splice(index, 1);
        this.service.render();
    }

    public foreignRegistrationApplications() {
        const additional = this.ensureRegistrationAdditional(this.registrationDraft.right);
        return additional.overseasApplications;
    }

    public addForeignRegistrationApplication() {
        this.addRegistrationAdditionalRow('overseasApplications');
    }

    public removeForeignRegistrationApplication(index: number) {
        this.removeRegistrationAdditionalRow('overseasApplications', index);
    }

    public addRegistrationContact(groupKey: string) {
        if (!this.registrationDraft[groupKey]) this.registrationDraft[groupKey] = [];
        this.registrationDraft[groupKey].push({ name: '', phone: '', email: '' });
        this.service.render();
    }

    public removeRegistrationContact(groupKey: string, index: number) {
        const rows = this.registrationDraft[groupKey] || [];
        if (rows.length <= 1) return;
        rows.splice(index, 1);
        this.service.render();
    }

    public handleRegistrationMarkImage(event: any) {
        const file = event?.target?.files?.[0];
        this.registrationDraft.markImageName = file?.name || '';
        if (event?.target) event.target.value = '';
        this.service.render();
    }

    public async handleConsultationRegistrationDocumentFile(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = Number(this.documentFileUsage?.max_file_size_bytes || 50 * 1024 * 1024);
        if (allowed.indexOf(extension) < 0) {
            await this.service.modal.error('허용되지 않은 파일 형식입니다.');
            if (event?.target) event.target.value = '';
            return;
        }
        if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
            await this.service.modal.error(`파일은 1바이트 이상 ${this.formatFileSize(maxSize)} 이하여야 합니다.`);
            if (event?.target) event.target.value = '';
            return;
        }
        this.ensureConsultationDraftShape();
        const document = this.consultationDraft.registrationDocuments;
        document.file = file;
        document.fileName = file.name || '';
        document.name = document.name || document.fileName;
        await this.service.render();
    }

    public addRegistrationDocument() {
        this.ensureRegistrationDocuments().push(this.emptyRegistrationDocument());
        this.service.render();
    }

    public removeRegistrationDocument(index: number) {
        const rows = this.ensureRegistrationDocuments();
        if (rows.length <= 1) return;
        rows.splice(index, 1);
        this.service.render();
    }

    public async handleRegistrationDocumentFile(event: any, index: number) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = Number(this.documentFileUsage?.max_file_size_bytes || 50 * 1024 * 1024);
        if (allowed.indexOf(extension) < 0) {
            await this.service.modal.error('허용되지 않은 파일 형식입니다.');
            if (event?.target) event.target.value = '';
            return;
        }
        if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
            await this.service.modal.error(`파일은 1바이트 이상 ${this.formatFileSize(maxSize)} 이하여야 합니다.`);
            if (event?.target) event.target.value = '';
            return;
        }
        const rows = this.ensureRegistrationDocuments();
        const row = rows[index];
        if (!row) return;
        row.file = file;
        row.fileName = file.name || '';
        row.name = row.name || row.fileName;
        await this.service.render();
    }

    public addRegistrationTrademarkProduct() {
        const detail = this.ensureRegistrationDraftDetail();
        detail.trademark.products.push({ productClass: '', productName: '' });
        this.service.render();
    }

    public removeRegistrationTrademarkProduct(index: number) {
        const detail = this.ensureRegistrationDraftDetail();
        if (detail.trademark.products.length <= 1) return;
        detail.trademark.products.splice(index, 1);
        this.service.render();
    }

    public async saveRegistrationDraft() {
        if (!await this.allowDraftInput(this.registrationDraft, 'save_case')) return;
        if (!String(this.registrationDraft?.patentClientNo || '').trim()) {
            await this.service.modal.error('새 사건 등록에는 특허고객번호가 반드시 필요합니다.');
            return;
        }
        const newCase = this.buildCaseFromRegistrationDraft();
        const saved = await this.saveCaseRecord(newCase);
        if (saved) {
            saved.documents = await this.saveRegistrationDocuments(saved);
        }
        if (saved && newCase.nextDue) {
            saved.nextDue = newCase.nextDue;
            saved.nextDueNote = newCase.nextDueNote;
            await this.saveCaseDeadlineRecord(saved);
        }
        if (saved && newCase.type === '해외출원' && newCase.relatedSourceCaseId) {
            const sourceCase = this.cases.find((item: any) => item.id === newCase.relatedSourceCaseId);
            if (sourceCase) {
                const sourceDetail = this.ensureCaseDetailShape(sourceCase);
                sourceDetail.hasOverseas = true;
                sourceCase.hasOverseas = true;
                const updatedSource = await this.saveCaseRecord(sourceCase);
                if (updatedSource) this.replaceCase(updatedSource);
            }
        }
        const nextCase = saved || newCase;
        const isNewCase = !this.cases.some((row) => row.id === nextCase.id);
        this.cases = [nextCase, ...this.cases.filter((row) => row.id !== nextCase.id)];
        if (isNewCase) this.adjustWorkCardCount(this.caseCategory(nextCase), 1);
        this.normalizeCaseData();
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        this.selectedCase = nextCase;
        this.selectedCaseTab = 'documents';
        this.isCaseSummaryEditing = false;
        this.activeWorkspace = 'caseDetail';
        this.syncLocationForWorkspace('caseDetail');
        this.notifyWorkspaceChanged();
        this.showRegistrationForm = false;
        this.showRegistrationAdditionalForm = false;
        if (saved && this.pendingConsultationTransfer?.consultationId) {
            const transfer = this.pendingConsultationTransfer;
            const consultation = this.consultations.find((row) => row.id === transfer.consultationId);
            if (consultation) {
                consultation.converted = true;
                consultation.status = '완료';
                consultation.transferredTo = transfer.target;
                consultation.transferredMatterId = saved.id;
            }
        }
        this.pendingConsultationTransfer = null;
        this.resetRegistrationDraft();
        await this.service.render();
    }

    public get selectedDocumentCount() {
        return (this.selectedCase?.documents || []).filter((doc: any) => doc.selected).length;
    }

    public get hasSelectedDocuments() {
        return this.selectedDocumentCount > 0;
    }

    public get allDocumentsSelected() {
        const documents = this.selectedCase?.documents || [];
        return documents.length > 0 && documents.every((doc: any) => doc.selected);
    }

    public async toggleAllDocuments(event: any) {
        const checked = !!event?.target?.checked;
        for (const doc of this.selectedCase?.documents || []) {
            doc.selected = checked;
        }
        await this.service.render();
    }

    public canManageDocumentFiles() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return ['TENANT_OWNER', 'TENANT_ADMIN', 'TENANT_MEMBER'].indexOf(role) >= 0;
    }

    public canReuploadLegacyDocument(doc: any) {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return role === 'TENANT_ADMIN'
            && doc?.legacyFile?.status === 'LEGACY_FILE_MISSING'
            && doc?.legacyFile?.reupload_allowed === true;
    }

    public openDocumentForm(mode: string = 'add') {
        if (mode === 'add' && !this.canManageDocumentFiles()) return;
        this.documentFormMode = mode;
        if (mode === 'edit') {
            const target = this.selectedCase?.documents?.find((doc: any) => doc.selected);
            if (!target) return;
            this.documentDraft = { ...target, fileName: target.name, file: null };
        } else {
            this.documentDraft = this.emptyDocumentDraft();
        }
        this.showDocumentForm = true;
        this.service.render();
    }

    public closeDocumentForm() {
        this.showDocumentForm = false;
        this.service.render();
    }

    public async handleDocumentDraftFile(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        if (this.documentDraft?.legacyFile) {
            if (event?.target) event.target.value = '';
            await this.service.modal.warning('Legacy 문서는 이 화면에서 파일을 교체할 수 없습니다. 관리자에게 문의해 주세요.');
            return;
        }
        const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = Number(this.documentFileUsage?.max_file_size_bytes || 50 * 1024 * 1024);
        if (allowed.indexOf(extension) < 0) {
            await this.service.modal.error('허용되지 않은 파일 형식입니다.');
            if (event?.target) event.target.value = '';
            return;
        }
        if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
            await this.service.modal.error(`파일은 1바이트 이상 ${this.formatFileSize(maxSize)} 이하여야 합니다.`);
            if (event?.target) event.target.value = '';
            return;
        }
        this.documentDraft.file = file;
        this.documentDraft.fileName = file?.name || '';
        this.documentDraft.name = this.documentDraft.fileName || this.documentDraft.name;
        await this.service.render();
    }

    public async saveDocumentDraft() {
        if (!this.selectedCase) return;
        if (this.documentFormMode === 'edit' && this.documentDraft?.legacyFile && this.documentDraft.file) {
            await this.service.modal.warning('Legacy 대체 파일은 metadata 수정과 분리된 전용 업로드로 등록해주세요.');
            return;
        }
        if (this.documentFormMode === 'add' && !this.documentDraft.file) {
            await this.service.modal.error('업로드할 문서 파일을 선택해주세요.');
            return;
        }
        if (this.documentUploading) return;
        this.selectedCase.documents = this.selectedCase.documents || [];
        const draft = {
            ...this.documentDraft,
            id: this.documentDraft.id || `doc-${Date.now()}`,
            uploadedAt: this.documentDraft.uploadedAt || this.today,
            name: this.documentDraft.name || this.documentDraft.fileName || '첨부서류',
            sent: this.documentDraft.sent || false,
            sentAt: this.documentDraft.sentAt || '',
            sentTo: this.documentDraft.sentTo || '',
            views: this.documentDraft.views || 0,
            selected: false
        };

        const saved = await this.saveDocumentRecord(draft, this.selectedCase);
        if (!saved) {
            await this.service.modal.error('문서 메타데이터 저장에 실패했습니다.');
            return;
        }
        this.documentDraft.id = saved.id;
        let nextDraft = { ...draft, ...saved, file: null };
        if (this.documentDraft.file) {
            const uploadResult = await this.uploadDocumentFile(saved.id, this.documentDraft.file);
            if (!uploadResult) return;
            const files = uploadResult.files || [];
            nextDraft = { ...nextDraft, files, currentFile: files[0] || null };
            this.documentFileUsage = uploadResult.usage || this.documentFileUsage;
        }

        if (this.documentFormMode === 'edit') {
            const index = this.selectedCase.documents.findIndex((doc: any) => doc.id === draft.id);
            if (index >= 0) this.selectedCase.documents[index] = { ...this.selectedCase.documents[index], ...nextDraft };
        } else {
            this.selectedCase.documents.unshift(nextDraft);
        }

        this.showDocumentForm = false;
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        await this.service.render();
    }

    public async deleteSelectedDocuments() {
        if (!this.selectedCase?.documents || !this.hasSelectedDocuments) return;
        if (this.selectedCase.documents.some((doc: any) => doc.selected && doc.legacyFile)) {
            await this.service.modal.warning('Legacy 문서 metadata와 원본 mapping은 감사 목적으로 삭제할 수 없습니다.');
            return;
        }
        const ids = this.selectedCase.documents.filter((doc: any) => doc.selected).map((doc: any) => doc.id);
        await this.deleteDocumentRecords(ids);
        this.selectedCase.documents = this.selectedCase.documents.filter((doc: any) => !doc.selected);
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        this.service.render();
    }

    public markConverted(item: any) {
        item.status = '완료';
        item.converted = true;
    }

    public async sendDocuments() {
        if (!this.selectedCase || !this.selectedCase.documents) return;
        for (const doc of this.selectedCase.documents) {
            if (doc.selected) {
                doc.sent = true;
                doc.sentAt = this.today;
                doc.sentTo = this.selectedCase.documentReceiver;
                doc.selected = false;
                await this.saveDocumentRecord(doc, this.selectedCase);
            }
        }
        this.service.render();
    }

    public async sendDocument(doc: any) {
        if (!doc || !this.selectedCase) return;
        doc.sent = true;
        doc.sentAt = this.today;
        doc.sentTo = this.selectedCase.documentReceiver;
        doc.views = doc.views || 0;
        await this.saveDocumentRecord(doc, this.selectedCase);
        this.service.render();
    }

    public async toggleDocumentSent(doc: any) {
        if (!doc || !this.selectedCase) return;
        doc.sent = !!doc.sent;
        doc.sentAt = doc.sent ? this.today : '';
        doc.sentTo = doc.sent ? (this.selectedCase.documentReceiver || this.selectedCase.detail?.documentReceiver?.name || '') : '';
        doc.views = doc.views || 0;
        await this.saveDocumentRecord(doc, this.selectedCase);
        await this.service.render();
    }

    public async openDocument(doc: any) {
        if (!doc) return;
        if (!this.canDownloadDocument(doc)) {
            await this.service.modal.warning(this.documentFileStatusMessage(doc));
            return;
        }
        await this.downloadDocument(doc);
    }

    public async downloadDocument(doc: any) {
        if (!doc) return;
        if (!this.canDownloadDocument(doc)) {
            await this.service.modal.warning(this.documentFileStatusMessage(doc));
            return;
        }
        const link = document.createElement('a');
        link.href = `${wiz.url('save_document')}?file_action=download&file_id=${encodeURIComponent(doc.currentFile.id)}`;
        link.rel = 'noopener';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    public canDownloadDocument(doc: any) {
        if (doc?.legacyFile && doc.legacyFile.status !== 'AVAILABLE') return false;
        if (doc?.legacyFile && doc.legacyFile.current_file_id !== doc?.currentFile?.id) return false;
        return !!doc?.currentFile?.downloadable && doc.currentFile.scan_status === 'CLEAN';
    }

    public documentFileStatusLabel(file: any, legacyFile: any = null) {
        if (legacyFile?.status === 'LEGACY_FILE_MISSING') return 'LEGACY_FILE_MISSING';
        if (legacyFile?.status === 'REUPLOAD_PENDING') return '재등록 검사 대기';
        if (legacyFile?.status === 'AVAILABLE') return 'AVAILABLE';
        const labels: any = {
            QUARANTINED: '검사 대기',
            SCANNING: '검사 중',
            CLEAN: '검사 완료',
            REJECTED: '차단됨',
            MISSING: '파일 누락'
        };
        return labels[file?.scan_status] || '파일 없음';
    }

    public documentFileStatusClass(file: any, legacyFile: any = null) {
        if (legacyFile?.status === 'AVAILABLE') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (legacyFile?.status === 'LEGACY_FILE_MISSING') return 'border-rose-200 bg-rose-50 text-rose-700';
        if (legacyFile?.status === 'REUPLOAD_PENDING') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (file?.scan_status === 'CLEAN') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (file?.scan_status === 'REJECTED' || file?.scan_status === 'MISSING') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public documentFileStatusMessage(doc: any) {
        const file = doc?.currentFile;
        if (doc?.legacyFile?.status === 'LEGACY_FILE_MISSING') return '파일 재등록 필요: 원본 Legacy 파일이 없어 다운로드할 수 없습니다.';
        if (doc?.legacyFile?.status === 'REUPLOAD_PENDING') return file?.scan_message || '대체 파일은 격리 저장되었으며 보안 검사 완료 전까지 다운로드할 수 없습니다.';
        if (!file) return '업로드된 파일이 없습니다.';
        if (file.scan_status === 'QUARANTINED') return file.scan_message || '악성 파일 검사가 완료되지 않아 다운로드할 수 없습니다.';
        if (file.scan_status === 'SCANNING') return '파일 검사 중입니다.';
        if (file.scan_status === 'REJECTED') return '보안 검사에서 차단된 파일입니다.';
        if (file.scan_status === 'MISSING') return '저장소에서 파일을 찾을 수 없습니다.';
        return '다운로드할 수 없는 파일입니다.';
    }

    public async reuploadLegacyDocument(doc: any, event: any) {
        const file = event?.target?.files?.[0];
        if (event?.target) event.target.value = '';
        if (!file || !this.canReuploadLegacyDocument(doc)) return;
        const extension = `.${String(file.name || '').split('.').pop() || ''}`.toLowerCase();
        const allowed = ['.pdf', '.txt', '.docx', '.xlsx', '.pptx', '.hwp', '.hwpx', '.jpg', '.jpeg', '.png', '.tif', '.tiff'];
        const maxSize = Number(this.documentFileUsage?.max_file_size_bytes || 50 * 1024 * 1024);
        if (allowed.indexOf(extension) < 0) {
            await this.service.modal.error('허용되지 않은 파일 형식입니다.');
            return;
        }
        if (Number(file.size || 0) <= 0 || Number(file.size || 0) > maxSize) {
            await this.service.modal.error(`파일은 1바이트 이상 ${this.formatFileSize(maxSize)} 이하여야 합니다.`);
            return;
        }
        const uploadResult = await this.uploadDocumentFile(doc.id, file, true);
        if (!uploadResult) return;
        this.applyDocumentFileResult(doc, uploadResult);
        await this.service.render();
    }

    public formatFileSize(value: any) {
        const bytes = Number(value || 0);
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
    }

    public shortSha(value: string) {
        return value ? `${value.slice(0, 12)}…` : '-';
    }

    public async rescanDocumentFile(doc: any) {
        const fileId = doc?.currentFile?.id;
        if (!this.canRescanDocumentFile(doc) || !fileId) return;
        const { code, data } = await wiz.call('save_document', { file_action: 'scan', file_id: fileId });
        if (code === 200) {
            this.applyDocumentFileResult(doc, data);
            this.documentFileUsage = data.usage || this.documentFileUsage;
            await this.service.render();
            if (doc.currentFile?.scan_status !== 'CLEAN') {
                await this.service.modal.warning(this.documentFileStatusMessage(doc));
            }
            return;
        }
        await this.service.modal.error(data?.message || '파일 재검사에 실패했습니다.');
    }

    public canRescanDocumentFile(doc: any) {
        if (!doc?.currentFile || doc.currentFile.scan_status !== 'QUARANTINED') return false;
        if (doc?.legacyFile) return doc.legacyFile.manage_allowed === true;
        return this.canManageDocumentFiles();
    }

    public async assignDeadline() {
        if (!this.selectedCase || !this.selectedCase.documents) return;
        const target = this.selectedCase.documents.find((doc: any) => doc.selected) || this.selectedCase.documents[0];
        if (target) await this.applyDocumentDeadline(target);
    }

    public async applyDocumentDeadline(doc: any) {
        if (!doc) return;
        if (doc.deadlineRule === 'none') {
            doc.dueDate = '';
            doc.deadlineTask = '';
        } else if (doc.deadlineRule === 'auto') {
            doc.dueDate = doc.dueDate || this.defaultDueDateForCategory(doc.category);
            doc.deadlineTask = doc.deadlineTask || this.defaultTaskForCategory(doc.category);
        } else {
            doc.dueDate = doc.dueDate || this.today;
            doc.deadlineTask = doc.deadlineTask || '담당자 점검';
        }
        doc.deadlineAssignee = doc.deadlineAssignee || this.selectedCase?.assignee || '';
        await this.saveDocumentRecord(doc, this.selectedCase);
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        this.service.render();
    }

    public async updateCaseNextDue(item: any) {
        if (!item) return;
        await this.saveCaseDeadlineRecord(item);
        this.rebuildDeadlinesFromCases();
        this.buildCalendar();
        await this.service.render();
    }

    public handleFileSelect(event: any) {
        const files = Array.from(event?.target?.files || []);
        this.addDocumentFiles(files);
        if (event?.target) event.target.value = '';
    }

    public allowDrop(event: any) {
        event.preventDefault();
    }

    public handleDocumentDrop(event: any) {
        event.preventDefault();
        const files = Array.from(event?.dataTransfer?.files || []);
        this.addDocumentFiles(files);
    }

    public caseSubjectLabel(item: any) {
        if (item?.right === '상표') return '상표이미지';
        if (item?.right === '디자인') return '물품명칭';
        return '발명의 명칭';
    }

    public caseSubjectValue(item: any) {
        if (!item) return '';
        if (item.right === '상표') return item.markText || item.displayName || item.title;
        if (item.right === '디자인') return item.productName || item.displayName || item.title;
        return item.displayName || item.title;
    }

    public deadlineRuleLabel(id: string) {
        const found = this.deadlineRuleOptions.find((item) => item.id === id);
        return found ? found.label : '담당자 직접입력';
    }

    public async showDate(date: string, status: string = '') {
        this.selectedDeadlineDate = date;
        this.selectedDeadlineStatus = status;
        this.selectedDeadlinePage = 1;
        this.activeWorkspace = 'dashboard';
        this.syncLocationForWorkspace('dashboard');
        this.notifyWorkspaceChanged();
        await this.service.render();
    }

    public get selectedDateDeadlines() {
        const date = this.selectedDeadlineDate || this.today;
        const status = this.selectedDeadlineStatus;
        return this.sortDeadlineRows(this.deadlines.filter((item) => {
            return item.date === date && (!status || item.status === status);
        }));
    }

    public paginatedSelectedDateDeadlines() {
        const list = this.selectedDateDeadlines;
        const page = this.normalizedSelectedDeadlinePage(list.length);
        const start = (page - 1) * this.selectedDeadlinePageSize;
        return list.slice(start, start + this.selectedDeadlinePageSize);
    }

    public selectedDeadlineCurrentPage() {
        return this.normalizedSelectedDeadlinePage(this.selectedDateDeadlines.length);
    }

    public selectedDeadlineTotalPages() {
        return Math.max(1, Math.ceil(this.selectedDateDeadlines.length / this.selectedDeadlinePageSize));
    }

    public selectedDeadlinePageNumbers() {
        const total = this.selectedDeadlineTotalPages();
        const current = this.selectedDeadlineCurrentPage();
        const start = Math.max(1, Math.min(current - 1, Math.max(1, total - 2)));
        const end = Math.min(total, start + 2);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public selectedDeadlinePageSummary() {
        const total = this.selectedDateDeadlines.length;
        if (total === 0) return '0건';
        const page = this.normalizedSelectedDeadlinePage(total);
        const start = (page - 1) * this.selectedDeadlinePageSize + 1;
        const end = Math.min(total, page * this.selectedDeadlinePageSize);
        return `${start}-${end} / ${total}건`;
    }

    public async setSelectedDeadlinePage(page: number) {
        this.selectedDeadlinePage = Math.max(1, Math.min(page, this.selectedDeadlineTotalPages()));
        await this.service.render();
    }

    public async previousSelectedDeadlinePage() {
        await this.setSelectedDeadlinePage(this.selectedDeadlineCurrentPage() - 1);
    }

    public async nextSelectedDeadlinePage() {
        await this.setSelectedDeadlinePage(this.selectedDeadlineCurrentPage() + 1);
    }

    public get todayDeadlines() {
        return this.sortDeadlineRows(this.deadlines.filter((item) => item.date === this.today));
    }

    public get weekDeadlines() {
        const start = this.parseDate(this.today).getTime();
        const end = start + 7 * 24 * 60 * 60 * 1000;
        return this.sortDeadlineRows(this.deadlines.filter((item) => {
            const time = this.parseDate(item.date).getTime();
            return time >= start && time <= end;
        }));
    }

    public paginatedWeekDeadlines() {
        const list = this.weekDeadlines;
        const page = this.normalizedWeekDeadlinePage(list.length);
        const start = (page - 1) * this.weekDeadlinePageSize;
        return list.slice(start, start + this.weekDeadlinePageSize);
    }

    public weekDeadlineCurrentPage() {
        return this.normalizedWeekDeadlinePage(this.weekDeadlines.length);
    }

    public weekDeadlineTotalPages() {
        return Math.max(1, Math.ceil(this.weekDeadlines.length / this.weekDeadlinePageSize));
    }

    public weekDeadlinePageNumbers() {
        const total = this.weekDeadlineTotalPages();
        const current = this.weekDeadlineCurrentPage();
        const start = Math.max(1, Math.min(current - 1, Math.max(1, total - 2)));
        const end = Math.min(total, start + 2);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public weekDeadlinePageSummary() {
        const total = this.weekDeadlines.length;
        if (total === 0) return '0건';
        const page = this.normalizedWeekDeadlinePage(total);
        const start = (page - 1) * this.weekDeadlinePageSize + 1;
        const end = Math.min(total, page * this.weekDeadlinePageSize);
        return `${start}-${end} / ${total}건`;
    }

    public async setWeekDeadlinePage(page: number) {
        this.weekDeadlinePage = Math.max(1, Math.min(page, this.weekDeadlineTotalPages()));
        await this.service.render();
    }

    public async previousWeekDeadlinePage() {
        await this.setWeekDeadlinePage(this.weekDeadlineCurrentPage() - 1);
    }

    public async nextWeekDeadlinePage() {
        await this.setWeekDeadlinePage(this.weekDeadlineCurrentPage() + 1);
    }

    public deadlineDateLabel(date: string) {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${year}.${month}.${day}`;
    }

    public money(value: number) {
        return new Intl.NumberFormat('ko-KR').format(value || 0);
    }

    public statusClass(status: string) {
        const map: any = {
            '검토중': 'bg-amber-50 text-amber-700 border-amber-200',
            '진행중': 'bg-blue-50 text-blue-700 border-blue-200',
            '완료': 'bg-emerald-50 text-emerald-700 border-emerald-200',
            '보류': 'bg-slate-50 text-slate-600 border-slate-200',
            '승인': 'bg-emerald-50 text-emerald-700 border-emerald-200',
            '수정요청': 'bg-orange-50 text-orange-700 border-orange-200',
            '작성중': 'bg-amber-50 text-amber-700 border-amber-200',
            '발송': 'bg-blue-50 text-blue-700 border-blue-200',
            '거절': 'bg-rose-50 text-rose-700 border-rose-200'
        };
        return map[status] || 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public stageClass(stage: string) {
        const map: any = {
            '상담/접수': 'bg-cyan-50 text-cyan-700 border-cyan-200',
            '출원/심사': 'bg-blue-50 text-blue-700 border-blue-200',
            '등록': 'bg-emerald-50 text-emerald-700 border-emerald-200',
            '거절': 'bg-rose-50 text-rose-700 border-rose-200',
            '중단': 'bg-slate-50 text-slate-600 border-slate-200',
            '심판': 'bg-violet-50 text-violet-700 border-violet-200',
            '소송': 'bg-orange-50 text-orange-700 border-orange-200'
        };
        return map[stage] || 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public deadlineClass(item: any) {
        if (item.status === 'due') return 'bg-rose-50 text-rose-700 border-rose-200';
        if (item.status === 'week') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        return 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public deadlineStatusLabel(item: any) {
        if (item.status === 'due') return '마감';
        if (item.status === 'week') return '7일전';
        return '기한';
    }

    public deadlineDueDateLabel(item: any) {
        if (!item?.dueDate) return '';
        const label = item.supplemental ? '예정 마감일' : '마감일';
        if (item.status === 'week') return `${label} ${this.deadlineDateLabel(item.dueDate)}`;
        return `${label} ${this.deadlineDateLabel(item.dueDate)}`;
    }

    public calendarDeadlineClass(item: any) {
        if (item.status === 'due') return 'border-rose-100 bg-rose-50 text-rose-700';
        if (item.status === 'week') return 'border-emerald-100 bg-emerald-50 text-emerald-800';
        return 'border-slate-100 bg-slate-50 text-slate-600';
    }

    public calendarDeadlineLabel(item: any) {
        return item?.caseTitle || item?.task || '기한';
    }

    public calendarDeadlineTitle(item: any) {
        const label = this.calendarDeadlineLabel(item);
        const task = item?.task ? ` · ${item.task}` : '';
        const date = item?.date ? ` · ${this.deadlineDateLabel(item.date)}` : '';
        const dueDate = item?.dueDate && item.dueDate !== item.date ? ` · 마감 ${this.deadlineDateLabel(item.dueDate)}` : '';
        return `${label}${task}${date}${dueDate}`;
    }

    public calendarDayTitle(day: any) {
        if (!day) return '';
        const parts: string[] = [];
        if (day.greenCount) parts.push(`7일 전 ${day.greenCount}건`);
        if (day.redCount) parts.push(`마감 ${day.redCount}건`);
        const summary = parts.length ? ` · ${parts.join(' / ')}` : '';
        return `${this.deadlineDateLabel(day.date)}${summary}`;
    }

    public calendarCountTitle(day: any, status: string) {
        const count = status === 'due' ? day?.redCount : day?.greenCount;
        const label = status === 'due' ? '마감기한' : '일주일 전 알림';
        return `${this.deadlineDateLabel(day?.date)} ${label} ${count || 0}건 상세 보기`;
    }

    public selectedDeadlineStatusLabel() {
        if (this.selectedDeadlineStatus === 'due') return '마감기한';
        if (this.selectedDeadlineStatus === 'week') return '일주일 전 알림';
        return '전체 기한';
    }

    public nextRegistrationStep() {
        this.activeRegistrationStep = Math.min(3, this.activeRegistrationStep + 1);
    }

    public prevRegistrationStep() {
        this.activeRegistrationStep = Math.max(1, this.activeRegistrationStep - 1);
    }

    private buildCaseFromRegistrationDraft() {
        const draft = this.registrationDraft;
        const detail = this.syncRegistrationDraftFromDetail();
        const caseKey = draft.caseKey || detail.caseKey || this.generateCaseKey();
        draft.caseKey = caseKey;
        detail.caseKey = caseKey;
        const rightGroup = draft.right || this.registrationRightTabs[0] || '특허/실용신안';
        const isDispute = draft.caseType === '이의/심판/소송';
        const right = isDispute ? (detail.dispute?.right || this.registrationDisputeRightFromGroup(rightGroup)) : rightGroup;
        const title = this.registrationCaseTitle(draft, rightGroup);
        const companyContact = this.contactNames(draft.companyContacts);
        const documentReceiver = this.contactNames(draft.documentReceivers);
        const additional = this.ensureRegistrationAdditional(rightGroup);

        return {
            id: `case-${Date.now()}`,
            caseKey,
            caseNo: detail.dispute?.caseNo || draft.caseNo || '',
            starred: false,
            workflow: draft.caseType === '이의/심판/소송' ? 'dispute' : 'application',
            disputeStatus: detail.dispute?.type || '',
            disputeCategory: detail.dispute?.category || '',
            disputeRelationType: detail.dispute?.relationType || '',
            claimant: detail.dispute?.claimant || '',
            respondent: detail.dispute?.respondent || '',
            stage: isDispute ? (detail.dispute?.type || '이의') : (draft.stage || '출원/심사'),
            detailedStatus: draft.detailedStatus || '심사중',
            customDetailedStatus: draft.customDetailedStatus || '',
            statusLabel: draft.detailedStatus === '직접입력' ? (draft.customDetailedStatus || '직접입력') : (draft.detailedStatus || '심사중'),
            right,
            type: draft.type || draft.caseType || '국내출원',
            title,
            displayName: title,
            applicationNo: isDispute ? (detail.dispute?.baseApplicationNo || '') : (draft.applicationNo || ''),
            filingDate: isDispute ? (detail.dispute?.claimDate || draft.filingDate || this.today) : (draft.filingDate || this.today),
            registrationNo: isDispute
                ? (detail.dispute?.baseRegistrationNo || '')
                : (draft.caseType === '해외출원' ? (detail.foreign?.internationalRegistrationNo || '') : (draft.registrationNo || '')),
            registrationDate: isDispute
                ? (detail.dispute?.baseRegistrationDate || '')
                : (draft.caseType === '해외출원' ? (detail.foreign?.internationalRegistrationDate || '') : (draft.registrationDate || '')),
            claimDate: isDispute ? (detail.dispute?.claimDate || '') : '',
            currentInstitution: isDispute ? (detail.dispute?.currentInstitution || '') : '',
            relatedDisputeCases: isDispute ? this.cloneValue(detail.dispute?.relatedCases || []) : [],
            clientName: this.contactNames(draft.clients) || this.contactNames(draft.applicants) || '미입력 고객',
            applicant: this.contactNames(draft.applicants),
            patentClientNo: draft.patentClientNo || '',
            nextDue: draft.nextDue || '',
            nextDueNote: draft.nextDueNote || '',
            assignee: draft.assignee || '',
            attorney: draft.attorney || '',
            memo: draft.memo || '',
            companyContact,
            documentReceiver,
            markText: right === '상표' ? title : '',
            markImageUrl: '',
            productName: right === '디자인' ? title : '',
            expeditedExam: !!draft.expeditedExam,
            partialExam: !!draft.partialExam,
            contacts: this.cloneValue({
                clients: draft.clients || [],
                applicants: draft.applicants || [],
                companyContacts: draft.companyContacts || [],
                documentReceivers: draft.documentReceivers || []
            }),
            additional: this.cloneValue(additional),
            detail: this.cloneValue(detail),
            relatedSourceCaseId: draft.relatedSourceCaseId || '',
            consultationTransfer: this.pendingConsultationTransfer ? this.cloneValue(this.pendingConsultationTransfer) : null,
            documents: [],
            memos: [],
            quote: ''
        };
    }

    private registrationDisputeRightFromGroup(right: string) {
        if (right === '상표' || right === '디자인') return right;
        return '특허';
    }

    private caseDetailFromRegistrationDraft(draft: any, additional: any) {
        const products = (additional?.products || []).map((item: any) => ({
            productClass: item?.productClass || '',
            productName: item?.productName || ''
        }));
        return {
            caseKey: draft.caseKey || '',
            patentClientNo: draft.patentClientNo || '',
            titleEn: draft.titleEn || '',
            ipcClass: additional?.ipcClass || '',
            claims: additional?.claims || '',
            priority: { applicationNo: '', firstApplicationNo: '', deadline: '', claimDate: '' },
            examination: { deadline: '', requestDate: additional?.examRequestDate || '' },
            expedited: { requestDate: '', decisionDate: '' },
            intermediate: { opinionDate: '', responseDate: '' },
            disposition: { decisionDate: '', paymentDate: '' },
            abandonment: { decisionDate: '', content: '' },
            annuity: {
                inspectionDate: '',
                initialNormalDeadline: '',
                initialPenaltyDeadline: '',
                initialPaymentDate: '',
                initialPaymentAmount: 0,
                schedule: []
            },
            renewal: {
                inspectionDate: '',
                paymentTermYears: 10,
                initialNormalDeadline: '',
                initialExtensionDeadline: '',
                initialPaymentDate: '',
                initialPaymentAmount: 0,
                schedule: []
            },
            companyContact: this.cloneValue(draft.companyContacts?.[0] || { name: '', phone: '', email: '' }),
            documentReceiver: this.cloneValue(draft.documentReceivers?.[0] || { name: '', phone: '', email: '' }),
            trademark: {
                products: products.length ? products : [{ productClass: '', productName: '' }],
                applications: {
                    original: { applicationNo: '', applicationDate: '' },
                    divisional: { applicationNo: '', applicationDate: '' },
                    additional: { applicationNo: '', applicationDate: '' }
                }
            },
            design: {
                itemClass: additional?.articleClass || '',
                itemName: additional?.productName || draft.productName || '',
                partialExamination: !!draft.partialExam,
                applications: {
                    original: { applicationNo: '', applicationDate: '' },
                    divisional: { applicationNo: '', applicationDate: '' }
                }
            }
        };
    }

    private async callDashboardApi(method: string, payload: any = {}) {
        this.dashboardApiErrorMessage = '';
        if (FORM_WRITE_METHODS.includes(method)) {
            const checked = validateFormDraft(payload || {}, method);
            if (checked.error) { this.dashboardApiErrorMessage = checked.error; return null; }
            payload = checked.value;
        }
        try {
            const { code, data } = await wiz.call(method, {
                payload: JSON.stringify(payload || {}),
                today: this.today
            });
            if (code === 200) return data || {};
            this.dashboardApiErrorMessage = data?.message || data?.error || '요청을 처리하지 못했습니다.';
        } catch (error) {
            console.error(`dashboard ${method} failed`, error);
            this.dashboardApiErrorMessage = '서버와 통신하지 못했습니다. 잠시 후 다시 시도해주세요.';
        }
        return null;
    }

    private async saveCaseRecord(item: any) {
        const data = await this.callDashboardApi('save_case', item);
        return data?.case || null;
    }

    private async deleteCaseRecord(id: string) {
        try {
            await wiz.call('delete_case', { id });
        } catch (error) {
            console.error('dashboard delete_case failed', error);
        }
    }

    private async saveConsultationRecord(item: any) {
        const data = await this.callDashboardApi('save_consultation', item);
        return data?.consultation || null;
    }

    private async saveDocumentRecord(document: any, caseItem: any) {
        const documentPayload = { ...(document || {}) };
        delete documentPayload.file;
        delete documentPayload.files;
        delete documentPayload.currentFile;
        const data = await this.callDashboardApi('save_document', { document: documentPayload, case: caseItem });
        return data?.document || null;
    }

    private async loadDocumentFilesForCase(caseItem: any, render: boolean = true) {
        if (!caseItem?.id) return;
        const { code, data } = await wiz.call('save_document', { file_action: 'list', matter_id: caseItem.id });
        if (code === 200) {
            const grouped: any = {};
            const legacyGrouped: any = {};
            for (const file of data.files || []) {
                grouped[file.document_id] = grouped[file.document_id] || [];
                grouped[file.document_id].push(file);
            }
            for (const legacyFile of data.legacy_files || []) {
                legacyGrouped[legacyFile.document_id] = legacyFile;
            }
            for (const doc of caseItem.documents || []) {
                doc.files = grouped[doc.id] || [];
                doc.legacyFile = legacyGrouped[doc.id] || null;
                this.applyDocumentFileResult(doc, {
                    files: doc.files,
                    legacy_files: doc.legacyFile ? [doc.legacyFile] : []
                });
            }
            this.documentFileUsage = data.usage || this.documentFileUsage;
        }
        if (render) await this.service.render();
    }

    private async uploadDocumentFile(documentId: string, file: any, legacyReupload: boolean = false) {
        const error = this.documentSelectionError(file);
        if (error) { await this.service.modal.error(error); return null; }
        this.documentUploading = true;
        this.documentUploadProgress = 0;
        let completed = false;
        try {
            await this.service.render();
            const formData = new FormData();
            formData.append('file_action', 'upload');
            formData.append('document_id', documentId);
            if (legacyReupload) formData.append('legacy_reupload', '1');
            formData.append('file', file);
            const response: any = await this.service.file.upload(
                wiz.url('save_document'), formData,
                async (percent: number) => {
                    this.documentUploadProgress = percent;
                    await this.service.render();
                },
            );
            const payload = this.responsePayload(response);
            if (Number(payload.code) === 200 && payload.data) {
                completed = true;
                this.documentUploadProgress = 100;
                const current = payload.data.files?.[0];
                if (current?.scan_status !== 'CLEAN') {
                    await this.service.modal.warning(current?.scan_message || '파일은 격리 저장되며 보안 검사 완료 전까지 다운로드할 수 없습니다.');
                }
                return payload.data;
            }
            await this.service.modal.error(this.responseMessage(payload, '문서 파일 업로드에 실패했습니다.'));
            return null;
        } catch (error) {
            await this.service.modal.error('문서 파일 업로드 중 오류가 발생했습니다. 다시 시도해 주세요.');
            return null;
        } finally {
            this.documentUploading = false;
            if (!completed) this.documentUploadProgress = 0;
            await this.service.render();
        }
    }

    private applyDocumentFileResult(doc: any, data: any) {
        if (!doc) return;
        const files = data?.files || [];
        const legacyFile = (data?.legacy_files || []).find((item: any) => item.document_id === doc.id)
            || doc.legacyFile
            || null;
        doc.files = files;
        doc.legacyFile = legacyFile;
        if (!legacyFile) {
            doc.currentFile = files[0] || null;
            return;
        }
        if (legacyFile.status === 'LEGACY_FILE_MISSING') {
            doc.currentFile = null;
            return;
        }
        const activeFileId = legacyFile.current_file_id || legacyFile.pending_file_id;
        doc.currentFile = files.find((item: any) => item.id === activeFileId) || null;
    }

    private async deleteDocumentRecords(ids: string[]) {
        const documentIds = (ids || []).filter((id) => !!id);
        if (documentIds.length === 0) return;
        try {
            await wiz.call('delete_documents', { ids: JSON.stringify(documentIds) });
        } catch (error) {
            console.error('dashboard delete_documents failed', error);
        }
    }

    private async saveCaseDeadlineRecord(item: any) {
        await this.callDashboardApi('save_case_deadline', item);
    }

    private async saveQuoteRecord(item: any) {
        const data = await this.callDashboardApi('save_quote', item);
        return data?.quote || null;
    }

    private async saveInfoItemRecord(item: any) {
        const data = await this.callDashboardApi('save_info_item', item);
        return data?.item || null;
    }

    private replaceCase(item: any) {
        const index = this.cases.findIndex((row) => row.id === item.id);
        if (index >= 0) this.cases[index] = item;
        if (this.selectedCase?.id === item.id) this.selectedCase = item;
    }

    private replaceQuote(item: any) {
        const index = this.quotes.findIndex((row) => row.id === item.id);
        if (index >= 0) this.quotes[index] = item;
    }

    private registrationCaseTitle(draft: any, right: string) {
        if (right === '상표') return draft.titleKo || draft.markImageName || '신규 상표 사건';
        if (right === '디자인') return draft.productName || '신규 디자인 사건';
        return draft.titleKo || draft.titleEn || '신규 특허/실용신안 사건';
    }

    private contactNames(rows: any[]) {
        return (rows || [])
            .map((row) => (row?.name || '').trim())
            .filter((name) => !!name)
            .join(', ');
    }

    private cloneValue(value: any) {
        return JSON.parse(JSON.stringify(value || null));
    }

    private applicantText(item: any) {
        if (!item) return '';
        const fromContacts = (item.contacts?.applicants || [])
            .map((row: any) => (row?.name || '').trim())
            .filter((name: string) => !!name)
            .join(', ');
        return (item.applicant || fromContacts || '').trim();
    }

    private matchesApplicantScope(item: any) {
        const applicant = this.applicantText(item);
        if (this.caseApplicantScope === 'registered') return !!applicant;
        if (this.caseApplicantScope === 'missing') return !applicant;
        if (this.caseApplicantScope === 'different') {
            const client = String(item?.clientName || '').trim();
            return !!applicant && !!client && applicant !== client;
        }
        return true;
    }

    private emptyConsultationDraft(source: any = null) {
        const currentUser = this.currentUserName();
        return {
            id: source?.id || '',
            clientId: source?.clientId || '',
            clientType: source?.clientType || source?.type || '',
            patentClientNo: source?.patentClientNo || '',
            clientContactName: source?.clientContactName || '',
            clientPhone: source?.clientPhone || '',
            clientEmail: source?.clientEmail || '',
            status: source?.status || '검토중',
            receiptNo: source?.receiptNo || '',
            date: source?.date || this.today || this.dateKey(new Date()),
            updatedAt: source?.updatedAt || source?.updated || this.today || this.dateKey(new Date()),
            consultant: source?.consultant || source?.clientContactName || '',
            assignee: source?.assignee || currentUser,
            clientName: source?.clientName || '',
            title: source?.title || '',
            consultationType: this.normalizeConsultationType(source?.consultationType || '출원/등록', source?.rightType),
            rightType: source?.rightType || '특허/실용신안',
            caseType: source?.caseType || '국내출원',
            summary: source?.summary || '',
            caseKey: source?.caseKey || source?.transferKey || this.generateCaseKey(),
            transferKey: source?.caseKey || source?.transferKey || '',
            transferredTo: source?.transferredTo || '',
            transferredMatterId: source?.transferredMatterId || '',
            converted: !!source?.converted,
            registrationDraft: this.cloneValue(source?.registrationDraft || {}),
            histories: this.cloneValue(source?.histories || []),
            registrationAdditional: this.cloneValue(source?.registrationAdditional || {
                reviewMemo: '',
                nextRequest: ''
            }),
            registrationDocuments: {
                id: source?.registrationDocuments?.id || source?.registrationDocuments?.documentId || '',
                category: source?.registrationDocuments?.category || '출원전서류',
                date: source?.registrationDocuments?.date || source?.date || this.today || this.dateKey(new Date()),
                name: source?.registrationDocuments?.name || '',
                note: source?.registrationDocuments?.note || '',
                fileName: source?.registrationDocuments?.fileName || '',
                files: this.cloneValue(source?.registrationDocuments?.files || []),
                currentFile: this.cloneValue(source?.registrationDocuments?.currentFile || null),
                file: null
            }
        };
    }

    private emptyConsultationHistoryDraft(text: string = '') {
        return {
            date: this.consultationDraft?.date || this.today || this.dateKey(new Date()),
            text: String(text || '').trim()
        };
    }

    private ensureConsultationDraftShape() {
        if (!this.consultationDraft) this.consultationDraft = this.emptyConsultationDraft();
        if (!Array.isArray(this.consultationDraft.histories)) this.consultationDraft.histories = [];
        if (!this.consultationDraft.registrationAdditional) {
            this.consultationDraft.registrationAdditional = { reviewMemo: '', nextRequest: '' };
        }
        if (!this.consultationDraft.registrationDocuments) {
            this.consultationDraft.registrationDocuments = {
                id: '',
                category: '출원전서류',
                date: this.consultationDraft.date || this.today || this.dateKey(new Date()),
                name: '',
                note: '',
                fileName: '',
                files: [],
                currentFile: null,
                file: null
            };
        }
        if (!this.consultationDraft.caseKey) {
            this.consultationDraft.caseKey = this.consultationDraft.transferKey || this.generateCaseKey();
        }
        this.consultationDraft.transferKey = this.consultationDraft.caseKey;
    }

    private buildConsultationFromDraft() {
        const draft = this.consultationDraft || {};
        this.syncRegistrationDraftFromDetail();
        const date = draft.date || this.today;
        const summary = String(draft.summary || '').trim();
        const histories = this.normalizedConsultationHistories(draft.histories, date, summary);
        const caseKey = draft.caseKey || draft.transferKey || this.generateCaseKey();
        draft.caseKey = caseKey;
        draft.transferKey = caseKey;
        const registrationAdditional = this.cloneValue(draft.registrationAdditional || {});
        const registrationDocuments = this.consultationRegistrationDocumentPayload(draft.registrationDocuments || {});
        const registrationDraft = this.cloneValue({
            ...this.registrationDraft,
            clientType: draft.clientType || '',
            registrationAdditional,
            registrationDocuments
        });

        return {
            id: draft.id || `consultation-${Date.now()}`,
            clientId: draft.clientId || '',
            clientType: draft.clientType || '',
            patentClientNo: draft.patentClientNo || '',
            clientContactName: draft.clientContactName || '',
            clientPhone: draft.clientPhone || '',
            clientEmail: draft.clientEmail || '',
            status: draft.status || '검토중',
            receiptNo: draft.receiptNo || this.generateConsultationReceiptNo(),
            date,
            updatedAt: this.today,
            consultant: draft.consultant || draft.clientContactName || '',
            clientName: draft.clientName || '',
            title: draft.title || `${draft.rightType || '상담'} 상담`,
            consultationType: this.normalizeConsultationType(draft.consultationType, draft.rightType) || '기타',
            rightType: draft.rightType || '특허/실용신안',
            caseType: draft.caseType || '국내출원',
            applicationNo: this.consultationApplicationNo({ registrationDraft }),
            registrationNo: this.consultationRegistrationNo({ registrationDraft }),
            assignee: draft.assignee || this.currentUserName(),
            summary,
            histories,
            caseKey,
            transferKey: caseKey,
            transferredTo: draft.transferredTo || '',
            transferredMatterId: draft.transferredMatterId || '',
            registrationDraft,
            registrationAdditional,
            registrationDocuments,
            converted: !!draft.converted,
            local: true
        };
    }

    private consultationRegistrationDocumentPayload(source: any) {
        return {
            id: source?.id || source?.documentId || '',
            category: source?.category || '출원전서류',
            date: source?.date || this.consultationDraft?.date || this.today || this.dateKey(new Date()),
            name: source?.name || '',
            note: source?.note || '',
            fileName: source?.fileName || '',
            files: this.cloneValue(source?.files || []),
            currentFile: this.cloneValue(source?.currentFile || null)
        };
    }

    private async persistConsultationRegistrationDocument(consultation: any) {
        this.ensureConsultationDraftShape();
        const source = this.consultationDraft.registrationDocuments || {};
        const existingId = source.id || source.documentId || '';
        if (!source.file && !existingId) return consultation;

        const documentDraft = {
            id: existingId,
            uploadedAt: source.date || consultation?.date || this.today,
            category: source.category || '출원전서류',
            name: source.name || source.fileName || '첨부서류',
            fileName: source.fileName || source.name || '',
            uploader: consultation?.assignee || this.currentUserName(),
            note: source.note || '',
            sent: false,
            sentAt: '',
            sentTo: '',
            views: 0,
            selected: false
        };
        const consultationDocumentCase = {
            clientId: consultation?.clientId || '',
            caseNo: consultation?.receiptNo || '',
            title: consultation?.title || '신규 상담 서류'
        };
        const savedDocument = await this.saveDocumentRecord(documentDraft, consultationDocumentCase);
        if (!savedDocument?.id) {
            await this.service.modal.error('서류정보 저장에 실패했습니다. 잠시 후 다시 시도해주세요.');
            return null;
        }

        let files = this.cloneValue(source.files || []);
        let currentFile = this.cloneValue(source.currentFile || null);
        if (source.file) {
            const uploadResult = await this.uploadDocumentFile(savedDocument.id, source.file);
            if (!uploadResult) return null;
            files = this.cloneValue(uploadResult.files || []);
            currentFile = this.cloneValue(files[0] || null);
            this.documentFileUsage = uploadResult.usage || this.documentFileUsage;
        }

        const metadata = this.consultationRegistrationDocumentPayload({
            ...source,
            id: savedDocument.id,
            fileName: source.fileName || savedDocument.fileName || savedDocument.name || '',
            files,
            currentFile
        });
        this.consultationDraft.registrationDocuments = { ...metadata, file: null };
        const updatedConsultation = {
            ...consultation,
            registrationDocuments: metadata,
            registrationDraft: {
                ...(consultation?.registrationDraft || {}),
                registrationDocuments: metadata
            }
        };
        const savedConsultation = await this.saveConsultationRecord(updatedConsultation);
        if (!savedConsultation?.id) {
            await this.service.modal.error('업로드한 서류를 상담에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.');
            return null;
        }
        return savedConsultation;
    }

    private normalizedConsultationHistories(histories: any[] = [], date: string = this.today, summary: string = '') {
        const rows = (histories || [])
            .map((item) => ({
                date: item?.date || date,
                text: String(item?.text || '').trim()
            }))
            .filter((item) => !!item.text);

        if (summary && !rows.some((item) => item.date === date && item.text === summary)) {
            rows.unshift({ date, text: summary });
        }

        return rows.length > 0 ? this.cloneValue(rows) : [{ date, text: '상담 접수' }];
    }

    private consultationSideSearchKeyword() {
        return String(this.consultationClientSearchQuery || this.consultationDraft?.consultant || this.consultationDraft?.clientName || '').trim().toLowerCase();
    }

    private clientSearchText(client: any) {
        const contacts = (client?.contacts || [])
            .map((contact: any) => [contact.name, contact.role, contact.email, contact.phone].join(' '))
            .join(' ');
        return [
            client?.name,
            client?.type,
            client?.patentClientNo,
            client?.owner,
            client?.address,
            contacts
        ].map((value) => String(value || '').toLowerCase()).join(' ');
    }

    private applyConsultationClientSource(source: any) {
        if (!source) return;
        const contact = this.primaryClientContact(source);
        this.consultationDraft.clientId = source.id || source.clientId || this.consultationDraft.clientId || '';
        this.consultationDraft.clientName = source.name || source.clientName || this.consultationDraft.clientName || '';
        this.consultationDraft.clientType = source.type || source.clientType || this.consultationDraft.clientType || '';
        this.consultationDraft.patentClientNo = source.patentClientNo || this.consultationDraft.patentClientNo || '';
        this.consultationDraft.clientContactName = contact.name || this.consultationDraft.clientContactName || '';
        this.consultationDraft.consultant = contact.name || this.consultationDraft.consultant || '';
        this.consultationDraft.clientPhone = contact.phone || this.consultationDraft.clientPhone || '';
        this.consultationDraft.clientEmail = contact.email || this.consultationDraft.clientEmail || '';
    }

    private consultationClientSource() {
        const draftClient = this.findClientByName(this.consultationDraft?.clientName);
        if (draftClient) return draftClient;

        const selectedConsultationClient = this.findClientByName(this.selectedConsultation?.clientName);
        if (selectedConsultationClient) return selectedConsultationClient;

        if (this.selectedClient) return this.selectedClient;
        if (this.selectedConsultation?.clientName) return { clientName: this.selectedConsultation.clientName };
        return this.clients[0] || null;
    }

    private findClientByName(value: string) {
        const keyword = String(value || '').trim().toLowerCase();
        if (!keyword) return null;
        return this.clients.find((client) => {
            const name = String(client?.name || '').trim().toLowerCase();
            return !!name && (name === keyword || name.indexOf(keyword) >= 0 || keyword.indexOf(name) >= 0);
        }) || null;
    }

    private primaryClientContact(source: any) {
        const contact = source?.contacts?.[0] || {};
        return {
            name: contact.name || source?.clientContactName || '',
            phone: contact.phone || source?.clientPhone || '',
            email: contact.email || source?.clientEmail || ''
        };
    }

    private generateConsultationReceiptNo() {
        const index = this.consultations.length + 1;
        return `CS-${this.today.replace(/-/g, '')}-${String(index).padStart(3, '0')}`;
    }

    private generateCaseKey() {
        const date = (this.today || this.dateKey(new Date())).replace(/-/g, '');
        const random = Math.random().toString(36).slice(2, 8).toUpperCase();
        return `CASE-${date}-${random}`;
    }

    private consultationQuoteSource(item: any) {
        return {
            title: item?.title || '상담 견적',
            clientName: item?.clientName || '',
            right: item?.rightType || '특허/실용신안',
            type: item?.caseType || '국내출원'
        };
    }

    private syncConsultationQuoteDraftSource() {
        const draft = this.consultationDraft || {};
        if (!this.quoteDraft?.selectedPartIds) {
            this.quoteDraft = this.emptyQuoteDraft(this.consultationQuoteSource(draft));
        }
        this.quoteDraft.source = draft.title || this.quoteDraft.source || '신규 상담 견적';
        this.quoteDraft.clientName = draft.clientName || this.quoteDraft.clientName || '';
        this.quoteDraft.rightType = draft.rightType || this.quoteDraft.rightType || '특허/실용신안';
        this.quoteDraft.caseType = draft.caseType || this.quoteDraft.caseType || '국내출원';
    }

    private fillRegistrationDraftFromConsultation(item: any, reset: boolean = true) {
        if (!item) return;
        if (reset) this.resetRegistrationDraft();
        if (item.registrationDraft && typeof item.registrationDraft === 'object') {
            Object.assign(this.registrationDraft, this.cloneValue(item.registrationDraft));
        }
        const intakeDocument = item.registrationDocuments || item.registrationDraft?.registrationDocuments || null;
        if (intakeDocument && String(intakeDocument.id || intakeDocument.name || intakeDocument.fileName || '').trim()) {
            const documents = this.ensureRegistrationDocuments();
            const mappedDocument = {
                id: intakeDocument.id || intakeDocument.documentId || '',
                uploadedAt: intakeDocument.date || item.date || this.today,
                category: intakeDocument.category || '출원전서류',
                name: intakeDocument.name || intakeDocument.fileName || '첨부서류',
                fileName: intakeDocument.fileName || '',
                files: this.cloneValue(intakeDocument.files || []),
                currentFile: this.cloneValue(intakeDocument.currentFile || null),
                file: null,
                dueDate: '',
                deadlineRule: 'manual',
                deadlineTask: '',
                deadlineAssignee: item.assignee || '',
                note: intakeDocument.note || ''
            };
            const existingIndex = documents.findIndex((document: any) =>
                (!!mappedDocument.id && document?.id === mappedDocument.id)
                || (!document?.id && document?.name === mappedDocument.name && document?.fileName === mappedDocument.fileName)
            );
            const emptyIndex = documents.findIndex((document: any) => !String(document?.id || document?.name || document?.fileName || '').trim());
            if (existingIndex >= 0) documents[existingIndex] = mappedDocument;
            else if (emptyIndex >= 0) documents[emptyIndex] = mappedDocument;
            else documents.unshift(mappedDocument);
        }
        const right = this.rights.indexOf(item.rightType) >= 0 ? item.rightType : '특허/실용신안';
        const caseType = item.caseType || this.caseTypeOptions[0] || '국내출원';
        this.registrationDraft.right = right;
        this.registrationDraft.caseType = caseType;
        this.registrationDraft.type = caseType;
        this.registrationDraft.caseKey = item.caseKey || item.transferKey || this.registrationDraft.caseKey || this.generateCaseKey();
        this.registrationDraft.stage = this.registrationDraft.stage || '출원/심사';
        this.registrationDraft.titleKo = item.title || this.registrationDraft.titleKo || '';
        this.registrationDraft.productName = right === '디자인' ? item.title || this.registrationDraft.productName || '' : this.registrationDraft.productName || '';
        this.registrationDraft.patentClientNo = item.patentClientNo || this.registrationDraft.patentClientNo || '';
        this.registrationDraft.clients = [this.mergeRegistrationContact(this.registrationDraft.clients?.[0], { name: item.clientName || '', phone: item.clientPhone || '', email: item.clientEmail || '' })];
        this.registrationDraft.applicants = [this.mergeRegistrationContact(this.registrationDraft.applicants?.[0], { name: item.clientName || '', phone: item.clientPhone || '', email: item.clientEmail || '' })];
        this.registrationDraft.companyContacts = [this.mergeRegistrationContact(this.registrationDraft.companyContacts?.[0], { name: item.consultant || item.clientContactName || '', phone: item.clientPhone || '', email: item.clientEmail || '' })];
        this.registrationDraft.documentReceivers = [this.mergeRegistrationContact(this.registrationDraft.documentReceivers?.[0], { name: item.consultant || item.clientContactName || '', phone: item.clientPhone || '', email: item.clientEmail || '' })];
        this.registrationDraft.assignee = item.assignee || this.registrationDraft.assignee || '';
        this.ensureRegistrationDocuments();
        for (const document of this.registrationDraft.documents) {
            document.deadlineAssignee = document.deadlineAssignee || this.registrationDraft.assignee || '';
        }
        this.ensureRegistrationAdditional(right);
        this.ensureRegistrationDraftDetail();
    }

    private emptyAdminSupportDraft() {
        return {
            category: '일반상담',
            caseNo: '',
            question: ''
        };
    }

    private emptyInfoUploadDraft(workspace: string) {
        const titleMap: any = {
            notices: '사무소 공지',
            laws: '법령/기준',
            media: '언론보도',
            forms: '업무 양식'
        };
        return {
            id: '',
            workspace,
            title: '',
            date: this.today,
            category: titleMap[workspace] || '사무소 공유',
            source: workspace === 'laws' ? '사무소 업로드' : '',
            publisher: workspace === 'media' ? '사무소 업로드' : '',
            updated: this.today,
            format: workspace === 'forms' ? '파일' : '',
            fileName: '',
            file: null,
            uploader: this.service?.auth?.session?.name || '',
            summary: '',
            scope: this.canManageNotices() ? 'admin' : 'office',
            pinned: false,
            pinnedAt: ''
        };
    }

    private emptyInfoDetailAttachmentDraft() {
        return {
            file: null,
            fileName: '',
            note: ''
        };
    }

    private infoItemUploadTimestamp(item: any) {
        return String(item?.latestAttachmentAt || item?.createdAt || item?.updatedAt || item?.updated || item?.date || '');
    }

    private defaultIpManagementGuideNotice() {
        return {
            id: 'system-guide-ip-management-v1',
            guideKey: 'ip-management-system-guide-v1',
            workspace: 'notices',
            title: 'IP 관리시스템 사용설명서',
            name: 'IP 관리시스템 사용설명서',
            category: '사용 안내',
            date: '2026-08-31',
            updated: '2026-08-31',
            createdAt: '2026-08-31 00:00',
            uploader: '주식회사 웅빈',
            scope: 'system',
            pinned: true,
            pinnedAt: '2026-08-31T00:00:00.000Z',
            systemManaged: true,
            summary: [
                '주식회사 웅빈에서 제공하는 IP 관리시스템은 상담·출원·등록·심판·소송에 이르는 전 단계를 한눈에 쉽게 확인·관리하고, 고객정보 및 자료의 안전한 관리와 연차·갱신기간 관리 등의 다양한 업무를 효율적이고 정확하게 처리할 수 있도록 도움을 주는 시스템입니다.',
                '',
                '지식재산 분야의 많은 고객과 사건을 관리해야 하는 특허사무소 및 다출원 기업 등이 보다 안심하고 업무를 수행함으로써 지식재산 기반을 공고히 마련할 수 있기를 진심으로 기원합니다.',
                '',
                '주식회사 웅빈이 제공하는 지식재산관리시스템을 이용해야 하는 이유',
                '1. 상담부터 출원·등록·심판·소송까지 모든 업무를 한곳에서 관리할 수 있습니다.',
                '2. 고객정보와 사건자료를 체계적으로 연결해 필요한 정보를 빠르게 확인할 수 있습니다.',
                '3. 연차·갱신기간과 주요 기한을 놓치지 않도록 효율적으로 관리할 수 있습니다.',
                '4. 조직별 접근 권한과 암호화 통신을 통해 중요 정보를 안전하게 보호합니다.',
                '5. 접속기록·백업·모니터링 정책을 기반으로 안정적인 업무 환경을 제공합니다.',
                '',
                '본 시스템은 암호화 통신과 조직별 접근 권한을 적용하며, 운영환경의 방화벽·접속기록·백업 및 모니터링 정책에 따라 관리됩니다. 승인된 사용자만 고객과 사건정보에 접근할 수 있습니다.'
            ].join('\n')
        };
    }

    private defaultResourceExample(workspace: string) {
        const tenantId = this.dashboard?.office?.tenant_id || 'resource-example-tenant';
        const common: any = {
            id: `resource-example-${workspace}`,
            resourceExampleKey: `resource-example-${workspace}-v1`,
            workspace,
            tenantId,
            date: '2026-09-01',
            updated: '2026-09-01',
            createdAt: '2026-09-01 09:00',
            updatedAt: '2026-09-01 09:00',
            latestAttachmentAt: '2026-09-01T09:00:00.000Z',
            uploader: '시스템 관리자',
            scope: 'admin',
            example: true
        };
        const examples: any = {
            laws: {
                ...common,
                resourceExampleKey: 'resource-example-laws-v1',
                title: '[예시] 특허 우선심사 기준 안내',
                name: '[예시] 특허 우선심사 기준 안내',
                category: '심사기준',
                source: '지식재산처',
                summary: '특허 우선심사 대상과 신청 시 준비할 증빙자료를 확인하기 위한 화면 확인용 예시입니다. 상세 화면에서 개정 전·후 첨부자료 이력을 함께 확인할 수 있습니다.',
                attachments: [
                    {
                        name: '특허_우선심사_기준_2026-09.pdf',
                        uploadedAt: '2026-09-01T09:00:00.000Z',
                        uploader: '시스템 관리자',
                        note: '신청 대상과 제출서류가 반영된 최신 개정 예시 자료',
                        size: 842000,
                        mime: 'application/pdf',
                        example: true
                    },
                    {
                        name: '특허_우선심사_기준_2026-06.pdf',
                        uploadedAt: '2026-06-15T09:00:00.000Z',
                        uploader: '시스템 관리자',
                        note: '이전 기준 예시 자료',
                        size: 798000,
                        mime: 'application/pdf',
                        example: true
                    }
                ]
            },
            media: {
                ...common,
                resourceExampleKey: 'resource-example-media-v1',
                title: '[예시] AI·반도체 특허출원 동향 보도',
                name: '[예시] AI·반도체 특허출원 동향 보도',
                category: '산업동향',
                publisher: '지식재산 전문매체',
                summary: 'AI·반도체 분야의 최근 특허출원 증가 추이와 기업 대응 동향을 정리한 화면 확인용 언론보도 예시입니다.',
                attachments: [
                    {
                        name: 'AI_반도체_특허출원_동향_보도자료.pdf',
                        uploadedAt: '2026-09-01T08:30:00.000Z',
                        uploader: '시스템 관리자',
                        note: '언론보도 원문 및 요약 예시',
                        size: 615000,
                        mime: 'application/pdf',
                        example: true
                    }
                ]
            },
            forms: {
                ...common,
                resourceExampleKey: 'resource-example-forms-v1',
                title: '[예시] 상표 출원 위임장 양식',
                name: '[예시] 상표 출원 위임장 양식',
                category: '출원서식',
                format: 'HWP',
                summary: '상표 출원 의뢰 시 고객에게 전달하는 위임장 양식을 관리하는 화면 확인용 예시입니다. 최신 양식을 추가하면 이전 파일과 함께 이력으로 보관됩니다.',
                attachments: [
                    {
                        name: '상표_출원_위임장_2026-09.hwpx',
                        uploadedAt: '2026-09-01T08:00:00.000Z',
                        uploader: '시스템 관리자',
                        note: '고객정보 입력란을 정리한 최신 양식 예시',
                        size: 126000,
                        mime: 'application/vnd.hancom.hwpx',
                        example: true
                    },
                    {
                        name: '상표_출원_위임장_2026-05.hwp',
                        uploadedAt: '2026-05-20T08:00:00.000Z',
                        uploader: '시스템 관리자',
                        note: '이전 양식 예시',
                        size: 118000,
                        mime: 'application/x-hwp',
                        example: true
                    }
                ]
            }
        };
        return examples[workspace] || null;
    }

    private emptyQuoteCostItem(category: string = '', item: string = '', amount: any = 0, note: string = '') {
        return { category, item, amount: this.numberValue(amount), note };
    }

    private emptyQuoteCostItems() {
        return [this.emptyQuoteCostItem()];
    }

    private quoteCostItemsFromLegacy(source: any) {
        const rows = [
            this.emptyQuoteCostItem('관납료', '관납료', source?.officialFee, '영수증 첨부'),
            this.emptyQuoteCostItem('대리인 수임료', '수임료', source?.serviceFee, '부가세 별도 또는 포함'),
            this.emptyQuoteCostItem('부가세', '부가세', source?.vat, ''),
            this.emptyQuoteCostItem('기타비용', '기타비용', source?.etcFee, '')
        ].filter((item: any) => this.numberValue(item.amount) > 0);
        return rows.length ? rows : this.emptyQuoteCostItems();
    }

    private rebuildConsultationQuoteTemplateSelection() {
        const selectedTemplates = this.consultationSelectedQuoteTemplates();
        const multiple = selectedTemplates.length > 1;
        this.quoteDraft.templateId = selectedTemplates[0]?.id || '';
        if (selectedTemplates[0]) {
            this.quoteDraft.standardFormId = this.standardQuoteFormForTemplate(selectedTemplates[0])?.id || this.quoteDraft.standardFormId;
        }
        if (!this.quoteDraft.selectedPartIds) this.quoteDraft.selectedPartIds = {};
        this.quoteDraft.selectedPartIds.cost = selectedTemplates.length === 1 && !selectedTemplates[0]?.custom
            ? `builtin-cost-${selectedTemplates[0].id}`
            : '';

        const costItems: any[] = [];
        for (const template of selectedTemplates) {
            const templateRows = this.quoteCostItemsFromLegacy(template)
                .filter((row: any) => this.numberValue(row?.amount) > 0);
            for (const row of templateRows) {
                costItems.push({
                    ...row,
                    item: multiple ? `${template.label} · ${row.item}` : row.item,
                    sourceTemplateId: template.id,
                    sourceTemplateLabel: template.label
                });
            }
        }
        this.quoteDraft.costItems = costItems.length ? costItems : this.emptyQuoteCostItems();
        if (selectedTemplates.length === 1) {
            this.quoteDraft.rightType = selectedTemplates[0].rightType || this.quoteDraft.rightType;
            this.quoteDraft.caseType = selectedTemplates[0].caseType || this.quoteDraft.caseType;
        }
        this.syncQuoteLegacyCosts();
    }

    private syncQuoteLegacyCosts() {
        const layout = this.activeStandardQuoteForm()?.layout;
        if (layout === 'patent') this.syncPatentQuoteCosts();
        if (layout === 'madrid') this.syncMadridQuoteCosts();
        if (layout === 'overseas-trademark') this.syncOverseasTrademarkQuoteCosts();
        if (layout === 'integrated') this.syncIntegratedQuoteCosts();
        const totals: any = { officialFee: 0, serviceFee: 0, vat: 0, etcFee: 0 };
        for (const row of this.quoteDraft?.costItems || []) {
            const amount = this.numberValue(row?.amount);
            if (row?.category === '관납료') totals.officialFee += amount;
            else if (row?.category === '대리인 수임료') totals.serviceFee += amount;
            else if (row?.category === '부가세') totals.vat += amount;
            else totals.etcFee += amount;
        }
        Object.assign(this.quoteDraft, totals);
        return totals;
    }

    private emptyStandardQuotePartDraft(partType: string = 'title') {
        return {
            id: '',
            partType,
            name: '',
            content: '',
            costItems: partType === 'cost' ? this.emptyQuoteCostItems() : [],
            sortOrder: 0
        };
    }

    private defaultStandardQuoteParts() {
        const baseParts: any[] = [
            {
                id: 'builtin-title-default', partType: 'title', name: '지식재산권 견적서 기본', builtIn: true,
                content: '특허사무소\n지식재산권 출원·등록 견적서', costItems: [], sortOrder: 0
            },
            {
                id: 'builtin-info-default', partType: 'info', name: '공급자·견적정보 기본', builtIn: true,
                content: '담당자님 귀하\n견적번호: 자동 생성\n견적일자: 작성일 기준\n아래와 같이 견적합니다.', costItems: [], sortOrder: 0
            },
            {
                id: 'builtin-guide-default', partType: 'guide', name: '참고·확인사항 기본', builtIn: true,
                content: '1. 입금 확인 후 업무에 착수합니다.\n2. 관납료에는 영수증을 첨부하고 대리인 비용은 계산서를 발급합니다.\n3. 심사 및 등록 단계에서 추가 비용이 발생할 수 있습니다.\n4. 해외비용은 환율과 송금일에 따라 조정될 수 있습니다.', costItems: [], sortOrder: 0
            },
            {
                id: 'builtin-seal-default', partType: 'seal', name: '대표자·직인 기본', builtIn: true,
                content: '특허사무소 대표 변리사 (직인생략)', costItems: [], sortOrder: 0
            }
        ];
        const costParts = (this.quoteTemplates || []).filter((item: any) => !item.custom).map((template: any, index: number) => ({
            id: `builtin-cost-${template.id}`,
            partType: 'cost',
            name: template.label,
            builtIn: true,
            content: '비용 항목과 금액은 실제 사건에 맞게 수정할 수 있습니다.',
            costItems: this.quoteCostItemsFromLegacy(template),
            sortOrder: index
        }));
        return [...baseParts, ...costParts];
    }

    private emptyQuoteDraft(sourceCase: any = null) {
        const disputeType = String(sourceCase?.detail?.dispute?.type || sourceCase?.disputeStatus || '').trim();
        const sourceRight = sourceCase?.detail?.dispute?.right || sourceCase?.right || '';
        const template = this.quoteTemplates.find((item) => item.disputeType === disputeType)
            || this.quoteTemplates.find((item) => !item.disputeType && item.rightType === sourceRight && item.caseType === sourceCase?.type)
            || this.quoteTemplates[0];
        const standardForm = this.standardQuoteFormForTemplate(template);
        const titlePart = this.availableStandardQuoteParts('title')[0];
        const infoPart = this.availableStandardQuoteParts('info')[0];
        const guidePart = this.availableStandardQuoteParts('guide')[0];
        const sealPart = this.availableStandardQuoteParts('seal')[0];
        const guideContent = this.usesDedicatedQuoteEditor(standardForm?.layout)
            ? this.dedicatedQuoteDefaultGuide(standardForm?.layout)
            : (guidePart?.content || '');
        return {
            editingQuoteId: '',
            editingQuoteStatus: '',
            editingQuoteSentAt: '',
            caseId: sourceCase?.id || '',
            caseNo: sourceCase?.disputeCaseNo || sourceCase?.caseNo || '',
            source: sourceCase?.title || '',
            clientName: sourceCase?.clientName || '',
            rightType: sourceRight || template.rightType,
            caseType: sourceCase?.type || template.caseType,
            templateId: template.id,
            standardFormId: standardForm?.id || 'form-patent',
            selectedTemplateIds: [],
            authoringMode: 'standard',
            selectedPartIds: {
                title: titlePart?.id || '',
                info: infoPart?.id || '',
                cost: '',
                guide: guidePart?.id || '',
                seal: sealPart?.id || ''
            },
            parts: {
                title: titlePart?.content || '',
                info: infoPart?.content || '',
                guide: guideContent,
                seal: sealPart?.content || ''
            },
            costItems: this.emptyQuoteCostItems(),
            customTemplateName: '',
            templateFileName: '',
            templateFile: null,
            existingAttachmentDocumentId: '',
            existingAttachmentFileId: '',
            existingAttachmentScanStatus: '',
            existingAttachmentDownloadable: false,
            officialFee: 0,
            serviceFee: 0,
            vat: 0,
            etcFee: 0,
            officeName: '',
            officeHeaderName: '',
            officeSubtitle: '',
            officeLogoDataUrl: '',
            officeLogoFileName: '',
            officeRegistrationNo: '',
            representative: '',
            officeAddress: '',
            officePhone: '',
            officeEmail: '',
            officeBusinessType: '서비스',
            officeBusinessItem: '변리사업',
            recipient: sourceCase?.clientName || '',
            recipientEmail: sourceCase?.clientEmail || '',
            quoteNo: '',
            quoteDate: '',
            subject: sourceCase?.title || '',
            validity: '',
            accountInfo: '',
            bankName: '',
            bankAccountNo: '',
            bankAccountHolder: '',
            patentApplicationOfficialFee: 0,
            patentApplicationAgentFee: 0,
            patentRegistrationOfficialFee: 0,
            patentRegistrationAgentFee: 0,
            patentPriorityApplicationOfficialFee: 0,
            patentPriorityExaminationOfficialFee: 0,
            patentPriorityApplicationAgentFee: 0,
            patentPriorityRegistrationOfficialFee: 0,
            patentPriorityRegistrationAgentFee: 0,
            madridRows: [
                { country: '인도', unitChf: 93, amount: 175383, note: '' },
                { country: '미국', unitChf: 460, amount: 867486, note: '' },
                { country: '러시아', unitChf: 100, amount: 188584, note: '' },
                { country: '유럽', unitChf: 789, amount: 1487927, note: '' },
                { country: '기본비용', unitChf: 653, amount: 1231453, note: '' },
                { country: '전자출원수수료', unitChf: 0, amount: 5000, note: '' }
            ],
            madridExchangeNote: '2026.05.04. 환율 기준',
            madridDomesticUnit: '',
            madridDomesticSupply: 0,
            madridDomesticVat: 0,
            overseasExchangeRate: 213.54,
            overseasExchangeRateDate: '',
            overseasExchangeRateSource: '',
            overseasTrademarkRows: [
                { country: '중국', officialAmount: 57650, officialForeign: '270위안', agentAmount: 550000, agentForeign: '2600위안' },
                { country: '한국', officialAmount: 0, officialForeign: '', agentAmount: 0, agentForeign: '' }
            ],
            integratedRows: [
                { rightLabel: '특허 1건 (우선심사)', applicationOfficialFee: 0, priorityOfficialFee: 0, agentFee: 0 },
                { rightLabel: '특허 1건 (우선심사)', applicationOfficialFee: 0, priorityOfficialFee: 0, agentFee: 0 },
                { rightLabel: '상표 1건 (우선심사, 1개류)', applicationOfficialFee: 0, priorityOfficialFee: 0, agentFee: 0 },
                { rightLabel: '디자인 1건 (우선심사)', applicationOfficialFee: 0, priorityOfficialFee: 0, agentFee: 0 }
            ],
            guide: guideContent,
            sealText: sourceCase ? (sealPart?.content || '') : ''
        };
    }

    private dedicatedQuoteDefaultGuide(layout: string) {
        if (layout === 'madrid') {
            return [
                '마드리드는 각국에서 의견제출통지(OA)가 발생시 현지 대리인을 수임하여야 합니다.',
                '해외 송금수수료와 국제출원료는 예상금액으로서, 송금일의 환율에 따라 실제 송금액과 비교하여 환불 또는 추가 청구가 이루어집니다.'
            ].join('\n');
        }
        if (layout === 'overseas-trademark') {
            return [
                '중국비용은 환율 213.54원(2026.3.11.기준)을 적용하고, 송금수수료는 제외하였습니다.',
                '입금 확인 후 착수하며, 통상 1주일 이내에 보고드립니다.',
                '상기 비용은 1개류 기준입니다.'
            ].join('\n');
        }
        if (layout === 'integrated') {
            return [
                '입금 확인 후 착수하며, 통상 3주 내에 보고드립니다.',
                '특허심사 후, 등록결정이 있을 경우 추가 비용이 발생됩니다(성공수수료+설정등록료).',
                '- 성공수수료 = 수임료의 100%',
                '- 설정등록료 = 특허(10만원 내외) / 디자인(22,500원) / 상표(220,120원)',
                '  특허 1~3년치 / 디자인 1~3년치 / 상표 1~10년치 등록료'
            ].join('\n');
        }
        return this.patentQuoteDefaultGuide();
    }

    private patentQuoteDefaultGuide() {
        return [
            '입금 확인 후 착수하며, 통상 3주 이내에 보고드립니다.',
            '특허청 관납료는 70% 감면금액으로 산정하였습니다(개인, 중소기업).',
            '중간서류 발생시 1회에 한해, 대응료 11만원(부가세 포함)이 발생할 수 있습니다.',
            '등록관납료는 최종 청구항수에 따라 달라질 수 있으며, 1~3년치 등록 비용입니다.'
        ].join('\n');
    }

    public selectedQuoteTemplate() {
        return this.quoteTemplates.find((item) => item.id === this.quoteDraft.templateId) || this.quoteTemplates[0];
    }

    private numberValue(value: any) {
        const parsed = parseInt(String(value || 0).replace(/,/g, ''), 10);
        return isNaN(parsed) ? 0 : parsed;
    }

    private resetRegistrationDraft() {
        this.activeRegistrationStep = 1;
        const right = this.registrationRightTabs[0] || '특허/실용신안';
        this.registrationDraft = {
            caseKey: this.generateCaseKey(),
            right,
            caseNo: '',
            applicationNo: '',
            filingDate: '',
            registrationNo: '',
            registrationDate: '',
            titleKo: '',
            titleEn: '',
            markImageName: '',
            productName: '',
            patentClientNo: '',
            caseType: this.caseTypeOptions[0] || '국내출원',
            stage: '출원/심사',
            detailedStatus: '심사중',
            customDetailedStatus: '',
            type: '국내출원',
            clients: [{ name: '', phone: '', email: '' }],
            applicants: [{ name: '', phone: '', email: '' }],
            companyContacts: [{ name: '', phone: '', email: '' }],
            documentReceivers: [{ name: '', phone: '', email: '' }],
            attorney: '',
            assignee: '',
            expeditedExam: false,
            partialExam: false,
            memo: '',
            nextDue: '',
            nextDueNote: '',
            relatedSourceCaseId: '',
            documents: [this.emptyRegistrationDocument()],
            detail: null,
            additional: {
                '특허/실용신안': this.emptyRegistrationAdditional('특허/실용신안'),
                '상표': this.emptyRegistrationAdditional('상표'),
                '디자인': this.emptyRegistrationAdditional('디자인')
            }
        };
        this.registrationDraft.detail = this.caseDetailFromRegistrationDraft(
            this.registrationDraft,
            this.registrationDraft.additional[right]
        );
    }

    private ensureRegistrationDraftDetail() {
        const draft = this.registrationDraft || {};
        const right = draft.right || this.registrationRightTabs[0] || '특허/실용신안';
        const additional = this.ensureRegistrationAdditional(right);
        if (!draft.detail || typeof draft.detail !== 'object') {
            draft.detail = this.caseDetailFromRegistrationDraft(draft, additional);
        }

        const detail = this.ensureCaseDetailShape(draft);
        detail.caseKey = draft.caseKey || detail.caseKey || this.generateCaseKey();
        draft.caseKey = detail.caseKey;
        detail.patentClientNo = detail.patentClientNo || draft.patentClientNo || '';
        detail.titleEn = detail.titleEn || draft.titleEn || '';
        detail.ipcClass = detail.ipcClass || additional.ipcClass || '';
        detail.claims = detail.claims || additional.claims || '';
        detail.examination.requestDate = detail.examination.requestDate || additional.examRequestDate || '';

        const legacyProducts = Array.isArray(additional.products) ? additional.products : [];
        const hasDetailProducts = detail.trademark.products.some((item: any) => item.productClass || item.productName);
        if (!hasDetailProducts && legacyProducts.some((item: any) => item.productClass || item.productName)) {
            detail.trademark.products = legacyProducts.map((item: any) => ({
                productClass: item.productClass || '',
                productName: item.productName || ''
            }));
        }

        detail.design.itemClass = detail.design.itemClass || additional.articleClass || '';
        detail.design.itemName = detail.design.itemName || additional.productName || draft.productName || '';
        detail.design.partialExamination = !!(detail.design.partialExamination || draft.partialExam);

        if (draft.caseType === '해외출원') {
            additional.internationalApplicationNo = additional.internationalApplicationNo
                || detail.foreign.internationalRegistrationNo
                || '';
            const savedApplications = Array.isArray(detail.foreign.countryApplications)
                ? detail.foreign.countryApplications
                : [];
            const hasEnteredApplication = additional.overseasApplications.some((item: any) =>
                item.country || item.requestType || item.currentStatus || item.progressStatus
            );
            if (!hasEnteredApplication && savedApplications.length) {
                additional.overseasApplications = this.cloneValue(savedApplications);
            }
        }

        const companyContact = draft.companyContacts?.[0];
        const documentReceiver = draft.documentReceivers?.[0];
        if (!detail.companyContact.name && companyContact) detail.companyContact = this.cloneValue(companyContact);
        if (!detail.documentReceiver.name && documentReceiver) detail.documentReceiver = this.cloneValue(documentReceiver);

        draft.detail = detail;
        return detail;
    }

    private syncRegistrationDraftFromDetail() {
        const draft = this.registrationDraft;
        const detail = this.ensureRegistrationDraftDetail();
        const right = draft.right || '특허/실용신안';
        const additional = this.ensureRegistrationAdditional(right);

        detail.caseKey = draft.caseKey || detail.caseKey || this.generateCaseKey();
        draft.caseKey = detail.caseKey;
        detail.patentClientNo = draft.patentClientNo || detail.patentClientNo || '';
        detail.titleEn = draft.titleEn || detail.titleEn || '';
        detail.companyContact = this.cloneValue(draft.companyContacts?.[0] || detail.companyContact);
        detail.documentReceiver = this.cloneValue(draft.documentReceivers?.[0] || detail.documentReceiver);

        additional.ipcClass = detail.ipcClass || '';
        additional.claims = detail.claims || '';
        additional.examRequestDate = detail.examination.requestDate || '';
        additional.products = this.cloneValue(detail.trademark.products);
        additional.articleClass = detail.design.itemClass || '';
        additional.productName = detail.design.itemName || '';
        draft.partialExam = !!detail.design.partialExamination;
        if (right === '디자인') draft.productName = detail.design.itemName || draft.productName || '';

        if (draft.caseType === '해외출원') {
            const countryApplications = (additional.overseasApplications || []).map((item: any) => ({
                country: item?.country || '',
                requestType: item?.requestType || '',
                currentStatus: item?.currentStatus || 'WIPO',
                progressStatus: item?.progressStatus || '심사중',
                customProgressStatus: item?.customProgressStatus || '',
                requestDate: item?.requestDate || '',
                localAgentName: item?.localAgentName || '',
                localAgentContact: item?.localAgentContact || '',
                localAgentEmail: item?.localAgentEmail || '',
                localAgentAddress: item?.localAgentAddress || '',
                note: item?.note || ''
            }));
            const activeApplications = countryApplications.filter((item: any) =>
                item.country || item.requestType || item.localAgentName || item.note
            );
            const primaryApplication = activeApplications[0] || countryApplications[0];
            detail.foreign.domesticApplicationNo = draft.applicationNo || '';
            detail.foreign.internationalRegistrationNo = detail.foreign.internationalRegistrationNo
                || additional.internationalApplicationNo
                || '';
            additional.internationalApplicationNo = detail.foreign.internationalRegistrationNo;
            detail.foreign.internationalRegistrationDate = detail.foreign.internationalRegistrationDate || '';
            detail.foreign.countryApplications = this.cloneValue(activeApplications);
            detail.foreign.countries = activeApplications
                .map((item: any) => String(item.country || '').trim())
                .filter((country: string, index: number, values: string[]) => !!country && values.indexOf(country) === index);
            detail.foreign.entryType = primaryApplication?.requestType || detail.foreign.entryType || '개별국';
            if (primaryApplication?.progressStatus) {
                draft.detailedStatus = primaryApplication.progressStatus;
                draft.customDetailedStatus = primaryApplication.progressStatus === '직접입력'
                    ? (primaryApplication.customProgressStatus || '')
                    : '';
            }
        }

        draft.detail = detail;
        return detail;
    }

    private normalizeCaseData() {
        for (const item of this.cases) {
            this.ensureCaseDetailShape(item);
            item.applicant = item.applicant || this.contactNames(item.contacts?.applicants || []);
            if (!item.memo && item.memos?.length) item.memo = item.memos[0].text || '';
            item.productName = item.productName || item.displayName || item.title;
            item.markText = item.markText || item.displayName || item.title;
            item.documents = item.documents || [];
            for (const doc of item.documents) {
                doc.category = this.normalizeDocumentCategory(doc.category);
                doc.deadlineRule = doc.deadlineRule || (doc.dueDate ? 'auto' : 'manual');
                doc.deadlineTask = doc.deadlineTask || this.defaultTaskForCategory(doc.category);
                doc.deadlineAssignee = doc.deadlineAssignee || item.assignee;
                doc.sentTo = doc.sentTo || (doc.sent ? item.documentReceiver : '');
                doc.selected = !!doc.selected;
                doc.views = doc.views || 0;
            }
        }
    }

    private ensureCaseDetailShape(item: any) {
        if (!item) return this.emptyCaseDetail();
        const source = item.detail && typeof item.detail === 'object' ? item.detail : {};
        const detail: any = this.emptyCaseDetail();
        detail.caseKey = source.caseKey || item.caseKey || '';
        detail.relatedSourceCaseId = source.relatedSourceCaseId || item.relatedSourceCaseId || '';
        detail.patentClientNo = source.patentClientNo || item.patentClientNo || '';
        detail.memoChecked = !!source.memoChecked;
        detail.hasOverseas = !!source.hasOverseas;
        detail.titleEn = source.titleEn || item.titleEn || '';
        detail.ipcClass = source.ipcClass || '';
        detail.claims = source.claims || '';
        for (const key of ['priority', 'examination', 'expedited', 'intermediate', 'disposition', 'abandonment', 'annuity', 'renewal']) {
            detail[key] = { ...detail[key], ...(source[key] || {}) };
        }
        if (this.isAnnuityRight(item)) {
            detail.annuity = this.buildAnnuityDetail(detail.annuity, detail.disposition);
            detail.disposition.paymentDate = detail.annuity.initialPaymentDate || '';
        }
        if (this.isTrademarkRight(item)) {
            detail.renewal = this.buildTrademarkRenewalDetail(detail.renewal, detail.disposition, detail.annuity);
            detail.disposition.paymentDate = detail.renewal.initialPaymentDate || '';
        }
        detail.companyContact = { ...detail.companyContact, ...(source.companyContact || {}) };
        detail.documentReceiver = { ...detail.documentReceiver, ...(source.documentReceiver || {}) };
        const sourceContacts = source.contacts && typeof source.contacts === 'object' ? source.contacts : {};
        for (const key of ['clients', 'applicants', 'companyContacts', 'documentReceivers']) {
            detail.contacts[key] = Array.isArray(sourceContacts[key])
                ? this.cloneValue(sourceContacts[key])
                : [];
        }
        detail.foreign = { ...detail.foreign, ...(source.foreign || {}) };
        detail.foreign.domesticApplicationNo = detail.foreign.domesticApplicationNo || item.foreignDomesticApplicationNo || item.applicationNo || '';
        detail.foreign.internationalRegistrationNo = detail.foreign.internationalRegistrationNo || item.internationalRegistrationNo || '';
        detail.foreign.entryType = detail.foreign.entryType || item.foreignEntryType || '개별국';
        detail.foreign.internationalRegistrationDate = detail.foreign.internationalRegistrationDate || item.registrationDate || '';
        detail.foreign.countries = Array.isArray(source.foreign?.countries)
            ? this.cloneValue(source.foreign.countries)
            : (Array.isArray(item.foreignCountries) ? this.cloneValue(item.foreignCountries) : []);
        detail.foreign.countryApplications = Array.isArray(source.foreign?.countryApplications)
            ? this.cloneValue(source.foreign.countryApplications)
            : [];
        detail.foreign.examinationHistory = Array.isArray(source.foreign?.examinationHistory)
            ? this.cloneValue(source.foreign.examinationHistory)
            : [];
        detail.dispute = { ...detail.dispute, ...(source.dispute || {}) };
        detail.dispute.caseNo = detail.dispute.caseNo || item.disputeCaseNo || item.trialNo || '';
        detail.dispute.claimDate = detail.dispute.claimDate || item.claimDate || item.filingDate || '';
        const disputeRight = String(detail.dispute.right || item.rightDisplay || item.right || '특허').trim();
        detail.dispute.right = disputeRight === '실용신안'
            ? '실용'
            : (disputeRight === '특허/실용신안' ? '특허' : disputeRight);
        const relatedCases = Array.isArray(source.dispute?.relatedCases) ? source.dispute.relatedCases : [];
        detail.dispute.relatedCases = relatedCases.map((value: any) => {
            if (value && typeof value === 'object') return String(value.caseNo || value.number || '').trim();
            return String(value || '').trim();
        });
        if (!detail.dispute.currentInstitution && (detail.dispute.type === '심판' || detail.dispute.type === '소송')) {
            detail.dispute.currentInstitution = detail.dispute.type === '소송' ? '특허법원' : '특허심판원';
        }
        detail.dispute.examinationHistory = Array.isArray(source.dispute?.examinationHistory)
            ? this.cloneValue(source.dispute.examinationHistory)
            : [];
        if (!detail.companyContact.name) detail.companyContact.name = item.companyContact || '';
        if (!detail.documentReceiver.name) detail.documentReceiver.name = item.documentReceiver || '';
        const trademark = source.trademark || {};
        detail.trademark.products = Array.isArray(trademark.products) && trademark.products.length
            ? this.cloneValue(trademark.products)
            : detail.trademark.products;
        const applications = trademark.applications || {};
        for (const key of ['original', 'divisional', 'additional']) {
            detail.trademark.applications[key] = { ...detail.trademark.applications[key], ...(applications[key] || {}) };
        }
        const design = source.design || {};
        detail.design.itemClass = design.itemClass || '';
        detail.design.itemName = design.itemName || item.productName || '';
        detail.design.partialExamination = !!(design.partialExamination ?? item.partialExam);
        const designApplications = design.applications || {};
        for (const key of ['original', 'divisional']) {
            detail.design.applications[key] = { ...detail.design.applications[key], ...(designApplications[key] || {}) };
        }
        item.detail = detail;
        item.caseKey = item.caseKey || detail.caseKey;
        item.relatedSourceCaseId = item.relatedSourceCaseId || detail.relatedSourceCaseId;
        item.patentClientNo = item.patentClientNo || detail.patentClientNo;
        item.titleEn = item.titleEn || detail.titleEn;
        return detail;
    }

    private emptyCaseDetail(): any {
        return {
            caseKey: '',
            relatedSourceCaseId: '',
            patentClientNo: '',
            memoChecked: false,
            hasOverseas: false,
            titleEn: '',
            ipcClass: '',
            claims: '',
            priority: { applicationNo: '', firstApplicationNo: '', deadline: '', claimDate: '' },
            examination: { deadline: '', requestDate: '' },
            expedited: { requestDate: '', decisionDate: '' },
            intermediate: { opinionDate: '', responseDate: '' },
            disposition: { decisionDate: '', paymentDate: '' },
            abandonment: { decisionDate: '', content: '' },
            annuity: {
                inspectionDate: '',
                initialNormalDeadline: '',
                initialPenaltyDeadline: '',
                initialPaymentDate: '',
                initialPaymentAmount: 0,
                schedule: []
            },
            renewal: {
                inspectionDate: '',
                paymentTermYears: 10,
                initialNormalDeadline: '',
                initialExtensionDeadline: '',
                initialPaymentDate: '',
                initialPaymentAmount: 0,
                schedule: []
            },
            companyContact: { name: '', phone: '', email: '' },
            documentReceiver: { name: '', phone: '', email: '' },
            contacts: {
                clients: [],
                applicants: [],
                companyContacts: [],
                documentReceivers: []
            },
            foreign: {
                domesticApplicationNo: '',
                internationalRegistrationNo: '',
                internationalRegistrationDate: '',
                entryType: '개별국',
                countries: [],
                countryApplications: [],
                examinationHistory: [],
                examinationHistoryLoadedAt: '',
                examinationHistoryReferenceNo: '',
                examinationHistorySourceCaseId: '',
                examinationHistorySourceCaseKey: '',
                examinationHistorySourceCase: {}
            },
            dispute: {
                relationType: '1',
                type: '이의',
                category: '이의',
                right: '특허',
                caseNo: '',
                claimDate: '',
                relatedCases: [],
                claimant: '',
                respondent: '',
                currentInstitution: '',
                baseApplicationNo: '',
                baseApplicationDate: '',
                baseRegistrationNo: '',
                baseRegistrationDate: '',
                customerMatterNumberType: 'registration',
                customerMatterNumber: '',
                customerMatterDate: '',
                examinationHistory: [],
                examinationHistoryLoadedAt: '',
                examinationHistoryReferenceNo: '',
                examinationHistorySourceCaseId: '',
                examinationHistorySourceCaseKey: '',
                examinationHistorySourceCase: {}
            },
            trademark: {
                products: [{ productClass: '', productName: '' }],
                applications: {
                    original: { applicationNo: '', applicationDate: '' },
                    divisional: { applicationNo: '', applicationDate: '' },
                    additional: { applicationNo: '', applicationDate: '' }
                }
            },
            design: {
                itemClass: '',
                itemName: '',
                partialExamination: false,
                applications: {
                    original: { applicationNo: '', applicationDate: '' },
                    divisional: { applicationNo: '', applicationDate: '' }
                }
            }
        };
    }

    private applyPriorityApplicationNumber(item: any) {
        const detail = this.ensureCaseDetailShape(item);
        const priorityNo = String(detail.priority.applicationNo || '').trim();
        if (!priorityNo) return;
        const currentNo = String(item.applicationNo || '').trim();
        if (currentNo && currentNo !== priorityNo && !detail.priority.firstApplicationNo) {
            detail.priority.firstApplicationNo = currentNo;
        }
        item.applicationNo = priorityNo;
    }

    private syncCaseFromDetail(item: any) {
        const detail = this.ensureCaseDetailShape(item);
        if (this.isAnnuityRight(item)) {
            this.rebuildAnnuitySchedule(item, false);
            detail.disposition.paymentDate = detail.annuity.initialPaymentDate || '';
        }
        if (this.isTrademarkRight(item)) {
            this.rebuildTrademarkRenewalSchedule(item, false);
            detail.disposition.paymentDate = detail.renewal.initialPaymentDate || '';
        }
        item.patentClientNo = detail.patentClientNo || '';
        item.titleEn = detail.titleEn || '';
        item.companyContact = detail.companyContact.name || '';
        item.documentReceiver = detail.documentReceiver.name || '';
        if (this.isDisputeCaseDetail(item)) {
            item.disputeStatus = detail.dispute.type || '이의';
            item.disputeCategory = detail.dispute.category || '이의';
            item.disputeCaseNo = detail.dispute.caseNo || '';
            item.trialNo = detail.dispute.caseNo || '';
            item.claimDate = detail.dispute.claimDate || '';
            item.claimant = detail.dispute.claimant || '';
            item.respondent = detail.dispute.respondent || '';
            item.currentInstitution = detail.dispute.currentInstitution || '';
            item.relatedDisputeCases = this.disputeRelatedCases(item);
            item.baseCaseNumber = detail.dispute.baseRegistrationNo || detail.dispute.baseApplicationNo || '';
            item.baseCaseDate = detail.dispute.baseRegistrationDate || detail.dispute.baseApplicationDate || '';
            if (this.disputeRightOptions.indexOf(detail.dispute.right) >= 0) {
                item.right = detail.dispute.right;
                item.rightDisplay = detail.dispute.right;
            }
        }
        if (this.isForeignCaseDetail(item)) {
            const applications = this.foreignCaseCountryApplications(item);
            const activeApplications = applications.filter((application: any) =>
                application?.country
                || application?.requestType
                || application?.currentStatus
                || application?.progressStatus
                || application?.customProgressStatus
                || application?.requestDate
                || application?.localAgentName
                || application?.localAgentContact
                || application?.localAgentEmail
                || application?.localAgentAddress
                || application?.note
            );
            const primaryApplication = activeApplications[0] || applications[0];
            detail.foreign.countryApplications = this.cloneValue(activeApplications);
            detail.foreign.countries = activeApplications
                .map((application: any) => String(application?.country || '').trim())
                .filter((country: string, index: number, values: string[]) => !!country && values.indexOf(country) === index);
            detail.foreign.entryType = primaryApplication?.requestType || detail.foreign.entryType || '개별국';
            item.applicationNo = detail.foreign.domesticApplicationNo || item.applicationNo || '';
            item.foreignDomesticApplicationNo = detail.foreign.domesticApplicationNo || '';
            item.internationalRegistrationNo = detail.foreign.internationalRegistrationNo || '';
            item.registrationNo = detail.foreign.internationalRegistrationNo || item.registrationNo || '';
            item.registrationDate = detail.foreign.internationalRegistrationDate || '';
            item.foreignEntryType = detail.foreign.entryType;
            item.foreignCountries = this.cloneValue(detail.foreign.countries);
            item.foreignCountryCountLabel = detail.foreign.countries.length ? `${detail.foreign.countries.length}개국` : '';
            if (primaryApplication?.progressStatus) {
                item.detailedStatus = primaryApplication.progressStatus;
                item.customDetailedStatus = primaryApplication.progressStatus === '직접입력'
                    ? (primaryApplication.customProgressStatus || '')
                    : '';
            }
        }
        if (item.right === '디자인') {
            item.productName = detail.design.itemName || '';
            item.partialExam = !!detail.design.partialExamination;
            if (detail.design.itemName) item.title = detail.design.itemName;
        }
    }

    private normalizeDocumentCategory(value: string) {
        const text = String(value || '');
        if (text.indexOf('출원전') >= 0 || text.indexOf('상담') >= 0) return '출원전서류';
        if (text.indexOf('출원') >= 0 || text.indexOf('심사') >= 0) return '출원심사서류';
        if (text.indexOf('최종') >= 0 || text.indexOf('등록') >= 0 || text.indexOf('거절') >= 0) return '최종서류';
        return '기타';
    }

    private isCaseListItem(item: any) {
        return item && item.stage !== '상담/접수' && item.workflow !== 'consultation' && item.workflow !== 'reception';
    }

    private ensureRegistrationAdditional(right: string) {
        if (!this.registrationDraft.additional) this.registrationDraft.additional = {};
        if (!this.registrationDraft.additional[right]) {
            this.registrationDraft.additional[right] = this.emptyRegistrationAdditional(right);
        }

        const additional = this.registrationDraft.additional[right];
        additional.overseasApplications = additional.overseasApplications || [];
        additional.trials = additional.trials || [];
        additional.lawsuits = additional.lawsuits || [];
        if (right === '상표') additional.products = additional.products?.length ? additional.products : [this.emptyRegistrationAdditionalRow('products')];
        if (additional.overseasApplications.length === 0) additional.overseasApplications.push(this.emptyRegistrationAdditionalRow('overseasApplications'));
        if (additional.trials.length === 0) additional.trials.push(this.emptyRegistrationAdditionalRow('trials'));
        if (additional.lawsuits.length === 0) additional.lawsuits.push(this.emptyRegistrationAdditionalRow('lawsuits'));
        this.removeRegistrationAdditionalMemoFields(additional);
        return additional;
    }

    private removeRegistrationAdditionalMemoFields(additional: any) {
        if (!Array.isArray(additional?.overseasApplications)) return;
        for (const overseas of additional.overseasApplications) {
            if (overseas && Object.prototype.hasOwnProperty.call(overseas, 'memo')) delete overseas.memo;
        }
    }

    private emptyRegistrationAdditional(right: string) {
        if (right === '상표') {
            return {
                products: [this.emptyRegistrationAdditionalRow('products')],
                relatedApplicationNo: '',
                internationalApplicationNo: '',
                priorityClaim: '',
                overseasApplications: [this.emptyRegistrationAdditionalRow('overseasApplications')],
                trials: [this.emptyRegistrationAdditionalRow('trials')],
                lawsuits: [this.emptyRegistrationAdditionalRow('lawsuits')]
            };
        }

        if (right === '디자인') {
            return {
                articleClass: '',
                productName: '',
                internationalApplicationNo: '',
                priorityClaim: '',
                overseasApplications: [this.emptyRegistrationAdditionalRow('overseasApplications')],
                trials: [this.emptyRegistrationAdditionalRow('trials')],
                lawsuits: [this.emptyRegistrationAdditionalRow('lawsuits')]
            };
        }

        return {
            ipcClass: '',
            claims: '',
            examRequestDate: '',
            internationalApplicationNo: '',
            priorityClaim: '',
            overseasApplications: [this.emptyRegistrationAdditionalRow('overseasApplications')],
            trials: [this.emptyRegistrationAdditionalRow('trials')],
            lawsuits: [this.emptyRegistrationAdditionalRow('lawsuits')]
        };
    }

    private emptyRegistrationAdditionalRow(collectionKey: string) {
        if (collectionKey === 'products') {
            return { productClass: '', productName: '', addedAt: '' };
        }
        if (collectionKey === 'trials') {
            return { trialNo: '', trialDate: '' };
        }
        if (collectionKey === 'lawsuits') {
            return { lawsuitNo: '', lawsuitDate: '' };
        }
        return {
            country: '',
            requestType: '',
            currentStatus: 'WIPO',
            progressStatus: '심사중',
            customProgressStatus: '',
            requestDate: '',
            localAgentName: '',
            localAgentContact: '',
            localAgentEmail: '',
            localAgentAddress: '',
            note: '',
            quote: ''
        };
    }

    private emptyDocumentDraft() {
        return {
            id: '',
            uploadedAt: this.today,
            category: this.documentCategories[1] || '출원서류',
            name: '',
            fileName: '',
            uploader: this.selectedCase?.assignee || '',
            note: '',
            dueDate: '',
            deadlineRule: 'manual',
            deadlineTask: '',
            deadlineAssignee: this.selectedCase?.assignee || '',
            file: null
        };
    }

    private emptyRegistrationDocument() {
        return {
            category: this.documentCategories[1] || '출원심사서류',
            name: '',
            fileName: '',
            file: null,
            dueDate: '',
            deadlineRule: 'manual',
            deadlineTask: '',
            deadlineAssignee: this.registrationDraft?.assignee || '',
            note: ''
        };
    }

    private ensureRegistrationDocuments() {
        if (!Array.isArray(this.registrationDraft?.documents)) {
            this.registrationDraft.documents = [];
        }
        if (!this.registrationDraft.documents.length) {
            this.registrationDraft.documents.push(this.emptyRegistrationDocument());
        }
        return this.registrationDraft.documents;
    }

    private async saveRegistrationDocuments(caseItem: any) {
        const savedDocuments: any[] = [];
        const enteredDocuments = this.ensureRegistrationDocuments().filter((item: any) =>
            String(item?.name || item?.fileName || '').trim()
        );
        for (let index = 0; index < enteredDocuments.length; index += 1) {
            const source = enteredDocuments[index];
            const draft = {
                id: source.id || `doc-${Date.now()}-${index}`,
                uploadedAt: source.uploadedAt || this.today,
                category: source.category || this.documentCategories[1] || '출원심사서류',
                name: source.name || source.fileName || '첨부서류',
                fileName: source.fileName || '',
                uploader: this.registrationDraft?.assignee || '',
                note: source.note || '',
                dueDate: source.dueDate || '',
                deadlineRule: source.deadlineRule || 'manual',
                deadlineTask: source.deadlineTask || '',
                deadlineAssignee: source.deadlineAssignee || this.registrationDraft?.assignee || '',
                sent: false,
                sentAt: '',
                sentTo: '',
                views: 0,
                selected: false
            };
            const saved = await this.saveDocumentRecord(draft, caseItem);
            if (!saved) continue;
            let nextDocument = {
                ...draft,
                ...saved,
                files: this.cloneValue(source.files || []),
                currentFile: this.cloneValue(source.currentFile || null),
                file: null
            };
            if (source.file) {
                const uploadResult = await this.uploadDocumentFile(saved.id, source.file);
                if (uploadResult) {
                    const files = uploadResult.files || [];
                    nextDocument = { ...nextDocument, files, currentFile: files[0] || null };
                    this.documentFileUsage = uploadResult.usage || this.documentFileUsage;
                }
            }
            savedDocuments.unshift(nextDocument);
        }
        return savedDocuments;
    }

    private responsePayload(response: any) {
        return response?.responseJSON || response || {};
    }

    private responseMessage(payload: any, fallback: string) {
        if (typeof payload?.message === 'string' && payload.message) return payload.message;
        if (typeof payload?.data?.message === 'string' && payload.data.message) return payload.data.message;
        return fallback;
    }

    private addDocumentFiles(files: any[]) {
        if (!this.selectedCase || !files.length) return;
        this.selectedCase.documents = this.selectedCase.documents || [];
        for (const file of files) {
            const doc = {
                id: `doc-${Date.now()}-${this.selectedCase.documents.length}`,
                uploadedAt: this.today,
                category: this.documentUploadCategory,
                name: file.name || '첨부서류',
                sent: false,
                sentAt: '',
                sentTo: '',
                dueDate: '',
                deadlineRule: 'manual',
                deadlineTask: '',
                deadlineAssignee: this.selectedCase.assignee,
                uploader: this.selectedCase.assignee,
                note: '',
                views: 0,
                selected: false
            };
            this.selectedCase.documents.unshift(doc);
        }
        this.service.render();
    }

    private rebuildDeadlinesFromCases() {
        const rows: any[] = [];
        for (const item of this.cases.filter((row) => this.isCaseListItem(row) && this.isAssignedToCurrentUser(row))) {
            for (const doc of item.documents || []) {
                if (doc.dueDate) {
                    this.pushDeadlinePair(rows, {
                        date: doc.dueDate,
                        caseId: item.id,
                        caseTitle: item.title,
                        document: doc.name,
                        assignee: doc.deadlineAssignee || item.assignee,
                        task: doc.deadlineTask || this.defaultTaskForCategory(doc.category)
                    });
                }
            }
            if (item.nextDue) {
                this.pushDeadlinePair(rows, {
                    date: item.nextDue,
                    caseId: item.id,
                    caseTitle: item.title,
                    document: '다음 점검',
                    assignee: item.assignee,
                    task: '점검일정'
                });
            }
        }
        this.deadlines = this.sortDeadlineRows(rows);
    }

    private pushDeadlinePair(rows: any[], item: any) {
        if (!item?.date) return;
        const dueDate = item.date;
        const task = item.task || item.document || '기한';
        const reminder = this.addDays(dueDate, -7);
        rows.push({ ...item, date: reminder, dueDate, status: 'week', task });
        rows.push({ ...item, date: dueDate, dueDate, status: 'due', task });
    }

    private normalizeDeadlineRows(rows: any[]) {
        const source = rows || [];
        const hasExpandedRows = source.some((item) => item?.status === 'week');
        if (hasExpandedRows) {
            return this.sortDeadlineRows(source
                .filter((item) => item?.date)
                .map((item) => ({
                    ...item,
                    dueDate: item.dueDate || (item.status === 'week' ? this.addDays(item.date, 7) : item.date)
                })));
        }

        const deadlines: any[] = [];
        for (const item of source) {
            const date = item?.date || item?.dueDate || '';
            if (!date) continue;
            this.pushDeadlinePair(deadlines, {
                ...item,
                date,
                task: item?.task || item?.document || '기한'
            });
        }
        return this.sortDeadlineRows(deadlines);
    }

    private ensureVisibleCalendarCoverage(rows: any[]) {
        const normalized = this.sortDeadlineRows(rows || []);
        const config = {
            ...this.calendarConfigFromToday(),
            ...(this.dashboard.calendar || {})
        };
        const visibleDates = new Set(normalized
            .filter((item) => this.isCalendarMonthDate(item?.date, config.year, config.month))
            .map((item) => item.date));
        const minimumVisibleDates = 16;
        if (visibleDates.size >= minimumVisibleDates) return normalized;

        const sourceCases = this.cases.filter((item) => this.isCaseListItem(item));
        if (sourceCases.length === 0) return normalized;

        const tasks = ['서류 검토', '의견 대응', '보정 검토', '등록 점검', '심사청구 점검', '고객 확인'];
        const filled = [...normalized];
        const seen = new Set(filled.map((item) => this.deadlineRowKey(item)));
        const start = this.parseDate(this.today);
        let fillIndex = 0;

        for (let offset = 0; offset <= 45 && visibleDates.size < minimumVisibleDates; offset++) {
            const current = new Date(start);
            current.setDate(start.getDate() + offset);
            if (current.getDay() === 0 || current.getDay() === 6) continue;

            const dueDate = this.dateKey(current);
            if (!this.isCalendarMonthDate(dueDate, config.year, config.month) || visibleDates.has(dueDate)) continue;

            const source = sourceCases[fillIndex % sourceCases.length];
            const task = tasks[fillIndex % tasks.length];
            const base = {
                caseId: source.id,
                caseTitle: this.caseSubjectValue(source),
                document: '일정 점검',
                assignee: source.assignee || source.attorney || '',
                task,
                dueDate,
                supplemental: true
            };
            const candidates = [
                { ...base, date: this.addDays(dueDate, -7), status: 'week' },
                { ...base, date: dueDate, status: 'due' }
            ];
            for (const item of candidates) {
                const key = this.deadlineRowKey(item);
                if (seen.has(key)) continue;
                seen.add(key);
                filled.push(item);
            }
            visibleDates.add(dueDate);
            fillIndex++;
        }

        return this.sortDeadlineRows(filled);
    }

    private isCalendarMonthDate(date: string, year: number, month: number) {
        if (!date || !/^\d{4}-\d{2}-\d{2}/.test(date)) return false;
        const parsed = this.parseDate(date);
        return parsed.getFullYear() === year && parsed.getMonth() === month - 1;
    }

    private deadlineRowKey(item: any) {
        return [
            item?.date || '',
            item?.status || '',
            item?.caseId || '',
            item?.task || '',
            item?.dueDate || ''
        ].join('|');
    }

    private sortDeadlineRows(rows: any[]) {
        return [...(rows || [])].sort((a, b) => {
            const dateDiff = this.parseDate(a.date).getTime() - this.parseDate(b.date).getTime();
            if (dateDiff !== 0) return dateDiff;
            const statusDiff = this.deadlineStatusWeight(a.status) - this.deadlineStatusWeight(b.status);
            if (statusDiff !== 0) return statusDiff;
            return this.calendarDeadlineLabel(a).localeCompare(this.calendarDeadlineLabel(b), 'ko');
        });
    }

    private normalizedSelectedDeadlinePage(total: number) {
        const pages = Math.max(1, Math.ceil(total / this.selectedDeadlinePageSize));
        return Math.max(1, Math.min(this.selectedDeadlinePage, pages));
    }

    private normalizedWeekDeadlinePage(total: number) {
        const pages = Math.max(1, Math.ceil(total / this.weekDeadlinePageSize));
        return Math.max(1, Math.min(this.weekDeadlinePage, pages));
    }

    private deadlineStatusWeight(status: string) {
        if (status === 'week') return 0;
        if (status === 'due') return 1;
        return 2;
    }

    private defaultDueDateForCategory(category: string) {
        const days: any = {
            '출원전서류': 7,
            '출원심사서류': 14,
            '최종서류': 30,
            '기타': 10
        };
        return this.addDays(this.today, days[category] || 10);
    }

    private defaultTaskForCategory(category: string) {
        const map: any = {
            '출원전서류': '출원 전 자료 검토',
            '출원심사서류': '출원·심사서류 검토/발송',
            '최종서류': '최종 결정·등록 일정 확인',
            '기타': '첨부서류 확인'
        };
        return map[category] || '서류 확인';
    }

    private buildCalendar() {
        const fallback = this.calendarConfigFromToday();
        const config = {
            ...fallback,
            ...(this.dashboard.calendar || {})
        };
        const first = new Date(config.year, config.month - 1, 1);
        const startOffset = (first.getDay() + 6) % 7;
        const start = new Date(config.year, config.month - 1, 1 - startOffset);
        const daysInMonth = new Date(config.year, config.month, 0).getDate();
        const weekCount = Math.ceil((startOffset + daysInMonth) / 7);
        const weeks: any[][] = [];

        for (let week = 0; week < weekCount; week++) {
            const days: any[] = [];
            for (let day = 0; day < 7; day++) {
                const current = new Date(start);
                current.setDate(start.getDate() + week * 7 + day);
                const key = this.dateKey(current);
                const items = this.sortDeadlineRows(this.deadlines.filter((deadline) => deadline.date === key));
                const redCount = items.filter((deadline) => deadline.status === 'due').length;
                const greenCount = items.filter((deadline) => deadline.status === 'week').length;
                days.push({
                    date: key,
                    day: current.getDate(),
                    currentMonth: current.getMonth() === config.month - 1,
                    isToday: key === this.today,
                    deadlines: items,
                    totalDeadlineCount: items.length,
                    redCount,
                    greenCount
                });
            }
            weeks.push(days);
        }

        this.calendarWeeks = weeks;
    }

    private syncCalendarToToday() {
        const todayConfig = this.calendarConfigFromToday();
        this.dashboard = {
            ...this.dashboard,
            calendar: {
                ...(this.dashboard.calendar || {}),
                ...todayConfig
            }
        };
    }

    private calendarConfigFromToday() {
        const today = this.parseDate(this.today);
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        return {
            year,
            month,
            label: `${year}.${String(month).padStart(2, '0')}`
        };
    }

    private parseDate(date: string) {
        const [year, month, day] = date.split('-').map((value) => parseInt(value, 10));
        return new Date(year, month - 1, day);
    }

    private addDays(date: string, amount: number) {
        const next = this.parseDate(date);
        next.setDate(next.getDate() + amount);
        return this.dateKey(next);
    }

    private dateKey(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}

export default PageDashboardComponent;